 document.addEventListener('DOMContentLoaded', () => {
        const WORKER_BASE = 'https://api.tinytunesongs.com';
        // Script font for the pinky promise, loaded up front so it's ready before the offer opens
        (function () {
          if (document.getElementById('ttScriptFont')) return;
          const fl = document.createElement('link');
          fl.id = 'ttScriptFont';
          fl.rel = 'stylesheet';
          fl.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600;700&display=swap';
          document.head.appendChild(fl);
        })();
        // "/en-intl/" for AU/NZ/CA visitors, "/" for the US: keeps cart and checkout in their own currency
        const ttRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

              window.TT_SKIP_REVEAL = true;   // song ends → straight to the package offer
              window.TT_END_POSTER = false;   // the package offer replaces the full-screen end poster
              window.TT_OFFER_VOICEOVER = true; // the "that was just a preview" voiceover plays under the offer, then the song
              window.TT_NO_POSTER_PLAYER = true; // the song plays on the 16:9 themed video with their character on the left
        // "We're making your song" video per theme. Leave a theme blank to use the default.
        window.TT_GEN_VIDEOS = {
          default: 'https://cdn.shopify.com/videos/c/o/v/7ed63dc3dffc43a5854916fdaf5c97c7.mp4',
          princess: '',   // paste the princess version link here
          superhero: '',  // paste the superhero version link here
          halloween: '',
        };
        window.TT_GEN_VIDEO_URL = window.TT_GEN_VIDEOS.default;

                // Fit the movie stage on screen: its bottom at the bottom of the phone, lyrics just above
        window.ttFrameStage = function () {
          const stg = document.getElementById('ttMediaStage');
          if (!stg) return;
          const r = stg.getBoundingClientRect();
          const vh = window.innerHeight;
          const top = r.height > vh - 20
            ? r.top + window.pageYOffset - 8          // taller than the screen: line up the top instead
            : r.bottom + window.pageYOffset - vh + 12; // fits: stage bottom sits at the bottom of the screen
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        };

               // Their poster 1 laid over the framed poster in the post-preview video, following the zoom.
        // Positions are measured against the actual video picture (not the player box), so it lines up in any layout.
        function ttAttachRevealPoster(container, videoEl) {
          var url = window.ttPoster1;
          if (!url || !container || !videoEl) return;
          var old = container.querySelector('.tt-rv-poster');
          if (old) old.remove();
          var el = document.createElement('div');
          el.className = 'tt-rv-poster';
          el.style.cssText =
            "position:absolute;z-index:6;pointer-events:none;display:none;" +
            "background:#111 url('" + url + "') center/cover no-repeat;";
          container.appendChild(el);

          // Poster timing + position for each post-preview video (% of the video picture)
          var POSTER_SPOTS = {
             standard: null, // not measured yet → no overlay on the regular version (better than the wrong spot)
            family: { T0: 9.567, T1: 12.2, A: { l: 57.81, t: 11.39, w: 29.53, h: 78.15 }, B: { l: 58.07, t: 3.89, w: 35.52, h: 93.8 } },
          };
          var isFamilyVideo = false; // always the standard post-preview video, which has no poster frame
          var spot = POSTER_SPOTS[isFamilyVideo ? 'family' : 'standard'];

          // ?posterdebug=1 shows the video's exact time on screen, for measuring
          if (/[?&]posterdebug=1/.test(location.search)) {
            var dbg = document.createElement('div');
            dbg.style.cssText = 'position:absolute;top:8px;left:8px;z-index:9;background:rgba(0,0,0,.75);color:#fff;font:700 13px monospace;padding:4px 8px;border-radius:6px;pointer-events:none';
            container.appendChild(dbg);
            (function tickDbg() {
              if (!dbg.isConnected) return;
              dbg.textContent = (isFamilyVideo ? 'family ' : 'standard ') + (videoEl.currentTime || 0).toFixed(2) + 's';
              requestAnimationFrame(tickDbg);
            })();
          }
          if (!spot) { el.remove(); return; }
          var T0 = spot.T0, T1 = spot.T1, A = spot.A, B = spot.B;
          function lerp(a, b, p) { return a + (b - a) * p; }

          // Where the video picture actually sits inside the container (handles cover/contain cropping)
          function pictureRect() {
            var vw = videoEl.videoWidth, vh = videoEl.videoHeight;
            if (!vw || !vh) return null;
            var cr = container.getBoundingClientRect();
            var vr = videoEl.getBoundingClientRect();
            var fit = (getComputedStyle(videoEl).objectFit || 'fill').toLowerCase();
            var dw = vr.width, dh = vr.height;
            if (fit === 'cover' || fit === 'contain') {
              var s = fit === 'cover'
                ? Math.max(vr.width / vw, vr.height / vh)
                : Math.min(vr.width / vw, vr.height / vh);
              dw = vw * s;
              dh = vh * s;
            }
            return {
              x: vr.left - cr.left - container.clientLeft + (vr.width - dw) / 2,
              y: vr.top - cr.top - container.clientTop + (vr.height - dh) / 2,
              w: dw,
              h: dh,
            };
          }

          (function frame() {
            if (!el.isConnected) return;
            var t = videoEl.currentTime || 0;
            var r = t >= T0 && t < T1 ? pictureRect() : null;
            if (r) {
              var p = (t - T0) / (T1 - T0);
              el.style.left = r.x + (r.w * lerp(A.l, B.l, p)) / 100 + 'px';
              el.style.top = r.y + (r.h * lerp(A.t, B.t, p)) / 100 + 'px';
              el.style.width = (r.w * lerp(A.w, B.w, p)) / 100 + 'px';
              el.style.height = (r.h * lerp(A.h, B.h, p)) / 100 + 'px';
              el.style.display = 'block';
            } else {
              el.style.display = 'none';
            }
            requestAnimationFrame(frame);
          })();
        }

        // Sends one named event to Clarity + Meta, once per page visit
        const ttTracked = {};
            function ttTrack(name, props) {
          if (ttTracked[name]) return;
          ttTracked[name] = true;
          try { if (window.clarity) window.clarity('event', name); } catch (e) {}
          try { if (typeof fbq === 'function') fbq('trackCustom', name, props || {}); } catch (e) {}
          // Log to the order's Airtable record (sendBeacon survives the jump to checkout)
          try {
            const payload = JSON.stringify({ code: code, event: name });
            const url = 'https://api.tinytunesongs.com/track';
            if (!(navigator.sendBeacon && navigator.sendBeacon(url, payload))) {
              fetch(url, { method: 'POST', body: payload, keepalive: true }).catch(() => {});
            }
          } catch (e) {}
        }

                // Purchase modal: "The Perfect Gift" photo — themed background with their poster, name, movie and ticket
        function ttRenderGiftBundle() {
          const inner = document.getElementById('ttModalVideoInner');
          const poster = window.ttPoster1;
          if (!inner || !poster) return; // no poster yet → keep the themed video
          if (ttLang === 'es') return; // gift photo labels are English — Spanish keeps the sample video
          const nice = titleCaseName(childName) || '';
          const poss = (nice ? (nice.endsWith('s') ? nice + "'" : nice + "'s") : 'Their').toUpperCase();
          const esc = (t) => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;');

          const BASES = {
            princess: 'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/Post_-_Princess.jpg?v=1791692931',
            superhero: 'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/POST_-_SUPER_HERO.jpg?v=1791692931',
            bedtime: 'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/Post_-_Bedtime.jpg?v=1791692931',
          };
          const base = BASES[String(window.ttSongTheme || '').toLowerCase()] ||
            'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/Post_-_everything_else.jpg?v=1791692931';

          if (!document.getElementById('ttGiftBundle2Styles')) {
            const s = document.createElement('style');
            s.id = 'ttGiftBundle2Styles';
            s.textContent = [
                '#ttModalVideoInner.tt-gb-on{aspect-ratio:1376/768 !important;background:#e8d6b8}',
              '#ttModalVideoInner.tt-gb-on > :not(.tt-gb){visibility:hidden !important}',
              '.tt-gb{position:absolute;inset:0;z-index:5;container-type:inline-size;overflow:hidden}',
              '.tt-gb-base{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block}',
              // Poster: the frame's white area
              '.tt-gb-poster{position:absolute;left:18.75%;top:16.41%;width:25.94%;height:70.57%;background:#111 center/cover no-repeat;box-shadow:inset 0 0 .5cqw rgba(0,0,0,.25)}',
              // Title pill + "includes:"
              '.tt-gb-title{position:absolute;left:51.4%;top:2.2%;transform:translateX(-50%);width:62%;display:flex;flex-direction:column;align-items:center;gap:.3cqw}',
              '.tt-gb-pill{display:block;max-width:100%;overflow:hidden;white-space:nowrap;background:#1f2b4d;color:#fff;font-family:Nunito,sans-serif;font-weight:900;font-size:2.8cqw;letter-spacing:.06em;line-height:1.15;padding:.8cqw 2.8cqw;border-radius:999px;box-shadow:0 .4cqw 1.2cqw rgba(0,0,0,.18)}',
              '.tt-gb-incl{font-family:Nunito,sans-serif;font-weight:800;font-size:1.7cqw;color:#2b2b3a}',
              // Tablet: name above the play button
              '.tt-gb-movie{position:absolute;left:74.85%;top:20.5%;transform:translate(-50%,-50%);max-width:25%;display:block;overflow:hidden;white-space:nowrap;font-family:Nunito,sans-serif;font-weight:900;font-size:2.6cqw;letter-spacing:.03em;color:#fff;text-shadow:0 .2cqw .8cqw rgba(0,0,0,.5),0 0 .3cqw rgba(0,0,0,.45)}',
              // Ticket: gold name left of the QR code
              '.tt-gb-ticket{position:absolute;left:56.1%;top:81.8%;transform:translate(-50%,-50%);width:10.5%;display:flex;flex-direction:column;align-items:center;text-align:center}',
              '.tt-gb-tk1{display:block;max-width:100%;overflow:hidden;white-space:nowrap;font-family:Fraunces,Georgia,serif;font-weight:700;font-size:2.1cqw;line-height:1.1;background:linear-gradient(135deg,#a8730a 0%,#f5d77a 45%,#b8860b 100%);-webkit-background-clip:text;background-clip:text;color:transparent}',
              '.tt-gb-tk2{font-family:Nunito,sans-serif;font-weight:900;font-size:1.05cqw;letter-spacing:.2em;color:#9a7420;margin-top:.3cqw}',
            ].join('\n');
            document.head.appendChild(s);
          }

          let gb = inner.querySelector('.tt-gb');
          if (!gb) {
            gb = document.createElement('div');
            gb.className = 'tt-gb';
            inner.appendChild(gb);
          }
          inner.classList.add('tt-gb-on');
          gb.innerHTML =
            '<img class="tt-gb-base" src="' + base + '" alt="">' +
               '<div class="tt-gb-poster" style="display:block !important;visibility:visible !important;opacity:1 !important;background-image:url(\'' + poster + '\')"></div>' +
            '<div class="tt-gb-title"><span class="tt-gb-pill">' + esc(poss) + ' PERFECT GIFT</span><span class="tt-gb-incl">includes:</span></div>' +
            '<div class="tt-gb-movie">' + esc(poss) + ' MOVIE</div>' +
            '<div class="tt-gb-ticket"><span class="tt-gb-tk1">' + esc(poss) + '</span><span class="tt-gb-tk2">PREMIERE</span></div>';

          // The videos under the photo aren't visible, so stop them
          inner.querySelectorAll('video').forEach((v) => { try { v.pause(); } catch (e) {} });

          // Shrink any text that's too long for its spot (long names)
          requestAnimationFrame(() => {
            gb.querySelectorAll('.tt-gb-pill,.tt-gb-movie,.tt-gb-tk1').forEach((el) => {
              el.style.fontSize = '';
              const basePx = parseFloat(getComputedStyle(el).fontSize) || 12;
              let scale = 1;
              while (el.scrollWidth > el.clientWidth + 1 && scale > 0.5) {
                scale -= 0.05;
                el.style.fontSize = basePx * scale + 'px';
              }
            });
          });

                 // The photo shows everything they get, so below it just show the bonus badge
          const vMetaEl = document.getElementById('ttModalVideoMeta');
               if (vMetaEl) {
            if (!document.getElementById('ttFreePillStyles')) {
              const fs = document.createElement('style');
              fs.id = 'ttFreePillStyles';
              fs.textContent =
                '.tt-free-pill{display:inline-block;margin-top:2px;padding:7px 11px;border-radius:10px;background:linear-gradient(135deg,#ef4444,#be123c);color:#fff;font-family:Nunito,sans-serif;font-size:11.5px;font-weight:900;line-height:1.3;letter-spacing:.01em;box-shadow:0 6px 16px rgba(190,18,60,.35);transform:rotate(-1.5deg);animation:ttFreePulse 2.2s ease-in-out infinite}' +
                '.tt-free-pill{white-space:nowrap;font-size:13px !important;letter-spacing:.03em !important}' +
                '.tt-free-pill b{display:block;font-size:11.5px;font-weight:800;letter-spacing:.02em;color:#fff3d0}' +
                '@keyframes ttFreePulse{0%,100%{box-shadow:0 6px 16px rgba(190,18,60,.35),0 0 0 0 rgba(239,68,68,.45)}50%{box-shadow:0 6px 16px rgba(190,18,60,.35),0 0 0 8px rgba(239,68,68,0)}}' +
                '@media (prefers-reduced-motion:reduce){.tt-free-pill{animation:none}}';
              document.head.appendChild(fs);
            }
                vMetaEl.innerHTML = ttLang === 'es'
              ? '<span class="tt-free-pill">🎁 TODO INCLUIDO GRATIS<b>por tiempo limitado</b></span>'
              : '<span class="tt-free-pill">🎁 ALL INCLUDED FREE<b>for a limited time</b></span>';
          }

          // Card matches the photo: sell the whole gift, on one line
          const vTitle = document.getElementById('ttModalVideoTitle');
          if (vTitle) {
            vTitle.textContent = ttLang === 'es' ? '🎁 El Regalo Perfecto' : '🎁 The Perfect Gift';
            vTitle.style.whiteSpace = 'nowrap';
          }
                   const vCtaEl = document.getElementById('ttModalVideoCta');
          if (vCtaEl) vCtaEl.textContent = ttLang === 'es' ? 'Comprar el regalo →' : 'Buy the gift →';
        }

        // Their opening scenes (first 3 of their movie), made when they approve their character
        function ttParseOpening(v) {
          let a = v;
          if (typeof a === 'string') { try { a = JSON.parse(a); } catch (e) { a = a.split(','); } }
          a = (Array.isArray(a) ? a : []).map((u) => String(u || '').trim()).filter((u) => /^https:\/\//.test(u));
          return a.length >= 3 ? a.slice(0, 3) : null;
        }
        // While their opening scenes are made: the 3 scenes appear and come to life, so the wait feels like progress
        function ttFilmingCard(on, holding) {
          let card = document.getElementById('ttFilm');
          if (!on) { if (card) card.remove(); return; }
          const stage = document.getElementById('ttMediaStage');
          if (!stage) return;
          const es = ttLang === 'es';
          const nm = titleCaseName(childName) || (es ? 'su estrella' : 'your star');
          const poss = /s$/i.test(nm) ? nm + "'" : nm + "'s";
          if (!card) {
            if (!document.getElementById('ttFilmStyles')) {
              const st = document.createElement('style');
              st.id = 'ttFilmStyles';
              st.textContent = [
                '#ttFilm{max-width:520px;margin:14px auto 0;padding:16px 14px 14px;border-radius:20px;background:radial-gradient(90% 80% at 50% 0%,#3a3f6b,#151a33 75%);color:#fff;text-align:center;font-family:Nunito,sans-serif;box-shadow:0 18px 40px -18px rgba(21,26,51,.6)}',
                '.ttf2-k{font-size:11px;font-weight:900;letter-spacing:.2em;color:#f6d27a}',
                '.ttf2-h{margin:6px 0 12px;font-family:Fraunces,Georgia,serif;font-size:20px;font-weight:600;line-height:1.2}',
                '.ttf2-row{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}',
                '.ttf2-fr{position:relative;aspect-ratio:16/10;border-radius:10px;overflow:hidden;background:#0b1020 center/cover no-repeat;border:2px solid rgba(255,255,255,.15);transition:border-color .4s}',
                '.ttf2-fr i{position:absolute;inset:0;background:linear-gradient(110deg,transparent 30%,rgba(255,255,255,.2) 50%,transparent 70%);background-size:220% 100%;animation:ttf2Sh 1.4s linear infinite}',
                '@keyframes ttf2Sh{from{background-position:120% 0}to{background-position:-120% 0}}',
                '.ttf2-fr.has{border-color:rgba(246,210,122,.65)}',
                '.ttf2-fr.ok i{display:none}',
                '.ttf2-fr span{position:absolute;left:0;right:0;bottom:0;padding:10px 4px 4px;background:linear-gradient(to top,rgba(5,8,20,.85),transparent);font-size:10.5px;font-weight:900}',
                '.ttf2-fr.ok span{color:#9ff0c1}',
                '.ttf2-s{margin-top:10px;font-size:13px;font-weight:700;color:rgba(255,255,255,.75)}',
                '#ttFilm{display:flex;flex-direction:column;align-items:center}',
                '.ttf2-k{order:0}.ttf2-h{order:1}.ttf2-pst{order:2}.ttf2-row{order:3;width:100%}.ttf2-st{order:4}.ttf2-bar{order:5}.ttf2-s{order:6}',
                '.ttf2-fr.has:not(.ok){filter:saturate(.7) brightness(.8)}',
                '.ttf2-st{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:12px;font-size:14px;font-weight:900;color:#fff}',
                '.ttf2-spin{display:block !important;width:16px;height:16px;border-radius:50%;border:2.5px solid rgba(246,210,122,.3);border-top-color:#f6d27a;animation:ttf2Spin .9s linear infinite}',
                '@keyframes ttf2Spin{to{transform:rotate(360deg)}}',
                '#ttFilm.done .ttf2-spin{display:none !important}',
                '#ttFilm.done .ttf2-st{color:#9ff0c1}',
                '.ttf2-bar{width:100%;max-width:260px;height:5px;margin-top:8px;border-radius:5px;background:rgba(255,255,255,.15);overflow:hidden}',
                '.ttf2-bar i{display:block !important;height:100%;width:0;border-radius:5px;background:linear-gradient(90deg,#f6d27a,#e9b64a);transition:width .6s linear}',
                '.ttf2-pst{display:none;position:relative;width:120px;aspect-ratio:2/3;margin:0 auto 34px;border-radius:6px;background:#0b1020 center/cover no-repeat;box-shadow:0 0 0 3px #fff,0 0 0 5px #f6d27a,0 14px 30px rgba(0,0,0,.5);animation:ttf2In .8s cubic-bezier(.2,1.3,.4,1)}',
                '.ttf2-pst.on{display:block}',
                '.ttf2-pst span{position:absolute;left:-40px;right:-40px;bottom:-24px;font-size:11.5px;font-weight:900;color:#f6d27a;white-space:nowrap}',
                '@keyframes ttf2In{from{opacity:0;transform:scale(.8) rotate(-3deg)}to{opacity:1;transform:none}}',
                '@media (prefers-reduced-motion:reduce){.ttf2-fr i,.ttf2-spin{animation:none}}',
              ].join('');
              document.head.appendChild(st);
            }
            card = document.createElement('div');
            card.id = 'ttFilm';
            card.innerHTML =
              '<div class="ttf2-k">🎬 ' + (es ? 'FILMANDO AHORA' : 'NOW FILMING') + '</div>' +
              '<div class="ttf2-h">' + (es ? 'Las primeras escenas de la película de ' + nm : poss + ' first movie scenes') + '</div>' +
              '<div class="ttf2-row">' + [1, 2, 3].map((i) => '<div class="ttf2-fr"><i></i><span>' + (es ? 'Escena ' : 'Scene ') + i + '</span></div>').join('') + '</div>' +
              '<div class="ttf2-s">' + (es ? 'Se reproducirán con su canción en un momento.' : 'They’ll play with ' + poss + ' song in just a moment.') + '</div>' +
              '<div class="ttf2-pst"><span>🖼️ ' + (es ? 'Su póster de cine' : poss + ' movie poster') + '</span></div>' +
              '<div class="ttf2-st"><i class="ttf2-spin"></i><span></span></div>' +
              '<div class="ttf2-bar"><i></i></div>';
            stage.after(card);
            ttTrack('pv_filming_card');
            card._tick = setInterval(() => {
              if (!card.isConnected) { clearInterval(card._tick); return; }
              ttFilmingCard(true, !!window.ttOpeningHolding);
            }, 600);
          }
          card.classList.toggle('holding', !!holding);
          const pUrl = window.ttPosterReady || (window.ttPoster1 && window.ttPoster1 !== (window.ttPosterBefore || '') ? window.ttPoster1 : '');
          const pEl = card.querySelector('.ttf2-pst');
          if (pUrl && pEl && pEl.dataset.url !== pUrl) {
            pEl.dataset.url = pUrl; pEl.style.backgroundImage = "url('" + pUrl + "')"; pEl.classList.add('on');
            const pl = pEl.querySelector('span');
            if (pl) pl.textContent = '✓ ' + (es ? 'Su póster de cine' : poss + ' movie poster');
          }
          const imgs = window.ttOpeningImages || [];
          const done = !!window.ttOpeningClips;
          card.querySelectorAll('.ttf2-fr').forEach((fr, i) => {
            if (imgs[i] && !fr.dataset.img) { fr.dataset.img = '1'; fr.style.backgroundImage = "url('" + imgs[i] + "')"; fr.classList.add('has'); }
            fr.classList.toggle('ok', done);
            fr.querySelector('span').textContent = done ? '✓ ' + (es ? 'Lista' : 'Ready')
              : imgs[i] ? '🎬 ' + (es ? 'Animando…' : 'Animating…') : (es ? 'Escena ' : 'Scene ') + (i + 1);
          });
          // Status line, progress bar and message: always clear that work is still happening
          card.classList.toggle('done', done);
          const stTxt = card.querySelector('.ttf2-st span');
          if (stTxt) stTxt.textContent = done
            ? (es ? '¡Listo! Empezando su canción…' : '✓ Ready! Starting ' + poss + ' song…')
            : imgs.length
            ? (es ? 'Dando vida a las escenas…' : 'Bringing the scenes to life…')
            : (es ? 'Pintando las escenas de ' + nm + '…' : 'Painting ' + poss + ' scenes…');
          const barI = card.querySelector('.ttf2-bar i');
          if (barI) {
            const need = TT_OPENING_NEED * 1000;
            const el = Math.max(0, Date.now() - (window.ttOpeningStarted || Date.now()));
            const pct = done ? 100 : 95 * (1 - Math.exp(-2.2 * el / need)); // slows near the end, never sits still
            barI.style.width = pct.toFixed(1) + '%';
          }
          const sEl = card.querySelector('.ttf2-s');
          if (sEl) sEl.textContent = done
            ? (es ? 'Se reproducirán con su canción en un momento.' : 'They’ll play with ' + poss + ' song in just a moment.')
            : imgs.length
            ? (es ? 'Son imágenes fijas: ahora las estamos animando.' : 'These are still frames. We’re animating them now.')
            : (es ? 'Se reproducirán con su canción.' : 'They’ll play with ' + poss + ' song.');
        }

        function ttWatchOpening() {
          if (window.ttOpeningClips || window.ttOpeningWatch) return;
          let n = 0;
          const showCard = () => ttFilmingCard(!!window.ttOpeningStarted && !introFinished && !document.getElementById('ttPremiere'), !!window.ttOpeningHolding);
          window.ttOpeningWatch = setInterval(() => {
            showCard();
            if (window.ttOpeningClips || ++n > 90) { clearInterval(window.ttOpeningWatch); return; } // up to ~6 min
            fetch(WORKER_BASE + '/status-by-code?code=' + encodeURIComponent(code), { cache: 'no-store' })
              .then((r) => r.json()).catch(() => ({}))
              .then((d) => {
                const f = (d && d.fields) || {};
                if (!window.ttOpeningImages) { const im = ttParseOpening(f.opening_images); if (im) window.ttOpeningImages = im; }
                const clips = ttParseOpening(f.opening_clips);
                if (clips && !window.ttOpeningClips) {
                  window.ttOpeningClips = clips;
                  clips.forEach((u) => { const v = document.createElement('video'); v.muted = true; v.preload = 'auto'; v.src = u; }); // start downloading
                }
                showCard();
              });
          }, 4000);
        }

        window.ttWarmDemoClip = function (url) {
          if (!url) return;
          var v = window.ttDemoClipPreload;
          if (!v) {
            v = document.createElement('video');
            v.muted = true;
            v.loop = true;
            v.playsInline = true;
            v.preload = 'auto';
            v.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;';
            document.body.appendChild(v);
            window.ttDemoClipPreload = v;
          }
          if (v.src !== url) {
            v.src = url;
            v.load();
            v.play().catch(function () {});
          }
        };

                   const THEMED_HERO_VIDEOS = {
          princess: {
            withCharacter: 'https://cdn.shopify.com/videos/c/o/v/a134a1bb387446b7b7351b99693fb3c9.mp4',
            noCharacter: 'https://cdn.shopify.com/videos/c/o/v/a602bba81fbb4f4387c911bfdbc4c64a.mp4',
          },
          birthday: {
            withCharacter: 'https://cdn.shopify.com/videos/c/o/v/c505bc11208e4c8992f902fa09c4020b.mp4',
            noCharacter: 'https://cdn.shopify.com/videos/c/o/v/b432246df8054fb1ad22d77645b7e247.mp4',
          },
          'missing you': {
            withCharacter: 'https://cdn.shopify.com/videos/c/o/v/c505bc11208e4c8992f902fa09c4020b.mp4',
            noCharacter: 'https://cdn.shopify.com/videos/c/o/v/b432246df8054fb1ad22d77645b7e247.mp4',
          },
          'just because': {
            withCharacter: 'https://cdn.shopify.com/videos/c/o/v/c505bc11208e4c8992f902fa09c4020b.mp4',
            noCharacter: 'https://cdn.shopify.com/videos/c/o/v/b432246df8054fb1ad22d77645b7e247.mp4',
          },
          superhero: {
            withCharacter: 'https://cdn.shopify.com/videos/c/o/v/0c1826fd28bf46609675da46a5ad18b7.mp4',
            noCharacter: 'https://cdn.shopify.com/videos/c/o/v/555d207345cc4ddfa5ceeb53d7a7c49c.mp4',
          },
          christmas: {
            withCharacter: 'https://cdn.shopify.com/videos/c/o/v/862214b42eaf4626a82b58881ccc8bb5.mp4',
            noCharacter: 'https://cdn.shopify.com/videos/c/o/v/862214b42eaf4626a82b58881ccc8bb5.mp4',
            split: true, // full-frame montage: page builds the left character panel itself
          },
          lullaby: {
            withCharacter: 'https://cdn.shopify.com/videos/c/o/v/7d87084f8eb240ac9eff65b4eb650174.mp4',
            noCharacter: 'https://cdn.shopify.com/videos/c/o/v/84077ad5bdb246cfaf3f3ee5f2dd7fd3.mp4',
          },
        };

        const SONG_VARIANT_ID_REGULAR = 44536393695343; // $9.99 — current standard price
        const SONG_VARIANT_ID_FIRST_MODAL = 54246201819247; // $8.99 — one-time modal offer
        const VIDEO_VARIANT_ID = 54277253234799; // $24.99 movie
        const VIDEO_VARIANT_ID_LIKENESS = 54277253234799; // $24.99 movie (same variant for photo-likeness)
        const FAMILY_PASS_VARIANT_ID = 52904326004847;
        const FREE_MOVIE_VARIANT_ID = 67761091412079; // $0 Free Movie Preview (test)

        let PREVIEW_LIMIT = 40;
        const FADE_LAST = 2;

             const upsellAudio = new Audio(
          'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/POST_AUDIO.mp3?v=1793501743'
        );
        upsellAudio.preload = 'auto';
        upsellAudio.load();

        let code = new URLSearchParams(window.location.search).get('code') || '';
        code = String(code || '').trim();
        if (code.startsWith('?code=')) code = code.slice(6);
        if (code.startsWith('code=')) code = code.slice(5);
        code = code.split('#')[0].trim();

        code = code.split('#')[0].trim();

        // ============ LANGUAGE (?lang=es) ============
        const ttLang =
          (new URLSearchParams(window.location.search).get('lang') || 'en').toLowerCase() === 'es' ? 'es' : 'en';
        const PT_ES = {
          giftAlmostTitle: (nice) =>
            nice ? `🎁 El Regalo de ${nice} Ya Casi Está Listo` : '🎁 Su Regalo Ya Casi Está Listo',
          almostDoneHead: '¡Casi listo — agregando los últimos detalles! ✨',
          wrappingGiftHead: (nice) => (nice ? `Terminando el regalo de ${nice}…` : 'Terminando su regalo…'),
          buySongBtn: (nameForButton, priceStr) => `
            <div class="tt-cta-top">🎁 Obtén la Canción Completa de ${nameForButton}</div>
            <div class="tt-cta-price" id="ttSongCardPrice">${priceStr}</div>
            <div class="tt-cta-sub">Enviado a tu correo • Descarga instantánea</div>
            <div class="tt-cta-offer tt-cta-offer-song" id="ttSongOfferNote">🎁 Compra 1 Canción, Recibe 1 Gratis — cupón por correo</div>
          `,
          modalTitle: (nice) => (nice ? `¿Listo para enviar el regalo de ${nice}?` : '¿Listo para enviar su regalo?'),
          modalSub: (nice) =>
            nice
              ? `Te enviaremos un enlace privado con la canción de ${nice} — compártelo con toda la familia.`
              : `Te enviaremos un enlace privado — compártelo con toda la familia en un solo toque.`,
          unlockSongTitle: '🎵 Desbloquear solo la canción',
          unlockSongMeta: 'Entrega instantánea • Cupón de canción extra por correo',
          incNameDefault: 'Tu Pequeño Estrella',
          expiredTitle: '⏳ Tu vista previa expiró',
          expiredSub:
            'Las vistas previas están disponibles por <b>48 horas</b>. Esta ha expirado — crea una nueva canción para obtener una vista previa nueva.',
          expiredRegenBtn: 'Crear una nueva canción',
          expiredFine: 'Solo toma unos minutos — y esta vez puedes enviarla como su regalo de inmediato.',
          expiredJsTitle: '⏳ Tu vista previa expiró',
          expiredJsSub: 'Tu vista previa expiró después de 48 horas.',
          familyPassActive: '✓ Pase Familiar Activo — tu canción se desbloqueará automáticamente',
          videoBadge: 'Los Niños Se Vuelven Locos Con Esto',
          videoTop: '🎬 Canción Completa + Video Mágico',
          videoOfferNote: '🎁 Compra 1 Video, Recibe 2 Canciones Gratis — cupón por correo',
          videoSubDefault: 'Mira a su personaje protagonizar el video musical',
          videoSubWithChar: 'Su personaje protagoniza cada escena',
          fpBadge: '✨ Mejor Valor',
          fpTitle: 'Pase Familiar',
          fpDesc: 'Canciones personalizadas ilimitadas, todo el año — cada niño, cada cumpleaños.',
             fpPerk: '🎬 Videos cuando quieras — solo $19.99 cada uno',
          fpPer: '/ año',
          fpBtn: '👑 Obtener Pase Familiar',
          modalEyebrow: '🎁 Un regalo que nunca olvidarán',
          modalVideoTitle: '🎬 Convierte su canción en un video',
          modalVideoMetaDefault: 'Compra 1, recibe 2 canciones gratis — cupón por correo',
          modalVideoMetaWithChar: '2 canciones gratis adicionales incluidas',
          modalVideoCtaDefault: 'Obtener su video →',
          modalVideoCtaBuild: 'Crear personaje →',
          modalDemoBadge: 'Clip de Muestra — El video completo tiene 25 escenas',
          modalTrust: 'Enlace Privado para Compartir  •  Entrega Instantánea',
          satisfactionLine: '💚 Garantía de satisfacción 100% — si no estás feliz, te reembolsamos al instante.',
          giftReadyEyebrow: '🎁 Tu canción personalizada está lista',
          songSuffix: (nice) => (nice ? `Canción de ${nice}` : 'Su Canción'),
          previewLen: 'Vista previa personalizada de 60 segundos',
          tapToHear: (nice) => (nice ? `Toca para escuchar la canción de ${nice}` : 'Toca para escuchar su canción'),
          unlockVideoHint: (nice) =>
            nice ? `🔒 Compra para Desbloquear el Video de ${nice}` : '🔒 Compra para Desbloquear Su Video',
          confirmEyebrow: '🎵 Esta es exactamente la canción que recibirás',
          confirmTitle: (possessive) => `Aquí está ${possessive ? 'la' : 'su'} canción completa 🎵`,
          confirmBuyBtn: (buyName) => `🎵 Obtener la Canción de ${buyName} →`,
          confirmLoadingLyrics: 'Cargando la canción completa…',
          confirmExplain: `Esta es exactamente la canción que te enviaremos — <b>la letra no se puede cambiar después de la compra.</b> Dale una última lectura, y si quieres algún cambio, simplemente crea una nueva vista previa primero. 💛`,
          confirmEdit: '¿Necesitas cambiar la letra? Crea una nueva vista previa',
          confirmTrust: 'Pago seguro · Entrega instantánea',
          confirmFallbackLyrics: 'Tu canción personalizada está lista 🎵',
          missingCodeAlert: 'Falta el código de vista previa. Por favor actualiza la página.',
          expiredAlert: 'Esta vista previa ha expirado. Por favor genera una nueva para continuar.',
          cartFailedAlert: 'No se pudo agregar al carrito. Abre la consola para más detalles.',
                    listeningTitle: (p) => (p === 'their' ? '🎧 Esta es su canción' : '🎧 Esta es la canción de ' + p.replace(/'s?$/, '')),
          unlockFullSongSub: (p) => (p === 'their' ? 'Desbloquéala para escuchar su canción completa' : 'Desbloquea la canción completa de ' + p.replace(/'s?$/, '')),
          songTitleWithName: (nice) => (nice ? 'La Canción de ' + nice : 'Su Canción'),
        };
        function pt(key) {
          return ttLang === 'es' ? PT_ES[key] : null;
        }
        function applyStaticTranslationsES() {
          if (ttLang !== 'es') return;
          const set = (sel, val, html) => {
            const el = typeof sel === 'string' ? document.querySelector(sel) : sel;
            if (el) {
              if (html) el.innerHTML = val;
              else el.textContent = val;
            }
          };
          set('.tt-expired-title', PT_ES.expiredTitle);
          set('.tt-expired-sub', PT_ES.expiredSub, true);
          set('#ttRegenBtn', PT_ES.expiredRegenBtn);
          set('.tt-expired-fine', PT_ES.expiredFine);
          set('#ttFamilyPassActive', PT_ES.familyPassActive);
          set('#ttBuyVideo .tt-cta-badge', PT_ES.videoBadge);
          set('#ttBuyVideo .tt-cta-top', PT_ES.videoTop);
          set('#ttVideoOfferNote', PT_ES.videoOfferNote);
          set('.tt-fp-premium-badge', PT_ES.fpBadge);
          set('.tt-fp-premium-title', PT_ES.fpTitle);
          set('.tt-fp-premium-desc', PT_ES.fpDesc);
          set('.tt-fp-premium-perk', PT_ES.fpPerk);
          set('.tt-fp-premium-per', PT_ES.fpPer);
          set('#ttFamilyPassBtn', PT_ES.fpBtn);
          set('.tt-modal-eyebrow', PT_ES.modalEyebrow);
          set('#ttModalVideoTitle', PT_ES.modalVideoTitle);
          set('#ttModalDemoBadge', PT_ES.modalDemoBadge);
          set('.tt-modal-trust', PT_ES.modalTrust);
          set('#ttSatisfactionLine', PT_ES.satisfactionLine);
                    set('#ttCharBuilderHeader > div', 'Personaje del Video');
          set('#ttCharBuilderHeader h2', '¿Quién protagoniza su video?');
          set('.ttx-badge', '★ Recomendado');
          set('.ttx-title', 'Sube una foto');
          set('.ttx-sub', 'La convertimos en su personaje animado — se parece justo a él/ella.');
          set('.ttx-cta span', '📸 Sube una foto');
          const ttxCaps = document.querySelectorAll('.ttx-cap');
          if (ttxCaps[0]) ttxCaps[0].textContent = 'Tu foto';
          if (ttxCaps[1]) ttxCaps[1].textContent = 'Su personaje';
          set('.ttx-or em', 'o');
          set('.ttx-alt-title', 'Crear un personaje');
          set('.ttx-alt-sub', '¿Sin foto? Elige su cabello, ojos y ropa');
          set('.ttx-alt-go', 'Empezar →');
          set('#ttncTryPhotoLink', '📸 O usa el cargador de fotos');
          set('.tt-inc-kicker', 'Estamos creando una canción para');
          set('#ttVideoSoundBtn span:last-child', 'Toca para el sonido');
          set('#ttReadyUnlockLine', '¿Listo para desbloquear su regalo?');
          set('.tt-modal-song-later', 'Agrega el video después por $19.99');
        }
        applyStaticTranslationsES();
        // ============ END LANGUAGE ============

        // ============ REGION (?region=au / ?region=nz) — display only; Shopify Markets charges actual currency at checkout ============
        const ttRegion = (() => {
          try {
            const r = (new URLSearchParams(window.location.search).get('region') || '').toLowerCase();
            if (r === 'au' || r === 'nz' || r === 'us') return r; // manual override for testing only
            const c = String((window.TT_SHOP || {}).country || '').toLowerCase(); // Shopify's IP-based country
            return c === 'au' || c === 'nz' ? c : 'us';
          } catch (e) {
            return 'us';
          }
        })();
        const REGION_PRICES = {
          au: { song: '$14.99 AUD', songFirst: '$12.99 AUD', video: '$39.99 AUD', familyPass: '$99.99 AUD', sep: '$77.96 AUD' },
          nz: { song: '$17.99 NZD', songFirst: '$13.99 NZD', video: '$44.99 NZD', familyPass: '$124.99 NZD', sep: '$88.96 NZD' },
        };
        function regionPrice(key) {
          // Real prices from Shopify, in this visitor's currency, so the page always matches checkout
          const shop = window.TT_SHOP || {};
          if (key === 'video' && shop.movie) return shop.movie;
          if (key === 'song' && shop.song) return shop.song;
          const p = REGION_PRICES[ttRegion];
          return p ? p[key] : null;
        }
        function applyRegionPrices() {
          if (ttRegion === 'us') return; // default markup already shows USD
          const set = (id, val) => {
            const el = document.getElementById(id);
            if (el && val) el.textContent = val;
          };
          set('ttSongCardPrice', regionPrice('song'));
          set('ttVideoCardPrice', regionPrice('video'));
          set('ttFpPrice', regionPrice('familyPass'));
          set('ttModalVideoPrice', regionPrice('video'));
        }
        applyRegionPrices();
        try { if (ttRegion !== 'us') localStorage.setItem('tt_region', ttRegion); } catch (e) {}
        // Christmas early bird: crossed-out $29.99 → current price (US, English, Christmas orders only)
        const XMAS_WAS = '$29.99';
        const ttIsXmas = () => occasion === 'christmas' && ttRegion === 'us' && ttLang !== 'es';
        const ttXmasBadge = (price) =>
          '<div style="margin:0 0 14px;padding:10px 12px;border-radius:14px;background:#effaf3;border:1.5px dashed #1e824c;text-align:center;font-family:Nunito,sans-serif">' +
            '<div style="font-size:11.5px;font-weight:900;letter-spacing:.08em;color:#1e824c">🎄 EARLY BIRD CHRISTMAS SPECIAL</div>' +
            '<div style="margin-top:4px;display:flex;align-items:baseline;justify-content:center;gap:10px">' +
              '<s style="font-size:17px;font-weight:800;color:#94a3b8">' + XMAS_WAS + '</s>' +
              '<b style="font-family:Fraunces,Georgia,serif;font-size:30px;font-weight:600;color:#d62839">' + price + '</b>' +
            '</div>' +
          '</div>';
        // ============ END REGION ============

        const LOCK_KEY = 'tinytunesPreviewLocked_' + code;
        function isPreviewLocked() {
          return localStorage.getItem(LOCK_KEY) === '1';
        }
        function setPreviewLocked(value) {
          if (value) localStorage.setItem(LOCK_KEY, '1');
          else localStorage.removeItem(LOCK_KEY);
        }

        let activeSongVariantId = SONG_VARIANT_ID_REGULAR;

        const FIRST_SEEN_KEY = 'tinytunesFirstSeen_' + code;
        let firstSeenAt = Number(localStorage.getItem(FIRST_SEEN_KEY) || 0);
        if (!firstSeenAt) {
          firstSeenAt = Date.now();
          try {
            localStorage.setItem(FIRST_SEEN_KEY, String(firstSeenAt));
          } catch (e) {}
        }
          const PREVIEW_EXPIRES_AT = firstSeenAt + 24 * 60 * 60 * 1000;

        let modalExpiryTimer = null;
             function updateModalExpiryNote() {
          const el = document.getElementById('ttModalExpiryNote');
          if (!el) return;
          const remaining = Math.min(window.ttExpiresAt || Infinity, PREVIEW_EXPIRES_AT) - Date.now();
          if (remaining <= 0) {
            el.textContent = ttLang === 'es' ? '⏳ Esta vista previa expiró' : '⏳ This preview has expired';
            if (modalExpiryTimer) { clearInterval(modalExpiryTimer); modalExpiryTimer = null; }
            return;
          }
          const s = Math.floor(remaining / 1000);
          const pad = (n) => String(n).padStart(2, '0');
          const clock = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
          el.textContent = (ttLang === 'es' ? '⏳ Canción guardada por ' : '⏳ Song saved for ') + clock;
        }
        const elTitle = document.getElementById('ttTitle');
        const elSub = document.getElementById('ttSub');
        const elLoading = document.getElementById('ttLoading');
        const elErr = document.getElementById('ttError');
        const elExpired = document.getElementById('ttExpired');
        const elOfferStack = document.getElementById('ttOfferStack');
        const elHead = document.getElementById('ttLoadingHead');
        const elLoadingSub = document.getElementById('ttLoadingSub');
        const elAudioBlock = document.getElementById('ttAudioBlock');
        const elEmailReassure = document.getElementById('ttEmailReassure');
        const elInboxTip = document.getElementById('ttInboxTip');
        const elLyricsWrap = document.getElementById('ttLyricsPreview');
        const elLyricsName = document.getElementById('ttLyricsName');
        const elLyricsText = document.getElementById('ttLyricsText');
        const elPercent = document.getElementById('ttPercent');
        const elCute = document.getElementById('ttCute');
        const btnSong = document.getElementById('ttBuySong');
        const btnVideo = document.getElementById('ttBuyVideo');
        const modal = document.getElementById('ttModal');
        const modalClose = document.getElementById('ttModalClose');
        const modalX = document.getElementById('ttModalX');
        const modalUnlock = document.getElementById('ttModalUnlock');
        const modalVideo = document.getElementById('ttModalVideo');
        const elVideoThumb = document.getElementById('ttVideoThumb');
        const elIntroVideoWrap = document.getElementById('ttIntroVideoWrap');
        const elIntroVideo = document.getElementById('ttIntroVideo');
        const elVideoSoundBtn = document.getElementById('ttVideoSoundBtn');

               const ttStageForLoading = document.getElementById('ttMediaStage');
        if (ttStageForLoading && elLoading && elLoading.parentNode !== ttStageForLoading) {
          ttStageForLoading.appendChild(elLoading);
        }

        if (!code && elErr) {
          elErr.style.display = 'block';
          elErr.textContent = 'Missing preview code in the URL.';
        }

                let childName = '';
        let customerName = '';
        let occasion = '';
        let genre = '';
        let introStarted = false;
        let introFinished = false;
        let previewReady = false;
        let realLyrics = '';
        let lyricsRevealShown = false;
        let charApproved = false;
        let approvedCharImageUrl = '';
        let currentStage = 'new';
        let hasEverPlayedBefore = null; // null = unknown yet, true/false once poll() tells us

        function fmtTime(sec) {
          sec = Math.max(0, Math.floor(sec || 0));
          const m = Math.floor(sec / 60);
          const s = String(sec % 60).padStart(2, '0');
          return `${m}:${s}`;
        }

        function titleCaseName(s) {
          s = String(s || '').trim();
          if (!s) return '';
          return s
            .replace(/\s+/g, ' ')
            .split(' ')
            .map((w) => w.slice(0, 1).toUpperCase() + w.slice(1))
            .join(' ');
        }

           // ============ CHARACTER HOOKS (builder sets window.savedCharacterId/Url) ============
        function updateFlowGuide() {
          const s1 = document.getElementById('ttFlowStep1');
          const s2 = document.getElementById('ttFlowStep2');
          const s3 = document.getElementById('ttFlowStep3');
          const title = document.querySelector('#ttFlowGuide .tt-flow-guide-title');
          const hasCharacter = !!(window.savedCharacterId || window.savedCharacterUrl);
          [s1, s2, s3].forEach((el) => { if (el) el.classList.remove('tt-flow-step-active', 'tt-flow-step-done'); });
          if (s1) {
            s1.innerHTML = '<b>1</b> ' + (previewReady ? 'Hear their song' : 'Make their song');
            s1.classList.add(previewReady ? 'tt-flow-step-done' : 'tt-flow-step-active');
          }
          if (s2) {
            s2.innerHTML = '<b>2</b> Create their character';
            if (hasCharacter) s2.classList.add('tt-flow-step-done');
            else if (previewReady) s2.classList.add('tt-flow-step-active');
          }
          if (s3) {
            s3.innerHTML = '<b>3</b> Make their movie';
            if (previewReady && hasCharacter) s3.classList.add('tt-flow-step-active');
          }
          if (title) title.textContent = hasCharacter && previewReady ? 'Their character is ready — make the movie' : previewReady ? 'Your song is ready!' : 'Your song is being made';
        }

        function updateVideoCta() {
          updateFlowGuide();
          const sub = document.getElementById('ttVideoSub');
          const isLikenessCharacter = !!window.savedCharacterUrl && window.ttCharacterMode === 'photo_likeness';

          if (sub)
            sub.textContent = window.savedCharacterId
              ? (isLikenessCharacter
                  ? 'Their real photo comes to life in the video'
                  : pt('videoSubWithChar') || 'Their character stars in every scene')
              : pt('videoSubDefault') || 'Watch their character star in the music video';

          const priceEl = document.getElementById('ttVideoCardPrice');
          if (priceEl) priceEl.textContent = regionPrice('video') || '$24.99';
        }
        function applyCharacterCtaEmphasis() {
          if (btnVideo) btnVideo.classList.add('tt-cta-hero'); // just reveals the badge, no layout shrink
        }

            function applyCharacterToPlayer() {
  if (!window.savedCharacterUrl) return;
  const displayUrl = window.savedCharacterUrl;
          const thumb = document.querySelector('.tt-hero-char-thumb');
          if (thumb) thumb.src = displayUrl;
          const slotImg = document.getElementById('ttHeroCharSlot');
          if (slotImg) slotImg.src = displayUrl;
          charApproved = true;
          approvedCharImageUrl = window.savedCharacterUrl;
          applyCharacterCtaEmphasis();
          const modalImg = document.getElementById('ttModalCharImg');
          const modalLayout = document.getElementById('ttModalCharLayout');
          const modalDemo = document.getElementById('ttModalDemoClip');
          if (modalImg && modalLayout && approvedCharImageUrl) {
            modalImg.src = approvedCharImageUrl;
            modalLayout.style.display = 'block';
            if (modalDemo) modalDemo.style.display = 'none';
          }
          // Built the character while the song was already playing — collapse the
          // builder now too, so purchase buttons stay right under the player.
          if (previewReady && window.savedCharacterUrl && !window.ttBuildingForMovie) {
  const cb = document.getElementById('ttCharBuilder');
  if (cb) cb.style.display = 'none';
}
        }

        window.updateVideoCta = updateVideoCta;
        window.applyCharacterToPlayer = applyCharacterToPlayer;
        document.addEventListener('ttCharacterSaved', () => {
          updateFlowGuide();
          updateVideoCta();
          applyCharacterToPlayer();
          // They came from the free-preview offer → bring it back, now with their character
          if (window.ttFreeAfterCharacter) ttWaitForCharacterThenOffer();
        });
        document.addEventListener('ttCharacterDressed', () => {
          updateFlowGuide();
          applyCharacterToPlayer();
        });
        document.addEventListener('ttCharacterSaved', () => {
          const w = document.getElementById('ttWaitNext');
          if (w) w.remove();
        });

        // ============ INTRO VIDEO FLOW ============
        function showThumbnailFallback() {
          introStarted = false;
          if (elIntroVideoWrap) elIntroVideoWrap.style.display = 'none';
          if (elVideoThumb) elVideoThumb.style.display = 'none';
          if (previewReady) {
            showAudio();
            return;
          }
          if (elLoading) elLoading.style.display = 'flex';
          if (elIntroVideo) {
            try {
              elIntroVideo.pause();
              elIntroVideo.currentTime = 0;
            } catch (e) {}
          }
        }

        function startIntroFlow(opts = {}) {
          const { userInitiated = false } = opts;
          introStarted = true;
          if (elVideoThumb) elVideoThumb.style.display = 'none';
          if (elIntroVideoWrap) elIntroVideoWrap.style.display = 'block';
          if (elAudioBlock) elAudioBlock.style.display = 'none';
          if (elLoading) elLoading.style.display = 'none';
          if (!elIntroVideo) return;
          if (userInitiated) {
            elIntroVideo.muted = false;
            elIntroVideo.volume = 1;
            if (elVideoSoundBtn) elVideoSoundBtn.style.display = 'none';
          } else {
            elIntroVideo.muted = true;
            if (elVideoSoundBtn) elVideoSoundBtn.style.display = '';
          }
          const genUrl = (window.TT_GEN_VIDEOS && (window.TT_GEN_VIDEOS[occasion] || window.TT_GEN_VIDEOS.default)) || window.TT_GEN_VIDEO_URL;
          if (genUrl && !elIntroVideo.dataset.ttGen) {
            elIntroVideo.dataset.ttGen = '1';
            elIntroVideo.src = genUrl;
               elIntroVideo.loop = true; // repeats until the song is ready, then cuts to it
          }
          elIntroVideo.loop = true; // whichever video plays, it loops until the song is ready
          const playPromise = elIntroVideo.play();
          if (playPromise && playPromise.catch) {
            playPromise.catch(() => {
              if (!userInitiated) {
                const tryOnInteraction = () => {
                  elIntroVideo.play().catch(() => {});
                  document.removeEventListener('touchstart', tryOnInteraction);
                  document.removeEventListener('scroll', tryOnInteraction);
                };
                document.addEventListener('touchstart', tryOnInteraction, { once: true });
                document.addEventListener('scroll', tryOnInteraction, { once: true });
              }
            });
          }
           if (!userInitiated) {
            // Slow phone connections (especially inside Facebook) need more than a few seconds.
            // Only fall back to the loader if the video truly can't load; if it's loaded but
            // autoplay was blocked, keep it on screen and nudge it to play.
            window.setTimeout(() => {
              if (introFinished || !elIntroVideo) return;
              const nothingLoaded = elIntroVideo.readyState === 0 && elIntroVideo.networkState !== 2; // 2 = still loading
              if (nothingLoaded) {
                showThumbnailFallback();
              } else if (elIntroVideo.paused) {
                elIntroVideo.play().catch(() => {});
                if (elVideoSoundBtn) elVideoSoundBtn.style.display = '';
              }
            }, 10000);
          }
        }

        // Intro: plays at least 2:20, and their character builder opens 20 seconds in
        const MIN_INTRO_SECONDS = 140;
        const TT_OPENING_NEED = 120;     // seconds from approval until the clips are ready (set from opening_log "ALL CLIPS READY")
        const TT_OPENING_MAX_HOLD = 90;  // the most extra time we'll ever add to the intro waiting for them
        const CHARACTER_AT_SECONDS = 15;
        let introPlayed = 0, introLastT = null, castWaitStart = 0;
        function showEarlyBuilder() {
          if (window.ttEarlyBuilderShown || introFinished || !introStarted || window.savedCharacterUrl) return;
          window.ttEarlyBuilderShown = true;
          window.ttMakingCast = true;
          ttTrack('pv_early_builder');
          ttStartCharacterForMovie({ early: true });
        }
        if (elIntroVideo) {
          elIntroVideo.addEventListener('timeupdate', () => {
            const t = elIntroVideo.currentTime || 0;
            if (introLastT !== null && !elIntroVideo.paused) {
              const d = t - introLastT;
              if (d > 0 && d < 2) introPlayed += d; // loops and skips don't count
            }
            introLastT = t;
            if (introPlayed >= CHARACTER_AT_SECONDS) showEarlyBuilder();
          });
        }
        setTimeout(showEarlyBuilder, (CHARACTER_AT_SECONDS + 10) * 1000); // a stalled video still gets the builder
        // Did they actually start making a character? (just seeing the builder doesn't count)
        ['click', 'input', 'change'].forEach((ev) =>
          document.addEventListener(ev, (e) => {
            if (e.target && e.target.closest && e.target.closest('#ttCharBuilder, #ttPremiere')) window.ttCharTouched = true;
          }, true)
        );
        let introCutTimer = null;
        function cutIntroWhenReady() {
          if (introCutTimer || introFinished) return;
          const check = () => {
            if (introFinished) { clearInterval(introCutTimer); return; }
            const building = !!window.ttCharTouched || !!window.savedCharacterUrl ||
              !!document.getElementById('ttPremiere') || ttBuilderBusy();
            const minSecs = building ? MIN_INTRO_SECONDS : 45; // not building → song as soon as it's ready
            const waitedOut = Date.now() - pageStart > (minSecs + 30) * 1000; // a stalled video never traps them
            if (introPlayed < minSecs && !waitedOut) return;
            // Their opening scenes are being made → keep the intro going until they're ready (never more than 60s extra)
            if (window.ttOpeningStarted && !window.ttOpeningClips) {
              if (!window.ttOpeningWaitStart) window.ttOpeningWaitStart = Date.now();
              const holdUntil = Math.min(window.ttOpeningDeadline || 0, window.ttOpeningWaitStart + TT_OPENING_MAX_HOLD * 1000);
              if (Date.now() < holdUntil) { window.ttOpeningHolding = true; ttFilmingCard(true, true); return; }
            }
            window.ttOpeningHolding = false;
            // Mid-way through their character or adding themselves → up to 90 more seconds
            if (building && window.ttMakingCast) {
              if (!castWaitStart) castWaitStart = Date.now();
              if (Date.now() - castWaitStart < 90000) return;
            }
            clearInterval(introCutTimer);
            finishIntroFlow();
          };
          introCutTimer = setInterval(check, 1000);
          check();
        }

        function finishIntroFlow() {
          if (introFinished) return;
          introFinished = true;
          ttFilmingCard(false);
          localStorage.setItem('tinytunesIntroSeen_' + code, '1');
          if (elIntroVideo) {
            try {
              elIntroVideo.pause();
            } catch (e) {}
          }
          if (elIntroVideoWrap) elIntroVideoWrap.style.display = 'none';
          if (previewReady) {
            showAudio();
          } else if (elLoading) {
            elLoading.style.display = 'flex';
          }
        }

        if (elVideoThumb) elVideoThumb.addEventListener('click', () => startIntroFlow({ userInitiated: true }));
                if (elIntroVideo) {
          const onIntroFail = () => { if (!introFinished) showThumbnailFallback(); };
          elIntroVideo.addEventListener('error', onIntroFail);
          const introSourceEl = elIntroVideo.querySelector('source');
          if (introSourceEl) introSourceEl.addEventListener('error', onIntroFail);
          elIntroVideo.addEventListener('ended', finishIntroFlow);
          elIntroVideo.addEventListener('timeupdate', () => {
            const t = elIntroVideo.currentTime || 0;
            const nameCard = document.getElementById('ttIntroNameCard');
            if (nameCard) {
              if (t < 10.22) nameCard.classList.remove('tt-hidden');
              else nameCard.classList.add('tt-hidden');
            }
          });
        }
                if (elIntroVideoWrap) {
          elIntroVideoWrap.addEventListener('click', (e) => {
            if (!elIntroVideo || !elIntroVideo.muted) return;
            if (e.target.closest && e.target.closest('#ttVideoSoundBtn')) return;
            if (elVideoSoundBtn) elVideoSoundBtn.click();
          });
        }

                // First tap anywhere on the page turns our sound on, which also silences the Facebook ad behind it
        const ttUnmuteOnFirstTap = () => {
          if (elIntroVideo && !introFinished && elIntroVideo.muted) {
            elIntroVideo.muted = false;
            elIntroVideo.volume = 1;
            elIntroVideo.play().catch(() => {});
            if (elVideoSoundBtn) elVideoSoundBtn.style.display = 'none';
          }
        };
        document.addEventListener('touchend', ttUnmuteOnFirstTap, { once: true, passive: true });

        // ── Keep OUR video/song playing: Facebook's ad audio pauses it (photo picker, app switch, its mini player) ──
        window.ttShowResumeTap = function (media) {
          if (!media) return;
          // The button disappears by itself as soon as that player is going again
          if (!media._ttResumeHook) {
            media._ttResumeHook = true;
            media.addEventListener('playing', () => {
              const btn = document.getElementById('ttResumeTap');
              if (btn && btn._ttMedia === media) btn.remove();
            });
          }
          // Reuse the button, but always point it at the most recently interrupted player.
          let b = document.getElementById('ttResumeTap');
          if (b) {
            b._ttMedia = media;
            return;
          }
          b = document.createElement('button');
          b.id = 'ttResumeTap';
          b.type = 'button';
          b._ttMedia = media;
          b.textContent = ttLang === 'es' ? '▶ Toca para continuar' : '▶ Tap to resume playback';
          b.style.cssText = 'position:fixed;left:50%;bottom:calc(24px + env(safe-area-inset-bottom,0px));transform:translateX(-50%);z-index:100005;padding:16px 26px;border:none;border-radius:999px;background:#151a33;color:#fff;font-family:Nunito,sans-serif;font-size:17px;font-weight:900;box-shadow:0 14px 30px rgba(0,0,0,.35);cursor:pointer;white-space:nowrap';
          b.addEventListener('click', () => {
            const target = b._ttMedia;
            if (!target) { b.remove(); return; }
            // Audio players may need sound re-enabled after a user gesture. Keep visual/reveal videos muted.
            if (target.tagName === 'AUDIO' || target === elIntroVideo) {
              target.muted = false;
              target.volume = 1;
            }
            const p = target.play();
            if (p && p.then) p.then(() => { if (b.isConnected && b._ttMedia === target) b.remove(); }).catch(() => {});
            else b.remove();
          });
          document.body.appendChild(b);
          ttTrack('pv_resume_tap_shown');
        };
        // Only guard the intro once it has really played (blocked autoplay has its own play nudge)
        let ttIntroHasPlayed = false;
        if (elIntroVideo) elIntroVideo.addEventListener('playing', () => { ttIntroHasPlayed = true; });
        const ttIntroShouldPlay = () =>
          ttIntroHasPlayed && introStarted && !introFinished && !window._ttExpired && elIntroVideo &&
          elIntroVideoWrap && elIntroVideoWrap.style.display !== 'none';
        const ttIntroWatch = () => {
          if (document.hidden || !ttIntroShouldPlay() || !elIntroVideo.paused) return;
          ttTrack('pv_media_stolen'); // counts how often this happens
          const p = elIntroVideo.play();
          if (p && p.catch) p.catch(() => window.ttShowResumeTap(elIntroVideo));
        };
        setInterval(ttIntroWatch, 1000);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) setTimeout(ttIntroWatch, 300); });
        window.addEventListener('pageshow', () => setTimeout(ttIntroWatch, 300));
        window.addEventListener('focus', () => setTimeout(ttIntroWatch, 300));
        document.addEventListener('click', ttUnmuteOnFirstTap, { once: true });
        
        if (elVideoSoundBtn) {
          elVideoSoundBtn.addEventListener('click', () => {
            if (!elIntroVideo) return;
            elIntroVideo.muted = false;
            elIntroVideo.volume = 1;
            elVideoSoundBtn.style.display = 'none';
            const p = elIntroVideo.play();
            if (p && p.catch) p.catch(() => {});
          });
        }

        const lyricLines = [
          '{name} is shining bright today',
          'Everyone clap for {name}',
          "It is {name}'s special moment now",
          '{name} is the star of the show',
          'Sing along with {name}',
          'Let us celebrate {name} today',
          '{name} is dancing in the spotlight',
          'This song was made for {name}',
        ];
        let lyricTimer = null,
          lyricStarted = false;
        function startLyricPreview() {
          if (lyricStarted) return;
          if (!elLyricsWrap || !elLyricsText || !elLyricsName) return;
          const nice = titleCaseName(childName) || 'your star';
          elLyricsName.textContent = nice;
          elLyricsWrap.style.display = 'block';
          let i = 0;
          elLyricsText.textContent = lyricLines[0].replace(/{name}/g, nice);
          lyricTimer = setInterval(() => {
            elLyricsText.textContent = lyricLines[i % lyricLines.length].replace(/{name}/g, nice);
            i++;
          }, 2400);
          lyricStarted = true;
        }
        function stopLyricPreview() {
          if (lyricTimer) clearInterval(lyricTimer);
          lyricTimer = null;
        }

        function renderLyricsInline(lyrics) {
          const esc = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const nameRe = childName ? new RegExp('\\b(' + esc(childName) + ')\\b', 'gi') : null;
          return String(lyrics)
            .split('\n')
            .map((raw) => {
              const line = raw.trim();
              if (!line) return '<div style="height:6px;"></div>';
              if (/^\[.*\]$/.test(line))
                return `<div style="font-family:Arial,sans-serif;font-size:11px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:#3c8ab3;margin:16px 0 7px;">${line.replace(
                  /^\[|\]$/g,
                  ''
                )}</div>`;
              let safe = line.replace(/</g, '&lt;').replace(/>/g, '&gt;');
              if (nameRe) safe = safe.replace(nameRe, '<span style="color:#e0a000;font-weight:900;">$1</span>');
              return `<div style="font-family:Georgia,'Times New Roman',serif;font-size:18px;font-weight:400;color:#1c2545;line-height:1.85;">${safe}</div>`;
            })
            .join('');
        }

                      function showLyricsReveal() {
          if (lyricsRevealShown || !realLyrics) return;
          lyricsRevealShown = true;
          stopLyricPreview();
          const fake = document.getElementById('ttLyricsPreview');
          if (fake) fake.style.display = 'none';
          let card = document.getElementById('ttLyricsReveal');
          if (!card) {
            card = document.createElement('div');
            card.id = 'ttLyricsReveal';
            card.style.cssText =
              'margin:16px auto 0;max-width:860px;border-radius:22px;background:#ffffff;border:1px solid #e8edf2;box-shadow:0 12px 34px rgba(15,23,42,.05);padding:28px 30px;text-align:left;font-family:Georgia,\'Times New Roman\',serif;opacity:0;transform:translateY(12px);transition:opacity .45s ease,transform .45s ease;';
            const stage = document.getElementById('ttMediaStage');
            if (stage && stage.parentNode) stage.parentNode.insertBefore(card, stage);
            else { const pc = document.querySelector('.tt-preview-card'); if (pc) pc.appendChild(card); }
          }
          const nice = titleCaseName(childName) || 'your little one';
          card.innerHTML = `
        <div style="text-align:center;font-size:12px;font-weight:900;letter-spacing:.08em;text-transform:uppercase;color:#3c8ab3;margin-bottom:4px;">✍️ ${ttLang === 'es' ? 'Escrita solo para' : 'Written just for'} ${nice}</div>
        <div style="text-align:center;font-size:13px;font-weight:700;color:#6b7280;margin-bottom:14px;">${ttLang === 'es' ? 'Esta es la letra de su canción 🎶' : 'Here are the words to their song🎶'}</div>
        <div style="max-height:180px;overflow-y:auto;padding:4px 6px;">${renderLyricsInline(realLyrics)}</div>
      `;
                   card.style.display = 'block';
          requestAnimationFrame(() => {
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
          });
          if (typeof window.ttRefreshCastStrip === 'function') window.ttRefreshCastStrip();
        }
        function setCTAName() {
          const nice = titleCaseName(childName);
          const fallback = 'Your';
          const nameForButton = nice || fallback;
          if (elTitle && !previewReady)
            if (elTitle)
  elTitle.innerHTML = pt('giftAlmostTitle')
    ? PT_ES.giftAlmostTitle(nice)
    : nice
    ? `🎁 ${nice}'s Gift<br>Is Almost Ready`
    : '🎁 Their Gift<br>Is Almost Ready';
          if (elHead)
            elHead.textContent =
              ['trimming_preview', 'uploading_preview'].indexOf(currentStage) !== -1 && !previewReady
                ? pt('almostDoneHead') || 'Almost done — just adding the final touches! ✨'
                : pt('wrappingGiftHead')
                ? PT_ES.wrappingGiftHead(nice)
                : nice
                ? `Wrapping up ${nice}'s gift…`
                : 'Wrapping up their gift…';
          const songPriceDisplay = regionPrice('song') || '$9.99';
          if (btnSong) {
            btnSong.innerHTML = pt('buySongBtn')
              ? PT_ES.buySongBtn(nameForButton, songPriceDisplay)
              : `
          <div class="tt-cta-top">🎁 Get ${nameForButton}'s Full Song</div>
          <div class="tt-cta-price" id="ttSongCardPrice">${songPriceDisplay}</div>
          <div class="tt-cta-sub">Delivered to your inbox • Download instantly</div>
          <div class="tt-cta-offer tt-cta-offer-song" id="ttSongOfferNote">🎁 Buy 1 Song, Get 1 Free — coupon delivered by email</div>
        `;
          }
          const t = document.getElementById('ttModalTitle');
          if (t)
            t.textContent = pt('modalTitle')
              ? PT_ES.modalTitle(nice)
              : nice
              ? `Ready to send ${nice}'s gift?`
              : `Ready to send their gift?`;
          const s = document.getElementById('ttModalSub');
          if (s)
            s.textContent = pt('modalSub')
              ? PT_ES.modalSub(nice)
              : nice
               ? `We'll email you ${nice}'s movie.`
              : `We'll email you a private link — forward it to the whole family in one tap.`;
          const songCardTitle = document.getElementById('ttModalSongTitle');
          const songCardMeta = document.getElementById('ttModalSongMeta');
          if (songCardTitle) songCardTitle.textContent = pt('unlockSongTitle') || `🎵 Unlock Song First`;
                    if (songCardMeta) {
            songCardMeta.style.whiteSpace = 'nowrap';
             songCardMeta.innerHTML = pt('unlockSongMeta') || `<span class="tt-bonus-badge"><span class="tt-bonus-badge-icon">🎁</span>Plus a bonus song FREE</span>`;
          }
          const incNameEl = document.getElementById('ttIncName');
          if (incNameEl) incNameEl.textContent = titleCaseName(childName) || pt('incNameDefault') || 'Your Little One';
        }

        function openModal() {
          ttTrack('pv_modal_open');
               const expEl = document.getElementById('ttModalExpiryNote');
          if (expEl) expEl.style.display = 'none'; // countdown turned off
          window.ttRevealActive = false;
          if (window.TT_SIMPLE_MODAL === false) {
            ttRenderGiftBundle();
            setTimeout(ttRenderGiftBundle, 0);
          }
          // Make sure the modal's videos are playing (muted + inline so phones allow autoplay)
          if (window.TT_SIMPLE_MODAL === false) document.querySelectorAll('#ttModal video').forEach((v) => {
            v.muted = true;
            v.playsInline = true;
            v.setAttribute('playsinline', '');
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          });
          if (!modal) return;
          const showFirstTimeOffer = false; // song is always $9.99 (no $8.99 first-time price)
          activeSongVariantId = showFirstTimeOffer ? SONG_VARIANT_ID_FIRST_MODAL : SONG_VARIANT_ID_REGULAR;

          const wasEl = document.getElementById('ttModalSongPriceWas');
          const nowEl = document.getElementById('ttModalSongPriceNow');
          const badgeEl = document.getElementById('ttModalSongBadge');
          if (nowEl)
            nowEl.textContent = showFirstTimeOffer
              ? regionPrice('songFirst') || '$8.99'
              : regionPrice('song') || '$9.99';
          if (wasEl) {
            wasEl.textContent = regionPrice('song') || '$9.99';
            wasEl.style.display = showFirstTimeOffer ? 'block' : 'none';
          }
           if (badgeEl) badgeEl.style.display = showFirstTimeOffer ? 'inline-block' : 'none';

          // New sales sheet instead of the old modal (song price + variant are already set above)
          if (window.TT_SIMPLE_MODAL !== false) {
            try {
              upsellAudio.pause();
              upsellAudio.currentTime = 0;
              const songA = document.getElementById('ttAudio');
              if (songA) { songA.currentTime = 0; songA.play().catch(() => {}); } // song plays behind the modal
            } catch (e) {}
            ttShowSimpleOffer();
            return;
          }

            modal.setAttribute('aria-hidden', 'false');
  const vCta = document.getElementById('ttModalVideoCta');
  const vMeta = document.getElementById('ttModalVideoMeta');
  if (vCta)
    vCta.textContent = window.savedCharacterId
      ? (ttLang === 'es'
          ? 'Comprar su película · ' + (regionPrice('video') || '$24.99') + ' →'
          : 'Buy their movie · ' + (regionPrice('video') || '$24.99') + ' →')
      : pt('modalVideoCtaBuild') || 'Build character →';
  if (vMeta) {
    vMeta.innerHTML =
      (pt('modalVideoMetaWithChar') || '<span class="tt-bonus-badge"><span class="tt-bonus-badge-icon">🎁</span>+ 2 songs FREE</span>') +
      '<div style="margin-top:6px;font-family:\'Nunito\',sans-serif;font-size:11.5px;font-weight:800;color:rgba(0,0,0,0.6);">🎟️ Includes their poster &amp; premiere ticket</div>';
  }
 const isLikeness = window.ttCharacterMode === 'photo_likeness';
const priceEl = document.getElementById('ttModalVideoPrice');
if (priceEl) priceEl.textContent = regionPrice('video') || '$24.99';
const likenessVisual = document.getElementById('ttModalLikenessVisual');
if (likenessVisual) likenessVisual.style.display = 'none';

            const modalDemo = document.getElementById('ttModalDemoClip');
          const modalLayout = document.getElementById('ttModalCharLayout');
          const modalDemoBadge = document.getElementById('ttModalDemoBadge');
          const NO_CHARACTER_MODAL_SRC = 'https://cdn.shopify.com/videos/c/o/v/494918573ab14ecc99f49f0bb6d6ed29.mp4';

          if (window.ttDemoClipUrl && modalDemo) {
            if (modalLayout) modalLayout.style.display = 'none';
            modalDemo.style.display = 'block';
            const currentSrc = modalDemo.querySelector('source').src;
            if (currentSrc !== window.ttDemoClipUrl) {
              modalDemo.querySelector('source').src = window.ttDemoClipUrl;
              modalDemo.load();
            }
            modalDemo.play().catch(() => {});
            if (modalDemoBadge) modalDemoBadge.style.display = 'block';
                   } else if (modalDemo && !window.savedCharacterUrl) {
            if (modalLayout) modalLayout.style.display = 'none';
            modalDemo.style.display = 'block';
            if (modalDemoBadge) modalDemoBadge.style.display = 'none';
            const sourceEl = modalDemo.querySelector('source');
            const themedNoCharSrc = (THEMED_HERO_VIDEOS[occasion] && THEMED_HERO_VIDEOS[occasion].noCharacter) || NO_CHARACTER_MODAL_SRC;
            if (sourceEl.src !== themedNoCharSrc) {
              sourceEl.src = themedNoCharSrc;
              modalDemo.load();
            }
            modalDemo.play().catch(() => {});
          }
          try {
            upsellAudio.pause();
            upsellAudio.currentTime = 0;
            const audio = document.getElementById('ttAudio');
            if (audio) {
              audio.currentTime = 0;
              audio.play().catch(() => {});
            }
          } catch (e) {}
        }

        function closeModal() {
          if (!modal) return;
          if (modalExpiryTimer) {
            clearInterval(modalExpiryTimer);
            modalExpiryTimer = null;
          }
          modal.setAttribute('aria-hidden', 'true');
        }
        function dismissModal() {
          closeModal();
        }

        if (modal)
          modal.addEventListener('click', (e) => {
            if (e.target === modal) dismissModal();
          });
        if (modalClose)
          modalClose.addEventListener('click', (e) => {
            e.preventDefault();
            dismissModal();
          });
        if (modalX)
          modalX.addEventListener('click', (e) => {
            e.preventDefault();
            dismissModal();
          });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') dismissModal();
        });

        function safeProps(props) {
          const out = {};
          for (const [k, v] of Object.entries(props || {})) {
            if (v === undefined || v === null) continue;
            out[k] = String(v);
          }
          return out;
        }

        // "Opening secure checkout…" cover, so they know the tap worked
        function ttCheckoutLoading(on) {
          let el = document.getElementById('ttCkLoad');
          if (!on) { if (el) el.remove(); return; }
          if (el) return;
          el = document.createElement('div');
          el.id = 'ttCkLoad';
          el.style.cssText = 'position:fixed;inset:0;z-index:100010;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;background:rgba(10,14,28,.72);color:#fff;font-family:Nunito,sans-serif;font-size:17px;font-weight:900;text-align:center;padding:24px';
          el.innerHTML = '<div style="width:44px;height:44px;border-radius:50%;border:4px solid rgba(246,210,122,.3);border-top-color:#f6d27a;animation:ttCkSpin .9s linear infinite"></div>' +
            '<style>@keyframes ttCkSpin{to{transform:rotate(360deg)}}</style>' +
            (ttLang === 'es' ? '🔒 Abriendo el pago seguro…' : '🔒 Opening secure checkout…');
          document.body.appendChild(el);
          setTimeout(() => { if (el.isConnected) el.remove(); window.ttCheckingOut = false; }, 12000); // never stuck
        }
        // Coming back from checkout with the back button: clear the cover
        window.addEventListener('pageshow', (e) => { if (e.persisted) { ttCheckoutLoading(false); window.ttCheckingOut = false; } });

        async function addAndCheckout(variantId, extraProps) {
          if (window._ttExpired) {
            alert(pt('expiredAlert') || 'This preview has expired. Please generate a new one to continue.');
            return;
          }
          if (window.ttCheckingOut) return; // already on the way to checkout: ignore extra taps
          window.ttCheckingOut = true;
          ttCheckoutLoading(true);
          try {
            localStorage.setItem('tt_code', code);
          } catch (e) {}
          await fetch(ttRoot + 'cart/clear.js', { method: 'POST' });
          await fetch(ttRoot + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { tt_code: code } }),
          });
          const baseProps = { _preview_code: code };
          const merged = Object.assign({}, baseProps, extraProps || {});
          const payload = { id: variantId, quantity: 1, properties: safeProps(merged) };
          const res = await fetch(ttRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
          if (!res.ok) {
            ttCheckoutLoading(false);
            window.ttCheckingOut = false;
            console.error('Add to cart failed:', res.status, await res.text().catch(() => '(no body)'));
            alert(pt('cartFailedAlert') || "Couldn't add to cart. Open console for details.");
            return;
          }
          const ckEmail = String(window.ttRecordEmail || '').trim();
          window.location.href = ckEmail
            ? ttRoot + 'checkout?checkout[email]=' + encodeURIComponent(ckEmail) // pre-filled: one less field, and recovery emails work even if they leave early
            : ttRoot + 'checkout';
        }
        function renderLyricsHtml(lyrics) {
          return String(lyrics)
            .split('\n')
            .map((raw) => {
              const line = raw.trim();
              if (!line) return '<div style="height:8px;"></div>';
              if (/^\[.*\]$/.test(line)) return `<div class="ttvc-section">${line.replace(/^\[|\]$/g, '')}</div>`;
              return `<div class="ttvc-line">${line.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>`;
            })
            .join('');
        }

        let pendingSongProps = { _gift_send_enabled: 'no' };

        function confirmThenBuySong(extraProps) {
          if (!code) return alert(pt('missingCodeAlert') || 'Missing preview code. Please refresh.');
          pendingSongProps = extraProps || { _gift_send_enabled: 'no' };

          let overlay = document.getElementById('ttSongConfirm');
          if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = 'ttSongConfirm';
            overlay.innerHTML = `
          <style>
            #ttSongConfirm{position:fixed;inset:0;z-index:100000;background:rgba(2,6,23,.62);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);display:none;align-items:flex-start;justify-content:center;padding:24px 14px;overflow-y:auto;box-sizing:border-box;}
            #ttSongConfirm.tt-open{display:flex;}
            .ttsc-box{width:100%;max-width:560px;background:rgba(255,255,255,.98);border:1px solid rgba(148,163,184,.2);border-radius:24px;box-shadow:0 24px 70px rgba(15,23,42,.28);padding:22px 20px 18px;position:relative;margin:auto;font-family:'Nunito',sans-serif;animation:ttscIn .3s ease forwards;}
            @keyframes ttscIn{from{opacity:0;transform:scale(.96) translateY(10px);}to{opacity:1;transform:scale(1) translateY(0);}}
            .ttsc-x{position:absolute;top:14px;right:14px;width:34px;height:34px;border-radius:10px;border:1px solid rgba(15,23,42,.1);background:#fff;color:#0f172a;cursor:pointer;font-size:20px;line-height:1;display:flex;align-items:center;justify-content:center;z-index:2;}
            .ttsc-eyebrow{text-align:center;font-size:11px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:#4fa3d1;margin-bottom:6px;}
            .ttsc-title{text-align:center;font-family:'Fraunces',serif;font-size:clamp(22px,4vw,30px);font-weight:600;letter-spacing:-.02em;color:#111827;line-height:1.1;margin-bottom:14px;}
            .ttsc-lyrics{max-height:42vh;overflow-y:auto;background:rgba(248,251,255,.9);border:1px solid rgba(79,163,209,.16);border-radius:16px;padding:18px;margin-bottom:14px;text-align:center;}
            .ttvc-section{font-size:11px;font-weight:900;letter-spacing:.1em;text-transform:uppercase;color:#9ca3af;margin:14px 0 6px;}
            .ttvc-section:first-child{margin-top:0;}
            .ttvc-line{font-size:15px;font-weight:700;color:#1f2937;line-height:1.7;}
            .ttsc-loading{color:#6b7280;font-weight:700;font-size:14px;padding:24px 0;}
            .ttsc-explain{background:rgba(249,200,70,.12);border:1px solid rgba(240,168,0,.25);border-radius:14px;padding:12px 14px;font-size:12.5px;font-weight:700;color:#7a5200;line-height:1.5;text-align:center;margin-bottom:14px;}
            .ttsc-buy{width:100%;padding:20px;border-radius:16px;border:none;cursor:pointer;font-family:'Nunito',sans-serif;font-size:19px;font-weight:900;letter-spacing:.01em;color:#ffffff;background:linear-gradient(135deg,#4fa3d1,#3c8ab3);box-shadow:0 14px 34px rgba(60,138,179,.42);animation:ttscPulse 2s ease-in-out infinite;}
            .ttsc-buy:hover{box-shadow:0 18px 44px rgba(60,138,179,.6);}
            @keyframes ttscPulse{0%{transform:scale(1);}50%{transform:scale(1.02);}100%{transform:scale(1);}}
            .ttsc-edit{display:block;width:100%;text-align:center;margin-top:12px;background:none;border:none;color:rgba(15,23,42,.45);font-family:'Nunito',sans-serif;font-size:12.5px;font-weight:700;cursor:pointer;text-decoration:underline;}
            .ttsc-edit:hover{color:rgba(15,23,42,.7);}
            .ttsc-trust{text-align:center;color:#9ca3af;font-size:11px;font-weight:700;margin-top:10px;}
          </style>
          <div class="ttsc-box" role="dialog" aria-modal="true">
            <button class="ttsc-x" id="ttscClose" type="button" aria-label="Close">×</button>
                        <div class="ttsc-eyebrow">${
                          pt('confirmEyebrow') || "🎵 This is the exact song you'll receive"
                        }</div>
            <div class="ttsc-title" id="ttscTitle">${
              pt('confirmTitle') ? PT_ES.confirmTitle(false) : "Here's their full song 🎵"
            }</div>
            <button class="ttsc-buy" id="ttscBuy" type="button" style="margin-bottom:14px;">${
              pt('confirmBuyBtn') ? PT_ES.confirmBuyBtn('Their') : '🎵 Send Their Song →'
            }</button>
            <div class="ttsc-lyrics" id="ttscLyrics"><div class="ttsc-loading">${
              pt('confirmLoadingLyrics') || 'Loading the full song…'
            }</div></div>
            <div class="ttsc-explain" id="ttscExplain"></div>
            <button class="ttsc-buy" id="ttscBuyBottom" type="button">${
              pt('confirmBuyBtn') ? PT_ES.confirmBuyBtn('Their') : '🎵 Send Their Song →'
            }</button>
            <button class="ttsc-edit" id="ttscEdit" type="button">${
              pt('confirmEdit') || 'Need to change the lyrics? Make a new preview'
            }</button>
            <div class="ttsc-trust">${pt('confirmTrust') || 'Secure checkout · Delivered instantly '}</div>
          </div>
        `;
            document.body.appendChild(overlay);

            (function () {
              var topBtn = document.getElementById('ttscBuy');
              var botBtn = document.getElementById('ttscBuyBottom');
              if (topBtn && botBtn) {
                botBtn.addEventListener('click', function () {
                  topBtn.click();
                });
                var sync = function () {
                  botBtn.textContent = topBtn.textContent;
                };
                sync();
                new MutationObserver(sync).observe(topBtn, { childList: true, characterData: true, subtree: true });
              }
            })();

            overlay.querySelector('#ttscClose').addEventListener('click', () => overlay.classList.remove('tt-open'));
            overlay.addEventListener('click', (e) => {
              if (e.target === overlay) overlay.classList.remove('tt-open');
            });
            overlay.querySelector('#ttscEdit').addEventListener('click', () => {
              window.location.href = '/products/tiny-tunes-song';
            });
            overlay.querySelector('#ttscBuy').addEventListener('click', () => {
              ttTrack('pv_click_song');
              setPreviewLocked(false);
              addAndCheckout(activeSongVariantId, pendingSongProps || { _gift_send_enabled: 'no' });
            });
          }

          const niceName = titleCaseName(childName);
          const possessive = niceName ? (niceName.endsWith('s') ? niceName + "'" : niceName + "'s") : 'their';
          const buyName = niceName ? possessive : 'Their';

          overlay.querySelector('#ttscTitle').textContent = pt('confirmTitle')
            ? PT_ES.confirmTitle(!!niceName)
            : `Here's ${niceName ? possessive : 'their'} full song 🎵`;
          overlay.querySelector('#ttscBuy').textContent = pt('confirmBuyBtn')
            ? PT_ES.confirmBuyBtn(buyName)
            : `🎵 Get ${buyName} Song →`;
          overlay.querySelector('#ttscExplain').innerHTML =
            pt('confirmExplain') ||
            `This is the exact song we'll send you — <b>the lyrics can't be changed after purchase.</b> Give it one last read, and if you'd like any changes, just make a new preview first. 💛`;

          overlay.classList.add('tt-open');

          const lyricsBox = overlay.querySelector('#ttscLyrics');
          lyricsBox.innerHTML = `<div class="ttsc-loading">Loading the full song…</div>`;
          fetch(`${WORKER_BASE}/status-by-code?code=${encodeURIComponent(code)}`, { cache: 'no-store' })
            .then((r) => r.json())
            .catch(() => ({}))
            .then((data) => {
              const lyrics = String((data && (data.lyrics || (data.fields && data.fields.lyrics))) || '').trim();
              lyricsBox.innerHTML = lyrics
                ? renderLyricsHtml(lyrics)
                : `<div class="ttvc-line">${pt('confirmFallbackLyrics') || 'Your personalized song is ready 🎵'}</div>`;
            })
            .catch(() => {
              lyricsBox.innerHTML = `<div class="ttvc-line">${
                pt('confirmFallbackLyrics') || 'Your personalized song is ready 🎵'
              }</div>`;
            });
        }

        function handleBuySongClick(e) {
          if (e && e.preventDefault) e.preventDefault();
          if (!code) return alert(pt('missingCodeAlert') || 'Missing preview code. Please refresh.');
          confirmThenBuySong({ _gift_send_enabled: 'no', Starring: titleCaseName(childName) || '' });
        }
        if (btnSong) btnSong.addEventListener('click', handleBuySongClick);

            // ── Make-the-movie flow: builder only → character ready → big reveal (song replays) → buy ──
        function ttStartCharacterForMovie(opts) {
          opts = opts || {};
          window.ttBuildingForMovie = true;
          window.ttCharacterRevealPending = true;
          window.ttCastAutoShown = false;
          window.ttPosterBefore = window.ttPoster1 || ''; // posters made before the character don't show them
          const cb = document.getElementById('ttCharBuilder');
          if (!cb) { window.location.href = '/pages/pick-your-character?code=' + encodeURIComponent(code); return; }
          try { const a = document.getElementById('ttAudio'); if (a) a.pause(); } catch (e) {}
          if (!opts.early) document.documentElement.classList.add('tt-building'); // during the intro, keep the video on screen
          const nmS = titleCaseName(childName);
          const possS = nmS ? (nmS.endsWith('s') ? nmS + "'" : nmS + "'s") : 'their';
          if (elTitle) elTitle.textContent = ttLang === 'es'
            ? (nmS ? 'Crea el personaje de ' + nmS : 'Crea su personaje')
            : 'Create ' + possS + ' character';
          if (elSub) elSub.textContent = ttLang === 'es'
            ? 'Sube una foto o diséñalo. Luego verás su película.'
            : "Upload a photo or design them.";
          cb.style.setProperty('display', 'block', 'important');
          cb.style.visibility = 'visible';
          cb.style.opacity = '1';
          ['ttWaitNext', 'ttNextSteps'].forEach((id) => { const el = document.getElementById(id); if (el) el.remove(); });
           // After the song: land on the builder. During the intro: stay put, the video tells them to look below
          if (!opts.early) setTimeout(() => {
            try { window.scrollTo({ top: Math.max(0, cb.getBoundingClientRect().top + window.pageYOffset - 10), behavior: 'smooth' }); } catch (e) {}
          }, 120);
          ttWatchForCast();
        }

        // "Ready" = they approved the character or finished the outfit, and no upload/family step is open
        document.addEventListener('click', (e) => {
          if (e.target.closest && e.target.closest('#ttCharbApproveBtn')) window.ttCharApprovedClick = true;
        }, true);
        document.addEventListener('ttCharacterDressed', () => { window.ttCharDressed = true; });
        function ttCharacterIsReady() {
          return !!window.savedCharacterUrl && !!window.ttCharacterApproved;
        }
        function ttBuilderBusy() {
          return !!document.querySelector('.tt-dressing-loading, .ttq-saved.working, .ttq-reveal-portrait.working, #ttLikenessUpload, #ttCastNotice, .tte-ov');
        }
        function ttWatchForCast() {
          if (window.ttCastWatch) return;
          let calm = 0;
          window.ttCastWatch = setInterval(() => {
            if (!window.ttBuildingForMovie || !ttCharacterIsReady()) { calm = 0; return; }
            if (document.getElementById('ttSS')) return;
            // If the builder shows its own approve button, wait for them to tap it
            const approveBtn = document.getElementById('ttCharbApproveBtn');
            const approveShowing = !!approveBtn && approveBtn.offsetParent !== null;
            if (approveShowing && !window.ttCharApprovedClick) { calm = 0; return; }
            // They chose "Try another photo": wait for the new character, not the one they rejected
            if (window.ttRejectedCharUrl && window.savedCharacterUrl === window.ttRejectedCharUrl) { calm = 0; return; }
            calm = ttBuilderBusy() ? 0 : calm + 1;
            if (calm >= 2 && !window.ttCastAutoShown) {
              window.ttCastAutoShown = true;
              ttRevealCharacter(); // opens the dark card: "Does this look like Sienna?" first, then "add yourself"
            }
          }, 1000);
        }
        // The cast step starts only after they see and approve their character (ttWatchForCast)
        document.addEventListener('ttCharacterFailed', ttCancelTakeover);
        function ttCancelTakeover() {
          const p = document.getElementById('ttPremiere');
          if (p) p.remove();
          window.ttTakeoverStarted = false;
          window.ttCastAutoShown = false;
          document.documentElement.classList.add('tt-building');
          const cb = document.getElementById('ttCharBuilder');
          if (cb) cb.style.setProperty('display', 'block', 'important');
        }
        function ttRevealCharacter() {
          if (window.ttTakeoverStarted) return;
          window.ttTakeoverStarted = true;
          document.documentElement.classList.remove('tt-building');
          const cb = document.getElementById('ttCharBuilder');
          if (cb) cb.style.setProperty('display', 'none', 'important');
          window.ttCharacterRevealPending = false;
          const songDone = !!window.ttSongDone;
          // Approved → "add yourself" → back to the show (the poster makes itself in the background)
          ttPosterTakeover(() => {
            window.ttBuildingForMovie = false;
            window.ttMakingCast = false;
            if (songDone) ttShowSimpleOffer();
            else ttBackToIntro();
          }, { early: true });
        }
        function ttBackToIntro() {
          setCTAName();
          if (!previewReady && elSub) elSub.textContent = ttLang === 'es' ? 'Su canción está casi lista.' : 'Their song is almost ready. Enjoy the show!';
          // Wait until the card is gone, then glide back to whichever video is on screen
          setTimeout(() => {
            const introVisible = !introFinished && elIntroVideoWrap && elIntroVideoWrap.offsetParent !== null;
            const target = introVisible ? elIntroVideoWrap : document.getElementById('ttMediaStage');
            try {
              if (target) {
                const r = target.getBoundingClientRect();
                const vh = window.innerHeight;
                const top = r.height > vh - 24
                  ? r.top + window.pageYOffset - 12
                  : r.top + window.pageYOffset - (vh - r.height) / 2; // video centered on the phone
                window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
              }
            } catch (e) {}
          }, 500);
        }

        // "Making their poster…" until the poster with their character is ready,
        // then the poster full-screen with the song for ~10 seconds, then the offer
         function ttPosterTakeover(onDone, opts) {
          opts = opts || {};
          const es = ttLang === 'es';
          const nmP = titleCaseName(childName) || (es ? 'su estrella' : 'your star');
          const possP = nmP.endsWith('s') ? nmP + "'" : nmP + "'s";
          if (!document.getElementById('ttPremiereStyles')) {
            const st = document.createElement('style');
            st.id = 'ttPremiereStyles';
            st.textContent = [
              '#ttPremiere{position:fixed;inset:0;z-index:100001;background:radial-gradient(80% 60% at 50% 20%,#2b3160 0%,#0b0f1f 75%);display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;transition:opacity .4s ease;font-family:Nunito,sans-serif;color:#fff;text-align:center}',
              '#ttPremiere.on{opacity:1}',
              '.ttpm-load{display:flex;flex-direction:column;align-items:center;gap:12px}',
              '.ttpm-spin{width:54px;height:54px;border-radius:50%;border:4px solid rgba(246,210,122,.25);border-top-color:#f6d27a;animation:ttpmSpin .9s linear infinite}',
              '@keyframes ttpmSpin{to{transform:rotate(360deg)}}',
              '.ttpm-load b{font-family:Fraunces,Georgia,serif;font-size:22px;font-weight:600}',
              '.ttpm-load small{font-size:13px;font-weight:700;color:rgba(255,255,255,.55);margin-top:6px}',
              '.ttpm-steps{list-style:none;margin:8px 0 0;padding:0;display:flex;flex-direction:column;gap:10px;text-align:left}',
              '.ttpm-steps li{display:flex;align-items:center;gap:10px;font-size:15px;font-weight:800;color:rgba(255,255,255,.35);transition:color .3s}',
              '.ttpm-steps li i{display:flex !important;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;border:2px solid rgba(255,255,255,.25);font-style:normal;font-size:11px;flex-shrink:0;box-sizing:border-box}',
              '.ttpm-steps li.active{color:#fff}',
              '.ttpm-steps li.active i{border-color:#f6d27a;border-top-color:transparent;animation:ttpmSpin .9s linear infinite}',
              '.ttpm-steps li.done{color:rgba(255,255,255,.75)}',
              '.ttpm-steps li.done i{background:#f6d27a;border-color:#f6d27a;color:#151a33;animation:none}',
              '.ttpm-steps li.done i:after{content:"✓";font-weight:900}',
              '.ttpm-show{display:none;flex-direction:column;align-items:center;gap:12px}',
              '#ttPremiere.show .ttpm-load{display:none}',
              '#ttPremiere.show .ttpm-show{display:flex}',
              '.ttpm-show small{font-size:12px;font-weight:900;letter-spacing:.3em;color:#f6d27a}',
              '.ttpm-poster{width:min(78vw,360px);max-height:62vh;aspect-ratio:2/3;object-fit:cover;border-radius:12px;border:5px solid #fff;box-shadow:0 0 0 2px #f6d27a,0 30px 70px rgba(0,0,0,.6),0 0 90px rgba(246,210,122,.35);animation:ttpmIn 1s cubic-bezier(.2,1.3,.4,1) both}',
              '@keyframes ttpmIn{from{opacity:0;transform:scale(.7) rotate(-3deg)}to{opacity:1;transform:none}}',
              '.ttpm-show b{font-family:Fraunces,Georgia,serif;font-style:italic;font-size:26px;font-weight:600}',
              '.ttpm-next{margin:-4px 0 2px;max-width:320px;font-size:14px;font-weight:700;line-height:1.45;color:rgba(255,255,255,.72)}',
              '.ttpm-skip{margin-top:4px;background:none;border:1px solid rgba(255,255,255,.35);color:#fff;border-radius:999px;padding:10px 20px;font-family:Nunito,sans-serif;font-size:14px;font-weight:900;cursor:pointer}',
              // "Starring … and featuring" family screen
              '.ttpm-cast{display:none;flex-direction:column;align-items:center;gap:10px;width:100%;max-width:420px;max-height:100%;overflow-y:auto}',
              '#ttPremiere.cast .ttpm-show{display:none}',
              '#ttPremiere.cast .ttpm-cast{display:flex;animation:ttpmFade .7s ease both}',
              '@keyframes ttpmFade{from{opacity:0}to{opacity:1}}',
              '.ttpm-cast>small{font-size:12px;font-weight:900;letter-spacing:.3em;color:#f6d27a}',
              '.ttpm-star{width:132px;height:132px;border-radius:50%;overflow:hidden;background:#fff;border:4px solid #fff;box-shadow:0 0 0 3px #f6d27a,0 18px 44px rgba(0,0,0,.5),0 0 60px rgba(246,210,122,.35)}',
              '.ttpm-star img{display:block;width:100%;height:100%;object-fit:cover;object-position:50% 12%;transform:scale(1.15);transform-origin:50% 15%}',
              '.ttpm-star-name{font-family:Fraunces,Georgia,serif;font-size:26px;font-weight:600}',
              '.ttpm-feat{margin-top:-4px;font-family:Fraunces,Georgia,serif;font-style:italic;font-size:17px;color:rgba(255,255,255,.7)}',
              '.ttpm-cast-list{display:flex;flex-direction:column;gap:8px;width:100%}',
              '.ttpm-c{display:flex;align-items:center;gap:12px;padding:10px 14px;border-radius:16px;background:rgba(255,255,255,.06);border:1.5px dashed rgba(246,210,122,.55);text-align:left;opacity:0;animation:ttpmCIn .5s ease forwards}',
              '@keyframes ttpmCIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
              '.ttpm-c-dot{display:flex !important;align-items:center;justify-content:center;width:44px;height:44px;flex-shrink:0;border-radius:50%;border:2px dashed rgba(246,210,122,.8);font-family:Fraunces,Georgia,serif;font-size:20px;font-weight:600;color:#f6d27a}',
              '.ttpm-c-tx{flex:1;min-width:0;display:flex;flex-direction:column}',
              '.ttpm-c-tx b{font-size:16px;font-weight:900;color:#fff}',
              '.ttpm-c-tx small{font-size:12px;font-weight:800;color:rgba(255,255,255,.55)}',
              '.ttpm-c-plus{display:flex !important;align-items:center;justify-content:center;width:28px;height:28px;flex-shrink:0;border-radius:50%;background:#f6d27a;color:#151a33;font-size:18px;font-weight:900}',
              '.ttpm-cast-note{margin:4px 0 0;max-width:330px;font-size:13.5px;font-weight:700;line-height:1.5;color:rgba(255,255,255,.75)}',
              '@media (prefers-reduced-motion:reduce){.ttpm-c{animation:none;opacity:1}}',
              // Family screen: only it shows, as one clean centered card
              '#ttPremiere.cast > :not(.ttpm-cast){display:none !important}',
              '.ttpm-cast{box-sizing:border-box;padding:22px 18px 20px;border-radius:24px;background:rgba(255,255,255,.05);border:1px solid rgba(246,210,122,.25);box-shadow:0 30px 70px rgba(0,0,0,.45);max-height:calc(100vh - 40px);margin:auto}',
                 '.ttpm-cast *{box-sizing:border-box}',
              // "Add yourself" on the making-their-character screen
              // Centered on screen, but scrolls if the photo step gets taller than the screen
              '#ttPremiere.selfing{overflow-y:auto}',
              '#ttPremiere.selfing .ttpm-load{margin:auto 0;padding:12px 0}',
              '#ttPremiere.selfing .ttpm-steps,#ttPremiere.selfing .ttpm-load > small{display:none}',
              '#ttPremiere.selfing .ttpm-spin{width:36px;height:36px;border-width:3px}',
              '#ttPremiere.selfing .ttpm-load > b{font-size:18px;color:rgba(255,255,255,.75)}',
              // The white photo card: no cast-page header, a real title, tidy spacing
              '.ttpm-self-panel{padding:18px 16px 14px !important;border-radius:20px !important;box-shadow:0 20px 50px rgba(0,0,0,.35)}',
              '.ttpm-self-panel > label{margin-bottom:10px !important;text-align:center;font-family:Fraunces,Georgia,serif;font-size:21px !important;font-weight:600 !important;color:#151a33}',
              '.ttpm-self-panel .ttic-card > :first-child{display:none !important}',
              '.ttpm-self-panel .ttic-card{margin-top:0 !important}',
              '.ttpm-self-note{text-align:center}',
              '.ttpm-selfask{width:100%;max-width:380px;margin-top:18px;padding:18px 16px;border-radius:20px;background:rgba(255,255,255,.06);border:1px solid rgba(246,210,122,.35);text-align:center}',
              '.ttpm-selfask h3{margin:0 0 6px;font-family:Fraunces,Georgia,serif;font-size:21px;font-weight:600;color:#fff;line-height:1.2}',
              '.ttpm-selfask p{margin:0 0 14px;font-size:13.5px;font-weight:700;line-height:1.45;color:rgba(255,255,255,.72)}',
              '.ttpm-selfask .yes{display:block;width:100%;min-height:52px;border:none;border-radius:14px;background:linear-gradient(135deg,#ffe9a8,#f6d27a 45%,#efb646);color:#151a33;font-family:Nunito,sans-serif;font-size:16px;font-weight:900;cursor:pointer}',
              '.ttpm-selfask .no{display:block;width:100%;margin-top:6px;padding:10px;border:none;background:none;color:rgba(255,255,255,.72);font-family:Nunito,sans-serif;font-size:14px;font-weight:800;text-decoration:underline;cursor:pointer}',
              '.ttpm-self-panel{width:100%;padding:14px;border-radius:18px;background:#fff;color:#151a33;text-align:left}',
              '.ttpm-self-panel label{display:block;margin-bottom:6px;font-size:13.5px;font-weight:900}',
              '.ttpm-self-row{display:flex;gap:8px}',
              '.ttpm-self-row input{flex:1;min-width:0;min-height:46px;padding:0 12px;border-radius:12px;border:1.5px solid rgba(21,26,51,.15);font-family:Nunito,sans-serif;font-size:16px;font-weight:700;color:#151a33}',
              '.ttpm-self-row button{min-height:46px;padding:0 16px;border:none;border-radius:12px;background:#151a33;color:#fff;font-family:Nunito,sans-serif;font-size:14.5px;font-weight:900;cursor:pointer}',
              '.ttpm-self-panel .ttic-card{border:none;padding:0;margin-top:8px;background:#fff}',
              '.ttpm-self-note{margin-top:8px;font-size:12px;font-weight:700;color:#7a8394}',
              '.ttpm-self-picks{display:flex;flex-wrap:wrap;gap:8px}',
              '.ttpm-self-picks button{min-height:44px;padding:0 14px;border-radius:999px;border:1.5px solid rgba(21,26,51,.15);background:#fff;font-family:Nunito,sans-serif;font-size:14.5px;font-weight:900;color:#151a33;cursor:pointer}',
              '.ttpm-self-picks button:last-child{border-style:dashed;color:#5b6475}',
              '.ttpm-c-dot img{width:100%;height:100%;object-fit:cover;object-position:50% 8%;border-radius:50%}',
              '.ttpm-c.done .ttpm-c-dot{border:2px solid #f6d27a;overflow:hidden}',
              // Tap a family row: + pops, row lights up, "free after checkout" glows gold
              '.ttpm-c{cursor:pointer;-webkit-tap-highlight-color:transparent;transition:border-color .3s,background .3s}',
              '.ttpm-c.lit{border-style:solid;border-color:#f6d27a;background:rgba(246,210,122,.12)}',
              '.ttpm-c.lit .ttpm-c-tx small{color:#f6d27a}',
              '.ttpm-c-plus.nudge{animation:ttpmPop .55s ease}',
              '.ttpm-c-tx small.nudge{animation:ttpmFlash 1.4s ease}',
              '@keyframes ttpmPop{0%{transform:scale(1) rotate(0)}30%{transform:scale(1.3) rotate(-14deg)}60%{transform:scale(1.15) rotate(10deg)}100%{transform:scale(1) rotate(0)}}',
              '@keyframes ttpmFlash{0%{opacity:.4}40%{opacity:1}100%{opacity:1}}',
              // Movie stage (after the poster)
              '.ttpm-vid{display:none;flex-direction:column;align-items:center;gap:12px;width:100%}',
              '#ttPremiere.vid .ttpm-show{display:none}',
              '#ttPremiere.vid .ttpm-vid{display:flex;animation:ttpmFade .7s ease both}',
              '@keyframes ttpmFade{from{opacity:0}to{opacity:1}}',
              '.ttpm-frame{position:relative;width:min(94vw,760px);aspect-ratio:16/9;border-radius:14px;overflow:hidden;background:#000;border:4px solid #fff;box-shadow:0 0 0 2px #f6d27a,0 30px 70px rgba(0,0,0,.6)}',
              '.ttpm-frame video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}',
              '.ttpm-char{position:absolute;left:4%;top:8%;width:32%;height:84%;object-fit:contain;object-position:bottom center;filter:drop-shadow(0 10px 22px rgba(0,0,0,.35));opacity:0;transform:translateY(10px) scale(.97);transition:opacity 1.1s ease,transform 1.1s cubic-bezier(.22,1,.36,1)}',
              '.ttpm-char.on{opacity:1;transform:none}',
              '.ttpm-vid b{font-family:Fraunces,Georgia,serif;font-style:italic;font-size:24px;font-weight:600}',
            ].join('');
            document.head.appendChild(st);
          }
          const pmSteps = es
            ? ['Estudiando el look de ' + nmP, 'Pintando su sonrisa', 'Igualando cabello y ojos', 'Preparando a ' + nmP + ' para la cámara', 'Últimos detalles ✨']
            : ['Studying ' + possP + ' look', 'Painting ' + possP + ' smile', 'Matching hair & eye color', 'Getting ' + nmP + ' camera-ready', 'Adding the final touches ✨'];
          const ov = document.createElement('div');
          ov.id = 'ttPremiere';
          ov.innerHTML =
            '<div class="ttpm-load"><div class="ttpm-spin" style="display:block !important"></div>' +
              '<b>' + (es ? 'Creando el personaje de ' + nmP + '…' : 'Making ' + possP + ' character…') + '</b>' +
              '<ul class="ttpm-steps">' + pmSteps.map((s) => '<li><i></i>' + s + '</li>').join('') + '</ul>' +
              '<small>' + (es ? 'Toma alrededor de un minuto' : 'This takes about a minute') + '</small></div>' +
            '<div class="ttpm-show"><small>' + (es ? '🎬 EL PÓSTER DE LA PELÍCULA DE ' + nmP.toUpperCase() : '🎬 ' + possP.toUpperCase() + ' MOVIE POSTER') + '</small>' +
               '<img class="ttpm-poster" alt="">' +
              '<b>' + (es ? 'Protagonizada por ' : 'Starring ') + nmP + '</b>' +
              '<p class="ttpm-next">' + (es ? 'A continuación: un vistazo a cómo se verá la película de ' + nmP : 'Up next: a peek at what ' + possP + ' movie will look like') + '</p>' +
              '<button type="button" class="ttpm-skip">' + (es ? 'Continuar →' : 'Continue →') + '</button></div>' +
            '<div class="ttpm-vid"><div class="ttpm-frame">' +
              '<video muted playsinline webkit-playsinline loop preload="auto"></video><img class="ttpm-char" alt=""></div>' +
              '<b>' + (es ? 'Protagonizada por ' : 'Starring ') + nmP + '</b>' +
              '<button type="button" class="ttpm-skip">' + (es ? 'Continuar →' : 'Continue →') + '</button></div>';
          document.body.appendChild(ov);
          requestAnimationFrame(() => ov.classList.add('on'));
          if (opts.early) {
            // Sits right under the video, where the builder was, instead of covering the screen
            if (!document.getElementById('ttPremiereInlineStyles')) {
              const si = document.createElement('style');
              si.id = 'ttPremiereInlineStyles';
              si.textContent =
                '#ttPremiere.inline{position:relative;inset:auto;z-index:5;max-width:560px;margin:14px auto 0;padding:24px 16px;border-radius:22px;box-shadow:0 18px 40px -20px rgba(11,15,31,.6)}' +
                '#ttPremiere.inline.selfing{overflow:visible}';
              document.head.appendChild(si);
            }
            ov.classList.add('inline');
            const cbA = document.getElementById('ttCharBuilder');
            if (cbA && cbA.parentNode) cbA.after(ov);
            // Center the card on screen (no jump up to the video first); again once images have loaded
            ov._focus = () => {
              try {
                const r = ov.getBoundingClientRect();
                const vh = window.innerHeight;
                const top = r.height > vh - 24
                  ? r.top + window.pageYOffset - 12
                  : r.top + window.pageYOffset - (vh - r.height) / 2;
                window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
              } catch (e) {}
            };
            setTimeout(ov._focus, 150);
            setTimeout(ov._focus, 700);
            const lb = ov.querySelector('.ttpm-load > b');
            if (lb) lb.textContent = es ? '¡' + nmP + ' está lista! ✨' : nmP + "'s character is ready! ✨";
          }
          // Tick through the checklist; the last step stays "in progress" until the poster is ready
          const stepEls = ov.querySelectorAll('.ttpm-steps li');
          let stepI = 0;
          if (stepEls[0]) stepEls[0].classList.add('active');
          const stepTimer = setInterval(() => {
            if (!ov.isConnected || ov.classList.contains('show')) { clearInterval(stepTimer); return; }
            const charReady = !!(window.ttCharacterApproved && window.savedCharacterUrl);
            const cap = charReady ? stepEls.length - 1 : stepEls.length - 2;
            if (stepI >= cap) return;
            stepEls[stepI].classList.remove('active');
            stepEls[stepI].classList.add('done');
            stepI++;
            stepEls[stepI].classList.add('active');
          }, 4500);

              let finished = false, showTimer = null;
          const POSTER_SECONDS = 15; // 1. their poster, song starts
          const CAST_SECONDS = 15;   // 2. family who can join the movie (only when the song names someone)
          const MOVIE_SECONDS = 15;  // 3. their movie player on the page
                                     // 4. then the offer, which stays up after the song ends

          // Family for the "and featuring" screen, gathered when the poster finishes (not before it's loaded)
          const castLabel = (e) => (typeof e === 'string' ? e : (e && (e.label || e.name)) || '');
          const castFromPage = () =>
            ((window.ttDetectedCast && window.ttDetectedCast.length ? window.ttDetectedCast : window.ttAllCastEntities) || []).map(castLabel);
          const castFromRecord = (f) => {
            let ents = f.detected_entities || '';
            if (typeof ents === 'string') { try { ents = JSON.parse(ents); } catch (e) { ents = ents.split(','); } }
            let out = Array.isArray(ents) ? ents.map(castLabel) : [];
            // Fallback: the family they added on the form ("Family and pets to include: Nana – baking… . Max the dog – …")
            if (!out.some((n) => String(n).trim())) {
              const m = String(f.other_details || '').match(/Family and pets to include:\s*([\s\S]*)$/i);
              if (m) out = m[1].split(/\.\s+/).map((s) => s.split(' – ')[0].replace(/\s*\([^)]*\)/g, '').replace(/^our pet\s+/i, ''));
            }
            return out;
          };
          const cleanCast = (names) => {
            const seen = {};
            const kid = String(childName || '').trim().toLowerCase();
            return names
              .map((n) => String(n || '').trim().replace(/\.$/, ''))
              .filter((n) => {
                const k = n.toLowerCase();
                if (!n || n.length > 30 || k === kid || seen[k]) return false;
                seen[k] = true;
                return true;
              })
              .slice(0, 5);
          };

          const openOffer = () => {
            clearTimeout(showTimer);
            if (!document.getElementById('ttSS')) onDone(); // song keeps playing behind it
          };

          // 3. → the real movie player on the page, filling the screen
          const finish = () => {
            if (opts.early) { if (!finished) closeEarly(); return; } // during the intro: close the card, back to the video
            if (finished) return;
            finished = true;
            clearTimeout(showTimer);
            ttTrack('pv_movie_stage_on');
            const bg = document.getElementById('ttBlurBg');
            if (bg) { try { bg.currentTime = 0; } catch (e) {} }
            const gr = document.getElementById('ttGiftReveal');
            if (gr) {
              gr.click(); // starts the player exactly like tapping play: video, character, lyrics
            } else {
              const wrapV = document.getElementById('ttPreviewVideoWrap');
              if (wrapV) wrapV.style.display = 'block';
              if (bg) bg.play().catch(() => {});
            }
            { const tp0 = document.querySelector('#ttStageHero .tt-tap-play'); if (tp0) tp0.remove(); }
            if (window.ttFrameStage) window.ttFrameStage();
            ov.style.transition = 'opacity .6s ease';
            ov.classList.remove('on');
            setTimeout(() => ov.remove(), 650);
            ttShowCastBar(); // their way to the offer sooner
            // Let the demo (their character over the example) play first.
            // Only if the song is still playing with time left, wait for its last 10 seconds instead.
            const songEl = document.getElementById('ttAudio');
            const lim = typeof PREVIEW_LIMIT === 'number' && PREVIEW_LIMIT > 0 ? PREVIEW_LIMIT : 60;
            const songT = songEl ? songEl.currentTime || 0 : lim;
            if (!songEl || songEl.paused || songEl.ended || songT >= lim - 12) {
              showTimer = setTimeout(openOffer, MOVIE_SECONDS * 1000); // full demo, then the offer
            } else {
              const offerWatch = setInterval(() => {
                if (document.getElementById('ttSS')) { clearInterval(offerWatch); return; }
                const t = songEl.currentTime || 0;
                if (songEl.ended || songEl.paused || t >= lim - 10) { clearInterval(offerWatch); openOffer(); }
              }, 500);
            }
          };

          // 2. "Starring … and featuring" screen with an empty spot for each family member
          const escP = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
          const castEl = document.createElement('div');
          castEl.className = 'ttpm-cast';
          castEl.innerHTML =
            '<small>' + (es ? '✨ EN LA PELÍCULA ✨' : '✨ STARRING IN THE MOVIE ✨') + '</small>' +
            '<div class="ttpm-star" style="display:block !important"><img alt="" src="' + escP(window.savedCharacterUrl || '') + '"></div>' +
            '<b class="ttpm-star-name">' + escP(nmP) + ' ⭐</b>' +
            '<em class="ttpm-feat">' + (es ? 'junto a' : 'and featuring') + '</em>' +
            '<div class="ttpm-cast-list"></div>' +
            '<p class="ttpm-cast-note">' + (es
              ? 'Después de comprar, sube una foto de cada uno y saldrán junto a ' + escP(nmP) + '. Gratis.'
              : 'After purchase, upload a photo of each one and they\'ll star right alongside ' + escP(nmP) + '. Free.') + '</p>' +
            '<button type="button" class="ttpm-skip">' + (es ? 'Continuar →' : 'Continue →') + '</button>';
          ov.appendChild(castEl);
          castEl.querySelector('.ttpm-skip').addEventListener('click', finish);

            const toCast = () => {
            if (finished || ov.classList.contains('cast') || ov.dataset.castLoading) return;
            clearTimeout(showTimer);
            ov.dataset.castLoading = '1';
            const go = (names) => {
              if (finished || !ov.isConnected) return;
              names = cleanCast(names);
              if (!names.length && !(window.ttSelfPick && window.ttSelfPick.label)) { finish(); return; } // nobody to feature → straight to the movie
              const starImg = castEl.querySelector('.ttpm-star img');
              if (starImg && window.savedCharacterUrl) starImg.src = window.savedCharacterUrl; // their final character
              // The person who added themselves shows as already in; "someone else" gets their own row at the top
              const me = window.ttSelfPick;
              if (me && me.label && !names.some((n) => n.toLowerCase() === me.label.toLowerCase())) names = [me.label].concat(names).slice(0, 5);
              castEl.querySelector('.ttpm-cast-list').innerHTML = names.map((n, i) => {
                const isMe = !!(me && me.label && n.toLowerCase() === me.label.toLowerCase());
                return '<div class="ttpm-c' + (isMe ? ' done lit' : '') + '" style="animation-delay:' + (0.5 + i * 0.35).toFixed(2) + 's">' +
                  '<span class="ttpm-c-dot">' + (isMe && me.url ? '<img src="' + escP(me.url) + '" alt="">' : escP(n.charAt(0).toUpperCase())) + '</span>' +
                  '<span class="ttpm-c-tx"><b>' + escP(n) + (isMe ? (es ? ' (tú)' : ' (you)') : '') + '</b><small>' +
                    (isMe ? (es ? '✓ ¡Ya estás en la película!' : "✓ You're already in the movie!") : (es ? 'Agrégalo gratis después de comprar · solo una foto' : 'Add free after purchase · just a photo')) +
                  '</small></span>' +
                  '<span class="ttpm-c-plus">' + (isMe ? '✓' : '+') + '</span>' +
                '</div>';
              }).join('');
              const listEl = castEl.querySelector('.ttpm-cast-list');
              if (!listEl.dataset.wired) {
                listEl.dataset.wired = '1';
                listEl.addEventListener('click', (e) => {
                  const row = e.target.closest('.ttpm-c');
                  if (!row || row.classList.contains('done')) return;
                  const plus = row.querySelector('.ttpm-c-plus');
                  const note = row.querySelector('.ttpm-c-tx small');
                  row.classList.add('lit');
                  if (note) note.textContent = es ? '📸 Subirás su foto justo después de comprar' : "📸 You'll upload their photo right after purchase";
                  [plus, note].forEach((el) => {
                    if (!el) return;
                    el.classList.remove('nudge');
                    void el.offsetWidth; // restart the animation on every tap
                    el.classList.add('nudge');
                  });
                  ttTrack('pv_cast_plus_tap');
                  clearTimeout(showTimer); // give them time to read before it moves on
                  showTimer = setTimeout(finish, 12000);
                });
              }
              ov.classList.add('cast');
              ttTrack('pv_cast_screen');
              if (ov._focus) setTimeout(ov._focus, 80);
              showTimer = setTimeout(finish, CAST_SECONDS * 1000);
            };
            const onPage = cleanCast(castFromPage());
            if (onPage.length) { go(onPage); return; }
            fetch(WORKER_BASE + '/status-by-code?code=' + encodeURIComponent(code), { cache: 'no-store' })
              .then((r) => r.json())
              .catch(() => ({}))
              .then((d) => go(castFromRecord((d && d.fields) || {})));
          };
          ov.querySelector('.ttpm-show .ttpm-skip').addEventListener('click', toCast);

          // 1. Poster + song
          const show = (url) => {
            const img = ov.querySelector('.ttpm-poster');
            img.src = url;
            ov.classList.add('show');
            const song = document.getElementById('ttAudio');
            if (song) { try { song.currentTime = 0; song.volume = 1; song.play().catch(() => {}); } catch (e) {} }
            // Load the movie player behind the poster, so it's ready when its turn comes
            const bgPre = document.getElementById('ttBlurBg');
            if (bgPre) { bgPre.preload = 'auto'; try { bgPre.load(); } catch (e) {} }
            showTimer = setTimeout(toCast, POSTER_SECONDS * 1000);
          };

          // Wait for a poster made after the character (the one that shows their child), up to ~60s
          let tries = 0;
          const before = window.ttPosterBefore || '';
          let waitedForChar = 0;
          const check = () => {
            if (finished || !ov.isConnected) return;
            // Character is still being made/dressed behind this screen
            if (!(window.ttCharacterApproved && window.savedCharacterUrl)) {
              if (++waitedForChar > 80) { ttCancelTakeover(); return; } // ~2 min: something failed, so back to the builder
              setTimeout(check, 1500);
              return;
            }
            const local = window.ttPoster1;
            if (local && local !== before) return preload(local);
            fetch(WORKER_BASE + '/status-by-code?code=' + encodeURIComponent(code), { cache: 'no-store' })
              .then((r) => r.json()).catch(() => ({}))
              .then((d) => {
                const u = String(((d && d.fields) || {}).preview_poster_1 || '').trim();
                if (u && u !== before) return preload(u);
                if (++tries >= 30) return preload(window.ttPoster1 || window.savedCharacterUrl || '');
                setTimeout(check, 3000);
              });
          };
          const preload = (u) => {
            if (!u) { finish(); return; }
            window.ttPoster1 = u;
            const im = new Image();
            im.onload = () => show(u);
            im.onerror = () => show(window.savedCharacterUrl || u);
                 im.src = u;
          };

          // ── "Add yourself" test (half of previews): asked while their character is "being made";
          //    the poster starts only after they add themselves (poster with both) or say no thanks (normal poster)
          // "Add yourself" for everyone (the poster waits for their choice)
          const ttSelfOn = !!window.TTCast;
          window.ttSelfTest = ttSelfOn;
          // Early mode: start their poster in the background so it's ready for the end of the song
          const startPostersBg = (selfKey, selfLabel) => {
            fetch(WORKER_BASE + '/start-posters', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ code, self_key: selfKey || '', self_label: selfLabel || '' }),
            }).catch(() => {});
            const beforeBg = window.ttPosterBefore || '';
            let n = 0;
            const pt2 = setInterval(() => {
              if (++n > 60) { clearInterval(pt2); return; }
              fetch(WORKER_BASE + '/status-by-code?code=' + encodeURIComponent(code), { cache: 'no-store' })
                .then((r) => r.json()).catch(() => ({}))
                .then((d) => {
                  const u = String(((d && d.fields) || {}).preview_poster_1 || '').trim();
                  if (u && u !== beforeBg) { clearInterval(pt2); window.ttPosterReady = u; const im = new Image(); im.src = u; } // held back until the song ends
                });
            }, 4000);
          };
          const closeEarly = () => {
            finished = true;
            ov.classList.remove('on');
            setTimeout(() => ov.remove(), 400);
            onDone();
          };
          if (!ttSelfOn && opts.early) { startPostersBg('', ''); toCast(); return; }
          if (!ttSelfOn) {
            // Character tool didn't load → just make the normal poster
            fetch(WORKER_BASE + '/start-posters', {
              method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code }),
            }).catch(() => {});
            check();
            return;
          }

          const startPosters = (selfKey, selfLabel) => {
            // Start the poster only once their child's character is approved (it's still being made while they add themselves)
            const send = () => {
              if (finished || !ov.isConnected) return;
              if (!(window.ttCharacterApproved && window.savedCharacterUrl)) { setTimeout(send, 800); return; }
              fetch(WORKER_BASE + '/start-posters', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code, self_key: selfKey || '', self_label: selfLabel || '' }),
              }).catch(() => {});
            };
            send();
            check(); // the usual "wait for the poster, then show it" (it also waits for the character)
          };
          const askSelf = () => {
            if (finished || !ov.isConnected) return;
            const load = ov.querySelector('.ttpm-load');
            const loadB = load && load.querySelector('b');
            if (!load) { check(); return; }
            ov.classList.add('selfing');
            const panel = document.createElement('div');
            panel.className = 'ttpm-selfask';
            const decide = (key, label) => {
              panel.remove();
              ov.classList.remove('selfing');
              if (opts.early) { startPostersBg(key, label); toCast(); return; } // next: the family who can join after checkout
              if (loadB) loadB.textContent = es ? 'Creando el póster…' : key ? 'Making your poster together…' : 'Making ' + possP + ' poster…';
              startPosters(key, label);
            };
            panel.innerHTML =
              '<h3>' + (es ? '⭐ ¿Quieres salir en la película de ' + escP(nmP) + '?' : '⭐ Want to be in ' + escP(possP) + ' movie too?') + '</h3>' +
              '<p>' + (es ? 'Agrégate y saldrás en el póster con ' + escP(nmP) + '. Toma unos 30 segundos.'
                         : "Add yourself and you'll be on the poster with " + escP(nmP) + '. Takes about 30 seconds.') + '</p>' +
              '<button type="button" class="yes">' + (es ? 'Sí, agrégame' : 'Yes, add me') + '</button>' +
              '<button type="button" class="no">' + (es ? 'No gracias, ver el póster' : 'No thanks, maybe later') + '</button>';
            load.appendChild(panel);
            panel.querySelector('.no').addEventListener('click', () => { ttTrack('pv_self_no'); decide('', ''); });
                      panel.querySelector('.yes').addEventListener('click', () => {
              ttTrack('pv_self_open');
              // Family named in the song (people only) → "I'm Nana" buttons; anyone else types what the child calls them
              const fam = ((window.ttDetectedCast && window.ttDetectedCast.length ? window.ttDetectedCast : window.ttAllCastEntities) || [])
                .map((e) => (typeof e === 'string' ? { key: '', label: e } : e))
                .filter((e) => e && e.label && e.kind !== 'pet' && e.kind !== 'horse' && String(e.label).toLowerCase() !== String(childName || '').toLowerCase())
                .slice(0, 6);
              panel.innerHTML =
                '<div class="ttpm-self-panel">' +
                  '<label>' + (es ? '¿Quién eres?' : 'Which one are you?') + '</label>' +
                  '<div class="ttpm-self-picks">' +
                    fam.map((e, i) => '<button type="button" data-i="' + i + '">' + (es ? 'Soy ' : "I'm ") + escP(e.label) + '</button>').join('') +
                    '<button type="button" data-i="other">' + (es ? 'Otra persona' : 'Someone else') + '</button>' +
                  '</div>' +
                  '<div class="ttpm-self-row" style="display:none"><input type="text" maxlength="24" autocomplete="off" placeholder="' + (es ? 'ej. Abuela, Nana, Papá' : 'e.g. Nana, Grandpa, Mom') + '">' +
                  '<button type="button">' + (es ? 'Siguiente →' : 'Next →') + '</button></div>' +
                  '<div class="ttpm-self-note"></div>' +
                '</div>' +
                '<button type="button" class="no">' + (es ? 'Omitir, ver el póster' : 'Skip for now') + '</button>';
              panel.querySelector('.no').addEventListener('click', () => { ttTrack('pv_self_skip'); decide('', ''); });
              const box = panel.querySelector('.ttpm-self-panel');
              const picks = box.querySelector('.ttpm-self-picks');
              const rowEl = box.querySelector('.ttpm-self-row');
              const inp = rowEl.querySelector('input');
              const toKey = (s) => String(s).toLowerCase().replace(/[^a-z0-9 ]/g, '').trim();
              const proceed = (key, label, inSong) => {
                if (picks.isConnected) picks.remove();
                rowEl.remove();
                box.querySelector('.ttpm-self-note').textContent = inSong ? '' :
                  (es ? 'Saldrás en la película (la canción no cambia).' : "You'll appear in the movie (the song stays as it is).");
                box.querySelector('label').textContent = es ? 'Sube una foto tuya' : 'Add a photo of you';
                window.TTCast.styles();
                const titleEl = box.querySelector('label');
                const setText = (el, t) => { if (el && el.textContent !== t) el.textContent = t; }; // only when it changes (no loop)
                const syncTitle = (cardEl) => {
                  if (cardEl.querySelector('.ttic-review-img')) {
                    setText(titleEl, es ? '¡Aquí estás, ' + label + '! ✨' : 'Here you are, ' + label + '! ✨');
                    setText(cardEl.querySelector('.ttic-review-q'), es ? '¿Se parece a ti?' : 'Does this look like you?');
                    setText(cardEl.querySelector('[data-act="approve"]'), es ? '✓ Sí, soy yo' : '✓ Yes, this is me');
                  } else if (cardEl.querySelector('.ttic-upload-status')) {
                    setText(titleEl, es ? 'Creando tu personaje…' : 'Making your character…');
                  } else {
                    setText(titleEl, es ? 'Sube una foto tuya' : 'Add a photo of you');
                  }
                };
                setTimeout(() => {
                  const cardEl = box.querySelector('.ttic-card');
                  if (!cardEl) return;
                  syncTitle(cardEl);
                  new MutationObserver(() => syncTitle(cardEl)).observe(cardEl, { childList: true, subtree: true });
                }, 0);
                box.appendChild(window.TTCast.mountCard({ key, label, kind: 'person' }, {
                  code, allowPhoto: true, photoOnly: true, adult: true, starName: nmP,
                  onDone: (k, url) => {
                    window.ttEntityImages = Object.assign({}, window.ttEntityImages || {}, { [k]: url });
                    window.ttSelfPick = { key: k, label, url, inSong }; // the family screen shows them as already added
                    ttTrack('pv_self_added');
                    setTimeout(() => decide(k, label), 700);
                  },
                }));
              };
              picks.addEventListener('click', (ev) => {
                const b = ev.target.closest('button');
                if (!b) return;
                if (b.dataset.i === 'other') {
                  picks.remove();
                  rowEl.style.display = '';
                  box.querySelector('label').textContent = es ? '¿Cómo te llama ' + nmP + '?' : 'What does ' + nmP + ' call you?';
                  setTimeout(() => { try { inp.focus(); } catch (e) {} }, 100);
                  return;
                }
                const e = fam[+b.dataset.i];
                proceed(e.key || toKey(e.label), e.label, true);
              });
              const typed = () => {
                const raw = inp.value.trim();
                if (raw.length < 2) { inp.focus(); return; }
                const label = raw.charAt(0).toUpperCase() + raw.slice(1); // "nana" → "Nana"
                const det = fam.find((e) => String(e.label).toLowerCase() === label.toLowerCase());
                proceed(det ? det.key || toKey(det.label) : toKey(label), det ? det.label : label, !!det);
              };
              rowEl.querySelector('button').addEventListener('click', typed);
              inp.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); typed(); } });
              if (!fam.length) picks.querySelector('[data-i="other"]').click(); // no family in the song → straight to the name
            });
          };
          // During the intro: they approve their grandchild's character first, then "add yourself"
          const reviewChar = () => {
            const load = ov.querySelector('.ttpm-load');
            if (!load || !window.savedCharacterUrl) { askSelf(); return; }
            if (!document.getElementById('ttPremiereReviewStyles')) {
              const rs = document.createElement('style');
              rs.id = 'ttPremiereReviewStyles';
              rs.textContent =
                '#ttPremiere.inline{max-width:600px !important;padding:28px 18px !important}' +
                '#ttPremiere.inline.selfing .ttpm-load > b{font-size:clamp(24px,6.5vw,30px) !important;color:#f6d27a !important}' +
                '.ttpm-review{max-width:440px !important;padding:22px 18px !important}' +
                '.ttpm-review-img{display:block;width:min(72vw,280px);aspect-ratio:4/5;height:auto;object-fit:cover;object-position:center 15%;margin:0 auto 16px;border-radius:18px;border:4px solid #fff;box-shadow:0 0 0 3px #f6d27a,0 20px 44px rgba(0,0,0,.5),0 0 70px rgba(246,210,122,.3)}' +
                '.ttpm-review h3{font-size:clamp(24px,6.5vw,28px) !important;margin:0 0 16px !important}' +
                '.ttpm-review .yes{min-height:62px !important;font-size:18px !important}' +
                '.ttpm-review .no{text-decoration:none !important;margin-top:10px !important;min-height:52px;font-size:15.5px !important;border:1.5px solid rgba(255,255,255,.4) !important;border-radius:14px}';
              document.head.appendChild(rs);
            }
            ov.classList.add('selfing');
            const lb = load.querySelector('b');
            const spin = load.querySelector('.ttpm-spin');
            if (spin) spin.style.setProperty('display', 'none', 'important');
            if (lb) lb.textContent = es ? 'Aquí está ' + nmP + ' ✨' : 'Meet ' + nmP + ' ✨';
            const panel = document.createElement('div');
            panel.className = 'ttpm-selfask ttpm-review';
            panel.innerHTML =
              '<img class="ttpm-review-img" src="' + escP(window.savedCharacterUrl) + '" alt="">' +
              '<h3>' + (es ? '¿Se parece a ' + escP(nmP) + '?' : 'Does this look like ' + escP(nmP) + '?') + '</h3>' +
              '<button type="button" class="yes">' + (es ? '✓ Sí, es ' + escP(nmP) : "✓ Yes, that's " + escP(nmP)) + '</button>' +
              '<button type="button" class="no">' + (es ? '📸 Probar otra foto' : '📸 Try another photo') + '</button>';
            load.appendChild(panel);
            panel.querySelector('.yes').addEventListener('click', () => {
              ttTrack('pv_char_approved');
              window.ttCharacterApproved = true;
              // Opening scenes only if they'll be ready before the song starts, with at most a short extra wait
              const introLeft = Math.max(0, MIN_INTRO_SECONDS - introPlayed);
              if (!introFinished && !window.ttSongDone && TT_OPENING_NEED <= introLeft + TT_OPENING_MAX_HOLD) {
                fetch(WORKER_BASE + '/start-opening', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code }) }).catch(() => {});
                window.ttOpeningStarted = Date.now();
                window.ttOpeningDeadline = Date.now() + (TT_OPENING_NEED + 20) * 1000;
                ttWatchOpening();
              } else {
                ttTrack('pv_opening_skipped');
              }
              panel.remove();
              if (spin) spin.style.removeProperty('display');
              if (lb) lb.textContent = es ? '¡' + nmP + ' está lista! ✨' : nmP + "'s character is ready! ✨";
              if (ttSkipSelfOn()) { window.ttSelfTest = false; ov.classList.remove('selfing'); startPostersBg('', ''); closeEarly(); }
              else askSelf();
              if (ov._focus) setTimeout(ov._focus, 80);
            });
            panel.querySelector('.no').addEventListener('click', () => {
              ttTrack('pv_char_retry');
              window.ttRejectedCharUrl = window.savedCharacterUrl;
              finished = true;
              ov.remove();
              window.ttTakeoverStarted = false;
              window.ttCastAutoShown = false;
              const cbR = document.getElementById('ttCharBuilder');
              if (cbR) {
                cbR.style.setProperty('display', 'block', 'important');
                const fileIn = cbR.querySelector('input[type="file"]');
                if (fileIn) { try { fileIn.value = ''; fileIn.click(); } catch (e) {} } // opens their photo picker right away
                setTimeout(() => { try { cbR.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }, 100);
              }
            });
          };
          if (opts.early) reviewChar();
          else askSelf();
        }

        // Floating button so they can always get back to the offer
         function ttShowCastBar() {
          { const cb0 = document.getElementById('ttCastBar'); if (cb0) cb0.remove(); }
          return; // floating button removed: it skipped the demo and covered the page
          const nmB = titleCaseName(String(childName || '').toLowerCase());
          const possB = nmB ? (nmB.endsWith('s') ? nmB + "'" : nmB + "'s") : 'their';
          let bar = document.getElementById('ttCastBar');
          if (!bar) {
            bar = document.createElement('button');
            bar.id = 'ttCastBar';
            bar.type = 'button';
            bar.style.cssText = "position:fixed;left:50%;bottom:calc(16px + env(safe-area-inset-bottom,0px));transform:translateX(-50%);z-index:99990;padding:15px 24px;border:none;border-radius:999px;background:#151a33;color:#fff;font-family:Nunito,sans-serif;font-size:16px;font-weight:900;box-shadow:0 14px 30px rgba(21,26,51,.45);white-space:nowrap;cursor:pointer";
            bar.addEventListener('click', () => {
              if (window.savedCharacterUrl) window.ttCharacterRevealPending = true;
              ttShowSalesSheet();
            });
            document.body.appendChild(bar);
          }
          bar.textContent = window.savedCharacterUrl
            ? (ttLang === 'es' ? '🎬 Obtener su película →' : '🎬 Get ' + possB + ' movie →')
            : (ttLang === 'es' ? '💛 Hacer su película →' : '💛 Make ' + possB + ' movie →');
        }

        // ── VIDEO CTA — if no character yet, send them to the character creator page ──
        function goToVideoCheckout(e) {
  if (e && e.preventDefault) e.preventDefault();
  // Every "get their movie" button shows the offer first; only the offer's own buy button goes to checkout
  if (!(e && e.fromSheet) && window.savedCharacterId && !document.getElementById('ttSS')) {
    ttShowSalesSheet();
    return;
  }
  // Free movie on offer (or they started building for it) → show that, never the paid checkout
  if ((window.ttFreeMovieAvailable || window.ttFreeAfterCharacter) && !document.getElementById('ttSS')) {
    window.ttFreeAfterCharacter = false;
    ttShowSalesSheet();
    return;
  }
  ttTrack('pv_click_movie');
  if (!code) return alert(pt('missingCodeAlert') || 'Missing preview code. Please refresh.');
  if (!window.savedCharacterId && !window.savedCharacterUrl) { ttStartCharacterForMovie(); return; }
  const isLikeness = window.ttCharacterMode === 'photo_likeness';
  const variantId = isLikeness ? VIDEO_VARIANT_ID_LIKENESS : VIDEO_VARIANT_ID;
  setPreviewLocked(false);
  // "Featuring" line: the person who added themselves first, then family named in the song (only shown if there are any)
  const meSelf = window.ttSelfPick && window.ttSelfPick.label ? window.ttSelfPick.label : '';
  const featList = [meSelf ? meSelf + (ttLang === 'es' ? ' (tú)' : ' (you)') : '']
    .concat(ttFamilyNames().filter((n) => !meSelf || n.toLowerCase() !== meSelf.toLowerCase()))
    .filter(Boolean)
    .slice(0, 4);
  const featuring = featList.length > 1 ? featList.slice(0, -1).join(', ') + ' & ' + featList[featList.length - 1] : featList[0] || '';
  addAndCheckout(variantId, {
    _gift_send_enabled: 'no',
    _character_id: window.savedCharacterId || 'restored',
    _outfit: window.ttOutfit || '',
    _character_mode: isLikeness ? 'photo_likeness' : 'standard',
    _self_test: window.ttSelfTest === undefined ? 'na' : window.ttSelfTest ? 'on' : 'off',
    _order_drawer: window.ttDrawerTest ? 'on' : 'off',
    Starring: titleCaseName(childName) || '',
    ...(featuring ? { Featuring: featuring } : {}),
    Guarantee: ttLang === 'es' ? 'Te encanta o te devolvemos tu dinero' : 'Love it or your money back',
    Includes: ttLang === 'es'
      ? 'Su película, póster, boleto de estreno, canción completa + 2 canciones extra'
      : 'Their movie, poster, premiere ticket, full song + 2 bonus songs',
    Delivery: ttLang === 'es' ? 'Por correo' : 'Emailed to you',
    _cast_names: ((window.ttDetectedCast && window.ttDetectedCast.length ? window.ttDetectedCast : window.ttAllCastEntities) || [])
      .map(function (e) { return String(e.label || '').trim(); }).filter(Boolean).slice(0, 5).join(', '),
  });
}
        window.ttGoToVideoCheckout = goToVideoCheckout;
        if (btnVideo) btnVideo.addEventListener('click', goToVideoCheckout);

        if (modalUnlock) {
          modalUnlock.addEventListener('click', (e) => {
            e.preventDefault();
            if (!code) return alert(pt('missingCodeAlert') || 'Missing preview code. Please refresh.');
            closeModal();
            confirmThenBuySong({ _gift_send_enabled: 'no', Starring: titleCaseName(childName) || '' });
          });
        }

        if (modalVideo) {
  modalVideo.addEventListener('click', (e) => {
    e.preventDefault();
    if (!code) return alert(pt('missingCodeAlert') || 'Missing preview code. Please refresh.');
    if (!window.savedCharacterId) {
      window.location.href = '/pages/pick-your-character?code=' + encodeURIComponent(code);
      return;
    }
    goToVideoCheckout(e);
  });
}

        // After "Create character → free movie": wait until the character is done, then bring the free offer back
        function ttWaitForCharacterThenOffer() {
          if (window.ttFreeWaitTimer) return;
          let tries = 0;
          const stop = () => { clearInterval(window.ttFreeWaitTimer); window.ttFreeWaitTimer = null; };
          window.ttFreeWaitTimer = setInterval(() => {
            if (++tries > 200 || !window.ttFreeAfterCharacter) return stop(); // give up after ~10 min
            if (!window.savedCharacterUrl) return;                            // still building
            if (document.getElementById('ttSS')) return;                      // a sheet is already open
            const busy = document.querySelector('.tt-dressing-loading, .ttq-saved.working, .ttq-reveal-portrait.working, #ttLikenessUpload');
            if (busy) return;                                                 // mid-outfit or mid-upload
            fetch(WORKER_BASE + '/free-movie-status?code=' + encodeURIComponent(code), { cache: 'no-store' })
              .then((r) => r.json())
              .then((s) => {
                if (!s || !s.available || !window.ttFreeAfterCharacter || document.getElementById('ttSS')) return;
                window.ttFreeAfterCharacter = false;
                stop();
                ttShowSalesSheet();
              })
              .catch(() => {});
          }, 3000);
        }
        // Buttons under the player: get the movie / just the song (returning visitors see them right away)
        function ttShowNextStepsBar() {
          if (document.getElementById('ttNextSteps')) return;
          const stage = document.getElementById('ttMediaStage');
          if (!stage) return;
          if (!document.getElementById('ttNextStepsStyles')) {
            const st = document.createElement('style');
            st.id = 'ttNextStepsStyles';
            st.textContent =
              '#ttNextSteps{max-width:520px;margin:14px auto 0;display:flex;flex-direction:column;align-items:center;gap:4px;animation:ttnsIn .35s ease}' +
              '.ttns-go{width:100%;min-height:58px;border:none;border-radius:16px;cursor:pointer;background:#151a33;color:#fff;font-family:Nunito,sans-serif;font-size:17px;font-weight:900;box-shadow:0 14px 30px -12px rgba(21,26,51,.6)}' +
              '.ttns-go:active{transform:scale(.98)}' +
              '.ttns-song{background:none;border:none;cursor:pointer;padding:10px;font-family:Nunito,sans-serif;font-size:14.5px;font-weight:800;color:#5b6475;text-decoration:underline;text-underline-offset:3px}' +
              '@keyframes ttnsIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}';
            document.head.appendChild(st);
          }
          const es = ttLang === 'es';
          const nm = titleCaseName(String(childName || '').toLowerCase());
          const possN = nm ? (/s$/i.test(nm) ? nm + "'" : nm + "'s") : 'their';
          const songPrice = regionPrice('song') || '$9.99';
          const box = document.createElement('div');
          box.id = 'ttNextSteps';
          const charB = window.savedCharacterUrl || '';
          const priceB = regionPrice('video') || '$24.99';
          if (!document.getElementById('ttNextStepsStyles2')) {
            const s2 = document.createElement('style');
            s2.id = 'ttNextStepsStyles2';
            s2.textContent =
              '#ttNextSteps{max-width:520px;margin:16px auto 0;gap:8px}' +
              '#ttNextSteps .ttns-card{display:flex;align-items:center;gap:12px;width:100%;box-sizing:border-box;padding:12px 14px;border-radius:16px;background:#fffaf0;border:1px solid rgba(240,180,41,.3);text-align:left}' +
              '#ttNextSteps .ttns-av{flex-shrink:0;display:flex;align-items:center;justify-content:center;width:54px;height:54px;border-radius:50%;object-fit:cover;object-position:center 12%;background:#fff;border:3px solid #fff;box-shadow:0 0 0 2px #f6d27a,0 6px 14px rgba(0,0,0,.15);font-size:24px}' +
              '#ttNextSteps .ttns-tx b{display:block;font-family:Fraunces,Georgia,serif;font-size:19px;font-weight:600;line-height:1.15;color:#151a33}' +
              '#ttNextSteps .ttns-tx small{display:block;margin-top:3px;font-family:Nunito,sans-serif;font-size:13px;font-weight:700;color:#6b7280}' +
              '#ttNextSteps button.ttns-go{width:100% !important;min-height:60px !important;border:none !important;border-radius:999px !important;cursor:pointer;font-family:Nunito,sans-serif !important;font-size:18px !important;font-weight:900 !important;color:#151a33 !important;text-shadow:none !important;' +
                'background:linear-gradient(135deg,#ffe9a8 0%,#f6d27a 45%,#efb646 100%) !important;' +
                'box-shadow:0 1px 0 rgba(255,255,255,.7) inset,0 14px 28px -12px rgba(224,150,20,.7) !important}' +
              '#ttNextSteps .ttns-guar{margin:0;font-family:Nunito,sans-serif;font-size:13px;font-weight:900;color:#1e8a55}' +
              '#ttNextSteps{gap:10px !important}' +
              '#ttNextSteps button.ttns-go,#ttNextSteps button.ttns-song{display:flex !important;align-items:center;justify-content:space-between;gap:14px;width:100% !important;min-height:74px !important;padding:12px 20px !important;border-radius:18px !important;text-align:left;cursor:pointer;font-family:Nunito,sans-serif !important;text-decoration:none !important;transition:transform .15s ease}' +
              '#ttNextSteps button.ttns-go:active,#ttNextSteps button.ttns-song:active{transform:scale(.98)}' +
              '#ttNextSteps button.ttns-song{background:#fff !important;border:1.5px solid #dfe5ee !important;color:#151a33 !important;box-shadow:0 8px 20px -12px rgba(21,26,51,.35) !important}' +
              '#ttNextSteps .ttns-l{min-width:0}' +
              '#ttNextSteps .ttns-l b{display:block;font-size:17px;font-weight:900;line-height:1.2}' +
              '#ttNextSteps .ttns-l small{display:block;margin-top:3px;font-size:12.5px;font-weight:700;opacity:.7}' +
              '#ttNextSteps .ttns-p{flex-shrink:0;font-family:Fraunces,Georgia,serif;font-size:24px;font-weight:600;line-height:1}' +
              '#ttNextSteps .ttns-song .ttns-p{font-size:20px;color:#5b6475}' +
              '#ttNextSteps .ttns-guar{display:flex;align-items:center;gap:12px;width:100%;box-sizing:border-box;margin:4px 0 0;padding:12px 16px;border-radius:16px;' +
                'background:linear-gradient(135deg,#f3fbf6,#e9f6ee);border:1px solid rgba(30,138,85,.18);text-align:left}' +
              '#ttNextSteps .ttns-seal{flex-shrink:0;display:flex;align-items:center;justify-content:center;width:42px;height:42px;border-radius:50%;background:#fff;' +
                'box-shadow:0 0 0 3px rgba(30,138,85,.12),0 4px 10px rgba(30,138,85,.18)}' +
              '#ttNextSteps .ttns-gt b{display:block;font-family:Fraunces,Georgia,serif;font-size:16px;font-weight:600;letter-spacing:-.01em;color:#14532d}' +
              '#ttNextSteps .ttns-gt small{display:block;margin-top:2px;font:700 12.5px/1.35 Nunito,sans-serif;color:#3f6b52}';
            document.head.appendChild(s2);
          }
          const titleB = es ? 'La película de ' + (nm || 'su estrella') : nm ? possN + ' movie' : 'Their movie';
          box.innerHTML =

            '<button type="button" class="ttns-go">' +
              (charB
                ? '<span class="ttns-l"><b>🎬 ' + titleB + '</b><small>' + (es ? 'Película y canción completas · póster y boleto' : 'Full movie + song · poster & ticket') + '</small></span>' +
                  '<span class="ttns-p">' + priceB + '</span>'
                : (es ? '🎨 Crear su personaje →' : '🎨 Create ' + possN + ' character →')) +
            '</button>' +
            '<button type="button" class="ttns-song">' +
              '<span class="ttns-l"><b>🎵 ' + (es ? 'Solo la canción' : 'Just the song') + '</b><small>' + (es ? 'Canción completa, enviada al instante' : 'Full song, emailed instantly') + '</small></span>' +
              '<span class="ttns-p">' + songPrice + '</span>' +
            '</button>' +
            ttGuaranteeHTML();
          box.querySelector('.ttns-go').addEventListener('click', () => {
            box.remove();
            if (window.savedCharacterUrl) {
              window.ttCharacterRevealPending = false; // don't restart the song
              ttTrack('pv_click_movie');
              if (window.ttDrawerTest) ttShowOrderDrawer(); // straight to "Your order", no modal in between
              else goToVideoCheckout({ fromSheet: true });
            } else {
              ttStartCharacterForMovie();
            }
          });
          box.querySelector('.ttns-song').addEventListener('click', () => {
            ttTrack('pv_click_song');
            confirmThenBuySong({ _gift_send_enabled: 'no', Starring: titleCaseName(childName) || '' });
          });
          stage.after(box);
        }
        // The guarantee: a handwritten pinky promise with a little heart peeking over the corner
        function ttGuaranteeHTML() {
          const es = ttLang === 'es';
          if (!document.getElementById('ttG5Styles')) {
            const st = document.createElement('style');
            st.id = 'ttG5Styles';
            st.textContent = [
              '.ttg5{position:relative;width:100%;box-sizing:border-box;margin-top:16px;padding:0;text-align:center;background:none;border:0;box-shadow:none}',
              '.ttg5-k{display:block;font:900 9.5px/1 Nunito,sans-serif !important;letter-spacing:.14em;color:#e86a88;white-space:nowrap}',
              ".ttg5-h{display:block;margin:6px 0 0;font-family:'Dancing Script','Snell Roundhand','Brush Script MT',cursive !important;font-weight:700 !important;font-size:29px !important;line-height:1.1 !important;letter-spacing:.01em;color:#2a2547 !important}",
              '.ttg5-sw{display:block;width:110px;height:9px;margin:7px auto 0;opacity:.85}',
              '.ttg5-m{font:900 16px/1 Nunito,sans-serif !important;font-style:normal !important;letter-spacing:.01em;color:#2a2547;vertical-align:.18em}',
              '.ttg5-s{display:block;max-width:300px;margin:4px auto 0;font:700 11.5px/1.4 Nunito,sans-serif !important;color:#9a909a}',
              '.ttg5-heart{display:none}',
            ].join('');
            document.head.appendChild(st);
          }
          const heart =
            '<svg class="ttg5-heart" viewBox="0 0 64 58" aria-hidden="true">' +
              '<defs><linearGradient id="ttg5Pink" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ff9fb4"/><stop offset="1" stop-color="#f2627f"/></linearGradient></defs>' +
              '<path d="M32 55 C 12 42, 3 31, 3 19 C 3 9, 11 3, 19 3 C 25 3, 29 6, 32 11 C 35 6, 39 3, 45 3 C 53 3, 61 9, 61 19 C 61 31, 52 42, 32 55 Z" fill="url(#ttg5Pink)" stroke="#fff" stroke-width="3"/>' +
              '<ellipse cx="18" cy="13" rx="6" ry="3.5" fill="#fff" opacity=".45" transform="rotate(-25 18 13)"/>' +
              '<g class="ttg5-eyes" fill="#3b2433"><ellipse cx="24" cy="25" rx="2.6" ry="3.4"/><ellipse cx="40" cy="25" rx="2.6" ry="3.4"/></g>' +
              '<ellipse cx="17.5" cy="32" rx="4" ry="2.5" fill="#ff8aa5"/><ellipse cx="46.5" cy="32" rx="4" ry="2.5" fill="#ff8aa5"/>' +
              '<path d="M27 31 Q 32 36 37 31" fill="none" stroke="#3b2433" stroke-width="2.4" stroke-linecap="round"/>' +
            '</svg>';
          const swash =
            '<svg class="ttg5-sw" viewBox="0 0 200 14" aria-hidden="true">' +
              '<path d="M6 9 C 50 3, 110 2, 150 6 C 168 8, 182 9, 194 5" fill="none" stroke="#f28aa3" stroke-width="2.6" stroke-linecap="round"/>' +
            '</svg>';
          return '<div class="ttg5">' + heart +
            '<span class="ttg5-k">♡ ' + (es ? 'LA GARANTÍA 100% DE TINY TUNES' : 'THE TINY TUNES 100% GUARANTEE') + ' ♡</span>' +
            '<span class="ttg5-h">' + (es ? 'Te encanta, o te devolvemos tu dinero.' : 'Love it, or your money back.') + '</span>' +
            swash +
          '</div>';
        }

        // Family names for the offers: found in the song, else the family they added on the form
        function ttFamilyNames() {
          const label = (e) => (typeof e === 'string' ? e : (e && (e.label || e.name)) || '');
          const has = (arr) => arr.some((n) => String(n || '').trim());
          let names = ((window.ttDetectedCast && window.ttDetectedCast.length ? window.ttDetectedCast : window.ttAllCastEntities) || []).map(label);
          const f = window.ttRecFields || {};
          if (!has(names)) {
            let ents = f.detected_entities || '';
            if (typeof ents === 'string') { try { ents = JSON.parse(ents); } catch (e) { ents = ents ? ents.split(',') : []; } }
            if (Array.isArray(ents)) names = ents.map(label);
          }
          if (!has(names)) {
            const m = String(f.other_details || '').match(/Family and pets to include:\s*([\s\S]*)$/i);
            if (m) names = m[1].split(/\.\s+/).map((s) => s.split(' – ')[0].replace(/\s*\([^)]*\)/g, '').replace(/^our pet\s+/i, ''));
          }
          const seen = {};
          const kid = String(childName || '').trim().toLowerCase();
          return names
            .map((n) => String(n || '').trim().replace(/\.$/, ''))
            .filter((n) => {
              const k = n.toLowerCase();
              if (!n || n.length > 30 || k === kid || seen[k]) return false;
              seen[k] = true;
              return true;
            })
            .slice(0, 5);
        }

          // ── Order review drawer: "Your order" with their own poster, what's included and the total, then checkout ──
       const TT_ORDER_DRAWER = 'off'; // 'on' = everyone · 'off' = nobody · 'test' = half of previews
        function ttOrderDrawerOn() {
          if (TT_ORDER_DRAWER === 'on') return true;
          if (TT_ORDER_DRAWER === 'off') return false;
          let h = 0;
          for (const c of String(code).toLowerCase()) h = (h * 31 + c.charCodeAt(0)) >>> 0;
          return h % 2 === 1;
        }
        window.ttDrawerTest = ttOrderDrawerOn();
        // Half of previews skip "add yourself" before checkout (they can still add family after)
        function ttSkipSelfOn() {
          let h = 7;
          for (const c of String(code).toLowerCase()) h = (h * 37 + c.charCodeAt(0)) >>> 0;
          return false; // everyone gets "add yourself"
        }

        function ttShowOrderDrawer() {
          if (document.getElementById('ttOD')) return;
          const es = ttLang === 'es';
          const nm = titleCaseName(String(childName || '').toLowerCase()) || (es ? 'su estrella' : 'Your star');
          const poss = /s$/i.test(nm) ? nm + "'" : nm + "'s";
          const price = regionPrice('video') || '$24.99';
          // Anchor: what it all costs bought separately (same as the offer); savings worked out from the two prices
          const sep = ttIsXmas() ? XMAS_WAS : ''; // Christmas early bird only
          const num = (s) => parseFloat(String(s).replace(/[^0-9.]/g, '')) || 0;
          const cur = (String(price).match(/[A-Z]{3}$/) || [''])[0];
          const saveAmt = Math.max(0, num(sep) - num(price));
          const saveTxt = saveAmt > 0 ? '$' + saveAmt.toFixed(2) + (cur ? ' ' + cur : '') : '';
          const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
          // Their own poster if one was made from their character, otherwise their character
          const posterOk = !!window.ttPoster1 && window.ttPoster1 !== (window.ttPosterBefore || '');
          const thumb = posterOk ? window.ttPoster1 : (window.savedCharacterUrl || '');
          const me = window.ttSelfPick && window.ttSelfPick.label ? window.ttSelfPick.label : '';
          const fam = ttFamilyNames().filter((n) => !me || n.toLowerCase() !== me.toLowerCase()).slice(0, 3);
          const join = (a) => (a.length > 1 ? a.slice(0, -1).join(', ') + (es ? ' y ' : ' & ') + a[a.length - 1] : a[0] || '');

          if (!document.getElementById('ttODStyles')) {
            const st = document.createElement('style');
            st.id = 'ttODStyles';
            st.textContent = [
              '#ttOD{position:fixed;inset:0;z-index:100002;display:flex;align-items:flex-end;justify-content:center;background:rgba(10,14,28,.45);opacity:0;transition:opacity .3s ease}',
              '#ttOD.on{opacity:1}',
              '.ttod-panel{width:100%;max-width:480px;max-height:92vh;display:flex;flex-direction:column;background:#fff;border-radius:22px 22px 0 0;box-shadow:0 -12px 40px rgba(10,14,28,.2);transform:translateY(100%);transition:transform .38s cubic-bezier(.22,1,.36,1);font-family:Nunito,sans-serif;color:#151a33}',
              '#ttOD.on .ttod-panel{transform:none}',
              '@media (min-width:700px){#ttOD{justify-content:flex-end;align-items:stretch}.ttod-panel{max-width:420px;max-height:none;height:100%;border-radius:0;transform:translateX(100%)}}',
              '.ttod-head{display:flex;align-items:center;justify-content:space-between;padding:18px 20px 12px;border-bottom:1px solid #eef1f5}',
              '.ttod-head b{font-family:Fraunces,Georgia,serif;font-size:22px;font-weight:600}',
              '.ttod-x{width:36px;height:36px;border:none;border-radius:50%;background:#f3f5f8;color:#151a33;font-size:20px;line-height:1;cursor:pointer}',
              '.ttod-body{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:16px 20px 6px}',
              '.ttod-item{display:flex;gap:14px;align-items:flex-start;padding:12px;border:1px solid #e8ecf2;border-radius:16px}',
              '.ttod-thumb{flex-shrink:0;width:74px;aspect-ratio:2/3;border-radius:10px;overflow:hidden;background:#eef2f6;box-shadow:0 6px 16px rgba(21,26,51,.15)}',
              '.ttod-thumb img{display:block;width:100%;height:100%;object-fit:cover;object-position:center 15%}',
              '.ttod-info{flex:1;min-width:0}',
              '.ttod-title{font-size:17px;font-weight:900;line-height:1.2}',
              '.ttod-meta{margin-top:3px;font-size:13px;font-weight:700;color:#5b6475}',
              '.ttod-price{display:flex;flex-direction:column;align-items:flex-end;font-size:17px;font-weight:900;white-space:nowrap}',
              '.ttod-price s{font-size:13px;font-weight:800;color:#94a3b8}',
              '.ttod-total-r{display:flex;align-items:baseline;gap:10px}',
              '.ttod-total-r s{font-size:16px;font-weight:800;color:#94a3b8}',
              '.ttod-save{margin:-4px 0 10px;text-align:right;font-size:13px;font-weight:900;color:#1e8a55}',
              '.ttod-list{list-style:none;margin:14px 0 0;padding:0;display:flex;flex-direction:column;gap:8px}',
              '.ttod-list li{display:flex;gap:10px;align-items:flex-start;font-size:14.5px;font-weight:800;line-height:1.35}',
              '.ttod-list i{flex-shrink:0;display:flex !important;align-items:center;justify-content:center;width:20px;height:20px;margin-top:1px;border-radius:50%;background:#e8f6ee;color:#1e8a55;font-style:normal;font-size:11px;font-weight:900}',
              '.ttod-facts{margin:16px 0 4px;padding:12px 14px;border-radius:14px;background:#f7f9fc;display:flex;flex-direction:column;gap:8px}',
              '.ttod-facts div{display:flex;gap:10px;font-size:13.5px;font-weight:700;line-height:1.35;color:#334155}',
              '.ttod-foot{padding:12px 20px calc(14px + env(safe-area-inset-bottom,0px));border-top:1px solid #eef1f5;background:#fff}',
              '.ttod-total{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:10px}',
              '.ttod-total span{font-size:15px;font-weight:800;color:#5b6475}',
              '.ttod-total b{font-family:Fraunces,Georgia,serif;font-size:26px;font-weight:600}',
              '.ttod-go{display:block;width:100%;min-height:56px;border:none;border-radius:14px;background:linear-gradient(135deg,#ffe08a,#f2bd3f 50%,#e8a52a);color:#151a33;font-family:Nunito,sans-serif;font-size:17px;font-weight:900;cursor:pointer;box-shadow:0 10px 24px -10px rgba(200,140,20,.6)}',
              '.ttod-go:active{transform:scale(.98)}',
              '.ttod-go:disabled{opacity:.7;cursor:progress}',
              '.ttod-pay{margin-top:8px;text-align:center;font-size:12px;font-weight:700;color:#8a94a6}',
              '.ttod-back{display:block;margin:4px auto 0;padding:8px;border:none;background:none;color:#5b6475;font-family:Nunito,sans-serif;font-size:14px;font-weight:800;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
              '@media (prefers-reduced-motion:reduce){#ttOD,.ttod-panel{transition:none}}',
            ].join('');
            document.head.appendChild(st);
          }

          const ov = document.createElement('div');
          ov.id = 'ttOD';
          ov.setAttribute('role', 'dialog');
          ov.setAttribute('aria-modal', 'true');
          ov.setAttribute('aria-label', es ? 'Tu pedido' : 'Your order');
          ov.innerHTML =
            '<div class="ttod-panel">' +
              '<div class="ttod-head"><b>' + (es ? 'Tu pedido' : 'Your order') + '</b><button type="button" class="ttod-x" aria-label="Close">×</button></div>' +
              '<div class="ttod-body">' +
                '<div class="ttod-item">' +
                  '<div class="ttod-thumb">' + (thumb ? '<img src="' + esc(thumb) + '" alt="">' : '') + '</div>' +
                  '<div class="ttod-info">' +
                    '<div class="ttod-title">' + esc(es ? 'La película de ' + nm : poss + ' Movie') + '</div>' +
                    '<div class="ttod-meta">' + esc((es ? 'Protagonizada por ' : 'Starring ') + nm) + '</div>' +
                    (me ? '<div class="ttod-meta">' + esc((es ? 'Con ' : 'Featuring ') + me + (es ? ' (tú)' : ' (you)')) + '</div>' : '') +
                  '</div>' +
                  '<div class="ttod-price">' + (saveTxt ? '<s>' + esc(sep) + '</s>' : '') + esc(price) + '</div>' +
                '</div>' +
                '<ul class="ttod-list">' +
                  '<li><i>✓</i>' + (es ? 'Su película completa y su canción completa' : 'Full movie & full song') + '</li>' +
                  '<li><i>✓</i>' + (es ? 'Póster de la película y boleto de estreno' : 'Movie poster & premiere ticket') + '</li>' +
                  (fam.length ? '<li><i>✓</i>' + esc(es ? 'Agrega a ' + join(fam) + ' gratis después de pagar' : 'Add ' + join(fam) + ' free after checkout') + '</li>' : '') +
                  '<li><i>✓</i>' + (es ? 'Elige su ropa y ajusta su look, gratis' : 'Pick their outfit & tweak their look, free') + '</li>' +
                '</ul>' +
                '<div class="ttod-facts">' +
                  '<div><span>📩</span>' + (es ? 'Te la enviamos por correo en menos de 24 horas' : 'Emailed to you in minutes') + '</div>' +
                  '<div><span>📺</span>' + (es ? 'Mírala en cualquier teléfono o TV y compártela' : 'Watch on any phone or TV, share with family') + '</div>' +
                  '<div><span>🛡️</span>' + (es ? 'Te encanta o te devolvemos tu dinero' : 'Love it or your money back') + '</div>' +
                '</div>' +
              '</div>' +
              '<div class="ttod-foot">' +
                '<div class="ttod-total"><span>' + (es ? 'Total' : 'Total') + '</span>' +
                  '<span class="ttod-total-r">' + (saveTxt ? '<s>' + esc(sep) + '</s>' : '') + '<b>' + esc(price) + '</b></span></div>' +
                (saveTxt ? '<div class="ttod-save">' + (es ? 'Ahorras ' + saveTxt + ' vs. comprarlo por separado' : (ttIsXmas() ? '🎄 Early Bird Christmas Special: you save ' + saveTxt : 'You save ' + saveTxt)) + '</div>' : '') +
                '<button type="button" class="ttod-go">🔒 ' + (es ? 'Pagar' : 'Checkout') + ' · ' + esc(price) + '</button>' +
                '<div class="ttod-pay">Shop Pay · PayPal · Venmo · ' + (es ? 'tarjetas' : 'cards') + '</div>' +
                '<button type="button" class="ttod-back">' + (es ? 'Seguir viendo' : 'Keep looking') + '</button>' +
              '</div>' +
            '</div>';
          document.body.appendChild(ov);
          const prevOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          requestAnimationFrame(() => ov.classList.add('on'));
          ttTrack('pv_drawer_open');

          const close = () => {
            ttTrack('pv_drawer_close');
            ov.classList.remove('on');
            document.documentElement.style.overflow = prevOverflow;
            document.removeEventListener('keydown', onKey);
            setTimeout(() => ov.remove(), 380);
            ttShowNextStepsBar(); // their way back to the offer
            setTimeout(() => { if (window.ttFrameStage) window.ttFrameStage(); }, 60);
          };
          const onKey = (e) => { if (e.key === 'Escape') close(); };
          document.addEventListener('keydown', onKey);
          ov.querySelector('.ttod-x').addEventListener('click', close);
          ov.querySelector('.ttod-back').addEventListener('click', close);
          ov.addEventListener('click', (e) => { if (e.target === ov) close(); });

          const go = ov.querySelector('.ttod-go');
          go.addEventListener('click', () => {
            ttTrack('pv_drawer_checkout');
            go.disabled = true;
            go.textContent = es ? 'Abriendo el pago seguro…' : 'Opening secure checkout…';
            setTimeout(() => { if (ov.isConnected) { go.disabled = false; go.textContent = '🔒 ' + (es ? 'Pagar' : 'Checkout') + ' · ' + price; } }, 8000);
            goToVideoCheckout({ fromSheet: true });
          });
        }
        // ── The sales modal: everything in their movie package, in one picture ──
        function ttShowPackageOffer() {
          if (document.getElementById('ttSO') || document.getElementById('ttOD')) return;
          window.ttMakingCast = false;
          ttTrack('pv_package_offer');
          ttTrack('pv_offer_shown');
          const es = ttLang === 'es';
          const nm = titleCaseName(String(childName || '').toLowerCase()) || (es ? 'su estrella' : 'Your star');
          const poss = /s$/i.test(nm) ? nm + "'" : nm + "'s";
          const price = regionPrice('video') || '$24.99';
          const songPrice = regionPrice('song') || '$9.99';
          const charUrl = window.savedCharacterUrl || '';
          const posterNow = () => {
            const p = window.ttPosterReady || window.ttPoster1 || '';
            return p && p !== (window.ttPosterBefore || '') ? p : '';
          };
          const poster = posterNow();
          const clip = (window.ttOpeningClips && window.ttOpeningClips[0]) || '';
          const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
          const meLow = window.ttSelfPick && window.ttSelfPick.label ? window.ttSelfPick.label.toLowerCase() : '';
          const fam = ttFamilyNames().filter((n) => n.toLowerCase() !== meLow).slice(0, 2);
          const famTxt = fam.length > 1 ? fam[0] + (es ? ' y ' : ' & ') + fam[1] : fam[0] || '';

          // Decorative QR for the ticket (same one every time for this order)
          const qr = (() => {
            let a = 7;
            for (const c of String(code + nm)) a = (a * 31 + c.charCodeAt(0)) >>> 0;
            const rnd = () => { a = (Math.imul(a, 1103515245) + 12345) >>> 0; return (a >>> 8) / 16777216; };
            const f = (x, y) => '<rect x="' + x + '" y="' + y + '" width="7" height="7" fill="#3a2400"/><rect x="' + (x + 1) + '" y="' + (y + 1) + '" width="5" height="5" fill="#fff8e1"/><rect x="' + (x + 2) + '" y="' + (y + 2) + '" width="3" height="3" fill="#3a2400"/>';
            const inF = (x, y) => (x < 8 && y < 8) || (x > 12 && y < 8) || (x < 8 && y > 12);
            let d = '';
            for (let y = 0; y < 21; y++) for (let x = 0; x < 21; x++) if (!inF(x, y) && rnd() > 0.52) d += '<rect x="' + x + '" y="' + y + '" width="1" height="1"/>';
            return '<svg viewBox="-1 -1 23 23" shape-rendering="crispEdges" aria-hidden="true"><rect x="-1" y="-1" width="23" height="23" fill="#fff8e1"/>' + f(0, 0) + f(14, 0) + f(0, 14) + '<g fill="#3a2400">' + d + '</g></svg>';
          })();

          if (!document.getElementById('ttPOStyles')) {
            const st = document.createElement('style');
            st.id = 'ttPOStyles';
            st.textContent = [
              '#ttSO{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:12px;background:rgba(10,14,28,.55);opacity:0;transition:opacity .3s ease}',
              '#ttSO.on{opacity:1}',
              '.ttpo-card{position:relative;width:100%;max-width:420px;max-height:94vh;overflow-y:auto;border-radius:24px;background:#fff;font-family:Nunito,sans-serif;color:#151a33;text-align:center;box-shadow:0 30px 70px rgba(10,14,28,.45);transform:translateY(12px);transition:transform .35s ease}',
              '#ttSO.on .ttpo-card{transform:none}',
              '.ttpo-hero{position:relative;padding:14px 12px 10px;overflow:hidden;background:radial-gradient(90% 70% at 50% 0%,#3a3f6b 0%,#151a33 72%)}',
              '.ttpo-hero::before{content:"";position:absolute;left:50%;top:-30%;width:220%;aspect-ratio:1;transform:translateX(-50%);background:repeating-conic-gradient(from 0deg,rgba(255,255,255,.05) 0deg 6deg,transparent 6deg 14deg);pointer-events:none;animation:ttpoSpin 80s linear infinite}',
              '@keyframes ttpoSpin{to{transform:translateX(-50%) rotate(360deg)}}',
              '.ttpo-x{position:absolute;top:10px;right:10px;z-index:9;width:34px;height:34px;border:none;border-radius:50%;background:rgba(255,255,255,.9);color:#151a33;font-size:20px;line-height:1;cursor:pointer}',
              '.ttpo-k{position:relative;margin:2px 0 14px;font-size:11px;font-weight:900;letter-spacing:.2em;color:#f6d27a}',
              // The scene: every size scales with its width
              '.ttpo-scene{position:relative;width:100%;aspect-ratio:10/8.2;container-type:inline-size}',
              '.ttpo-it{position:absolute;opacity:0;transform:rotate(var(--r)) scale(.85);animation:ttpoIn .6s cubic-bezier(.2,1.25,.4,1) var(--d) forwards}',
              '@keyframes ttpoIn{to{opacity:1;transform:rotate(var(--r))}}',
              '.ttpo-tag{position:absolute;top:-3.8cqw;left:2cqw;z-index:3;padding:1cqw 2.2cqw;border-radius:999px;background:#f6d27a;color:#151a33;font:900 2.8cqw/1 Nunito,sans-serif;white-space:nowrap;box-shadow:0 1cqw 2.4cqw rgba(0,0,0,.35)}',
              // Private page
              '.ttpo-page{left:1%;top:5%;width:58%;--r:-3deg;--d:.15s;background:#fffaf0;border-radius:2.2cqw;box-shadow:0 0 0 .5cqw #fff,0 3cqw 6cqw rgba(0,0,0,.5);text-align:left}',
              '.ttpo-bar{display:flex;align-items:center;gap:.8cqw;padding:1.3cqw 1.8cqw;border-radius:2.2cqw 2.2cqw 0 0;background:#151a33}',
              '.ttpo-bar i{display:block;width:1.2cqw;height:1.2cqw;border-radius:50%;background:rgba(255,255,255,.35)}',
              '.ttpo-bar span{margin-left:1cqw;font-size:2.2cqw;font-weight:900;color:#f6d27a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
              '.ttpo-vid{position:relative;margin:1.8cqw;aspect-ratio:16/9;border-radius:1.4cqw;overflow:hidden;background:#0b1020 center 20%/cover no-repeat}',
              '.ttpo-vid video{display:block;width:100%;height:100%;object-fit:cover}',
              '.ttpo-vid b{position:absolute;left:50%;top:50%;display:flex;align-items:center;justify-content:center;width:8cqw;height:8cqw;margin:-4cqw 0 0 -4cqw;padding-left:.6cqw;border-radius:50%;background:rgba(255,255,255,.92);color:#151a33;font-size:3cqw;box-shadow:0 1cqw 3cqw rgba(0,0,0,.4)}',
              '.ttpo-row{display:flex;gap:1.4cqw;padding:0 1.8cqw 1.8cqw}',
              '.ttpo-row span{flex:1;padding:1.1cqw 0;border-radius:1.2cqw;background:#fff;border:1px solid #e5e7eb;font-size:2.3cqw;font-weight:900;text-align:center}',
              '.ttpo-row span.g{background:linear-gradient(180deg,#f7d774,#e9b64a);border-color:transparent;color:#2b1d00}',
              // Poster
              '.ttpo-poster{left:60%;top:2%;width:37%;aspect-ratio:2/3;--r:4deg;--d:.35s;border-radius:1cqw;box-shadow:0 0 0 1.1cqw #fff,0 0 0 1.5cqw #f6d27a,0 4cqw 8cqw rgba(0,0,0,.55)}',
              '.ttpo-pin{position:absolute;inset:0;overflow:hidden;border-radius:1cqw;background:radial-gradient(80% 60% at 50% 25%,#3a3f6b,#151a33)}',
              '.ttpo-pin img.full{width:100%;height:100%;object-fit:cover;transition:opacity .5s}',
              '.ttpo-pin .fb{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:flex-end;padding:2cqw;color:#fff}',
              '.ttpo-pin .fb img{position:absolute;inset:6% 8% 26%;width:84%;height:68%;object-fit:contain;object-position:bottom}',
              '.ttpo-pin .fb small{position:relative;font-size:1.7cqw;font-weight:900;letter-spacing:.2em;color:#f6d27a}',
              '.ttpo-pin .fb b{position:relative;font-family:Fraunces,Georgia,serif;font-size:4.6cqw;font-weight:700;line-height:1.05;text-transform:uppercase;overflow-wrap:anywhere}',
              // Song file
              '.ttpo-song{left:2%;top:64%;width:40%;--r:-2deg;--d:.55s;display:flex;align-items:center;gap:2cqw;padding:2.2cqw;border-radius:2cqw;background:#fff;box-shadow:0 3cqw 6cqw rgba(0,0,0,.45);text-align:left}',
              '.ttpo-ic{flex-shrink:0;display:flex;align-items:center;justify-content:center;width:8.5cqw;height:8.5cqw;border-radius:1.8cqw;background:linear-gradient(135deg,#f7d774,#e9b64a);font-size:4.4cqw}',
              '.ttpo-st{flex:1;min-width:0}',
              '.ttpo-st b{display:block;font-size:2.9cqw;font-weight:900;line-height:1.15;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
              '.ttpo-st small{display:block;font-size:2.2cqw;font-weight:800;color:#6b7280}',
              '.ttpo-wave{display:flex;align-items:center;gap:.5cqw;height:3.4cqw;margin-top:.8cqw}',
              '.ttpo-wave i{display:block;width:.7cqw;height:100%;border-radius:1cqw;background:#e9b64a;transform-origin:center;animation:ttpoWave 1.1s ease-in-out infinite}',
              '@keyframes ttpoWave{0%,100%{transform:scaleY(.3)}50%{transform:scaleY(1)}}',
              '.ttpo-dl{flex-shrink:0;display:flex;align-items:center;justify-content:center;width:6cqw;height:6cqw;border-radius:50%;background:#151a33;color:#f6d27a;font-size:3cqw;font-weight:900}',
              // Ticket
              '.ttpo-tk{left:40%;top:72%;width:57%;--r:3deg;--d:.75s;display:flex;align-items:center;gap:2.4cqw;padding:2.4cqw 2.4cqw 2.4cqw 3.6cqw;border-radius:2cqw;border:1cqw solid #fff;background:linear-gradient(140deg,#fff3d0 0%,#f5dc8a 45%,#d4af37 100%);color:#3a2400;box-shadow:0 3cqw 6cqw rgba(0,0,0,.5);text-align:left;box-sizing:border-box}',
              '.ttpo-tk-l{flex:1;min-width:0}',
              '.ttpo-tk-l small{display:block;font-size:1.8cqw;font-weight:900;letter-spacing:.2em}',
              '.ttpo-tk-l b{display:block;margin:.8cqw 0 .4cqw;font-family:Fraunces,Georgia,serif;font-size:5cqw;font-weight:700;line-height:1;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
              '.ttpo-tk-l em{display:block;font-family:Fraunces,Georgia,serif;font-style:italic;font-size:2.5cqw;font-weight:600}',
              '.ttpo-qr{flex-shrink:0;width:11cqw;padding:.6cqw;border-radius:1cqw;background:#fff8e1}',
              '.ttpo-qr svg{display:block;width:100%;height:auto}',
              // Body
              '.ttpo-body{padding:16px 20px 16px}',
              '.ttpo-h{margin:0 0 6px;font-family:Fraunces,Georgia,serif;font-size:clamp(22px,6vw,26px);font-weight:600;line-height:1.15;letter-spacing:-.02em}',
              '.ttpo-sub{margin:0 auto 14px;max-width:330px;font-size:14px;font-weight:700;line-height:1.45;color:#5b6475}',
              '.ttpo-xmas{margin:-6px 0 10px;font-size:13px;font-weight:900;color:#1e824c}',
              '.ttpo-xmas s{margin-left:4px;color:#9ca3af;font-weight:700}',
              '.ttpo-go,.ttpo-song-b{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;min-height:68px;padding:12px 18px;border-radius:16px;cursor:pointer;text-align:left;font-family:Nunito,sans-serif;color:#151a33;box-sizing:border-box}',
              '.ttpo-go{border:none;color:#2b1d00;background:linear-gradient(180deg,#fff3c4 0%,#f7d774 22%,#e9b64a 52%,#c98f22 78%,#e6b54d 100%);box-shadow:0 1px 0 rgba(255,255,255,.85) inset,0 12px 26px -10px rgba(201,143,34,.7),0 0 0 1px rgba(160,110,20,.35)}',
              '.ttpo-song-b{margin-top:10px;background:#fff;border:1.5px solid #dfe5ee;box-shadow:0 8px 20px -12px rgba(21,26,51,.35)}',
              '.ttpo-go:active,.ttpo-song-b:active{transform:scale(.98)}',
              '.ttpo-l b{display:block;font-size:17px;font-weight:900;line-height:1.2}',
              '.ttpo-l small{display:block;margin-top:2px;font-size:12.5px;font-weight:700;opacity:.72}',
              '.ttpo-p{flex-shrink:0;font-family:Fraunces,Georgia,serif;font-size:24px;font-weight:600;line-height:1}',
              '.ttpo-song-b .ttpo-p{font-size:20px;color:#5b6475}',
              '.ttpo-guar{display:flex;align-items:center;gap:12px;margin-top:10px;padding:11px 14px;border-radius:16px;text-align:left;background:linear-gradient(135deg,#f3fbf6,#e9f6ee);border:1px solid rgba(30,138,85,.18)}',
              '.ttpo-seal{flex-shrink:0;display:flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:50%;background:#fff;box-shadow:0 0 0 3px rgba(30,138,85,.12)}',
              '.ttpo-guar b{display:block;font-family:Fraunces,Georgia,serif;font-size:15px;font-weight:600;color:#14532d}',
              '.ttpo-guar small{display:block;margin-top:1px;font-size:12px;font-weight:700;color:#3f6b52}',
              '@media (prefers-reduced-motion:reduce){.ttpo-it{animation:none;opacity:1;transform:rotate(var(--r))}.ttpo-wave i,.ttpo-hero::before{animation:none}}',
            ].join('');
            document.head.appendChild(st);
          }

          if (!document.getElementById('ttPO2Styles')) {
            const s2 = document.createElement('style');
            s2.id = 'ttPO2Styles';
            s2.textContent = [
              '.ttpo-show{position:relative;display:flex;flex-direction:column;gap:12px}',
              '.ttpo-main{position:relative;aspect-ratio:16/9;border-radius:14px;overflow:hidden;background:#0b1020;box-shadow:0 0 0 2px rgba(246,210,122,.75),0 18px 40px rgba(0,0,0,.5)}',
              '.ttpo-main video,.ttpo-main img{display:block;width:100%;height:100%;object-fit:cover;object-position:center 25%}',
              '.ttpo-chip{position:absolute;top:8px;left:8px;padding:5px 10px;border-radius:999px;background:rgba(10,14,28,.6);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);color:#fff;font:800 10.5px Nunito,sans-serif}',
              '.ttpo-main-cap{position:absolute;left:0;right:0;bottom:0;padding:28px 14px 10px;background:linear-gradient(to top,rgba(5,8,20,.85),rgba(5,8,20,0));text-align:left}',
              '.ttpo-main-cap small{display:block;font:900 9px/1 Nunito,sans-serif;letter-spacing:.24em;color:#f6d27a}',
              '.ttpo-main-cap b{display:block;margin-top:4px;font:italic 600 clamp(19px,5.6vw,25px)/1.05 Fraunces,Georgia,serif;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
              '.ttpo-row3{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}',
              '.ttpo-tile{display:flex;flex-direction:column;align-items:center;gap:6px;min-width:0}',
              '.ttpo-tile>b{font:800 11.5px/1.2 Nunito,sans-serif;color:rgba(255,255,255,.88);text-align:center}',
              '.ttpo-tthumb{position:relative;width:100%;aspect-ratio:4/5;border-radius:10px;overflow:hidden;box-shadow:0 8px 18px rgba(0,0,0,.4)}',
              '.ttpo-tthumb.ttpo-pin{position:relative;inset:auto}',
              '.ttpo-tthumb .fb small,.ttpo-tthumb .fb b{display:none}',
              '.ttpo-tthumb .fb img{inset:0;width:100%;height:100%;object-fit:cover;object-position:center 15%}',
              '.ttpo-sng{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;background:linear-gradient(160deg,#fff,#fff4d6)}',
              '.ttpo-sng>span:first-child{display:flex;align-items:center;justify-content:center;width:44%;aspect-ratio:1;border-radius:12px;background:linear-gradient(135deg,#f7d774,#e9b64a);color:#151a33;font-size:22px}',
              '.ttpo-sng .ttpo-wave{display:flex;align-items:center;gap:3px;height:16px;margin:0}',
              '.ttpo-sng .ttpo-wave i{width:3px}',
              '.ttpo-tkt{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;padding:8px;box-sizing:border-box;background:linear-gradient(140deg,#fff3d0,#f5dc8a 45%,#d4af37);color:#3a2400;text-align:center}',
              '.ttpo-tkt small{font:900 8px Nunito,sans-serif;letter-spacing:.18em}',
              '.ttpo-tkt b{max-width:100%;font:700 clamp(12px,3.6vw,15px)/1.05 Fraunces,Georgia,serif;text-transform:uppercase;overflow-wrap:anywhere}',
              '.ttpo-tkt i{display:block;width:46%;padding:3px;border-radius:4px;background:#fff8e1}',
              '.ttpo-tkt i svg{display:block;width:100%;height:auto}',
            ].join('');
            document.head.appendChild(s2);
          }
          if (!document.getElementById('ttPO4Styles')) {
            const s4 = document.createElement('style');
            s4.id = 'ttPO4Styles';
            s4.textContent = [
              '.ttpo-bx{position:relative;width:100%;aspect-ratio:1/.82;container-type:inline-size}',
              // Movie: behind, fanned right
              '.ttpo-bx-mv{left:36%;top:8%;width:60%;aspect-ratio:16/10;z-index:1;border-radius:2cqw;overflow:hidden;background:#0b1020;box-shadow:0 0 0 1.2cqw #151a33,0 0 0 1.6cqw rgba(246,210,122,.5),0 3cqw 7cqw rgba(0,0,0,.55)}',
              '.ttpo-bx-mv video,.ttpo-bx-mv img{display:block;width:100%;height:100%;object-fit:cover;object-position:center 20%}',
              '.ttpo-bx-chip{position:absolute;top:2cqw;right:2cqw;padding:.8cqw 1.8cqw;border-radius:99px;background:rgba(10,14,28,.65);color:#fff;font:800 2.5cqw Nunito,sans-serif;white-space:nowrap}',
              '.ttpo-bx-play{position:absolute;left:60%;top:48%;transform:translate(-50%,-50%);display:flex;align-items:center;justify-content:center;width:9cqw;height:9cqw;padding-left:.6cqw;box-sizing:border-box;border-radius:50%;background:rgba(255,255,255,.92);color:#151a33;font-size:3.4cqw;box-shadow:0 1cqw 3cqw rgba(0,0,0,.4)}',
              '.ttpo-bx-cap{position:absolute;left:0;right:0;bottom:0;padding:5cqw 2.5cqw 1.8cqw;background:linear-gradient(to top,rgba(5,8,20,.85),rgba(5,8,20,0));text-align:right;font:italic 600 3.6cqw/1.1 Fraunces,Georgia,serif;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
              // Poster: front, full 2:3
              '.ttpo-bx-pst{left:5%;top:3%;width:38%;aspect-ratio:2/3;z-index:3;border-radius:1cqw;box-shadow:0 0 0 1.1cqw #fff,0 0 0 1.5cqw #f6d27a,0 4cqw 9cqw rgba(0,0,0,.6)}',
              // Ticket: front, bottom left
              '.ttpo-bx-tk{left:4%;top:70%;width:48%;z-index:4;display:flex;align-items:center;gap:2cqw;padding:2.2cqw 2.4cqw 2.2cqw 3.4cqw;box-sizing:border-box;border-radius:2cqw;border:.9cqw solid #fff;background:linear-gradient(140deg,#fff3d0,#f5dc8a 45%,#d4af37);color:#3a2400;box-shadow:0 3cqw 6cqw rgba(0,0,0,.5);text-align:left}',
              '.ttpo-bx-tkl{flex:1;min-width:0}',
              '.ttpo-bx-tkl small{display:block;font:900 1.9cqw Nunito,sans-serif;letter-spacing:.2em}',
              '.ttpo-bx-tkl b{display:block;margin:.6cqw 0 .3cqw;font:700 4.4cqw/1 Fraunces,Georgia,serif;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
              '.ttpo-bx-tkl em{display:block;font:italic 600 2.3cqw Fraunces,Georgia,serif;white-space:nowrap}',
              '.ttpo-bx-qr{flex-shrink:0;width:10cqw;padding:.6cqw;border-radius:1cqw;background:#fff8e1}',
              '.ttpo-bx-qr svg{display:block;width:100%;height:auto}',
              // Song: front, bottom right
              '.ttpo-bx-sg{left:50%;top:63%;width:46%;z-index:5;display:flex;align-items:center;gap:2.4cqw;padding:2.4cqw;box-sizing:border-box;border-radius:2.4cqw;background:#fff;box-shadow:0 3cqw 6cqw rgba(0,0,0,.45);text-align:left}',
              '.ttpo-bx-ic{flex-shrink:0;display:flex;align-items:center;justify-content:center;width:9cqw;height:9cqw;border-radius:2cqw;background:linear-gradient(135deg,#f7d774,#e9b64a);color:#151a33;font-size:4.6cqw}',
              '.ttpo-bx-sx{flex:1;min-width:0}',
              '.ttpo-bx-sx b{display:block;font:900 3.4cqw/1.1 Nunito,sans-serif;color:#151a33;white-space:nowrap}',
              '.ttpo-bx-sx small{display:block;margin-top:.4cqw;font:700 2.5cqw/1.2 Nunito,sans-serif;color:#6b7280;white-space:nowrap}',
              '.ttpo-bx-sg .ttpo-wave{display:flex;align-items:center;gap:.6cqw;height:3.4cqw;margin-top:1cqw}',
              '.ttpo-bx-sg .ttpo-wave i{width:.7cqw}',
            ].join('');
            document.head.appendChild(s4);
          }
          if (!document.getElementById('ttPO5Styles')) {
            const s5 = document.createElement('style');
            s5.id = 'ttPO5Styles';
            const hole = (pos) => 'radial-gradient(circle at ' + pos + ',transparent var(--n),#000 calc(var(--n) + .2cqw))';
            const holes = [hole('0 50%'), hole('100% 50%'), hole('74% 0'), hole('74% 100%')].join(',');
            s5.textContent = [
              // Outer piece keeps position + tilt; the shadow follows the notches
              '.ttpo-bx-tk{padding:0 !important;border:0 !important;background:none !important;box-shadow:none !important;display:block !important;filter:drop-shadow(0 2.4cqw 2.8cqw rgba(0,0,0,.45))}',
              '.ttpo-tk2{--n:2.2cqw;position:relative;display:flex;align-items:stretch;border-radius:1.6cqw;color:#3a2400;' +
                'background:linear-gradient(140deg,#fff3d0 0%,#f5dc8a 45%,#d4af37 100%);' +
                '-webkit-mask:' + holes + ';-webkit-mask-composite:source-in;mask:' + holes + ';mask-composite:intersect}',
              // Main part
              '.ttpo-tk2-m{flex:0 0 74%;min-width:0;box-sizing:border-box;padding:2.4cqw 2cqw 2.2cqw 4cqw;text-align:left}',
              '.ttpo-tk2-m small{display:block;font:900 1.8cqw Nunito,sans-serif;letter-spacing:.22em;white-space:nowrap}',
              '.ttpo-tk2-m b{display:block;margin:.7cqw 0 .3cqw;font:700 3.8cqw/1.05 Fraunces,Georgia,serif;text-transform:uppercase;overflow-wrap:anywhere}',
              '.ttpo-tk2-m em{display:block;font:italic 600 2.3cqw Fraunces,Georgia,serif;white-space:nowrap}',
              '.ttpo-tk2-row{display:block;margin-top:1cqw;padding-top:.8cqw;border-top:.25cqw solid rgba(58,36,0,.3);font:900 1.6cqw Nunito,sans-serif;letter-spacing:.18em;opacity:.75;white-space:nowrap}',
              // Tear-off stub
              '.ttpo-tk2-s{flex:1;min-width:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.8cqw;padding:2cqw 2.6cqw 2cqw 1.2cqw;border-left:.35cqw dashed rgba(58,36,0,.45);background:rgba(255,255,255,.18)}',
              '.ttpo-tk2-qr{display:block;width:100%;max-width:8cqw;padding:.5cqw;box-sizing:border-box;border-radius:.8cqw;background:#fff8e1}',
              '.ttpo-tk2-qr svg{display:block;width:100%;height:auto}',
              '.ttpo-tk2-s small{font:800 1.5cqw Nunito,sans-serif;letter-spacing:.06em;white-space:nowrap}',
            ].join('');
            document.head.appendChild(s5);
          }
          const vidBg = poster || charUrl;
          const posterInner = poster
            ? '<img class="full" src="' + esc(poster) + '" alt="">'
            : '<div class="fb">' + (charUrl ? '<img src="' + esc(charUrl) + '" alt="">' : '') +
                '<small>A TINYTUNES ORIGINAL</small><b>' + esc(nm) + '</b></div>';
          const waves = [5, 9, 6, 10, 7, 4, 8, 6, 9, 5].map((h, i) => '<i style="animation-delay:' + (i * 0.09).toFixed(2) + 's"></i>').join('');

          const ov = document.createElement('div');
          ov.id = 'ttSO';
          ov.setAttribute('role', 'dialog');
          ov.setAttribute('aria-modal', 'true');
          ov.innerHTML =
            '<div class="ttpo-card">' +
              '<div class="ttpo-hero">' +
                '<button type="button" class="ttpo-x" aria-label="Close">×</button>' +
                '<div class="ttpo-k" style="margin-bottom:5px">🎁 ' + (es ? 'EL PAQUETE COMPLETO' : 'THE COMPLETE MOVIE PACKAGE') + '</div>' +
                '<div style="position:relative;margin:0 0 14px;font:800 12.5px/1.3 Nunito,sans-serif;color:rgba(255,255,255,.8);text-align:center">' +
                  (es ? 'Película completa · Canción completa · Póster · Boleto escaneable' : 'Full movie · Full song · Movie poster · Scannable ticket') + '</div>' +
                             '<div class="ttpo-bx">' +
                  '<div class="ttpo-it ttpo-bx-mv" style="--r:5deg;--d:.1s">' +
                    (clip ? '<video muted loop playsinline autoplay preload="auto" src="' + esc(clip) + '"></video>'
                      : charUrl ? '<img src="' + esc(charUrl) + '" alt="">' : '') +
                    '<span class="ttpo-bx-chip">🔒 ' + (es ? 'Página privada' : 'Private page') + '</span>' +
                    '<span class="ttpo-bx-play">▶</span>' +
                    '<span class="ttpo-bx-cap">' + esc(es ? 'La película de ' + nm : poss + ' movie') + '</span>' +
                  '</div>' +
                  '<div class="ttpo-it ttpo-bx-pst" style="--r:-2deg;--d:.3s"><div class="ttpo-pin">' + posterInner + '</div></div>' +
                  '<div class="ttpo-it ttpo-bx-tk" style="--r:-5deg;--d:.5s"><div class="ttpo-tk2">' +
                    '<div class="ttpo-tk2-m"><small>★ ' + (es ? 'ADMITE UNO' : 'ADMIT ONE') + ' ★</small>' +
                      '<b>' + esc(nm) + '</b><em>' + (es ? 'Estreno mundial' : 'World premiere') + '</em>' +
                      '<span class="ttpo-tk2-row">' + (es ? 'FILA A · ASIENTO 1' : 'ROW A · SEAT 1') + '</span></div>' +
                    '<div class="ttpo-tk2-s"><span class="ttpo-tk2-qr">' + qr + '</span>' +
                      '<small>N\u00BA ' + String(Math.abs([...String(code)].reduce((a, c) => (a * 31 + c.charCodeAt(0)) | 0, 7)) % 100000).padStart(5, '0') + '</small></div>' +
                  '</div></div>' +
                  '<div class="ttpo-it ttpo-bx-sg" style="--r:3deg;--d:.65s"><span class="ttpo-bx-ic">♪</span>' +
                    '<span class="ttpo-bx-sx"><b>' + (es ? 'Canción completa' : 'Full song') + '</b>' +
                    '<small>' + esc(typeof ttFullSongLen === 'function'
                      ? (es ? ttFullSongLen(true) : ttFullSongLen(false).replace('-minute', ' min')) + ' · MP3'
                      : 'MP3') + '</small>' +
                    '<span class="ttpo-wave">' + waves + '</span></span></div>' +
                '</div>' +
              '</div>' +
              '<div class="ttpo-body">' +
                '<h2 class="ttpo-h">' + esc(es ? 'El regalo que ' + nm + ' nunca olvidará' : 'The gift ' + nm + ' will never forget') + '</h2>' +
                (famTxt
                  ? '<p class="ttpo-sub">' + esc(es ? '💛 Agrega a ' + famTxt + ' a la película gratis después de pagar' : '💛 Add ' + famTxt + ' to the movie free after checkout') + '</p>'
                  : '<div style="height:8px"></div>') +
                (ttIsXmas() ? '<div class="ttpo-xmas">🎄 Early bird Christmas price <s>' + XMAS_WAS + '</s></div>' : '') +
                '<button type="button" class="ttpo-go"><span class="ttpo-l"><b>🎬 ' + esc(es ? 'La película de ' + nm : poss + ' movie') + '</b>' +
                  '<small>' + (es ? 'Enviado a tu correo · míralo en cualquier pantalla' : 'Emailed to you · watch on any screen') + '</small></span><span class="ttpo-p">' + esc(price) + '</span></button>' +
                '<button type="button" class="ttpo-song-b"><span class="ttpo-l"><b>🎵 ' + (es ? 'Solo la canción' : 'Just the song') + '</b>' +
                  '<small>' + (es ? 'Canción completa, enviada al instante' : 'Full song, emailed instantly') + '</small></span><span class="ttpo-p">' + esc(songPrice) + '</span></button>' +
                ttGuaranteeHTML() +
              '</div>' +
            '</div>';
          document.body.appendChild(ov);
          requestAnimationFrame(() => ov.classList.add('on'));
          const pv = ov.querySelector('.ttpo-bx video');
          if (pv) pv.play().catch(() => {});

          // Tap an item → it pops up big for a closer look, then goes back after 4 seconds
          if (!document.getElementById('ttPOZoomStyles')) {
            const zs = document.createElement('style');
            zs.id = 'ttPOZoomStyles';
            zs.textContent = [
              '.ttpo-zoom{position:fixed;inset:0;z-index:100005;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:20px;background:rgba(10,14,28,.82);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);opacity:0;transition:opacity .25s ease;cursor:zoom-out}',
              '.ttpo-zoom.on{opacity:1}',
              '.ttpo-zoom-stage{width:min(92vw,460px);container-type:inline-size;display:flex;justify-content:center;transform:scale(.85);transition:transform .4s cubic-bezier(.2,1.3,.4,1)}',
              '.ttpo-zoom.on .ttpo-zoom-stage{transform:none}',
              '.ttpo-zoom .ttpo-it{position:relative !important;left:auto !important;top:auto !important;opacity:1 !important;animation:none !important;transform:none !important}',
              '.ttpo-zoom-cap{max-width:340px;text-align:center;font:800 15px/1.4 Nunito,sans-serif;color:#fff}',
              '.ttpo-zoom-bar{width:120px;height:4px;border-radius:4px;background:rgba(255,255,255,.2);overflow:hidden}',
              '.ttpo-zoom-bar i{display:block;width:100%;height:100%;background:#f6d27a;transform-origin:left;animation:ttpoZoomBar 4s linear forwards}',
              '@keyframes ttpoZoomBar{from{transform:scaleX(1)}to{transform:scaleX(0)}}',
              '.ttpo-bx .ttpo-it{cursor:zoom-in}',
            ].join('');
            document.head.appendChild(zs);
          }
          const ZOOM = {
            'ttpo-bx-pst': { w: '64%', cap: es ? '🖼️ Su póster de cine, listo para imprimir' : '🖼️ ' + poss + ' movie poster, ready to print' },
            'ttpo-bx-tk': { w: '92%', cap: es ? '🎟️ Boleto de estreno: escanéalo para ver la película' : '🎟️ Premiere ticket: scan it to watch the movie' },
            'ttpo-bx-sg': { w: '86%', cap: es ? '🎵 Su canción completa, para guardar' : '🎵 ' + poss + ' full song, theirs to keep' },
            'ttpo-bx-mv': { w: '100%', cap: es ? '🎬 Su página privada para ver y compartir' : '🎬 ' + poss + ' private movie page to watch & share' },
          };
          let zoomTimer = null;
          const closeZoom = () => {
            clearTimeout(zoomTimer);
            const z = ov.querySelector('.ttpo-zoom');
            if (z) { z.classList.remove('on'); setTimeout(() => z.remove(), 250); }
          };
          ov.querySelectorAll('.ttpo-bx .ttpo-it').forEach((item) => {
            const key = Object.keys(ZOOM).find((k) => item.classList.contains(k));
            if (!key) return;
            item.addEventListener('click', (e) => {
              e.stopPropagation();
              closeZoom();
              const z = document.createElement('div');
              z.className = 'ttpo-zoom';
              const stage = document.createElement('div');
              stage.className = 'ttpo-zoom-stage';
              const clone = item.cloneNode(true);
              clone.style.width = ZOOM[key].w;
              stage.appendChild(clone);
              z.appendChild(stage);
              z.insertAdjacentHTML('beforeend', '<div class="ttpo-zoom-cap">' + esc(ZOOM[key].cap) + '</div><div class="ttpo-zoom-bar"><i></i></div>');
              ov.appendChild(z);
              const cv = clone.querySelector('video');
              if (cv) { cv.muted = true; cv.play().catch(() => {}); }
              requestAnimationFrame(() => z.classList.add('on'));
              z.addEventListener('click', (ev) => { ev.stopPropagation(); closeZoom(); });
              zoomTimer = setTimeout(closeZoom, 4000);
              ttTrack('pv_package_zoom');
            });
          });

          // Behind the offer: the "that was just a preview" voiceover first (once), then the song
          const startSongBehind = () => {
            try {
              const songA = document.getElementById('ttAudio');
              if (ov.isConnected && songA && songA.paused) {
                window.ttRevealActive = false;
                songA.currentTime = 0;
                songA.play().catch(() => {});
              }
            } catch (e) {}
          };
          setTimeout(() => {
            if (!ov.isConnected) return;
            if (window.TT_OFFER_VOICEOVER && !window.ttVoPlayed && window.ttSongDone) {
              window.ttVoPlayed = true;
              window.ttRevealActive = true; // keeps it playing if Facebook grabs the sound
              try { upsellAudio.currentTime = 0; upsellAudio.muted = false; } catch (e) {}
              upsellAudio.addEventListener('ended', startSongBehind, { once: true });
              upsellAudio.play().catch(startSongBehind);
              ttTrack('pv_offer_voiceover');
            } else {
              startSongBehind();
            }
          }, 80);

          // Their real poster swaps in the moment it's ready
          const pinEl = ov.querySelector('.ttpo-pin');
          const posterWatch = poster ? null : setInterval(() => {
            if (!ov.isConnected) { clearInterval(posterWatch); return; }
            const p = posterNow();
            if (!p) return;
            clearInterval(posterWatch);
            const im = new Image();
            im.onload = () => { if (pinEl) pinEl.innerHTML = '<img class="full" src="' + esc(p) + '" alt="">'; };
            im.src = p;
          }, 1500);

          const close = (back) => {
            if (posterWatch) clearInterval(posterWatch);
            closeZoom();
            window.ttRevealActive = false;
            try { if (!upsellAudio.paused) upsellAudio.pause(); } catch (e) {}
            ov.classList.remove('on');
            setTimeout(() => ov.remove(), 300);
            if (back) {
              ttShowNextStepsBar();
              setTimeout(() => { if (window.ttFrameStage) window.ttFrameStage(); }, 60);
            }
          };
          ov.querySelector('.ttpo-x').addEventListener('click', () => { ttTrack('pv_package_close'); close(true); });
          ov.addEventListener('click', (e) => { if (e.target === ov) { ttTrack('pv_package_close'); close(true); } });
          ov.querySelector('.ttpo-go').addEventListener('click', () => {
            ttTrack('pv_click_movie');
            close(false);
            if (window.ttPosterReady) window.ttPoster1 = window.ttPosterReady;
            if (window.ttDrawerTest) ttShowOrderDrawer();
            else goToVideoCheckout({ fromSheet: true });
          });
          ov.querySelector('.ttpo-song-b').addEventListener('click', () => {
            ttTrack('pv_click_song');
            close(false);
            confirmThenBuySong({ _gift_send_enabled: 'no', Starring: titleCaseName(childName) || '' });
          });
        }

        // ── Offer after the post-preview video: her movie → poster → premiere ticket, one gold button ──
        function ttShowSimpleOffer() {
          if (document.getElementById('ttSO') || document.getElementById('ttOD')) return;
          if (window.savedCharacterUrl) { ttShowPackageOffer(); return; } // the package modal is the sales modal
          window.ttMakingCast = false;
          ttTrack('pv_simple_modal');
          ttTrack('pv_offer_shown');
          const es = ttLang === 'es';
          const nm = titleCaseName(String(childName || '').toLowerCase()) || (es ? 'su estrella' : 'them');
          const poss = /s$/i.test(nm) ? nm + "'" : nm + "'s";
          const price = regionPrice('video') || '$24.99';
          const songPrice = regionPrice('song') || '$9.99';
          const charUrl = window.savedCharacterUrl || '';
          const hasChar = !!charUrl;
          const pRaw = window.ttPosterReady || window.ttPoster1 || '';
          const poster = pRaw && pRaw !== (window.ttPosterBefore || '') ? pRaw : '';
          const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
          const vids = THEMED_HERO_VIDEOS[occasion] ||
            (occasion === 'bedtime' || genre === 'lullaby' || genre === 'bedtime' ? THEMED_HERO_VIDEOS.lullaby : THEMED_HERO_VIDEOS.birthday);
          const movieSrc = hasChar ? vids.withCharacter : vids.noCharacter;

          const slides = [{
            dur: 5000,
            cap: '🎬 ' + (es ? 'La película de ' + nm : poss + ' movie'),
            html: '<div class="ttso-mv' + (hasChar && vids.split ? ' split' : '') + '"><video muted playsinline loop preload="auto" src="' + esc(movieSrc) + '"></video>' +
              (hasChar && !vids.noSlot ? '<img class="ttso-mv-char" src="' + esc(charUrl) + '" alt="">' : '') + '</div>',
          }];
          if (poster) slides.push({
            cap: '🖼️ ' + (es ? 'Su póster de cine' : poss + ' movie poster'),
            html: '<div class="ttso-pst"><img src="' + esc(poster) + '" alt=""></div>',
          });
          // Their private page, drawn with their name, poster/character and family
          const pgImg = poster || charUrl;
          const pgFam = ttFamilyNames().slice(0, 2);
          slides.push({
            cap: '🔗 ' + (es ? 'Su página privada' : poss + ' private movie page'),
            html:
              '<div class="ttso-pg">' +
                '<div class="ttso-pg-bar"><i></i><i></i><i></i><span>🔒 ' + esc(es ? 'Página privada de ' + nm : 'Private page · just for ' + nm) + '</span></div>' +
                '<div class="ttso-pg-body">' +
                  '<div class="ttso-pg-vid"' + (pgImg ? ' style="background-image:url(\'' + esc(pgImg) + '\')"' : '') + '><span>▶</span></div>' +
                  '<div class="ttso-pg-side">' +
                    '<b>' + esc(es ? 'La película de ' + nm : poss + ' Movie') + '</b>' +
                    '<div class="ttso-pg-btn">▶ ' + (es ? 'Ver' : 'Watch') + '</div>' +
                    '<div class="ttso-pg-btn alt">🔗 ' + (es ? 'Compartir' : 'Share') + '</div>' +
                    '<div class="ttso-pg-cast">' +
                      (charUrl ? '<i><img src="' + esc(charUrl) + '" alt=""></i>' : '') +
                      pgFam.map((n) => '<i>' + esc(n.charAt(0).toUpperCase()) + '</i>').join('') +
                      '<i class="add">+</i>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</div>',
          });
          slides.push({
            cap: '🎟️ ' + (es ? 'Su boleto de estreno' : poss + ' premiere ticket'),
            html: '<div class="ttso-tk"><small>' + (es ? 'ESTRENO MUNDIAL' : 'WORLD PREMIERE') + '</small>' +
              '<b>' + esc(nm.toUpperCase()) + '</b><em>' + esc((es ? 'Protagonizada por ' : 'Starring ') + nm) + '</em><span>★ ★ ★ ★ ★</span></div>',
          });

          if (!document.getElementById('ttSOStyles')) {
            const st = document.createElement('style');
            st.id = 'ttSOStyles';
            st.textContent = [
              '#ttSO{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(10,14,28,.5);opacity:0;transition:opacity .3s ease}',
              '#ttSO.on{opacity:1}',
              '.ttso-card{position:relative;width:100%;max-width:390px;max-height:94vh;overflow-y:auto;border-radius:24px;background:#fff;text-align:center;font-family:Nunito,sans-serif;color:#151a33;box-shadow:0 30px 70px rgba(10,14,28,.4);transform:translateY(12px);transition:transform .35s ease}',
              '#ttSO.on .ttso-card{transform:none}',
              '.ttso-hero{position:relative;padding:24px 14px 14px;background:radial-gradient(80% 70% at 50% 0%,#3a3f6b 0%,#151a33 72%)}',
              '.ttso-x{position:absolute;top:10px;right:10px;z-index:3;width:34px;height:34px;border:none;border-radius:50%;background:rgba(255,255,255,.9);color:#151a33;font-size:20px;line-height:1;cursor:pointer}',
              '.ttso-stage{position:relative;height:200px}',
              '.ttso-s{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;opacity:0;transform:translateX(44px);transition:opacity .55s ease,transform .75s cubic-bezier(.22,1,.36,1);pointer-events:none}',
              '.ttso-s.on{opacity:1;transform:none}',
              '.ttso-s.out{opacity:0;transform:translateX(-44px)}',
              '.ttso-mv{position:relative;width:min(100%,330px);aspect-ratio:16/9;border-radius:12px;overflow:hidden;border:4px solid #fff;background:#0b1020;box-shadow:0 0 0 2px #f6d27a,0 18px 40px rgba(0,0,0,.5)}',
              '.ttso-mv video{display:block;width:100%;height:100%;object-fit:cover}',
              '.ttso-mv-char{position:absolute;left:4%;top:8%;width:32%;height:84%;object-fit:contain;object-position:bottom center;filter:drop-shadow(0 8px 16px rgba(0,0,0,.35))}',
              '.ttso-pst{height:190px;aspect-ratio:2/3;border-radius:8px;overflow:hidden;border:4px solid #fff;box-shadow:0 0 0 2px #f6d27a,0 18px 40px rgba(0,0,0,.5);transform:rotate(-2deg)}',
              '.ttso-pst img{display:block;width:100%;height:100%;object-fit:cover}',
              '.ttso-tk{position:relative;width:min(88%,290px);padding:18px 16px;border-radius:14px;border:4px solid #fff;background:linear-gradient(140deg,#fff3d0 0%,#f5dc8a 45%,#d4af37 100%);color:#3a2400;transform:rotate(2deg);box-shadow:0 18px 40px rgba(0,0,0,.45)}',
              '.ttso-tk:before,.ttso-tk:after{content:"";position:absolute;top:50%;width:20px;height:20px;margin-top:-10px;border-radius:50%;background:#1d2244}',
              '.ttso-tk:before{left:-14px}.ttso-tk:after{right:-14px}',
              '.ttso-tk small{display:block;font-size:10px;font-weight:900;letter-spacing:.24em}',
              '.ttso-tk b{display:block;margin:6px 0 2px;font-family:Fraunces,Georgia,serif;font-size:32px;font-weight:700;line-height:1;overflow-wrap:anywhere}',
              '.ttso-tk em{display:block;font-family:Fraunces,Georgia,serif;font-style:italic;font-size:15px;font-weight:600}',
              '.ttso-tk span{display:block;margin-top:6px;font-size:11px;letter-spacing:.3em;color:#8a6200}',
              '.ttso-cap{margin-top:12px;min-height:24px;font-family:Fraunces,Georgia,serif;font-style:italic;font-weight:600;font-size:18px;color:#fff}',
              '.ttso-cap.in{animation:ttsoCap .5s ease}',
              '@keyframes ttsoCap{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}',
              '.ttso-dots{display:flex;justify-content:center;gap:6px;margin-top:8px}',
              '.ttso-dots i{display:block;width:6px;height:6px;border-radius:999px;background:rgba(255,255,255,.35);transition:all .3s}',
              '.ttso-dots i.on{width:18px;background:#f6d27a}',
              '.ttso-body{padding:18px 20px 14px}',
              '.ttso-h{margin:0 0 8px;font-family:Fraunces,Georgia,serif;font-size:clamp(23px,6.2vw,28px);font-weight:600;line-height:1.12;letter-spacing:-.02em;color:#151a33}',
              '.ttso-h em{position:relative;display:block;width:fit-content;margin:4px auto 0;font-style:italic;font-weight:600;color:#2f6f96}',
              `.ttso-h em::after{content:"";position:absolute;left:2%;right:-3%;bottom:-.12em;height:.24em;pointer-events:none;background:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 20' preserveAspectRatio='none'%3E%3Cpath d='M3 14 C 50 4, 120 2, 197 9' stroke='%23f2b84b' stroke-width='5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat center/100% 100%}`,
              '.ttso-sub{margin:0 0 16px;font-size:14.5px;font-weight:700;line-height:1.45;color:#5b6475}',
              '.ttso-go{display:block;width:100%;min-height:58px;border-radius:14px;font-family:Nunito,sans-serif;font-size:17px;font-weight:900;cursor:pointer}',
              '.ttso-guar{margin:10px 0 0;font-size:13px;font-weight:800;color:#1e8a55}',
              '.ttso-song{margin-top:2px;padding:8px;border:none;background:none;color:#5b6475;font-family:Nunito,sans-serif;font-size:13.5px;font-weight:800;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
              '@media (max-width:420px){.ttso-stage{height:180px}.ttso-pst{height:170px}.ttso-h{font-size:23px}}',
              '@media (prefers-reduced-motion:reduce){#ttSO,.ttso-card,.ttso-s{transition:opacity .2s}.ttso-s,.ttso-s.out{transform:none}}',
            ].join('');
            document.head.appendChild(st);
          }

          if (!document.getElementById('ttSongBigStyles')) {
            const sb = document.createElement('style');
            sb.id = 'ttSongBigStyles';
            sb.textContent =
              '#ttSO .ttso-song{display:block;width:100%;min-height:52px;margin-top:10px;padding:0 16px;border:1.5px solid #dfe5ee;border-radius:14px;' +
              'background:#fff;color:#151a33;font-size:15px;font-weight:900;text-decoration:none;box-shadow:0 8px 20px -12px rgba(21,26,51,.35)}' +
              // Compact modal: fits one phone screen
              '#ttSO .ttso-hero{padding:16px 14px 10px !important}' +
              '#ttSO .ttso-stage{height:160px !important}' +
              '#ttSO .ttso-pst{height:150px !important}' +
              '#ttSO .ttso-mv{width:min(100%,270px) !important}' +
              '#ttSO .ttso-cap{margin-top:8px;font-size:15px}' +
              '#ttSO .ttso-body{padding:16px 20px 14px}' +
              '#ttSO .ttso-h{font-size:24px;margin-bottom:6px}' +
              '#ttSO .ttso-sub{margin:0 auto 14px;max-width:320px;font-size:14px;line-height:1.45}' +
              '#ttSO .ttso-xmas{margin:-4px 0 10px;font-size:13px;font-weight:900;color:#1e824c}' +
              '#ttSO .ttso-xmas s{margin-left:4px;color:#9ca3af;font-weight:700}' +
              '#ttSO .ttso-guar{margin-top:8px;font-size:12.5px}' +
              '#ttSO .ttso-mv.split video{position:absolute;top:0;left:36%;width:64%;height:100%}' +
              '#ttSO .ttso-mv.split::before{content:"";position:absolute;left:0;top:0;bottom:0;width:36%;background:#fff}' +
              '#ttSO .ttso-mv-char{z-index:1}';
            document.head.appendChild(sb);
          }
          if (!document.getElementById('ttSOv2Styles')) {
            const s2 = document.createElement('style');
            s2.id = 'ttSOv2Styles';
            s2.textContent =
              '#ttSO button.ttso-go{border:none !important;color:#2b1d00 !important;text-shadow:0 1px 0 rgba(255,245,210,.6) !important;' +
                'background:linear-gradient(180deg,#fff3c4 0%,#f7d774 22%,#e9b64a 52%,#c98f22 78%,#e6b54d 100%) !important;' +
                'box-shadow:0 1px 0 rgba(255,255,255,.85) inset,0 -2px 0 rgba(120,80,0,.25) inset,0 12px 26px -10px rgba(201,143,34,.7),0 0 0 1px rgba(160,110,20,.35) !important}' +
              '.ttso-inc{list-style:none;margin:2px auto 16px;padding:0;display:inline-flex;flex-direction:column;gap:8px;text-align:left}' +
              '.ttso-inc li{display:flex;gap:10px;align-items:flex-start;font-size:15px;font-weight:800;line-height:1.3;color:#1e293b}' +
              '.ttso-inc i{flex-shrink:0;display:flex;align-items:center;justify-content:center;width:20px;height:20px;margin-top:1px;border-radius:50%;background:#e8f6ee;color:#1e8a55;font-style:normal;font-size:11px;font-weight:900}' +
              '.ttso-next{margin:8px 0 0;font-size:13px;font-weight:700;line-height:1.45;color:#5b6475}' +
              '.ttso-pg{width:min(100%,320px);border-radius:12px;overflow:hidden;background:#fffaf0;border:3px solid #fff;box-shadow:0 0 0 2px #f6d27a,0 18px 40px rgba(0,0,0,.5);text-align:left;font-family:Nunito,sans-serif}' +
              '.ttso-pg-bar{display:flex;align-items:center;gap:4px;padding:6px 8px;background:#151a33}' +
              '.ttso-pg-bar i{display:block;width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,.35)}' +
              '.ttso-pg-bar span{margin-left:6px;font-size:10px;font-weight:900;color:#f6d27a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
              '.ttso-pg-body{display:flex;gap:10px;padding:10px}' +
              '.ttso-pg-vid{flex:0 0 52%;aspect-ratio:16/10;border-radius:8px;background:#0b1020 center 20%/cover no-repeat;display:flex;align-items:center;justify-content:center}' +
              '.ttso-pg-vid span{display:flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:50%;background:rgba(255,255,255,.92);color:#151a33;font-size:12px;padding-left:2px;box-shadow:0 4px 12px rgba(0,0,0,.35)}' +
              '.ttso-pg-side{flex:1;min-width:0;display:flex;flex-direction:column;gap:5px}' +
              '.ttso-pg-side b{font-family:Fraunces,Georgia,serif;font-size:14px;font-weight:600;line-height:1.1;color:#151a33;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
              '.ttso-pg-btn{padding:5px 8px;border-radius:7px;background:linear-gradient(180deg,#f7d774,#e9b64a);font-size:10.5px;font-weight:900;color:#2b1d00;text-align:center}' +
              '.ttso-pg-btn.alt{background:#fff;border:1px solid #e5e7eb;color:#151a33}' +
              '.ttso-pg-cast{display:flex;margin-top:2px}' +
              '.ttso-pg-cast i{display:flex;align-items:center;justify-content:center;width:22px;height:22px;margin-right:-5px;border-radius:50%;overflow:hidden;border:2px solid #fff;background:#fff8e6;font-style:normal;font-family:Fraunces,Georgia,serif;font-size:10px;font-weight:700;color:#b7862a}' +
              '.ttso-pg-cast i img{width:100%;height:100%;object-fit:cover;object-position:50% 8%}' +
              '.ttso-pg-cast i.add{border-style:dashed;border-color:#e9c46a;background:#fff;color:#b7862a;font-family:Nunito,sans-serif;font-size:13px}';
            document.head.appendChild(s2);
          }
          const ov = document.createElement('div');
          ov.id = 'ttSO';
          ov.setAttribute('role', 'dialog');
          ov.setAttribute('aria-modal', 'true');
          ov.innerHTML =
            '<div class="ttso-card">' +
              '<div class="ttso-hero">' +
                '<button type="button" class="ttso-x" aria-label="Close">×</button>' +
                '<div class="ttso-stage">' + slides.map((s, i) => '<div class="ttso-s' + (i ? '' : ' on') + '">' + s.html + '</div>').join('') + '</div>' +
                '<div class="ttso-cap">' + esc(slides[0].cap) + '</div>' +
                (slides.length > 1 ? '<div class="ttso-dots">' + slides.map((s, i) => '<i' + (i ? '' : ' class="on"') + '></i>').join('') + '</div>' : '') +
              '</div>' +
              '<div class="ttso-body">' +
                '<h2 class="ttso-h">' + (es ? 'El regalo perfecto 🎁' : 'The Perfect Gift 🎁') + '</h2>' +
                '<p class="ttso-sub">' + esc(es
                  ? 'Su película y canción completas, póster y boleto de estreno. Agrega a la familia gratis.'
                  : poss + ' full movie & song, poster and premiere ticket. Add family free after checkout.') + '</p>' +
                (hasChar && ttIsXmas()
                  ? '<div class="ttso-xmas">🎄 Early bird Christmas price <s>$29.99</s></div>'
                  : '') +
                '<button type="button" class="ttso-go">' + esc(hasChar
                  ? (es ? 'Obtener su película · ' : 'Get ' + poss + ' movie · ') + price
                  : (es ? 'Crear su personaje' : 'Create ' + poss + ' character')) + '</button>' +
                '<button type="button" class="ttso-song">' + esc((es ? '🎵 Solo su canción completa · ' : '🎵 Just ' + poss + ' full song · ') + songPrice) + '</button>' +
                '<p class="ttso-guar">' + (es ? '🔒 Pago seguro · Te encanta o te devolvemos tu dinero' : '🔒 Secure checkout · Love it or your money back') + '</p>' +
              '</div>' +
            '</div>';
          document.body.appendChild(ov);
          requestAnimationFrame(() => ov.classList.add('on'));

          // Slides: movie → poster → ticket, sliding in from the right
          const sEls = ov.querySelectorAll('.ttso-s');
          const dots = ov.querySelectorAll('.ttso-dots i');
          const capEl = ov.querySelector('.ttso-cap');
          const playV = (k) => sEls.forEach((s, j) => {
            const v = s.querySelector('video');
            if (!v) return;
            if (j === k) { v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.play().catch(() => {}); }
            else v.pause();
          });
          playV(0);
          let si = 0;
          const nextSlide = () => {
            if (!ov.isConnected || sEls.length < 2) return;
            const prev = sEls[si];
            prev.classList.remove('on');
            prev.classList.add('out');
            setTimeout(() => prev.classList.remove('out'), 750);
            if (dots[si]) dots[si].classList.remove('on');
            si = (si + 1) % sEls.length;
            sEls[si].classList.add('on');
            if (dots[si]) dots[si].classList.add('on');
            if (capEl) { capEl.classList.remove('in'); void capEl.offsetWidth; capEl.textContent = slides[si].cap; capEl.classList.add('in'); }
            playV(si);
            setTimeout(nextSlide, slides[si].dur || 3500);
          };
          setTimeout(nextSlide, slides[0].dur || 3500);

          const close = (back) => {
            ov.classList.remove('on');
            setTimeout(() => ov.remove(), 300);
            if (back) {
              ttShowNextStepsBar();
              setTimeout(() => { if (window.ttFrameStage) window.ttFrameStage(); }, 60);
            }
          };
          ov.querySelector('.ttso-x').addEventListener('click', () => { ttTrack('pv_simple_close'); close(true); });
          ov.addEventListener('click', (e) => { if (e.target === ov) close(true); });
          ov.querySelector('.ttso-go').addEventListener('click', () => {
            close(false);
            if (!hasChar) { ttTrack('pv_simple_build'); window.ttMakingCast = true; ttStartCharacterForMovie(); return; }
            ttTrack('pv_click_movie');
            if (window.ttDrawerTest) ttShowOrderDrawer();
            else goToVideoCheckout({ fromSheet: true });
          });
          ov.querySelector('.ttso-song').addEventListener('click', () => {
            ttTrack('pv_click_song');
            close(false);
            confirmThenBuySong({ _gift_send_enabled: 'no', Starring: titleCaseName(childName) || '' });
          });
        }
        // ── The sales sheet: one clean offer at the end of the preview ──
        function ttShowSalesSheet() {
          if (document.getElementById('ttSS')) return;
          if (window.savedCharacterUrl) { ttShowPackageOffer(); return; } // the package modal is the sales modal
          ttTrack('pv_offer_shown');

          // Settings
          const SONG_PRICE = 9.99;          // song on its own
          const MOVIE_LATER_PRICE = 19.99;  // what song owners pay to add the movie later (must match Shopify)
          const BUNDLE_PRICE = 24.99;
          const LAUNCH_LABEL = '';

          const es = ttLang === 'es';
          const nm = titleCaseName(String(childName || '').toLowerCase()) || (es ? 'su estrella' : 'them');
          const isUS = ttRegion === 'us';
          const moviePrice = regionPrice('video') || '$' + BUNDLE_PRICE.toFixed(2);
          const songNowEl = document.getElementById('ttModalSongPriceNow');
          const songPrice = regionPrice('song') || (songNowEl && songNowEl.textContent.trim()) || '$' + SONG_PRICE.toFixed(2);
          const separately = SONG_PRICE + MOVIE_LATER_PRICE;
          const showAnchor = false; // no crossed-out price or "SAVE" badge
          const saving = Math.round(separately - BUNDLE_PRICE);

          window.ttRevealActive = false;
          try { upsellAudio.pause(); } catch (e) {}

          if (!document.getElementById('ttSSStyles')) {
            const st = document.createElement('style');
            st.id = 'ttSSStyles';
            st.textContent = [
              '#ttSS{position:fixed;inset:0;z-index:100000;display:flex;align-items:flex-end;justify-content:center;background:rgba(10,14,28,.28);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);opacity:0;transition:opacity .65s ease}',
              '#ttSS.on{opacity:1}',
              '.ttss-card{position:relative;width:100%;max-width:440px;max-height:94vh;overflow-y:auto;background:#fff;border-radius:28px 28px 0 0;box-shadow:0 -12px 36px rgba(10,14,28,.16);transform:translateY(16px);opacity:.98;transition:transform .65s ease,opacity .65s ease;padding-bottom:env(safe-area-inset-bottom,0px)}',
              '#ttSS.on .ttss-card{transform:translateY(0);opacity:1}',
              '@media (min-width:600px){#ttSS{align-items:center}.ttss-card{border-radius:28px}}',
              '.ttss-hero{position:relative;height:clamp(230px,36vh,320px);overflow:hidden;background:radial-gradient(70% 90% at 50% 0%,#fffaf0 0%,#fdebc4 55%,#f6d690 100%)}',
              '.ttss-hero:before{content:"";position:absolute;inset:-20% 15% 30%;background:radial-gradient(closest-side,rgba(255,255,255,.95),rgba(255,255,255,0));pointer-events:none}',
              '.ttss-rays{position:absolute;left:50%;top:-10%;width:260%;aspect-ratio:1;transform:translate(-50%,-50%);background:repeating-conic-gradient(from 0deg,rgba(255,255,255,.24) 0deg 6deg,rgba(255,255,255,0) 6deg 14deg);pointer-events:none;animation:ttssSpin 60s linear infinite}',
              '@keyframes ttssSpin{to{transform:translate(-50%,-50%) rotate(360deg)}}',
              '.ttss-spark{position:absolute;bottom:20%;width:5px;height:5px;border-radius:50%;background:radial-gradient(circle,#fff 0%,#f5d77a 60%,transparent 100%);opacity:0;pointer-events:none;animation:ttssRise 6s ease-in infinite}',
              '@keyframes ttssRise{0%{opacity:0;transform:translateY(0) scale(.6)}15%{opacity:.9}100%{opacity:0;transform:translateY(-160px) scale(1)}}',
              '.ttss-char{position:absolute;left:50%;bottom:62px;height:70%;transform:translateX(-50%);mix-blend-mode:multiply;-webkit-mask-image:radial-gradient(ellipse 62% 58% at 50% 50%,#000 72%,transparent 100%);mask-image:radial-gradient(ellipse 62% 58% at 50% 50%,#000 72%,transparent 100%);animation:ttssBob 4s ease-in-out infinite}',
              '@keyframes ttssBob{0%,100%{translate:0 0}50%{translate:0 -4px}}',
              '.ttss-hero.has-mini .ttss-char{left:40%}',
              '.ttss-mini{position:absolute;right:9%;bottom:66px;width:25%;aspect-ratio:2/3;object-fit:cover;border:4px solid #fff;border-radius:6px;box-shadow:0 12px 26px rgba(80,50,0,.28);rotate:6deg;animation:ttssSway 5s ease-in-out infinite}',
              '@keyframes ttssSway{0%,100%{rotate:6deg}50%{rotate:4deg}}',
              '@media (prefers-reduced-motion:reduce){.ttss-rays,.ttss-spark,.ttss-char,.ttss-mini{animation:none}}',
              '.ttss-poster{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center 18%}',
                            '.ttss-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}',
              '.ttss-video-fade{position:absolute;left:0;right:0;bottom:0;height:55%;background:linear-gradient(to top,rgba(10,14,28,.85),rgba(10,14,28,0));pointer-events:none}',
                 '.ttss-hero.has-video .ttss-star{display:none}',
              '.ttss-floor{position:absolute;left:50%;bottom:36px;width:46%;height:18px;transform:translateX(-50%);background:radial-gradient(closest-side,rgba(120,80,10,.22),transparent);pointer-events:none}',
              '.ttss-star{position:absolute;left:0;right:0;bottom:12px;text-align:center;font-family:Fraunces,Georgia,serif}',
              '.ttss-star small{display:block;font-family:Nunito,sans-serif;font-size:10.5px;font-weight:900;letter-spacing:.32em;color:#a16207}',
              '.ttss-star b{display:block;font-size:22px;font-weight:600;color:#3b2a0a;line-height:1.1}',
              '.ttss-x{position:absolute;top:12px;right:12px;z-index:3;width:36px;height:36px;border-radius:50%;border:none;background:rgba(255,255,255,.75);color:#1f2937;font-size:20px;line-height:36px;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.08)}',
              '.ttss-body{padding:20px 24px 22px;text-align:center;font-family:Nunito,sans-serif}',
              '.ttss-h{margin:0 0 4px;font-family:Fraunces,Georgia,serif;font-size:26px;font-weight:600;color:#0f172a;line-height:1.15}',
              '.ttss-sub{margin:0 0 16px;font-size:14.5px;font-weight:700;color:#64748b}',
              '.ttss-list{display:inline-flex;flex-direction:column;gap:7px;margin:0 0 18px;text-align:left}',
              '.ttss-list div{display:flex;align-items:center;gap:10px;font-size:15px;font-weight:800;color:#1e293b}',
              '.ttss-list i{font-style:normal;width:26px;height:26px;border-radius:50%;background:#f1f5f9;display:flex;align-items:center;justify-content:center;font-size:14px}',
              '.ttss-launch{display:inline-block;margin-bottom:6px;padding:4px 10px;border-radius:999px;background:#fff7ed;color:#c2410c;font-size:11px;font-weight:900;letter-spacing:.06em;text-transform:uppercase}',
              '.ttss-price{display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:14px}',
              '.ttss-was{font-size:18px;font-weight:800;color:#94a3b8;text-decoration:line-through}',
              '.ttss-now{font-family:Fraunces,Georgia,serif;font-size:36px;font-weight:600;color:#0f172a;line-height:1}',
              '.ttss-save{padding:5px 9px;border-radius:8px;background:#dcfce7;color:#15803d;font-size:11.5px;font-weight:900;letter-spacing:.04em}',
              '.ttss-cta{display:block;width:100%;padding:18px 20px;border:none;border-radius:16px;background:linear-gradient(180deg,#1e293b,#0b1220);color:#fff;font-family:Nunito,sans-serif;font-size:17.5px;font-weight:900;cursor:pointer;box-shadow:0 12px 26px rgba(11,18,32,.28),inset 0 1px 0 rgba(255,255,255,.12);transition:transform .15s ease}',
              '.ttss-cta:active{transform:scale(.98)}',
              '.ttss-trust{margin:10px 0 0;font-size:12.5px;font-weight:700;color:#64748b}',
              '.ttss-trust span{color:#f59e0b;letter-spacing:1px}',
              '.ttss-song{margin-top:14px;background:none;border:none;color:#475569;font-family:Nunito,sans-serif;font-size:14px;font-weight:800;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
                                '.ttf-email{margin:0 0 14px;text-align:center}',
                  '.ttf-email-row{display:inline-flex;justify-content:center;align-items:center;gap:6px;padding:0;background:none;border:none;max-width:100%}',
                  '.ttf-email-label{text-transform:none;letter-spacing:0;font-size:13.5px;font-weight:700;color:#7a8394}',
                  '.ttf-email-val{flex:0 1 auto;font-size:13.5px;font-weight:800;color:#151a33}',
                  '.ttf-email-edit{font-size:13.5px;text-decoration:underline;text-underline-offset:3px}',
                  '.ttf-email-input{text-align:left}',

              '.ttss-rot{position:relative;height:38px;margin:2px 0 14px}',
              '.ttss-r{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;white-space:nowrap;font-family:Fraunces,Georgia,serif;font-style:italic;font-weight:700;font-size:26px;letter-spacing:-.015em;color:#151a33;opacity:0;transform:translateY(6px);transition:opacity .6s ease,transform .6s ease}',
              '.ttss-r.on{opacity:1;transform:none}',



                              '.ttss-hero.has-cast{height:auto !important;padding:26px 16px 14px;display:flex;flex-direction:column;align-items:center;gap:12px}',
              '.ttss-hero.has-cast .ttss-star{position:relative;bottom:auto;z-index:1}',
              '.ttss-cast{position:relative;z-index:1;display:flex;flex-direction:column;align-items:center;gap:12px}',
              '.ttss-cast-lead{width:132px;height:132px;border-radius:50%;overflow:hidden;background:#fff;border:4px solid #fff;box-shadow:0 0 0 3px #f6d27a,0 16px 32px rgba(80,50,0,.25)}',
              '.ttss-cast-lead img{width:100%;height:100%;object-fit:cover;object-position:center 12%}',
              '.ttss-cast-row{display:flex;justify-content:center;gap:14px;flex-wrap:wrap}',
              '.ttss-cast-m{display:flex;flex-direction:column;align-items:center;gap:5px;width:70px}',
              '.ttss-cast-m i{display:block;width:64px;height:64px;border-radius:50%;overflow:hidden;background:#fff;border:3px solid #fff;box-shadow:0 8px 18px rgba(80,50,0,.2)}',
              '.ttss-cast-m img{width:100%;height:100%;object-fit:cover;object-position:center 12%}',
              '.ttss-cast-m span{font-family:Nunito,sans-serif;font-size:12px;font-weight:900;color:#3b2a0a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:70px}',
              '.ttss-gw-h{font-family:Fraunces,Georgia,serif;font-style:italic;font-weight:700;font-size:25px;line-height:1.2;color:#151a33;margin:2px 0 14px}',
                            '.ttss-hero.has-premiere{height:auto !important;padding:22px 16px 14px;display:flex;flex-direction:column;align-items:center;gap:12px;background:radial-gradient(80% 60% at 50% 0%,#3a3f6b 0%,#151a33 70%)}',
              '.ttss-hero.has-premiere:before{background:radial-gradient(closest-side,rgba(255,236,170,.35),rgba(255,236,170,0))}',
              '.ttss-hero.has-premiere .ttss-star{position:relative;bottom:auto;z-index:1}',
              '.ttss-hero.has-premiere .ttss-star small{color:#f6d27a}',
              '.ttss-hero.has-premiere .ttss-star b{color:#fff}',
              '.ttss-pwrap{position:relative;z-index:1;width:min(62%,250px);aspect-ratio:2/3;border-radius:10px;overflow:hidden;border:4px solid #fff;box-shadow:0 0 0 2px #f6d27a,0 22px 50px rgba(0,0,0,.55),0 0 60px rgba(246,210,122,.35);background:#0b1020;opacity:0;transform:scale(.7) rotate(-3deg);animation:ttssPosterIn .9s cubic-bezier(.2,1.3,.4,1) 1.35s forwards}',
              '@keyframes ttssPosterIn{to{opacity:1;transform:none}}',
              '.ttss-pimg{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;transition:opacity .6s ease}',
              '.ttss-pimg.is-char{object-position:center 15%;background:#eef2f6}',
              '.ttss-pshine{position:absolute;inset:0;background:linear-gradient(115deg,transparent 35%,rgba(255,255,255,.55) 50%,transparent 65%);transform:translateX(-120%);animation:ttssShine 1.4s ease 2.2s forwards;pointer-events:none}',
              '@keyframes ttssShine{to{transform:translateX(120%)}}',
              '.ttss-fam{position:relative;z-index:1;display:flex;flex-wrap:wrap;justify-content:center;gap:12px;opacity:0;animation:ttssFade .5s ease 2.4s forwards}',
              '@keyframes ttssFade{to{opacity:1}}',
              '.ttss-fam-m{display:flex;flex-direction:column;align-items:center;gap:4px;width:62px;background:none;border:none;padding:0;cursor:pointer;font-family:Nunito,sans-serif}',
              '.ttss-fam-m i{display:flex;align-items:center;justify-content:center;width:52px;height:52px;border-radius:50%;overflow:hidden;font-style:normal;font-size:24px;font-weight:900;color:#f6d27a;border:2px dashed rgba(246,210,122,.8);background:rgba(255,255,255,.08)}',
              '.ttss-fam-m.done i{border:3px solid #fff;background:#fff;box-shadow:0 6px 14px rgba(0,0,0,.3)}',
              '.ttss-fam-m img{width:100%;height:100%;object-fit:cover;object-position:center 15%}',
              '.ttss-fam-m span{font-size:11.5px;font-weight:900;color:#fff;max-width:62px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
              '.ttss-fam-hint{width:100%;text-align:center;font-family:Nunito,sans-serif;font-size:11.5px;font-weight:800;color:rgba(255,255,255,.75);margin-top:2px}',
              '.ttss-fam-panel{margin:0 0 14px;text-align:left}',
              '.ttss-curtain{position:absolute;inset:0;z-index:5;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;background:#0b0f1f;color:#fff;text-align:center;font-family:Fraunces,Georgia,serif;animation:ttssCurtain 1.5s ease forwards;pointer-events:none}',
              '.ttss-curtain small{font-family:Nunito,sans-serif;font-size:12px;font-weight:900;letter-spacing:.3em;color:#f6d27a}',
              '.ttss-curtain b{font-size:38px;font-weight:600;font-style:italic}',
              '@keyframes ttssCurtain{0%,60%{opacity:1}100%{opacity:0;visibility:hidden}}',
              '@media (prefers-reduced-motion:reduce){.ttss-pwrap,.ttss-fam{animation:none;opacity:1;transform:none}.ttss-curtain{display:none}}',
                            '.ttss-pwrap{width:min(48%,190px);animation-delay:.1s}',
              '.ttss-prow{position:relative;z-index:1;display:flex;align-items:center;justify-content:center;gap:14px}',
              '.ttss-cbub{display:flex;flex-direction:column;align-items:center;gap:6px;opacity:0;animation:ttssFade .5s ease .6s forwards}',
              '.ttss-cbub i{display:block;width:84px;height:84px;border-radius:50%;overflow:hidden;background:#fff;border:3px solid #fff;box-shadow:0 0 0 2px #f6d27a,0 10px 24px rgba(0,0,0,.4)}',
              '.ttss-cbub img{width:100%;height:100%;object-fit:cover;object-position:center 12%}',
              '.ttss-cbub span{font-family:Fraunces,Georgia,serif;font-style:italic;font-size:15px;font-weight:600;color:#fff}',
              '.ttss-lock{position:relative;z-index:1;text-align:center;opacity:0;animation:ttssFade .5s ease .9s forwards}',
              '.ttss-lock-row{display:flex;flex-wrap:wrap;justify-content:center;gap:6px;margin-bottom:6px}',
              '.ttss-lock-chip{padding:5px 11px;border-radius:999px;background:rgba(255,255,255,.1);border:1px solid rgba(246,210,122,.45);font-family:Nunito,sans-serif;font-size:12px;font-weight:900;color:#fff}',
              '.ttss-lock-txt{font-family:Nunito,sans-serif;font-size:12.5px;font-weight:800;color:#f6d27a}',
                            '.ttss-face{position:relative;z-index:1;width:min(68%,250px);aspect-ratio:1;border-radius:50%;background-color:#fff;background-repeat:no-repeat;background-size:240%;background-position:50% 9%;border:5px solid #fff;box-shadow:0 0 0 3px #f6d27a,0 24px 60px rgba(0,0,0,.55),0 0 80px rgba(246,210,122,.45);animation:ttssFaceIn .8s cubic-bezier(.2,1.3,.4,1) both}',
              '@keyframes ttssFaceIn{from{opacity:0;transform:scale(.75)}to{opacity:1;transform:none}}',
                 '@media (max-width:600px){' +
                                 '.ttss-cbub i{width:68px;height:68px}' +
                '#ttSS{align-items:center;padding:14px}' +
                '.ttss-card{border-radius:24px;max-height:92vh}' +
                '.ttss-hero{height:clamp(170px,26vh,210px)}' +
                '.ttss-char{bottom:42px;height:64%}' +
                '.ttss-mini{bottom:46px;width:18%}' +
                '.ttss-star{bottom:6px}' +
                '.ttss-star small{font-size:9px;letter-spacing:.28em}' +
                '.ttss-star b{font-size:18px}' +
                '.ttss-x{width:32px;height:32px;line-height:32px;font-size:18px}' +
                '.ttss-body{padding:14px 18px 14px}' +
                '.ttss-h{font-size:21px;margin-bottom:8px}' +
                '.ttss-sub{display:none}' +
                '.ttss-list{gap:4px;margin-bottom:10px}' +
                '.ttss-list div{font-size:13.5px;gap:8px}' +
                '.ttss-list i{width:20px;height:20px;font-size:11px}' +
                '.ttss-price{margin-bottom:10px;gap:8px}' +
                '.ttss-now{font-size:28px}' +
                '.ttss-was{font-size:14px}' +
                '.ttss-save{font-size:10px;padding:4px 7px}' +
                '.ttss-cta{padding:14px 18px;font-size:16px}' +
                '.ttss-trust{font-size:11px;margin-top:6px}' +
                '.ttss-song{margin-top:6px;font-size:13px}' +
                '.ttss-rot{height:32px;margin:0 0 10px}' +
                '.ttss-r{font-size:21px}' +
                                '.ttss-hero.has-cast{padding:20px 12px 10px}' +
                '.ttss-cast-lead{width:108px;height:108px}' +
                '.ttss-cast-m i{width:54px;height:54px}' +
                '.ttss-gw-h{font-size:21px}' +
                                '.ttss-pwrap{width:min(58%,210px)}' +
                '.ttss-curtain b{font-size:30px}' +
                '.ttss-fam-m i{width:44px;height:44px}' +
                                '.ttss-face{width:min(62%,210px)}' +
              '}',

            ].join('');
            document.head.appendChild(st);
          }

          if (!document.getElementById('ttSSv2Styles')) {
            const st2 = document.createElement('style');
            st2.id = 'ttSSv2Styles';
            st2.textContent = [
              // Showcase: star → poster → ticket
              '.ttsv{position:relative;z-index:1;display:flex;flex-direction:column;align-items:center;gap:10px;width:100%}',
              '.ttsv-stage{position:relative;width:100%;height:240px}',
              '.ttsv-s{position:absolute;inset:0;display:flex !important;align-items:center;justify-content:center;opacity:0;transform:scale(.92);transition:opacity .6s ease,transform .8s cubic-bezier(.2,1.2,.4,1);pointer-events:none}',
              '.ttsv-s.on{opacity:1;transform:none}',
              '.ttsv-face{width:220px;height:220px;border-radius:50%;overflow:hidden;background:#fff;border:5px solid #fff;box-shadow:0 0 0 3px #f6d27a,0 24px 60px rgba(0,0,0,.55),0 0 80px rgba(246,210,122,.45)}',
              '.ttsv-face img{display:block;width:100%;height:100%;object-fit:cover;object-position:50% 12%;transform:scale(1.15);transform-origin:50% 15%}',
              '.ttsv-poster{height:230px;aspect-ratio:2/3;border-radius:8px;overflow:hidden;border:5px solid #fff;box-shadow:0 0 0 2px #f6d27a,0 24px 50px rgba(0,0,0,.55);transform:rotate(-3deg)}',
              '.ttsv-poster img{display:block;width:100%;height:100%;object-fit:cover}',
              // Movie slide + opening-credits name
              '.ttsv-movie{position:relative;width:min(92%,340px);aspect-ratio:16/9;border-radius:12px;overflow:hidden;border:5px solid #fff;background:#0b1020;box-shadow:0 0 0 2px #f6d27a,0 24px 50px rgba(0,0,0,.55)}',
              '.ttsv-movie video{display:block;width:100%;height:100%;object-fit:cover}',
              '.ttsv-ex{position:absolute;top:8px;left:8px;padding:3px 8px;border-radius:999px;background:rgba(0,0,0,.55);color:#fff;font-family:Nunito,sans-serif;font-size:9.5px;font-weight:900;letter-spacing:.14em}',
              '.ttsv-credit{position:absolute;left:0;right:0;bottom:0;display:flex;flex-direction:column;align-items:center;padding:28px 10px 10px;background:linear-gradient(to top,rgba(5,8,20,.75),rgba(5,8,20,0));pointer-events:none;opacity:0}',
              '.ttsv-credit small{font-family:Nunito,sans-serif;font-size:8.5px;font-weight:900;letter-spacing:.32em;color:#f6d27a}',
              '.ttsv-credit b{margin-top:2px;font-family:Fraunces,Georgia,serif;font-style:italic;font-weight:600;font-size:clamp(20px,6vw,26px);line-height:1.05;color:#fff;text-shadow:0 2px 12px rgba(0,0,0,.6);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}',
              '.ttsv-s.on .ttsv-credit{animation:ttsvCredit 1.2s ease .35s forwards}',
              '@keyframes ttsvCredit{from{opacity:0;transform:scale(.94);letter-spacing:.08em}to{opacity:1;transform:none;letter-spacing:0}}',
                            '.ttsv-movie{position:relative;width:min(92%,340px);aspect-ratio:16/9;border-radius:12px;overflow:hidden;border:5px solid #fff;background:#0b1020;box-shadow:0 0 0 2px #f6d27a,0 24px 50px rgba(0,0,0,.55)}',
              '.ttsv-movie video{display:block;width:100%;height:100%;object-fit:cover}',
              '.ttsv-ex{position:absolute;top:8px;left:8px;padding:3px 8px;border-radius:999px;background:rgba(0,0,0,.55);color:#fff;font-family:Nunito,sans-serif;font-size:9.5px;font-weight:900;letter-spacing:.14em}',
              '.ttsv-ticket{position:relative;width:min(84%,300px);padding:22px 18px 18px;border-radius:14px;border:5px solid #fff;text-align:center;transform:rotate(3deg);background:linear-gradient(140deg,#fff3d0 0%,#f5dc8a 45%,#d4af37 100%);color:#3a2400;box-shadow:0 24px 50px rgba(0,0,0,.5)}',
              '.ttsv-ticket:before,.ttsv-ticket:after{content:"";position:absolute;top:50%;width:22px;height:22px;margin-top:-11px;border-radius:50%;background:#1b2040}',
              '.ttsv-ticket:before{left:-16px}.ttsv-ticket:after{right:-16px}',
              '.ttsv-ticket small{display:block;font-family:Nunito,sans-serif;font-size:10px;font-weight:900;letter-spacing:.24em}',
              '.ttsv-ticket b{display:block;margin:8px 0 4px;font-family:Fraunces,Georgia,serif;font-size:38px;font-weight:700;line-height:1;letter-spacing:.02em;overflow-wrap:anywhere}',
              '.ttsv-ticket em{display:block;font-family:Fraunces,Georgia,serif;font-style:italic;font-size:15px;font-weight:600}',
              '.ttsv-ticket span{display:block;margin-top:8px;font-size:12px;letter-spacing:.3em;color:#8a6200}',
              // Ticket with a QR stub on the right
              '.ttsv-ticket{display:flex;align-items:center;gap:14px;width:min(90%,330px);text-align:left;padding:18px 16px 16px 20px}',
              '.ttsv-tk-l{flex:1;min-width:0}',
              '.ttsv-ticket b{font-size:32px}',
              '.ttsv-qr{position:relative;flex-shrink:0;width:66px;height:66px;padding:4px;border-radius:6px;background:#fff8e1;box-shadow:inset 0 0 0 1px rgba(58,36,0,.2)}',
              '.ttsv-qr:before{content:"";position:absolute;left:-9px;top:-14px;bottom:-14px;border-left:2px dashed rgba(58,36,0,.35)}',
              '.ttsv-qr svg{display:block;width:100%;height:100%}',
              '@media (max-width:600px){.ttsv-qr{width:54px;height:54px}.ttsv-ticket b{font-size:26px}}',
              '.ttsv-cap{min-height:24px;font-family:Fraunces,Georgia,serif;font-style:italic;font-weight:600;font-size:19px;color:#fff}',
              '.ttsv-cap.in{animation:ttsvCap .5s ease}',
              '@keyframes ttsvCap{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}',
              '.ttsv-dots{display:flex;gap:6px}',
              '.ttsv-dots i{display:block !important;width:6px;height:6px;border-radius:999px;background:rgba(255,255,255,.35);transition:all .3s}',
              '.ttsv-dots i.on{width:18px;background:#f6d27a}',
              // Body
              '.ttss-sub2{margin:0 0 14px;font-size:13.5px;font-weight:800;color:#64748b}',
              '.ttss-list i{color:#1e8a55;font-weight:900}',
              '.ttss-price{flex-direction:column;gap:3px}',
              '.ttss-once{font-family:Nunito,sans-serif;font-size:12.5px;font-weight:800;color:#64748b}',
              '.ttss-body{padding-bottom:4px !important}',
              // Pinned footer
              '.ttss-foot{position:sticky;bottom:0;z-index:3;padding:12px 22px calc(10px + env(safe-area-inset-bottom,0px));background:linear-gradient(to top,#fff 82%,rgba(255,255,255,0));text-align:center}',
              '.ttss-guar{margin:8px 0 0;font-family:Nunito,sans-serif;font-size:13px;font-weight:900;color:#1e8a55}',
              '.ttss-foot .ttss-song{margin-top:2px}',
              // Mobile: bottom sheet
              '@media (max-width:600px){' +
                '#ttSS{align-items:flex-end !important;padding:0 !important}' +
                '.ttss-card{border-radius:24px 24px 0 0 !important;max-height:88vh !important;transform:translateY(16px) !important;opacity:.98;transition:transform .65s ease,opacity .65s ease}' +
                '#ttSS.on .ttss-card{transform:translateY(0) !important;opacity:1}' +
                '.ttss-card:before{content:"";position:absolute;top:8px;left:50%;width:40px;height:5px;margin-left:-20px;border-radius:999px;background:rgba(255,255,255,.45);z-index:5}' +
                '.ttsv-stage{height:190px}' +
                '.ttsv-face{width:170px;height:170px}' +
                '.ttsv-poster{height:180px}' +
                '.ttsv-ticket b{font-size:30px}' +
                '.ttsv-cap{font-size:16px}' +
                // Centered card on phones, not a bottom sheet
                '#ttSS{align-items:center !important;justify-content:center !important;padding:14px !important}' +
                '.ttss-card{border-radius:24px !important;width:100% !important;max-width:440px !important;max-height:88vh !important;margin:0 auto !important}' +
                '.ttss-card:before{display:none !important}' +
              '}',
              '@media (prefers-reduced-motion:reduce){.ttsv-s{transition:opacity .3s}}',
                            '.ttss-price{margin-bottom:4px !important}.ttss-foot{padding-top:6px !important}',
            ].join('');
            document.head.appendChild(st2);
          }

          const charUrl = window.savedCharacterUrl || '';
          const posterUrl = window.ttPoster1 || '';
          const sparks = [12, 24, 34, 66, 76, 88, 18, 82].map((x, i) =>
            '<span class="ttss-spark" style="left:' + x + '%;animation-delay:' + (i * 0.75).toFixed(2) + 's"></span>'
          ).join('');
                    const noCharSet = THEMED_HERO_VIDEOS[occasion] || (genre === 'lullaby' ? THEMED_HERO_VIDEOS.lullaby : null);
          const noCharVideo = (noCharSet && noCharSet.noCharacter) || 'https://cdn.shopify.com/videos/c/o/v/494918573ab14ecc99f49f0bb6d6ed29.mp4';
              const escC = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
           const castImgs = window.ttEntityImages || {};
          const castMembers = (window.ttAllCastEntities || []).filter((e) => e && castImgs[e.key]).slice(0, 5);
          const premiere = !!charUrl; // every character offer uses the big face close-up
          const famList = ((window.ttDetectedCast && window.ttDetectedCast.length ? window.ttDetectedCast : window.ttAllCastEntities) || []).slice(0, 5);
          // Showcase slides: the star, their real poster (if made after the character), their premiere ticket
          const posterOk = !!posterUrl && posterUrl !== (window.ttPosterBefore || '');
          const possSV = /s$/i.test(nm) ? nm + "'" : nm + "'s";
          const svSlides = [
            { cap: es ? '⭐ ' + nm + ', la estrella' : '⭐ ' + nm + ', the star',
              html: '<div class="ttsv-face"><img src="' + escC(charUrl) + '" alt=""></div>' },
          ];

          // Movie slide: their own demo clip if one exists, otherwise a 5-second themed example
          // "default" covers Birthday, Just Because and Missing You
          const EXAMPLE_MOVIES = {
            default: 'https://cdn.shopify.com/videos/c/o/v/80752555977f4e20aa8168b244f472c0.mp4',
            princess: 'https://cdn.shopify.com/videos/c/o/v/348505e870fe43f9bfc14916ea196e89.mp4',
            superhero: 'https://cdn.shopify.com/videos/c/o/v/650206384d5742c790ff4e67529ebf7d.mp4',
            halloween: 'https://cdn.shopify.com/videos/c/o/v/799497c7c22845f294af607cd6c20a47.mp4',
            christmas: 'https://cdn.shopify.com/videos/c/o/v/862214b42eaf4626a82b58881ccc8bb5.mp4',
            bedtime: 'https://cdn.shopify.com/videos/c/o/v/e75456915c284a7f97123ed75d62ba24.mp4',
          };
          const ownClip = window.ttDemoClipUrl || '';
          const exMovie =
            EXAMPLE_MOVIES[occasion] ||
            (genre === 'lullaby' || occasion === 'bedtime' ? EXAMPLE_MOVIES.bedtime : null) ||
            EXAMPLE_MOVIES.default;
          svSlides.push({
            dur: 4500,
            cap: ownClip
              ? (es ? '🎥 ' + nm + ' en acción' : '🎥 ' + nm + ' in action')
                : (es ? '🎥 La película de ' + nm : '🎥 ' + possSV + ' movie'),
            html: '<div class="ttsv-movie"><video muted playsinline loop preload="auto" src="' + escC(ownClip || exMovie) + '"></video>' +
              '' +
              '<span class="ttsv-credit"><small>' + (es ? 'UN ORIGINAL DE TINYTUNES' : 'A TINYTUNES ORIGINAL') + '</small>' +
                '<b>' + escC(es ? 'La película de ' + nm : possSV + ' Movie') + '</b></span>' +
              '</div>',
          });
          if (posterOk) {
            svSlides.push({ cap: es ? '🎬 El póster de su película' : '🎬 ' + possSV + ' movie poster',
              html: '<div class="ttsv-poster"><img src="' + escC(posterUrl) + '" alt=""></div>' });
          }
          // Decorative QR (unique per order, not scannable): seeded from their code so it never changes
          const ttQR = (seed) => {
            let a = 2166136261;
            for (const c of String(seed)) a = Math.imul(a ^ c.charCodeAt(0), 16777619);
            const rnd = () => {
              a = (a + 0x6d2b79f5) | 0;
              let t = Math.imul(a ^ (a >>> 15), 1 | a);
              t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
              return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
            };
            const finder = (x, y) =>
              '<rect x="' + x + '" y="' + y + '" width="7" height="7" fill="#3a2400"/>' +
              '<rect x="' + (x + 1) + '" y="' + (y + 1) + '" width="5" height="5" fill="#fff8e1"/>' +
              '<rect x="' + (x + 2) + '" y="' + (y + 2) + '" width="3" height="3" fill="#3a2400"/>';
            const inFinder = (x, y) => (x < 8 && y < 8) || (x > 12 && y < 8) || (x < 8 && y > 12);
            let dots = '';
            for (let y = 0; y < 21; y++) {
              for (let x = 0; x < 21; x++) {
                if (!inFinder(x, y) && rnd() > 0.52) dots += '<rect x="' + x + '" y="' + y + '" width="1" height="1"/>';
              }
            }
            return '<svg viewBox="-1 -1 23 23" shape-rendering="crispEdges" aria-hidden="true">' +
              '<rect x="-1" y="-1" width="23" height="23" fill="#fff8e1"/>' +
              finder(0, 0) + finder(14, 0) + finder(0, 14) +
              '<g fill="#3a2400">' + dots + '</g></svg>';
          };
          svSlides.push({ cap: es ? '🎟️ Su boleto de estreno' : '🎟️ ' + possSV + ' premiere ticket',
            html: '<div class="ttsv-ticket">' +
              '<div class="ttsv-tk-l"><small>ADMIT ONE · ' + (es ? 'ESTRENO' : 'WORLD PREMIERE') + '</small>' +
                '<b>' + escC(nm.toUpperCase()) + '</b><em>' + (es ? 'Protagonizada por ' : 'Starring ') + escC(nm) + '</em><span>★ ★ ★ ★ ★</span></div>' +
              '<div class="ttsv-qr">' + ttQR(code + ':' + nm) + '</div>' +
            '</div>' });
          const premiereArt = '<div class="ttss-rays"></div>' + sparks +
            '<div class="ttsv">' +
              '<div class="ttsv-stage">' + svSlides.map((s, i) => '<div class="ttsv-s' + (i ? '' : ' on') + '">' + s.html + '</div>').join('') + '</div>' +
              '<div class="ttsv-cap">' + escC(svSlides[0].cap) + '</div>' +
              (svSlides.length > 1 ? '<div class="ttsv-dots">' + svSlides.map((s, i) => '<i' + (i ? '' : ' class="on"') + '></i>').join('') + '</div>' : '') +
            '</div>';
          const heroArt = premiere
            ? premiereArt
            : posterUrl
            ? '<img class="ttss-poster" src="' + posterUrl + '" alt="">'
            : '<video class="ttss-video" autoplay muted loop playsinline preload="auto" src="' + noCharVideo + '"></video><div class="ttss-video-fade"></div>';

          const T = es ? {
            starring: 'PROTAGONIZADA POR', h: 'Haz de ' + nm + ' la estrella 🎬',
            sub: 'La película de ' + nm + ', directo a tu correo 📩',
            l1: 'Su película animada', l2: 'Su canción completa', l3: '2 canciones extra gratis',
            save: 'AHORRA $' + saving, cta: 'Comprar la película de ' + nm + ' · ' + moviePrice + ' →',
            trust: '10,000+ familias · Te encanta o te devolvemos tu dinero', song: 'O solo la canción por ' + songPrice,
          } : {
            starring: 'STARRING', h: 'Make ' + nm + ' the star 🎬',
            sub: 'Emailed straight to you 📩',
            l1: 'Their animated movie', l2: 'Their full song', l3: '2 bonus songs, free',
            save: 'SAVE $' + saving, cta: 'Buy ' + nm + "'s movie · " + moviePrice + ' →',
            trust: '10,000+ families · Love it or your money back', song: 'Or just the song for ' + songPrice,
          };

          const ov = document.createElement('div');
          ov.id = 'ttSS';
          ov.setAttribute('role', 'dialog');
          ov.setAttribute('aria-modal', 'true');
                const possN2 = /s$/i.test(nm) ? nm + "'" : nm + "'s";
          const meLow = window.ttSelfPick && window.ttSelfPick.label ? window.ttSelfPick.label.toLowerCase() : '';
          const famNames = ttFamilyNames().filter((n) => n.toLowerCase() !== meLow).slice(0, 3); // they already added themselves
          const famWho = famNames.length > 1
            ? famNames.slice(0, -1).join(', ') + ' & ' + famNames[famNames.length - 1]
            : famNames[0] || '';
          ov.innerHTML =
            '<div class="ttss-card">' +
              '<div class="ttss-hero' + (premiere ? ' has-premiere' : charUrl ? ' has-cast' : '') + (!charUrl && !posterUrl ? ' has-video' : '') + '">' + heroArt +
                '<button type="button" class="ttss-x" aria-label="Close">×</button>' +
                (premiere
                  ? ''
                  : '<div class="ttss-star"><small>' + T.starring + ' ' + nm.toUpperCase() + '</small><b>' +
                      (es ? 'Haz la película de ' + nm : 'Make ' + possN2 + ' movie') + '</b></div>') +
              '</div>' +
              '<div class="ttss-body">' +
                '<h2 class="ttss-h">' + T.h + '</h2>' +
                '<p class="ttss-sub2">' + (es ? 'Hecha a mano · lista en aproximadamente una hora' : 'Assembled by hand · Ready in minutes') + '</p>' +
                '' +
                              '<div class="ttss-list">' +
                             '<div><i>✓</i>' + escC(es ? 'Su película completa y su canción completa' : possN2 + ' full movie & full song') + '</div>' +
                  (famWho ? '<div><i>✓</i>' + escC(es ? 'Agrega a ' + famWho + ' después de pagar' : 'Add ' + famWho + ' after checkout') + '</div>' : '') +
                  '<div><i>✓</i>' + (es ? 'Su póster y boleto de estreno' : 'Movie poster & premiere ticket') + '</div>' +
                  (famWho ? '<div><i>✓</i>' + (es ? 'Elige su ropa y ajusta su look gratis' : 'Pick their outfit & tweak their look, free') + '</div>' : '') +
                '</div>' +
                             '<div class="ttss-price">' +
                  '<span style="display:flex;align-items:center;justify-content:center;gap:12px">' +
                    '<span style="display:flex;flex-direction:column;align-items:flex-end;line-height:1.1;font-family:Nunito,sans-serif;color:#94a3b8">' +
                      '<s style="font-size:19px;font-weight:800">' + (ttIsXmas() ? XMAS_WAS : (regionPrice('sep') || '$' + (SONG_PRICE * 3 + MOVIE_LATER_PRICE).toFixed(2))) + '</s>' +
                      '<small style="font-size:10.5px;font-weight:800;' + (ttIsXmas() ? 'color:#1e824c' : '') + '">' + (ttIsXmas() ? '🎄 Early Bird Christmas' : es ? 'por separado' : 'separately') + '</small></span>' +
                    '<span class="ttss-now">' + moviePrice + '</span>' +
                  '</span>' +
                  (LAUNCH_LABEL ? '<span class="ttss-launch" style="margin:8px 0 0">' + LAUNCH_LABEL + '</span>' : '') +
                '</div>' +
              '</div>' +
              '<div class="ttss-foot">' +
                '<button type="button" class="ttss-cta">' + T.cta + '</button>' +
                '<p class="ttss-guar">🛡️ ' + (es ? 'Te encanta o te devolvemos tu dinero' : 'Love it or your money back') + '</p>' +
                '<button type="button" class="ttss-song">' + T.song + '</button>' +
              '</div>' +
            '</div>';
          document.body.appendChild(ov);
          // Character reveal moment: replay the song as their newly-created character appears.
          if (charUrl && window.ttCharacterRevealPending) {
            window.ttCharacterRevealPending = false;
            const revealSong = document.getElementById('ttAudio');
            if (revealSong) {
              try { revealSong.pause(); revealSong.currentTime = 0; revealSong.volume = 1; } catch (e) {}
              const playRevealSong = () => { setTimeout(() => revealSong.play().catch(() => {}), 1350); }; // in sync with the poster
              if (revealSong.readyState >= 2) playRevealSong();
              else revealSong.addEventListener('canplay', playRevealSong, { once: true });
            }
          }
          if (premiere) {
            // Poster not ready yet → show the character in the frame, then cross-fade to the real poster
            const pimg = ov.querySelector('.ttss-pimg');
            if (pimg && pimg.classList.contains('is-char')) {
              let pTries = 0;
              const pTimer = setInterval(() => {
                if (!ov.isConnected || ++pTries > 60) { clearInterval(pTimer); return; }
                const u = window.ttPoster1;
                if (!u || u === (window.ttPosterBefore || '')) return;
                clearInterval(pTimer);
                const pre = new Image();
                pre.onload = () => {
                  pimg.style.opacity = '0';
                  setTimeout(() => { pimg.src = u; pimg.classList.remove('is-char'); pimg.style.opacity = '1'; }, 300);
                };
                pre.src = u;
              }, 1000);
            }
            // "+" circles → add that family member right here
            ov.querySelectorAll('.ttss-fam-m:not(.done)').forEach((btn) => {
              btn.addEventListener('click', () => {
                const ent = famList.find((e) => e.key === btn.dataset.key);
                if (!ent || typeof window.ttBuildFamilyCard !== 'function' || btn.classList.contains('done')) return;
                const body = ov.querySelector('.ttss-body');
                let panel = ov.querySelector('.ttss-fam-panel');
                if (panel && panel.dataset.key === ent.key) { panel.remove(); return; }
                if (panel) panel.remove();
                panel = document.createElement('div');
                panel.className = 'ttss-fam-panel';
                panel.dataset.key = ent.key;
                panel.appendChild(window.ttBuildFamilyCard(ent, (k, url) => {
                  if (url) {
                    btn.classList.add('done');
                    btn.querySelector('i').innerHTML = '<img src="' + escC(url) + '" alt="">';
                  }
                  setTimeout(() => panel.remove(), 900);
                }));
                body.insertBefore(panel, body.firstChild);
                try { panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
              });
            });
          }
          const prevOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          requestAnimationFrame(() => ov.classList.add('on'));

               // Showcase: star → movie → poster → ticket (the movie slide stays up longer)
          const svS = ov.querySelectorAll('.ttsv-s');
          if (svS.length > 1) {
            const svCap = ov.querySelector('.ttsv-cap');
            const svDots = ov.querySelectorAll('.ttsv-dots i');
            let svI = 0;
            const playSlideVideo = (i) => {
              svS.forEach((s, k) => {
                const v = s.querySelector('video');
                if (!v) return;
                if (k === i) {
                  try { v.currentTime = 0; } catch (e) {}
                  v.play().catch(() => {});
                } else {
                  v.pause();
                }
              });
            };
            playSlideVideo(0);
            const svNext = () => {
              if (!ov.isConnected) return;
              svS[svI].classList.remove('on');
              if (svDots[svI]) svDots[svI].classList.remove('on');
              svI = (svI + 1) % svS.length;
              svS[svI].classList.add('on');
              if (svDots[svI]) svDots[svI].classList.add('on');
              if (svCap) {
                svCap.classList.remove('in');
                void svCap.offsetWidth;
                svCap.textContent = svSlides[svI].cap;
                svCap.classList.add('in');
              }
              playSlideVideo(svI);
              setTimeout(svNext, svSlides[svI].dur || 2600);
            };
            setTimeout(svNext, svSlides[0].dur || 2600);
          }
          const ssRot = ov.querySelectorAll('.ttss-r');
          let ssRi = 0;
          const ssRotTimer = ssRot.length > 1 ? setInterval(() => {
            if (!ov.isConnected) { clearInterval(ssRotTimer); return; }
            ssRot[ssRi].classList.remove('on');
            ssRi = (ssRi + 1) % ssRot.length;
            ssRot[ssRi].classList.add('on');
          }, 2600) : null;

              // Make sure the sheet's video plays: muted + inline, with a retry on the first touch
          ov.querySelectorAll('video').forEach((v) => {
            v.muted = true;
            v.defaultMuted = true;
            v.playsInline = true;
            v.loop = true;
            v.setAttribute('muted', '');
            v.setAttribute('playsinline', '');
            v.setAttribute('webkit-playsinline', '');
            const go = () => v.play().catch(() => {});
            go();
            if (v.readyState < 2) v.addEventListener('canplay', go, { once: true });
            ov.addEventListener('touchstart', go, { once: true, passive: true });
          });

          const remove = () => {
            ov.classList.remove('on');
            document.documentElement.style.overflow = prevOverflow;
            document.removeEventListener('keydown', onKey);
            setTimeout(() => ov.remove(), 300);
          };

                    const ttShowNextSteps = () => {
            if (document.getElementById('ttNextSteps')) return;
            const stage = document.getElementById('ttMediaStage');
            if (!stage) return;
            if (!document.getElementById('ttNextStepsStyles')) {
              const st = document.createElement('style');
              st.id = 'ttNextStepsStyles';
              st.textContent =
                '#ttNextSteps{max-width:520px;margin:14px auto 0;display:flex;flex-direction:column;align-items:center;gap:4px;animation:ttnsIn .35s ease}' +
                '.ttns-go{width:100%;min-height:58px;border:none;border-radius:16px;cursor:pointer;background:#151a33;color:#fff;font-family:Nunito,sans-serif;font-size:17px;font-weight:900;box-shadow:0 14px 30px -12px rgba(21,26,51,.6)}' +
                '.ttns-go:active{transform:scale(.98)}' +
                '.ttns-song{background:none;border:none;cursor:pointer;padding:10px;font-family:Nunito,sans-serif;font-size:14.5px;font-weight:800;color:#5b6475;text-decoration:underline;text-underline-offset:3px}' +
                '@keyframes ttnsIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}';
              document.head.appendChild(st);
            }
            const possN = nm ? (/s$/i.test(nm) ? nm + "'" : nm + "'s") : 'their';
            const box = document.createElement('div');
            box.id = 'ttNextSteps';
            box.innerHTML =
              '<button type="button" class="ttns-go">' +
              (es ? '🎬 Haz la película de ' + (nm || 'su estrella') + ' →' : '🎬 ' + (charUrl ? 'Get ' : 'Make ') + possN + ' movie →') +
              '</button>' +
              '<button type="button" class="ttns-song">' + T.song + '</button>';
            box.querySelector('.ttns-go').addEventListener('click', () => {
              box.remove();
              if (charUrl) ttShowSalesSheet();
              else ttStartCharacterForMovie();
            });
            box.querySelector('.ttns-song').addEventListener('click', () => {
              ttTrack('pv_click_song');
              confirmThenBuySong({ _gift_send_enabled: 'no', Starring: titleCaseName(childName) || '' });
            });
            stage.after(box);
          };
               const dismiss = () => {
            remove();
            ttShowCastBar();
            ttShowNextSteps();
            // When they close the modal, frame the movie with the lyrics just above
            setTimeout(() => { if (window.ttFrameStage) window.ttFrameStage(); }, 60);
          };
          const onKey = (e) => { if (e.key === 'Escape') dismiss(); };
          document.addEventListener('keydown', onKey);

          ov.querySelector('.ttss-x').addEventListener('click', dismiss);
          ov.addEventListener('click', (e) => { if (e.target === ov) dismiss(); });
          ov.querySelector('.ttss-cta').addEventListener('click', () => {
            ttTrack('pv_click_movie');
            remove();
            if (window.ttDrawerTest) ttShowOrderDrawer(); // "Your order" first (half of buyers while testing)
            else goToVideoCheckout({ fromSheet: true });
          });
          ov.querySelector('.ttss-song').addEventListener('click', () => {
            ttTrack('pv_click_song');
            remove();
            confirmThenBuySong({ _gift_send_enabled: 'no', Starring: titleCaseName(childName) || '' });
          });

                    // ── No character yet: this sheet becomes "make their movie" (character first, then the cast + offer) ──
          if (!charUrl) {
            const gBody = ov.querySelector('.ttss-body');
            const gFoot = ov.querySelector('.ttss-foot');
            if (gFoot) gFoot.remove(); // this version has its own buttons
               const possG = nm.endsWith('s') ? nm + "'" : nm + "'s";
            const famG = ttFamilyNames().slice(0, 3);
            const famJoin = famG.length > 1 ? famG.slice(0, -1).join(', ') + ' & ' + famG[famG.length - 1] : famG[0] || '';
            const famLine = famJoin
              ? (es ? 'Agrega a ' + famJoin + ' a la película' : 'Add ' + famJoin + ' to the movie')
              : (es ? 'Agrega a mamá, papá y la familia' : 'Add Mom, Dad & the family');
            if (!document.getElementById('ttGwStyles')) {
              const gs = document.createElement('style');
              gs.id = 'ttGwStyles';
              gs.textContent = [
                // Hero: crop the video's baked-in labels, soft fade into the card
                '#ttSS .ttss-hero.has-video{height:clamp(190px,30vh,250px) !important}',
                '#ttSS .ttss-hero.has-video .ttss-video{transform:scale(1.16);transform-origin:50% 45%}',
                '#ttSS .ttss-hero.has-video .ttss-video-fade{height:38%;background:linear-gradient(to top,#fff 0%,rgba(255,255,255,0) 100%)}',
                '.ttgw-tag{position:absolute;top:14px;left:14px;z-index:3;padding:6px 10px;border-radius:999px;background:rgba(15,23,42,.55);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);color:#fff;font-family:Nunito,sans-serif;font-size:10.5px;font-weight:900;letter-spacing:.14em}',
                '#ttSS .ttss-x{background:rgba(255,255,255,.85);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}',
                // Body
                '.ttgw{padding:6px 26px 22px !important;text-align:center;font-family:Nunito,sans-serif}',
                '.ttgw-k{font-size:11px;font-weight:900;letter-spacing:.18em;text-transform:uppercase;color:#b7862a}',
                '.ttgw-h{margin:8px 0 6px;font-family:Fraunces,Georgia,serif;font-size:clamp(25px,7vw,30px);font-weight:600;letter-spacing:-.02em;line-height:1.1;color:#151a33}',
                '.ttgw-sub{margin:0 auto 20px;max-width:300px;font-size:14.5px;font-weight:600;line-height:1.5;color:#64748b}',
                '.ttgw-list{display:flex;flex-direction:column;gap:12px;margin:0 auto 22px;max-width:300px;text-align:left}',
                '.ttgw-li{display:flex;align-items:center;gap:12px;font-size:15px;font-weight:700;color:#1e293b;line-height:1.3}',
                '.ttgw-li i{flex-shrink:0;display:flex !important;align-items:center;justify-content:center;width:24px;height:24px;border-radius:50%;background:#151a33;color:#f6d27a;font-style:normal;font-size:12px;font-weight:900}',
                '.ttgw .ttss-cta{border-radius:14px;padding:17px 20px;font-size:16.5px;letter-spacing:.01em}',
                '.ttgw-guar{display:flex;align-items:center;justify-content:center;gap:6px;margin:12px 0 0;font-size:12.5px;font-weight:800;color:#64748b}',
                '.ttgw-guar svg{width:14px;height:14px;flex-shrink:0}',
                '.ttgw .ttss-song{margin-top:6px;font-size:13.5px;font-weight:800;color:#64748b}',
                '@media (max-width:600px){.ttgw{padding:4px 22px 20px !important}.ttgw-sub{margin-bottom:18px}}',
              ].join('');
              document.head.appendChild(gs);
            }
            gBody.className = 'ttss-body ttgw';
            const heroG = ov.querySelector('.ttss-hero');
            if (heroG && !heroG.querySelector('.ttgw-tag')) {
              heroG.insertAdjacentHTML('beforeend', '<span class="ttgw-tag">' + (es ? 'EJEMPLO' : 'EXAMPLE MOVIE') + '</span>');
            }
            const shieldG = '<svg viewBox="0 0 24 24" fill="none" stroke="#1e8a55" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6z"/><path d="M9 12l2 2 4-4"/></svg>';
            gBody.innerHTML =
              '<div class="ttgw-k">' + (es ? 'Paso 2 de 3' : 'Step 2 of 3') + '</div>' +
              '<h2 class="ttgw-h">' + (es ? 'Haz la película de ' + escC(nm) : 'Make ' + escC(possG) + ' movie') + '</h2>' +
              '<p class="ttgw-sub">' + (es
                ? 'Primero, crea su personaje animado. Toma alrededor de un minuto.'
                : 'First, create ' + escC(possG) + ' animated character. It takes about a minute.') + '</p>' +
              '<div class="ttgw-list">' +
                '<div class="ttgw-li"><i>✓</i>' + (es ? escC(nm) + ' como personaje animado' : escC(nm) + ' as an animated character') + '</div>' +
                '<div class="ttgw-li"><i>✓</i>' + escC(famLine) + '</div>' +
                '<div class="ttgw-li"><i>✓</i>' + (es ? 'Su póster y boleto de estreno' : 'Their movie poster & premiere ticket') + '</div>' +
              '</div>' +
              '<button type="button" class="ttss-cta ttss-gw-go">' + (es ? 'Crear su personaje →' : 'Create ' + escC(possG) + ' character →') + '</button>' +
              '<p class="ttgw-guar">' + shieldG + (es ? 'Te encanta o te devolvemos tu dinero' : 'Love it or your money back') + '</p>' +
              '<button type="button" class="ttss-song">' + T.song + '</button>';
            gBody.querySelector('.ttss-gw-go').addEventListener('click', () => { remove(); ttStartCharacterForMovie(); });
            gBody.querySelector('.ttss-song').addEventListener('click', () => {
              ttTrack('pv_click_song');
              remove();
              confirmThenBuySong({ _gift_send_enabled: 'no', Starring: titleCaseName(childName) || '' });
            });
            return;
          }
          return; // free-movie test is off
          // Free movie preview test: if this visitor qualifies, the sheet becomes the free offer
          const forceFree = /[?&]freemovie=1/.test(location.search); // testing shortcut
          fetch(WORKER_BASE + '/free-movie-status?code=' + encodeURIComponent(code), { cache: 'no-store' })
            .then((r) => r.json())
            .catch(() => ({}))
            .then((s) => {
              if (!ov.isConnected || !s) return;
              try { if (localStorage.getItem('tt_free_movie_used') === '1') return; } catch (e) {}
              // Eligible but no character yet → offer the free preview, starting with their character
              if (!s.available && s.reason === 'no_character') {
                const subNC = ov.querySelector('.ttss-sub');
                if (subNC) subNC.textContent = es
                  ? 'Crea su personaje y te haremos su película gratis. Mira los primeros 60 segundos.'
                  : 'Create their character and we\'ll make ' + nm + '\'s movie free. Watch the first 60 seconds.';
                const priceNC = ov.querySelector('.ttss-price');
                if (priceNC) {
                  priceNC.style.flexDirection = 'column';
                  priceNC.style.gap = '4px';
                  priceNC.innerHTML =
                    '<span class="ttss-now">' + (es ? 'Vista previa gratis' : 'Free preview') + '</span>' +
                    '<span style="font-size:14px;font-weight:800;color:#64748b;">' +
                    (es ? 'Luego ' + moviePrice + ' solo si te encanta' : 'Then ' + moviePrice + ' only if you love it') + '</span>';
                }
                const trustNC = ov.querySelector('.ttss-trust');
                if (trustNC) trustNC.innerHTML = es
                  ? '🎁 <strong>1 película gratis por familia</strong> · Sin pago hoy'
                  : '🎁 <strong>1 free movie preview per customer</strong> · No payment today';
                const oldNC = ov.querySelector('.ttss-cta');
                const ncCta = oldNC.cloneNode(true);
                ncCta.textContent = es ? '🎨 Crear su personaje → película gratis' : '🎨 Create ' + nm + "'s character → free movie";
                oldNC.replaceWith(ncCta);
                ncCta.addEventListener('click', () => {
                  ttTrack('pv_click_free_movie_build');
                  window.ttFreeAfterCharacter = true; // reopen the free offer once their character is saved
                  ttWaitForCharacterThenOffer();
                  remove();
                  try { closeModal(); } catch (e) {}
                  const cb = document.getElementById('ttCharBuilder');
                  if (cb) {
                    cb.style.display = '';
                    setTimeout(() => { try { cb.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }, 350);
                  }
                });
                return;
              }
              if (!s.available) return;
                            window.ttFreeMovieAvailable = true;
                              // ── Free offer: clean, minimal body ──
              if (!document.getElementById('ttssFreeStyles')) {
                const fs = document.createElement('style');
                fs.id = 'ttssFreeStyles';
                fs.textContent = [
                  '.ttf{padding:22px 24px 20px;text-align:center;font-family:Nunito,sans-serif}',
                  '.ttf-eyebrow{display:inline-block;padding:5px 12px;border-radius:999px;background:#fef3c7;color:#92400e;font-size:11px;font-weight:900;letter-spacing:.14em;margin-bottom:10px}',
                  '.ttf-h{font-family:Fraunces,Georgia,serif;font-size:27px;font-weight:600;color:#0f172a;line-height:1.15;margin:0 0 6px}',
                  '.ttf-sub{font-size:15px;font-weight:600;color:#64748b;line-height:1.5;margin:0 auto 18px;max-width:320px}',
                  '.ttf-email{margin:0 0 12px;text-align:left}',
                  '.ttf-email-row{display:flex;align-items:center;gap:10px;padding:13px 14px;border-radius:14px;background:#f8fafc;border:1px solid #e2e8f0}',
                  '.ttf-email-label{flex-shrink:0;font-size:11px;font-weight:900;color:#94a3b8;text-transform:uppercase;letter-spacing:.08em}',
                  '.ttf-email-val{flex:1;min-width:0;font-size:15px;font-weight:800;color:#0f172a;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
                  '.ttf-email-edit{flex-shrink:0;background:none;border:none;padding:0;color:#3c8ab3;font-family:Nunito,sans-serif;font-size:13px;font-weight:800;cursor:pointer}',
                  '.ttf-email-input{display:none;width:100%;padding:14px 16px;border-radius:14px;border:1.5px solid #cbd5e1;font-family:Nunito,sans-serif;font-size:16px;font-weight:700;color:#0f172a;box-sizing:border-box}',
                  '.ttf-email-input:focus{outline:none;border-color:#3c8ab3;box-shadow:0 0 0 4px rgba(60,138,179,.15)}',
                  '.ttf-err{display:none;margin:6px 2px 0;font-size:12.5px;font-weight:800;color:#b42318}',
                               '.ttf-fine{margin:12px 0 0;font-size:12.5px;font-weight:700;color:#94a3b8;line-height:1.5}',
                  '.ttf-price{display:block;margin-top:3px;font-size:14px;font-weight:800;color:#475569}',
                  '.ttf-price b{color:#0f172a;font-weight:900}',
                      '.ttf .ttss-song{margin-top:10px}',
                  '.ttf-sms{margin:2px 0 14px;text-align:left}',
                  '.ttf-sms-check{display:flex;align-items:center;gap:10px;cursor:pointer;font-family:Nunito,sans-serif;font-size:14.5px;font-weight:800;color:#334155}',
                  '.ttf-sms-check input{flex-shrink:0;width:20px;height:20px;margin:0;accent-color:#3c8ab3;cursor:pointer}',
                  '.ttf-sms-more{display:none;margin:10px 0 0}',
                  '.ttf-sms.on .ttf-sms-more{display:block}',
                  '.ttf-phone{display:block;width:100%;padding:13px 14px;border-radius:14px;border:1px solid #e2e8f0;background:#f8fafc;font-family:Nunito,sans-serif;font-size:16px;font-weight:700;color:#0f172a;box-sizing:border-box}',
                  '.ttf-phone:focus{outline:none;border-color:#3c8ab3;box-shadow:0 0 0 4px rgba(60,138,179,.15);background:#fff}',
                  '.ttf-phone-legal{margin:6px 2px 0;font-family:Nunito,sans-serif;font-size:10.5px;font-weight:600;line-height:1.45;color:#a3acb9}',
                  '.ttf-phone-legal a{color:#8a94a6;text-decoration:underline}',
                  '.ttf-sms-txt{display:flex;flex-direction:column;line-height:1.25}',
                  '.ttf-sms-txt b{font-weight:900;color:#151a33}',
                  '.ttf-sms-txt small{font-size:12.5px;font-weight:700;color:#7a8394;margin-top:2px}',
                  '.ttf-sms-check{align-items:flex-start !important}',
                  '.ttf-sms-check input{margin-top:2px !important}',
                ].join('');
                document.head.appendChild(fs);
              }

              const bodyEl = ov.querySelector('.ttss-body');
              bodyEl.className = 'ttss-body ttf';
                            bodyEl.innerHTML =
                '<div class="ttf-eyebrow">' + (es ? 'PELÍCULA GRATIS' : 'FREE MOVIE PREVIEW') + '</div>' +
                '<h2 class="ttf-h">' + (es ? 'Mira la película de ' + nm : 'Watch ' + nm + "'s movie") + '</h2>' +
                       '<p class="ttf-sub">' + (es ? 'La hacemos y te la enviamos por correo.' : "We'll make it and email it to you.") + '</p>' +
                '<div class="ttf-email">' +
                        '<div class="ttf-email-row"><span class="ttf-email-label">' + (es ? 'Se enviará a' : 'Sending to') + '</span>' +
                  '<span class="ttf-email-val"></span>' +
                  '<button type="button" class="ttf-email-edit">' + (es ? 'Cambiar' : 'Edit') + '</button></div>' +
                  '<input type="email" class="ttf-email-input" autocomplete="email" inputmode="email" placeholder="' + (es ? 'Tu correo' : 'Your email') + '">' +
                  '<div class="ttf-err"></div>' +
                '</div>' +
                             (ttRegion === 'us'
                  ? '<div class="ttf-sms">' +
                      '<label class="ttf-sms-check"><input type="checkbox" class="ttf-sms-ok">' +
                                                '<span class="ttf-sms-txt"><b>📱 ' + (es ? 'Envíame un texto en cuanto esté lista' : "Text me the second it's ready") + '</b>' +
                        '<small>' + (es ? 'Para no perdérmela' : "So I don't miss it") + '</small></span></label>' +
                      '<div class="ttf-sms-more">' +
                        '<input type="tel" class="ttf-phone" inputmode="tel" autocomplete="tel" placeholder="' + (es ? 'Tu número de celular' : 'Your mobile number') + '">' +
                        '<p class="ttf-phone-legal">' + (es
                          ? 'Hasta 2 mensajes sobre este pedido. Pueden aplicar tarifas. Responde HELP para ayuda, STOP para cancelar. No es necesario para comprar. '
                          : 'Up to 2 texts about this order. Msg & data rates may apply. Reply HELP for help, STOP to cancel. Not required to purchase. ') +
                          '<a href="/policies/terms-of-service" target="_blank" rel="noopener">' + (es ? 'Términos' : 'Terms') + '</a> · ' +
                          '<a href="/policies/privacy-policy" target="_blank" rel="noopener">' + (es ? 'Privacidad' : 'Privacy') + '</a></p>' +
                      '</div>' +
                    '</div>'
                  : '') +
                '<button type="button" class="ttss-cta ttf-cta">' + (es ? '🎬 Enviar mi vista previa gratis' : '🎬 Send my free preview') + '</button>' +
                 '<p class="ttf-fine"><span class="ttf-price">' + (es
                    ? 'Película completa <b>' + moviePrice + '</b> si te encanta'
                    : 'Full movie <b>' + moviePrice + '</b> if you love it') + '</span></p>' +
                '<button type="button" class="ttss-song">' + T.song + '</button>';
              const freeCta = bodyEl.querySelector('.ttf-cta');
              const ctaLabel = freeCta.textContent;
              const emRow = bodyEl.querySelector('.ttf-email-row');
              const emVal = bodyEl.querySelector('.ttf-email-val');
              const emInput = bodyEl.querySelector('.ttf-email-input');
                    const emErr = bodyEl.querySelector('.ttf-err');
              const smsWrap = bodyEl.querySelector('.ttf-sms');
              const smsOk = bodyEl.querySelector('.ttf-sms-ok');
              if (smsWrap && smsOk) smsOk.addEventListener('change', () => {
                smsWrap.classList.toggle('on', smsOk.checked);
                if (smsOk.checked) setTimeout(() => { const p = smsWrap.querySelector('.ttf-phone'); if (p) p.focus(); }, 50);
              });

              let savedEmail = '';
              try { savedEmail = localStorage.getItem('tt_email') || ''; } catch (e) {}
              if (!savedEmail) savedEmail = window.ttRecordEmail || '';
              const showInput = () => {
                emRow.style.display = 'none';
                emInput.style.display = 'block';
                setTimeout(() => { emInput.focus(); emInput.select(); }, 50);
              };
              emInput.value = savedEmail;
              if (savedEmail) emVal.textContent = savedEmail;
              else { emRow.style.display = 'none'; emInput.style.display = 'block'; }
              bodyEl.querySelector('.ttf-email-edit').addEventListener('click', showInput);
              const showErr = (msg) => {
                emErr.textContent = msg;
                emErr.style.display = msg ? 'block' : 'none';
                if (msg && emInput.style.display === 'none') showInput();
              };

              bodyEl.querySelector('.ttss-song').addEventListener('click', () => {
                ttTrack('pv_click_song');
                remove();
                confirmThenBuySong({ _gift_send_enabled: 'no', Starring: titleCaseName(childName) || '' });
              });

              freeCta.addEventListener('click', () => {
                const email = emInput.value.trim().toLowerCase();
                if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/.test(email)) {
                  showErr(es ? 'Escribe un correo válido.' : 'Please enter a valid email.');
                  return;
                }
                showErr('');
                ttTrack('pv_click_free_movie');
                freeCta.disabled = true;
                freeCta.textContent = es ? 'Iniciando su película…' : 'Starting ' + nm + "'s movie…";
                const isLikeness = window.ttCharacterMode === 'photo_likeness';
                fetch(WORKER_BASE + '/start-free-movie', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                     body: JSON.stringify({
                    code, email,
                    phone: (bodyEl.querySelector('.ttf-sms-ok') || {}).checked
                      ? ((bodyEl.querySelector('.ttf-phone') || {}).value || '').trim()
                      : '',
                    character_mode: isLikeness ? 'photo_likeness' : 'standard',
                  }),
                })
                  .then((r) => r.json())
                  .catch(() => ({}))
                  .then((out) => {
                    if (!out || !out.ok) {
                      freeCta.disabled = false;
                      freeCta.textContent = ctaLabel;
                      showErr(
                        out && out.reason === 'email_already_used'
                          ? (es ? 'Este correo ya usó su película gratis.' : 'This email has already used its free movie preview.')
                          : (es ? 'Algo salió mal. Intenta de nuevo.' : 'Something went wrong. Please try again.')
                      );
                      return;
                    }
                    try { localStorage.setItem('tt_email', email); } catch (e) {}
                    try { if (typeof fbq === 'function') fbq('trackCustom', 'FreeMovieStarted'); } catch (e) {}
                    setPreviewLocked(false);
                    window.location.href =
                      ttRoot + 'pages/song-unlocked?code=' + encodeURIComponent(code) +
                      (ttLang === 'es' ? '&lang=es' : '') +
                      (ttRegion !== 'us' ? '&region=' + ttRegion : '') +
                      (out.cast ? '#cast' : '');
                  });
              });
            });
        }
        // ── FAMILY PASS (underneath the CTAs only — not in the modal) ──
        const fpBtn = document.getElementById('ttFamilyPassBtn');
        if (fpBtn)
          fpBtn.addEventListener('click', () => {
            if (!code) return alert(pt('missingCodeAlert') || 'Missing preview code. Please refresh.');
            addAndCheckout(FAMILY_PASS_VARIANT_ID, { _preview_code: code });
          });

        function emailLine(secondsWaiting) {
          if (secondsWaiting < 25) return "Stay right here — this page updates automatically when it's ready.";
          if (secondsWaiting < 55)
            return "Still loading — keep this tab open. (We'll also send a backup email, just in case.)";
          return "Almost there — keep this tab open. If you don't see it here, check your inbox for the backup email.";
        }

        const pageStart = Date.now();

        function updateEmailMessaging() {
          if (!elLoading || elLoading.style.display === 'none') return;
          const secondsWaiting = Math.floor((Date.now() - pageStart) / 1000);
          if (elLoadingSub) elLoadingSub.textContent = emailLine(secondsWaiting);
          if (secondsWaiting >= 45) {
            if (elEmailReassure) {
              elEmailReassure.style.display = 'block';
              elEmailReassure.textContent = "Keep this tab open — we'll also send a backup email, just in case.";
            }
            if (elInboxTip) elInboxTip.style.display = 'block';
          } else {
            if (elEmailReassure) elEmailReassure.style.display = 'none';
            if (elInboxTip) elInboxTip.style.display = 'none';
          }
        }

        let elAudio = null;
        let audioHandlersBound = false;
        let faded = false;
        let playCount = 0;

        let playRevealSequence = null;

        function showPreviewVideo() {
          const stage = document.getElementById('ttMediaStage');
          if (!stage) return;
          const capturedCode = code;
          const capturedChildName = childName;
                                            const charImg = window.savedCharacterUrl || '';
        const hasExtraCharacters = (function () {
          var all = window.ttAllCastEntities || [];
          var images = window.ttEntityImages || {};
          return all.some(function (e) { return !!images[e.key]; });
        })();
        
                               const isBirthday = occasion === 'birthday';
          const isPrincess = occasion === 'princess';
          const isSuperhero = occasion === 'superhero';
                 const isLullaby = genre === 'lullaby';
                     const isFromFarAway = occasion === 'missing you' || occasion === 'from far away';
                    const isJustBecause = occasion === 'just because';
          const isHalloween = occasion === 'halloween';
                 const giftCardOuterStyle = isHalloween
            ? `border-radius:22px;position:relative;overflow:visible;background:linear-gradient(160deg,#1c0f2e 0%,#3a1a52 55%,#5a2a1a 100%);border:1px solid rgba(255,140,40,.35);box-shadow:0 10px 44px rgba(90,40,140,.4), inset 0 1px 0 rgba(255,255,255,.04);padding:40px 20px 34px;text-align:center;cursor:pointer;`
            : isBirthday
            ? `border-radius:22px;position:relative;overflow:visible;background:linear-gradient(160deg,#fff8ee 0%,#fdeef2 55%,#faf0ff 100%);border:1px solid rgba(224,160,0,.22);box-shadow:0 10px 42px rgba(224,160,0,.16);padding:38px 20px 34px;text-align:center;cursor:pointer;`
            : isPrincess
            ? `border-radius:22px;position:relative;overflow:visible;background:linear-gradient(160deg,#fdf4ff 0%,#fbeaff 45%,#fff5e6 100%);border:1px solid rgba(186,120,240,.28);box-shadow:0 10px 44px rgba(186,120,240,.20);padding:40px 20px 34px;text-align:center;cursor:pointer;`
            : isSuperhero
            ? `border-radius:22px;position:relative;overflow:visible;background:linear-gradient(160deg,#0f1b3d 0%,#1a2a5e 55%,#0c1530 100%);border:1px solid rgba(255,204,60,.3);box-shadow:0 10px 44px rgba(20,30,80,.45), inset 0 1px 0 rgba(255,255,255,.04);padding:40px 20px 34px;text-align:center;cursor:pointer;`
                       : isLullaby
            ? `border-radius:22px;position:relative;overflow:visible;background:linear-gradient(160deg,#1a2144 0%,#2a2f5e 50%,#1e2450 100%);border:1px solid rgba(180,190,255,.25);box-shadow:0 10px 44px rgba(30,36,80,.4), inset 0 1px 0 rgba(255,255,255,.04);padding:40px 20px 34px;text-align:center;cursor:pointer;`
                  : isFromFarAway
            ? `border-radius:22px;position:relative;overflow:hidden;background:linear-gradient(160deg,#fff0f4 0%,#ffe4ed 50%,#fff5f0 100%);border:1px solid rgba(244,114,182,.28);box-shadow:0 10px 42px rgba(244,114,182,.18);padding:30px 20px 34px;text-align:center;cursor:pointer;`
            : isJustBecause
            ? `border-radius:22px;position:relative;overflow:hidden;background:linear-gradient(160deg,#fff9eb 0%,#eef9ff 50%,#fef0ff 100%);border:1px solid rgba(120,180,255,.25);box-shadow:0 10px 40px rgba(120,150,255,.16);padding:30px 20px 34px;text-align:center;cursor:pointer;`
            : `border-radius:22px;background:linear-gradient(160deg,#f0f8ff 0%,#e8f4fb 50%,#f5f0ff 100%);border:1px solid rgba(79,163,209,0.2);box-shadow:0 8px 40px rgba(60,138,179,0.12);padding:30px 20px 34px;text-align:center;cursor:pointer;`;
                     const giftRibbon = isHalloween
            ? `<div style="position:absolute;inset:0;border-radius:22px;overflow:hidden;pointer-events:none;z-index:0;">
                 <style>
                   @keyframes ttBatFly{0%{transform:translate(-30px,0) scale(.9);opacity:0}12%{opacity:.9}50%{transform:translate(170px,-16px) scale(1)}88%{opacity:.8}100%{transform:translate(360px,8px) scale(.9);opacity:0}}
                   @keyframes ttGhostFloat{0%,100%{transform:translateY(0);opacity:.8}50%{transform:translateY(-10px);opacity:1}}
                 </style>
                 <div style="position:absolute;top:-30%;right:-10%;width:70%;height:80%;background:radial-gradient(circle,rgba(255,170,60,.28),transparent 62%);"></div>
                 <span style="position:absolute;top:14%;left:0;font-size:18px;animation:ttBatFly 7s linear infinite;">🦇</span>
                 <span style="position:absolute;top:36%;left:0;font-size:13px;animation:ttBatFly 9s linear infinite -4s;">🦇</span>
                 <span style="position:absolute;bottom:14%;left:8%;font-size:20px;animation:ttGhostFloat 3.4s ease-in-out infinite;">👻</span>
                 <span style="position:absolute;bottom:18%;right:9%;font-size:17px;animation:ttGhostFloat 3.8s ease-in-out infinite 1s;">🍬</span>
               </div>`
            : isSuperhero
            ? `<div style="position:absolute;inset:0;border-radius:22px;overflow:hidden;pointer-events:none;z-index:0;">
                 <div style="position:absolute;top:-30%;left:50%;transform:translateX(-50%);width:140%;height:70%;background:radial-gradient(ellipse,rgba(255,204,60,.16),transparent 65%);"></div>
                 <div style="position:absolute;inset:0;background-image:radial-gradient(1.5px 1.5px at 20% 25%,rgba(255,255,255,.5),transparent),radial-gradient(1.5px 1.5px at 70% 15%,rgba(255,255,255,.4),transparent),radial-gradient(1px 1px at 45% 35%,rgba(255,255,255,.35),transparent),radial-gradient(1.5px 1.5px at 85% 45%,rgba(255,255,255,.4),transparent),radial-gradient(1px 1px at 12% 55%,rgba(255,255,255,.3),transparent),radial-gradient(1.5px 1.5px at 60% 60%,rgba(255,255,255,.3),transparent);opacity:.8;"></div>
               </div>`
            : isPrincess
            ? `<div style="position:absolute;inset:0;border-radius:22px;overflow:hidden;pointer-events:none;z-index:0;">
                 <div style="position:absolute;top:-20%;left:50%;transform:translateX(-50%);width:130%;height:60%;background:radial-gradient(ellipse,rgba(240,190,255,.28),transparent 65%);"></div>
               </div>`
                       : isLullaby
            ? `<div style="position:absolute;inset:0;border-radius:22px;overflow:hidden;pointer-events:none;z-index:0;">
                 <style>
                   @keyframes ttStarBlink1 { 0%,100%{opacity:.15;} 50%{opacity:.9;} }
                   @keyframes ttStarBlink2 { 0%,100%{opacity:.7;} 50%{opacity:.1;} }
                   @keyframes ttStarBlink3 { 0%,100%{opacity:.25;} 50%{opacity:.85;} }
                 </style>
                 <div style="position:absolute;top:-15%;left:50%;transform:translateX(-50%);width:120%;height:55%;background:radial-gradient(ellipse,rgba(200,210,255,.14),transparent 65%);"></div>
                 <span style="position:absolute;top:20%;left:15%;width:2px;height:2px;border-radius:50%;background:#fff;box-shadow:0 0 4px 1px rgba(255,255,255,.8);animation:ttStarBlink1 3.2s ease-in-out infinite;"></span>
                 <span style="position:absolute;top:12%;left:75%;width:2.5px;height:2.5px;border-radius:50%;background:#fff;box-shadow:0 0 5px 1px rgba(255,255,255,.85);animation:ttStarBlink2 4s ease-in-out infinite .6s;"></span>
                 <span style="position:absolute;top:30%;left:40%;width:1.5px;height:1.5px;border-radius:50%;background:#fff;box-shadow:0 0 3px 1px rgba(255,255,255,.7);animation:ttStarBlink3 2.6s ease-in-out infinite 1.1s;"></span>
                 <span style="position:absolute;top:40%;left:88%;width:2px;height:2px;border-radius:50%;background:#fff;box-shadow:0 0 4px 1px rgba(255,255,255,.8);animation:ttStarBlink1 3.6s ease-in-out infinite 1.8s;"></span>
                 <span style="position:absolute;top:50%;left:25%;width:1.8px;height:1.8px;border-radius:50%;background:#fff;box-shadow:0 0 3px 1px rgba(255,255,255,.75);animation:ttStarBlink2 4.4s ease-in-out infinite 2.3s;"></span>
                 <span style="position:absolute;top:65%;left:60%;width:2.2px;height:2.2px;border-radius:50%;background:#fff;box-shadow:0 0 4px 1px rgba(255,255,255,.8);animation:ttStarBlink3 3s ease-in-out infinite .3s;"></span>
                 <span style="position:absolute;top:8%;left:50%;width:1.5px;height:1.5px;border-radius:50%;background:#fff;box-shadow:0 0 3px 1px rgba(255,255,255,.7);animation:ttStarBlink1 3.8s ease-in-out infinite 2.6s;"></span>
                               <span style="position:absolute;top:55%;left:8%;width:2px;height:2px;border-radius:50%;background:#fff;box-shadow:0 0 4px 1px rgba(255,255,255,.8);animation:ttStarBlink2 3.3s ease-in-out infinite 1.4s;"></span>
               </div>`
            : isFromFarAway
            ? `<div style="position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:0;">
                 <style>
                   @keyframes ttHeartFloat1 { 0%{transform:translateY(0) scale(.9);opacity:0;} 15%{opacity:.85;} 85%{opacity:.6;} 100%{transform:translateY(-260px) scale(1.05);opacity:0;} }
                   @keyframes ttHeartFloat2 { 0%{transform:translateY(0) scale(.8);opacity:0;} 15%{opacity:.75;} 85%{opacity:.5;} 100%{transform:translateY(-260px) scale(1);opacity:0;} }
                 </style>
                               <span style="position:absolute;bottom:0;left:10%;font-size:15px;animation:ttHeartFloat1 8s ease-in infinite -4s;">💗</span>
                 <span style="position:absolute;bottom:0;left:28%;font-size:11px;animation:ttHeartFloat2 6.5s ease-in infinite -3s;">💕</span>
                 <span style="position:absolute;bottom:0;left:50%;font-size:17px;animation:ttHeartFloat1 9s ease-in infinite -6s;">💗</span>
                 <span style="position:absolute;bottom:0;left:68%;font-size:12px;animation:ttHeartFloat2 7s ease-in infinite -1s;">💕</span>
                 <span style="position:absolute;bottom:0;left:85%;font-size:14px;animation:ttHeartFloat1 7.5s ease-in infinite -5s;">💗</span>
                                <span style="position:absolute;bottom:0;left:40%;font-size:10px;animation:ttHeartFloat2 6s ease-in infinite -2s;">💕</span>
               </div>`
            : isJustBecause
            ? `<div style="position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:0;">
                 <style>
                   @keyframes ttConfettiFall { 0%{transform:translateY(-30px) rotate(0deg);opacity:0;} 8%{opacity:1;} 92%{opacity:.9;} 100%{transform:translateY(340px) rotate(360deg);opacity:0;} }
                 </style>
                 <span style="position:absolute;top:0;left:6%;width:7px;height:7px;background:#f472b6;border-radius:2px;animation:ttConfettiFall 4.2s linear infinite -1.4s;"></span>
                 <span style="position:absolute;top:0;left:16%;width:6px;height:6px;background:#60a5fa;border-radius:50%;animation:ttConfettiFall 3.6s linear infinite -.5s;"></span>
                 <span style="position:absolute;top:0;left:27%;width:6px;height:9px;background:#fbbf24;border-radius:1px;animation:ttConfettiFall 4.8s linear infinite -3.1s;"></span>
                 <span style="position:absolute;top:0;left:38%;width:7px;height:7px;background:#a78bfa;border-radius:2px;animation:ttConfettiFall 4s linear infinite -2.2s;"></span>
                 <span style="position:absolute;top:0;left:49%;width:6px;height:6px;background:#34d399;border-radius:50%;animation:ttConfettiFall 3.9s linear infinite -.9s;"></span>
                 <span style="position:absolute;top:0;left:60%;width:7px;height:7px;background:#f472b6;border-radius:1px;animation:ttConfettiFall 4.5s linear infinite -3.6s;"></span>
                 <span style="position:absolute;top:0;left:71%;width:6px;height:9px;background:#60a5fa;border-radius:2px;animation:ttConfettiFall 3.7s linear infinite -1.9s;"></span>
                 <span style="position:absolute;top:0;left:81%;width:6px;height:6px;background:#fbbf24;border-radius:50%;animation:ttConfettiFall 4.3s linear infinite -2.7s;"></span>
                 <span style="position:absolute;top:0;left:91%;width:7px;height:7px;background:#a78bfa;border-radius:1px;animation:ttConfettiFall 4.1s linear infinite -.3s;"></span>
                 <span style="position:absolute;top:0;left:44%;width:6px;height:6px;background:#34d399;border-radius:2px;animation:ttConfettiFall 3.8s linear infinite -3.9s;"></span>
               </div>`
            : '';
                 const giftBow = isHalloween
            ? `<div style="position:absolute;top:-26px;left:50%;transform:translateX(-50%);z-index:3;filter:drop-shadow(0 4px 12px rgba(255,140,40,.5));">
                 <svg width="58" height="54" viewBox="0 0 58 54" xmlns="http://www.w3.org/2000/svg">
                   <defs><radialGradient id="ttPumpGrad" cx="40%" cy="35%" r="70%"><stop offset="0%" stop-color="#ffb347"/><stop offset="100%" stop-color="#e2600c"/></radialGradient></defs>
                   <path d="M28 12 C28 5 31 3 34 4" stroke="#3f6b2a" stroke-width="4" fill="none" stroke-linecap="round"/>
                   <ellipse cx="18" cy="32" rx="13" ry="18" fill="url(#ttPumpGrad)"/>
                   <ellipse cx="40" cy="32" rx="13" ry="18" fill="url(#ttPumpGrad)"/>
                   <ellipse cx="29" cy="32" rx="13" ry="20" fill="url(#ttPumpGrad)" stroke="#c9500a" stroke-width="1"/>
                   <path d="M20 28 L25 23 L28 29 Z M31 29 L34 23 L39 28 Z" fill="#4a1f00"/>
                   <path d="M19 38 Q29 47 39 38 Q34 41 29 40 Q24 41 19 38 Z" fill="#4a1f00"/>
                 </svg>
               </div>`
            : isBirthday
            ? `<div style="position:absolute;top:-20px;left:50%;transform:translateX(-50%);z-index:3;filter:drop-shadow(0 4px 8px rgba(150,20,40,.25));">
                 <svg width="76" height="46" viewBox="0 0 76 46" xmlns="http://www.w3.org/2000/svg">
                   <defs>
                     <linearGradient id="ttBowGrad" x1="20%" y1="0%" x2="80%" y2="100%">
                       <stop offset="0%" stop-color="#ff6b7a"/><stop offset="55%" stop-color="#e8384f"/><stop offset="100%" stop-color="#c41f36"/>
                     </linearGradient>
                   </defs>
                   <path d="M36 23 C 30 8, 8 4, 5 16 C 2 27, 18 29, 36 23 Z" fill="url(#ttBowGrad)"/>
                   <path d="M40 23 C 46 8, 68 4, 71 16 C 74 27, 58 29, 40 23 Z" fill="url(#ttBowGrad)"/>
                   <path d="M36 23 C 32 27, 28 31, 27 35 C 26 39, 32 40, 35 36 C 37 33, 37 27, 36 23 Z" fill="#c41f36" opacity=".5"/>
                   <path d="M40 23 C 44 27, 48 31, 49 35 C 50 39, 44 40, 41 36 C 39 33, 39 27, 40 23 Z" fill="#c41f36" opacity=".5"/>
                   <circle cx="38" cy="23" r="7" fill="#e8384f" stroke="#b8172d" stroke-width="1.5"/>
                 </svg>
               </div>`
            : isPrincess
            ? `<div style="position:absolute;top:-24px;left:50%;transform:translateX(-50%);z-index:3;filter:drop-shadow(0 4px 10px rgba(186,120,240,.35));">
                 <svg width="66" height="48" viewBox="0 0 66 48" xmlns="http://www.w3.org/2000/svg">
                   <defs>
                     <linearGradient id="ttCrownGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                       <stop offset="0%" stop-color="#ffe27a"/><stop offset="100%" stop-color="#e0a800"/>
                     </linearGradient>
                   </defs>
                   <path d="M8 40 L4 16 L18 27 L33 8 L48 27 L62 16 L58 40 Z" fill="url(#ttCrownGrad)" stroke="#c98f00" stroke-width="1.5" stroke-linejoin="round"/>
                   <circle cx="33" cy="8" r="4.5" fill="#f472b6"/>
                   <circle cx="4" cy="16" r="3.5" fill="#a78bfa"/>
                   <circle cx="62" cy="16" r="3.5" fill="#a78bfa"/>
                   <rect x="8" y="40" width="50" height="5" rx="2" fill="url(#ttCrownGrad)" stroke="#c98f00" stroke-width="1"/>
                 </svg>
               </div>`
                : isSuperhero
            ? `<div style="position:absolute;top:-22px;left:50%;transform:translateX(-50%);z-index:3;filter:drop-shadow(0 4px 12px rgba(255,204,60,.4));">
                 <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                   <defs>
                     <linearGradient id="ttShieldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                       <stop offset="0%" stop-color="#4fa3ff"/><stop offset="100%" stop-color="#1d4ed8"/>
                     </linearGradient>
                   </defs>
                   <path d="M30 3 L52 11 V29 C52 42 43 51 30 57 C17 51 8 42 8 29 V11 Z" fill="url(#ttShieldGrad)" stroke="#ffcc3c" stroke-width="2"/>
                   <path d="M22 30 L28 36 L40 22" stroke="#ffe27a" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                 </svg>
               </div>`
                    : isLullaby
            ? `<div style="position:absolute;top:-20px;left:50%;transform:translateX(-50%);z-index:3;filter:drop-shadow(0 4px 10px rgba(180,190,255,.35));">
                 <svg width="56" height="44" viewBox="0 0 56 44" xmlns="http://www.w3.org/2000/svg">
                   <defs>
                     <linearGradient id="ttMoonGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                       <stop offset="0%" stop-color="#ffe9a8"/><stop offset="100%" stop-color="#f0c862"/>
                     </linearGradient>
                   </defs>
                   <path d="M32 6 C22 6 14 14 14 24 C14 34 22 42 32 42 C24 40 18 32 18 24 C18 16 24 8 32 6 Z" fill="url(#ttMoonGrad)"/>
                   <circle cx="44" cy="10" r="2.2" fill="#fff" opacity=".9"/>
                   <circle cx="49" cy="18" r="1.4" fill="#fff" opacity=".75"/>
                   <circle cx="8" cy="14" r="1.6" fill="#fff" opacity=".8"/>
                 </svg>
               </div>`
                 : isJustBecause
            ? `<div style="position:absolute;top:-20px;left:50%;transform:translateX(-50%);z-index:3;filter:drop-shadow(0 4px 10px rgba(120,150,255,.3));">
                 <svg width="54" height="54" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">
                   <defs>
                     <radialGradient id="ttBurstGrad" cx="50%" cy="50%" r="50%">
                       <stop offset="0%" stop-color="#ffd76a"/><stop offset="100%" stop-color="#f472b6"/>
                     </radialGradient>
                   </defs>
                   <path d="M27 4 L31 19 L46 15 L34 25 L46 35 L31 31 L27 46 L23 31 L8 35 L20 25 L8 15 L23 19 Z" fill="url(#ttBurstGrad)" stroke="#e0568f" stroke-width="1"/>
                   <circle cx="27" cy="25" r="7" fill="#fff" opacity=".95"/>
                 </svg>
               </div>`
            : '';
          const demoClipForReveal = window.ttDemoClipUrl || '';
          const themedHeroSet =
            THEMED_HERO_VIDEOS[occasion] ||
            (occasion === 'bedtime' || genre === 'lullaby' || genre === 'bedtime' ? THEMED_HERO_VIDEOS.lullaby : null);
          const hasCharForHero = !!charImg;
          const DEFAULT_BLUR_URL = 'https://cdn.shopify.com/videos/c/o/v/38c6e6ce71c14313901c5ffe230e51e3.mp4';
          const DEFAULT_REVEAL_URL = 'https://cdn.shopify.com/videos/c/o/v/79fc7190e5b649dfb088c67b88619c7e.mp4';
          const blurVideoUrl = themedHeroSet
            ? hasCharForHero
              ? themedHeroSet.withCharacter
              : themedHeroSet.noCharacter
            : DEFAULT_BLUR_URL;
          const revealVideoUrl = DEFAULT_REVEAL_URL;

          stage.innerHTML = `
  <style>
        @keyframes ttBarFlow2 { 0%{background-position:0% 50%;} 50%{background-position:100% 50%;} 100%{background-position:0% 50%;} }
    @keyframes ttArrowBounce { 0%,100%{transform:translateY(0);} 50%{transform:translateY(4px);} }
    .tt-stage-hero { position:relative; width:100%; aspect-ratio:16/9; border-radius:22px; overflow:hidden; background:linear-gradient(135deg,#1e3a5f,#0f1c2e 70%); box-shadow:0 12px 40px rgba(17,24,39,.16); }
    .tt-stage-hero video.tt-blur-bg { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; }
    .tt-stage-hero video.tt-reveal-video { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; display:none; z-index:1; }
    .tt-stage-hero video.tt-personal-demo { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; z-index:1; opacity:0; transition:opacity .8s ease; pointer-events:none; }
    .tt-stage-hero video.tt-personal-demo.show { opacity:1; }
    .tt-personal-demo-badge { position:absolute; bottom:14px; right:14px; z-index:3; background:rgba(0,0,0,.55); backdrop-filter:blur(3px); color:#fff; font-family:'Nunito',sans-serif; font-size:11px; font-weight:900; letter-spacing:.02em; padding:6px 12px; border-radius:999px; opacity:0; transition:opacity .8s ease; pointer-events:none; white-space:nowrap; }
.tt-personal-demo-badge.show { opacity:1; }
    .tt-stage-hero .tt-hero-dim { position:absolute; inset:0; background:linear-gradient(to top, rgba(8,17,33,.75) 0%, rgba(8,17,33,.25) 45%, rgba(8,17,33,.15) 100%); }
    .tt-hero-char-thumb { position:absolute; top:14px; left:14px; width:60px; height:60px; border-radius:14px; object-fit:cover; object-position:center 20%; box-shadow:0 8px 22px rgba(0,0,0,.4); border:2px solid rgba(255,255,255,.85); z-index:2; }
    .tt-video-unlock-hint { position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); z-index:2; text-align:center; color:#fff; font-family:'Nunito',sans-serif; font-weight:900; line-height:1.35; text-shadow:0 2px 10px rgba(0,0,0,.65); background:rgba(0,0,0,.32); backdrop-filter:blur(2px); padding:14px 22px; border-radius:16px; max-width:82%; opacity:0; transition:opacity 0.8s ease; }
    .tt-video-unlock-hint.show { opacity:1; }
    .tt-video-unlock-hint .tt-vuh-top { font-size:clamp(15px,3.8vw,19px); }
    .tt-hero-char-reveal { position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); z-index:3; width:150px; height:188px; object-fit:cover; object-position:center 20%; border-radius:16px; box-shadow:0 14px 40px rgba(0,0,0,.45); border:3px solid rgba(255,255,255,.85); opacity:0; transition:opacity 1.4s ease; pointer-events:none; }
    .tt-hero-char-reveal.show { opacity:1; }
    .tt-hero-char-slot {
  position:absolute; left:4%; top:8%; width:32%; height:84%;
  object-fit:contain; object-position:bottom center; z-index:2;
  border-radius:14px;
  filter:drop-shadow(0 10px 22px rgba(0,0,0,.35));
  opacity:0;
  transform:translateY(10px) scale(.97);
  transition:opacity 1.1s ease, transform 1.1s cubic-bezier(.22,1,.36,1);
}
.tt-hero-char-slot.show { opacity:1; transform:translateY(0) scale(1); }
    .tt-hero-example { position:absolute; top:10px; left:10px; z-index:4; max-width:calc(100% - 120px); padding:6px 11px; border-radius:12px; background:rgba(21,26,51,.72); -webkit-backdrop-filter:blur(6px); backdrop-filter:blur(6px); color:#fff; font:800 12px/1.35 Nunito,sans-serif; pointer-events:none; transition:opacity .3s; }
    .tt-hero-star { position:absolute; top:10px; right:10px; z-index:4; display:flex; flex-direction:column; align-items:center; gap:4px; pointer-events:none; }
    .tt-hero-star img { width:84px; height:84px; object-fit:cover; object-position:top; border-radius:50%; border:3px solid #f6d27a; background:#fff; box-shadow:0 6px 18px rgba(0,0,0,.35); }
    .tt-hero-star b { padding:3px 9px; border-radius:999px; background:#f6d27a; color:#151a33; font:900 11.5px Nunito,sans-serif; white-space:nowrap; }
        .tt-stage-hero.tt-split video.tt-blur-bg { left:36%; width:64%; }
    .tt-hero-split-panel { position:absolute; left:0; top:0; bottom:0; width:36%; z-index:1; background:#fff; }
    .tt-stage-hero.tt-split { background:#fff; }
    .tt-stage-hero.tt-split .tt-hero-dim { left:36%; }
    .tt-hero-ex-pill { position:absolute; top:10px; right:10px; z-index:4; padding:4px 12px; border-radius:999px; border:2px solid #fff; background:rgba(60,90,110,.75); color:#fff; font:900 13px Nunito,sans-serif; pointer-events:none; }
    #ttPvBadge.ending ~ .tt-hero-example { opacity:0; }
    .tt-stage-hero.tt-reveal-phase .tt-hero-example, .tt-stage-hero.tt-reveal-phase .tt-hero-star,
    .tt-stage-hero.tt-reveal-phase .tt-hero-ex-pill, .tt-stage-hero.tt-reveal-phase .tt-hero-split-panel { display:none; }
    @media (max-width:480px){ .tt-hero-star img{ width:62px; height:62px; } .tt-hero-ex-pill{ top:6px; right:6px; padding:2px 8px; font-size:10px; border-width:1.5px; } .tt-hero-example{ left:66px; right:8px; bottom:12px; } }
    .tt-hero-meta { position:absolute; left:0; right:0; bottom:0; padding:16px 18px; color:#fff; z-index:2; }
    .tt-hero-title { font-family:'Fraunces',serif; font-weight:600; font-size:clamp(19px,4.5vw,26px); letter-spacing:-.02em; line-height:1.05; text-shadow:0 2px 12px rgba(0,0,0,.4); }
    .tt-hero-sub { font-size:12.5px; font-weight:700; opacity:.9; margin-top:3px; text-shadow:0 1px 8px rgba(0,0,0,.4); }
    .tt-hero-controls { display:flex; align-items:center; gap:14px; margin-top:12px; }
    .tt-hero-play { width:46px; height:46px; border-radius:50%; border:none; cursor:pointer; flex-shrink:0; background:#fff; display:grid; place-items:center; box-shadow:0 6px 20px rgba(0,0,0,.3); transition:transform .15s; }
    .tt-hero-play:hover { transform:scale(1.06); }
    .tt-hero-track { flex:1; min-width:0; }
    .tt-hero-bar { position:relative; height:7px; border-radius:999px; background:rgba(255,255,255,.28); cursor:pointer; overflow:hidden; }
    .tt-hero-fill { height:100%; width:0%; border-radius:999px; background:linear-gradient(90deg,#7dd3fc,#a78bfa,#f472b6); background-size:300% 300%; animation:ttBarFlow2 4s ease infinite; transition:width .1s linear; }
    .tt-hero-time { font-size:10.5px; font-weight:800; color:rgba(255,255,255,.85); margin-top:5px; text-align:right; }
    .tt-pv-badge { position:absolute; top:10px; left:10px; z-index:2; display:inline-flex; align-items:center; padding:5px 10px; border-radius:999px; background:rgba(21,26,51,.82); -webkit-backdrop-filter:blur(6px); backdrop-filter:blur(6px); box-shadow:0 4px 12px rgba(0,0,0,.25); pointer-events:none; font-family:'Nunito',sans-serif; }
    .tt-pv-badge b { font-size:11.5px; font-weight:900; letter-spacing:.06em; color:#f6d27a; line-height:1; white-space:nowrap; }
    .tt-pv-badge small { display:none; }
    .tt-pv-badge.ending { background:rgba(190,30,45,.9); }
    .tt-pv-badge.ending b { color:#fff; }
    .tt-stage-hero.tt-reveal-phase .tt-pv-badge { display:none; }
    .tt-stage-hero.tt-reveal-phase .tt-hero-dim,
    .tt-stage-hero.tt-reveal-phase .tt-hero-meta,
    .tt-stage-hero.tt-reveal-phase .tt-video-unlock-hint,
    .tt-stage-hero.tt-reveal-phase .tt-hero-char-reveal,
    .tt-stage-hero.tt-reveal-phase .tt-hero-char-slot,
    .tt-stage-hero.tt-reveal-phase .tt-hero-char-thumb,
    .tt-stage-hero.tt-reveal-phase .tt-personal-demo,
    .tt-stage-hero.tt-reveal-phase .tt-personal-demo-badge { display:none; }
        .tt-ly { position:relative; display:block; z-index:1; width:100%; box-sizing:border-box; padding:22px 18px 18px; margin:0 auto 12px; text-align:center; pointer-events:none; background:#fff; border:1px solid #edf1f5; border-radius:18px; box-shadow:0 8px 24px rgba(15,23,42,.05); }
    .tt-ly-line { display:block; max-width:100%; font-family:'Fraunces',Georgia,serif; font-size:clamp(23px,5.8vw,32px); font-weight:600; line-height:1.42; color:#b7bec8; }
    .tt-ly-line span { transition:color .18s ease,text-shadow .18s ease; }
    .tt-ly-line span.on { color:#182b49; text-shadow:0 1px 0 rgba(255,255,255,.7); }
    .tt-ly-line span.nm.on { color:#c58a08; }
    .tt-ly-next { margin-top:8px; font-family:'Nunito',sans-serif; font-size:12px; font-weight:700; color:#9aa5b1; }
    .tt-ly-tag { margin:0 0 8px; font-family:'Nunito',sans-serif; font-size:10.5px; font-weight:900; letter-spacing:.14em; text-transform:uppercase; color:#b7862a; }
    .tt-next-cap { position:absolute; left:0; right:0; bottom:0; z-index:1; pointer-events:none; padding:44px 16px 16px 76px; text-align:center;
      background:linear-gradient(to top, rgba(8,13,30,.92) 0%, rgba(8,13,30,.75) 45%, rgba(8,13,30,0) 100%);
      font-family:'Fraunces',Georgia,serif; font-style:italic; font-weight:600; font-size:clamp(19px,5vw,28px); line-height:1.15; color:#fff;
      text-shadow:0 2px 12px rgba(0,0,0,.5); }
    .tt-next-cap b { color:#f6d27a; font-weight:600; }
    .tt-stage-hero.tt-poster-mode .tt-next-cap, .tt-stage-hero.tt-reveal-phase .tt-next-cap { display:none; }
    @media (max-width:600px){ .tt-ly { padding:18px 12px 14px; border-radius:14px; } .tt-ly-next{ display:none; } }
        .tt-hero-example.tt-cap2 { top:auto; left:0; right:0; bottom:0; max-width:none; padding:22px 12px 12px 74px; border-radius:0; background:linear-gradient(to top, rgba(8,13,30,.7), rgba(8,13,30,0)); -webkit-backdrop-filter:none; backdrop-filter:none; text-align:center; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; color:#fff; font:800 clamp(11px,3vw,14px)/1.2 Nunito,sans-serif; text-shadow:0 1px 6px rgba(0,0,0,.5); }
    .tt-stage-hero.tt-split .tt-hero-example.tt-cap2 { left:36%; padding-left:12px; }
    @media (max-width:480px){ .tt-hero-example.tt-cap2 { left:0; right:0; bottom:0; padding:16px 6px 8px 64px; font-size:clamp(9.5px,2.7vw,11px); white-space:normal; line-height:1.25; } .tt-stage-hero.tt-split .tt-hero-example.tt-cap2 { left:36%; padding-left:6px; } }
    .tt-opening { position:absolute; inset:0; z-index:1; display:none; overflow:hidden; }
    .tt-opening video { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; opacity:0; transition:opacity .15s linear, filter 1.4s ease, transform 1.6s ease; }
    .tt-opening video.on { opacity:1; }
    .tt-stage-hero.tt-op-on .tt-opening, .tt-stage-hero.tt-op-locked .tt-opening { display:block; }
    .tt-stage-hero.tt-op-on .tt-hero-char-slot, .tt-stage-hero.tt-op-on .tt-hero-split-panel, .tt-stage-hero.tt-op-on .tt-hero-example, .tt-stage-hero.tt-op-on .tt-hero-ex-pill,
    .tt-stage-hero.tt-op-locked .tt-hero-char-slot, .tt-stage-hero.tt-op-locked .tt-hero-split-panel, .tt-stage-hero.tt-op-locked .tt-hero-example, .tt-stage-hero.tt-op-locked .tt-hero-ex-pill { display:none; }
    .tt-stage-hero.tt-op-locked .tt-opening video.on { filter:blur(14px) brightness(.55); transform:scale(1.08); }
    .tt-op-lock { position:absolute; inset:0; z-index:2; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:8px; padding:0 10% 46px; text-align:center; cursor:pointer; opacity:0; visibility:hidden; transition:opacity 1.2s ease .2s, visibility 0s linear 1.4s; }
    .tt-stage-hero.tt-op-locked .tt-op-lock { opacity:1; visibility:visible; transition:opacity 1.2s ease .2s; }
    .tt-op-ic { display:flex !important; align-items:center; justify-content:center; width:clamp(40px,10vw,58px); height:clamp(40px,10vw,58px); border-radius:50%; background:rgba(255,255,255,.14); border:2px solid rgba(246,210,122,.85); font-size:clamp(18px,4.6vw,26px); }
    .tt-op-lock b { font-family:Fraunces,Georgia,serif; font-weight:600; font-size:clamp(16px,4.4vw,26px); line-height:1.15; color:#fff; text-shadow:0 2px 12px rgba(0,0,0,.55); }
    .tt-op-btn { padding:8px 16px; border-radius:999px; background:linear-gradient(180deg,#fff3c4,#f7d774 30%,#e9b64a 70%,#d9a23a); color:#2b1d00; font:900 clamp(11.5px,3.2vw,15px) Nunito,sans-serif; white-space:nowrap; box-shadow:0 8px 20px -8px rgba(201,143,34,.8); }
    .tt-stage-hero.tt-reveal-phase .tt-opening, .tt-stage-hero.tt-reveal-phase .tt-op-lock { display:none; }
    .tt-stage-hero.tt-op-on .tt-hero-dim, .tt-stage-hero.tt-op-locked .tt-hero-dim { display:none !important; }
    .tt-op-sub { max-width:92%; font:800 clamp(11px,3vw,14px)/1.3 Nunito,sans-serif; color:#f6d27a; text-shadow:0 1px 8px rgba(0,0,0,.6); }
    .tt-stage-hero video.tt-lock-bg { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; z-index:1; display:none; filter:blur(14px) brightness(.55); transform:scale(1.08); }
    .tt-stage-hero.tt-op-locked .tt-opening { display:none; }
    .tt-stage-hero.tt-op-locked video.tt-lock-bg { display:block; }
    @media (max-width:480px){ .tt-op-ic { display:none !important; } .tt-op-lock { gap:5px; } }
    </style>

            <div id="ttGiftReveal" style="${giftCardOuterStyle}">
            ${giftBow}
            ${giftRibbon}
            <div style="position:relative;z-index:2;">
    ${
      charImg
        ? `<img src="${charImg}" alt="" style="width:120px;height:150px;object-fit:cover;object-position:center 20%;border-radius:16px;margin:0 auto 16px;display:block;box-shadow:0 10px 28px rgba(60,138,179,.28);">`
        : ''
    }
             <div style="font-weight:950;font-size:clamp(22px,6vw,34px);color:${(isSuperhero || isLullaby || isHalloween) ? '#ffffff' : '#111827'};letter-spacing:-0.03em;line-height:1.05;margin-bottom:6px;">${
          pt('songTitleWithName')
            ? PT_ES.songTitleWithName(titleCaseName(capturedChildName))
            : (titleCaseName(capturedChildName) ? titleCaseName(capturedChildName) + "'s" : 'Your') + (
                  isHalloween ? ' Halloween Song'
                : isLullaby ? ' Lullaby'
                : isBirthday ? ' Birthday Song'
                : isPrincess ? ' Fairytale Story'
                : isSuperhero ? ' Superhero Anthem'
                : ' Song'
              )
        }</div>
           <div style="font-size:13px;color:${(isSuperhero || isLullaby || isHalloween) ? 'rgba(255,255,255,.75)' : '#6b7280'};font-weight:700;margin-bottom:24px;">${
      pt('previewLen') || '60-second personalized preview'
    }</div>
    <div style="width:96px;height:96px;border-radius:50%;background:linear-gradient(135deg,#4fa3d1,#3c8ab3);display:grid;place-items:center;margin:0 auto 18px;animation:ttPulse 1.8s ease-out infinite;">
      <svg width="40" height="40" viewBox="0 0 44 44"><polygon points="10,4 40,22 10,40" fill="white"/></svg>
    </div>
                         <div style="font-weight:900;font-size:17px;color:${(isSuperhero || isLullaby || isHalloween) ? '#ffffff' : '#111827'};display:flex;align-items:center;justify-content:center;gap:6px;">
            <span>${ttLang === 'es' ? 'Letra completa abajo' : 'Full Lyrics Below'}</span>
          <span style="display:inline-block;animation:ttArrowBounce 1.6s ease-in-out infinite;">↓</span>
        </div>
                          ${
            occasion === 'halloween' && !hasExtraCharacters
        ? `<style>
             @keyframes ttBdayIn { from{opacity:0;transform:translateY(6px) scale(.96);} to{opacity:1;transform:translateY(0) scale(1);} }
             @keyframes ttPumpWiggle{0%,100%{transform:rotate(0deg) scale(1);}25%{transform:rotate(-10deg) scale(1.1);}75%{transform:rotate(10deg) scale(1.1);}}
             .tt-hw-badge{animation:ttBdayIn .5s cubic-bezier(.22,1,.36,1);}
             .tt-hw-badge .tt-pump{display:inline-block;animation:ttPumpWiggle 1.8s ease-in-out infinite;}
           </style>
           <div class="tt-hw-badge" style="margin-top:14px;display:inline-flex;align-items:center;gap:12px;padding:12px 20px 12px 14px;border-radius:18px;background:linear-gradient(135deg,#2a1242,#4b1f6b);border:2px solid #ff8c28;box-shadow:0 8px 22px rgba(90,40,140,.45);">
             <div style="flex-shrink:0;width:38px;height:38px;border-radius:50%;background:linear-gradient(135deg,#ffb347,#e2600c);display:flex;align-items:center;justify-content:center;box-shadow:0 3px 8px rgba(226,96,12,.45);">
               <span class="tt-pump" style="font-size:18px;">🎃</span>
             </div>
             <div style="text-align:left;">
               <div style="font-family:'Nunito',sans-serif;font-size:14px;font-weight:900;color:#ffc27a;letter-spacing:-.01em;">Trick-or-treat time!</div>
               <div style="font-family:'Nunito',sans-serif;font-size:11.5px;font-weight:700;color:#d9c2f0;margin-top:1px;">👻 A spooky-fun song, starring them</div>
             </div>
           </div>`
        : occasion === 'birthday' && !hasExtraCharacters
        ? `<style>
             @keyframes ttCakeBounce { 0%,100%{transform:rotate(0deg) scale(1);} 25%{transform:rotate(-8deg) scale(1.08);} 75%{transform:rotate(8deg) scale(1.08);} }
             .tt-bday-badge { animation: ttBdayIn .5s cubic-bezier(.22,1,.36,1); }
             @keyframes ttBdayIn { from{opacity:0;transform:translateY(6px) scale(.96);} to{opacity:1;transform:translateY(0) scale(1);} }
             .tt-bday-badge .tt-bday-cake { display:inline-block; animation: ttCakeBounce 1.8s ease-in-out infinite; }
           </style>
           <div class="tt-bday-badge" style="margin-top:14px;display:inline-flex;align-items:center;gap:12px;padding:12px 20px 12px 14px;border-radius:18px;background:linear-gradient(135deg,#fff5cc,#ffd9e8);border:2px solid #f0b429;box-shadow:0 8px 22px rgba(224,160,0,.28);">
             <div style="flex-shrink:0;width:38px;height:38px;border-radius:50%;background:linear-gradient(135deg,#ffd76a,#e0a000);display:flex;align-items:center;justify-content:center;box-shadow:0 3px 8px rgba(154,90,0,.35);">
               <span class="tt-bday-cake" style="font-size:19px;">🎂</span>
             </div>
             <div style="text-align:left;">
               <div style="font-family:'Nunito',sans-serif;font-size:14px;font-weight:900;color:#7a3d00;letter-spacing:-.01em;">
                 A birthday surprise, right on time
               </div>
               <div style="font-family:'Nunito',sans-serif;font-size:11.5px;font-weight:700;color:#a56a2e;margin-top:1px;">
                 💌 Choose their birthday — we'll send it that day
               </div>
             </div>
           </div>`
               : occasion === 'princess' && !hasExtraCharacters
        ? `<style>
             @keyframes ttSparkleFloat{ 0%,100%{transform:translateY(0) rotate(0deg);opacity:.9;} 50%{transform:translateY(-3px) rotate(12deg);opacity:1;} }
             .tt-princess-badge { animation: ttBdayIn .5s cubic-bezier(.22,1,.36,1); }
             .tt-princess-badge .tt-sparkle { display:inline-block; animation: ttSparkleFloat 2.2s ease-in-out infinite; }
           </style>
           <div class="tt-princess-badge" style="margin-top:14px;display:inline-flex;align-items:center;gap:12px;padding:12px 20px 12px 14px;border-radius:18px;background:linear-gradient(135deg,#f3e0ff,#ffe9c7);border:2px solid #c98ff2;box-shadow:0 8px 22px rgba(186,120,240,.28);">
             <div style="flex-shrink:0;width:38px;height:38px;border-radius:50%;background:linear-gradient(135deg,#e0a8ff,#a855f7);display:flex;align-items:center;justify-content:center;box-shadow:0 3px 8px rgba(140,60,200,.35);">
               <span class="tt-sparkle" style="font-size:18px;">✨</span>
             </div>
             <div style="text-align:left;">
               <div style="font-family:'Nunito',sans-serif;font-size:14px;font-weight:900;color:#6b21a8;letter-spacing:-.01em;">
                 A royal debut, fit for a princess
               </div>
               <div style="font-family:'Nunito',sans-serif;font-size:11.5px;font-weight:700;color:#9333ea;margin-top:1px;">
                 👑 Their crown moment, coming right up
               </div>
             </div>
           </div>`
                         : occasion === 'superhero' && !hasExtraCharacters
        ? `<style>
             @keyframes ttBoltPulse { 0%,100%{transform:scale(1);filter:drop-shadow(0 0 2px rgba(255,204,60,.6));} 50%{transform:scale(1.15);filter:drop-shadow(0 0 6px rgba(255,204,60,.9));} }
             .tt-hero-badge { animation: ttBdayIn .5s cubic-bezier(.22,1,.36,1); }
             .tt-hero-badge .tt-bolt { display:inline-block; animation: ttBoltPulse 1.6s ease-in-out infinite; }
           </style>
           <div class="tt-hero-badge" style="margin-top:14px;display:inline-flex;align-items:center;gap:12px;padding:12px 20px 12px 14px;border-radius:18px;background:linear-gradient(135deg,#1a2a5e,#0f1b3d);border:2px solid #ffcc3c;box-shadow:0 8px 22px rgba(20,30,80,.5);">
             <div style="flex-shrink:0;width:38px;height:38px;border-radius:50%;background:linear-gradient(135deg,#4fa3ff,#1d4ed8);display:flex;align-items:center;justify-content:center;box-shadow:0 3px 8px rgba(20,60,180,.5);">
               <span class="tt-bolt" style="font-size:18px;">⚡</span>
             </div>
             <div style="text-align:left;">
               <div style="font-family:'Nunito',sans-serif;font-size:14px;font-weight:900;color:#ffe27a;letter-spacing:-.01em;">
                 Hero mode: activated
               </div>
               <div style="font-family:'Nunito',sans-serif;font-size:11.5px;font-weight:700;color:#9fc2ff;margin-top:1px;">
                 🦸 Their origin story starts now
               </div>
             </div>
           </div>`
                     : genre === 'lullaby' && !hasExtraCharacters
        ? `<style>
             @keyframes ttStarTwinkle{ 0%,100%{opacity:.5;transform:scale(1);} 50%{opacity:1;transform:scale(1.2);} }
             .tt-lullaby-badge { animation: ttBdayIn .5s cubic-bezier(.22,1,.36,1); }
             .tt-lullaby-badge .tt-star { display:inline-block; animation: ttStarTwinkle 2s ease-in-out infinite; }
           </style>
           <div class="tt-lullaby-badge" style="margin-top:14px;display:inline-flex;align-items:center;gap:12px;padding:12px 20px 12px 14px;border-radius:18px;background:linear-gradient(135deg,#2a2f5e,#1a2144);border:2px solid rgba(200,210,255,.4);box-shadow:0 8px 22px rgba(30,36,80,.45);">
             <div style="flex-shrink:0;width:38px;height:38px;border-radius:50%;background:linear-gradient(135deg,#ffe9a8,#f0c862);display:flex;align-items:center;justify-content:center;box-shadow:0 3px 8px rgba(150,120,40,.35);">
               <span class="tt-star" style="font-size:17px;">✨</span>
             </div>
             <div style="text-align:left;">
               <div style="font-family:'Nunito',sans-serif;font-size:14px;font-weight:900;color:#f0dfa0;letter-spacing:-.01em;">
                 A gentle lullaby, made just for them
               </div>
               <div style="font-family:'Nunito',sans-serif;font-size:11.5px;font-weight:700;color:#b8c2f0;margin-top:1px;">
                 🌙 Sweet dreams start right here
               </div>
             </div>
           </div>`
                : occasion === 'just because' && !hasExtraCharacters
        ? `<style>
             @keyframes ttPartyBounce{ 0%,100%{transform:rotate(0deg) scale(1);} 25%{transform:rotate(-10deg) scale(1.1);} 75%{transform:rotate(10deg) scale(1.1);} }
             .tt-jb-badge { animation: ttBdayIn .5s cubic-bezier(.22,1,.36,1); }
             .tt-jb-badge .tt-party { display:inline-block; animation: ttPartyBounce 1.8s ease-in-out infinite; }
           </style>
           <div class="tt-jb-badge" style="margin-top:14px;display:inline-flex;align-items:center;gap:12px;padding:12px 20px 12px 14px;border-radius:18px;background:linear-gradient(135deg,#fff3d6,#e0f0ff);border:2px solid #93c5fd;box-shadow:0 8px 22px rgba(120,150,255,.22);">
             <div style="flex-shrink:0;width:38px;height:38px;border-radius:50%;background:linear-gradient(135deg,#ffb84f,#f472b6);display:flex;align-items:center;justify-content:center;box-shadow:0 3px 8px rgba(200,100,150,.35);">
               <span class="tt-party" style="font-size:18px;">🎉</span>
             </div>
                   <div style="text-align:left;">
               <div style="font-family:'Nunito',sans-serif;font-size:14px;font-weight:900;color:#1e3a5f;letter-spacing:-.01em;">
                 A surprise, just because!
               </div>
               <div style="font-family:'Nunito',sans-serif;font-size:11.5px;font-weight:700;color:#5b7ba8;margin-top:1px;">
                 🎉 Make an ordinary day extraordinary.
               </div>
             </div>
           </div>`
        : ''
    }
  </div>
  </div>

  <div id="ttPreviewVideoWrap" style="display:none;">
    <div class="tt-ly" id="ttLy" style="display:none"><div class="tt-ly-tag">${ttLang === 'es' ? '🎧 Vista previa de ' + Math.round(PREVIEW_LIMIT) + ' segundos' : '🎧 ' + Math.round(PREVIEW_LIMIT) + '-second preview'}</div><div class="tt-ly-line" id="ttLyLine"></div><div class="tt-ly-next" id="ttLyNext"></div></div>
    <div class="tt-stage-hero" id="ttStageHero">
      <video class="tt-blur-bg" id="ttBlurBg" muted loop playsinline preload="auto"><source src="${blurVideoUrl}"></video>
      <video class="tt-lock-bg" id="ttLockBg" muted loop playsinline preload="none"></video>
      <video class="tt-reveal-video" id="ttRevealVideo" muted playsinline preload="auto"><source src="${revealVideoUrl}"></video>
      <video class="tt-personal-demo" id="ttPersonalDemo" muted loop playsinline preload="auto"><source src=""></video>
      <div class="tt-personal-demo-badge" id="ttPersonalDemoBadge">Preview Clip — Full video has 25 scenes</div>
      <div class="tt-hero-dim"></div>
      ${!charImg ? '<div class="tt-next-cap">' + (ttLang === 'es'
        ? 'Siguiente: crea el personaje de <b>' + (titleCaseName(capturedChildName) || 'su estrella') + '</b> ✨'
        : 'Next: create <b>' + (titleCaseName(capturedChildName) ? (titleCaseName(capturedChildName).endsWith('s') ? titleCaseName(capturedChildName) + "'" : titleCaseName(capturedChildName) + "'s") : 'their') + '</b> character ✨') + '</div>' : ''}
      <div class="tt-pv-badge" id="ttPvBadge"><b id="ttPvBadgeTop"></b><small id="ttPvBadgeSub"></small></div>
      <div class="tt-video-unlock-hint" id="ttVideoHint"><span class="tt-vuh-top" id="ttVideoHintText"></span></div>
      <img class="tt-hero-char-reveal" id="ttHeroCharReveal" src="${charImg}" alt="">
      <div class="tt-opening" id="ttOpening"><video muted playsinline preload="auto"></video><video muted playsinline preload="auto"></video><video muted playsinline preload="auto"></video></div>
      <div class="tt-op-lock" id="ttOpLock">${(() => {
        const es = ttLang === 'es';
        const n = titleCaseName(capturedChildName);
        const poss = n ? (n.endsWith('s') ? n + "'" : n + "'s") : 'their';
        const meLow = window.ttSelfPick && window.ttSelfPick.label ? window.ttSelfPick.label.toLowerCase() : '';
        const fam = (typeof ttFamilyNames === 'function' ? ttFamilyNames() : []).filter((x) => x.toLowerCase() !== meLow).slice(0, 2);
        const famTxt = fam.length > 1 ? fam[0] + (es ? ' y ' : ' & ') + fam[1] : fam[0] || '';
        const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;');
        const sub = famTxt
          ? (es ? 'Agrega a ' + famTxt + ' a la película gratis después de comprar' : 'Add ' + famTxt + ' to the movie free after purchase')
          : (es ? '20+ escenas más, cada una hecha para su canción' : '20+ more scenes, each one made for the song');
        return '<span class="tt-op-ic">🎬</span>' +
          '<b>' + esc(es ? 'La película de ' + (n || 'su estrella') + ' continúa…' : (n ? poss : 'Their') + ' movie keeps going…') + '</b>' +
          '<small class="tt-op-sub">' + esc(sub) + '</small>' +
          '<span class="tt-op-btn">' + esc(es ? 'Ver el resto de la película de ' + (n || 'su estrella') + ' →' : 'See the rest of ' + poss + ' movie →') + '</span>';
      })()}</div>
      ${(() => {
        const raw = typeof childName !== 'undefined' && childName
          ? (typeof titleCaseName === 'function' ? titleCaseName(childName) : childName) : '';
        const nm = String(raw).replace(/[<>&"]/g, '');
        const poss = nm ? (nm.endsWith('s') ? nm + "'" : nm + "'s") : 'Their';
        let out = '';
        if (themedHeroSet && hasCharForHero && themedHeroSet.split) {
          out += `<div class="tt-hero-split-panel"></div><span class="tt-hero-ex-pill">Example clips</span>`;
        }
        if (themedHeroSet && hasCharForHero && !themedHeroSet.noSlot) {
          out += `<img class="tt-hero-char-slot" id="ttHeroCharSlot" src="${charImg}" alt="">`;
        } else if (themedHeroSet && hasCharForHero) {
          out += `<div class="tt-hero-star"><img src="${charImg}" alt=""><b>⭐ ${nm || 'Starring'}</b></div>`;
        }
        if (themedHeroSet && themedHeroSet.split && hasCharForHero) {
          out += `<div class="tt-hero-example tt-cap2">${ttLang === 'es'
            ? 'Así se verá la película de ' + (nm || 'su estrella')
            : poss + ' movie will look like this'}</div>`;
        }
        return out;
      })()}
      <div class="tt-hero-meta">
  <div class="tt-hero-controls">
          <button id="ttAudioPlayBtn" class="tt-hero-play">
            <svg id="ttPlayIcon" width="18" height="18" viewBox="0 0 18 18"><polygon points="4,2 16,9 4,16" fill="#3c8ab3"/></svg>
            <svg id="ttPauseIcon" width="18" height="18" viewBox="0 0 18 18" style="display:none;"><rect x="3" y="2" width="4" height="14" rx="1.5" fill="#3c8ab3"/><rect x="11" y="2" width="4" height="14" rx="1.5" fill="#3c8ab3"/></svg>
          </button>
          <div class="tt-hero-track">
            <div id="ttProgressBar" class="tt-hero-bar"><div id="ttProgressFill" class="tt-hero-fill"></div></div>
            <div id="ttTimeDisplay" class="tt-hero-time">0:00 / 1:00</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <audio id="ttAudio" playsinline preload="auto" style="display:none;"></audio>
`;

          const giftReveal = document.getElementById('ttGiftReveal');
          const videoWrap = document.getElementById('ttPreviewVideoWrap');
          const stageHero = document.getElementById('ttStageHero');
          const blurBg = document.getElementById('ttBlurBg');
          const revealVideo = document.getElementById('ttRevealVideo');
          if (themedHeroSet && themedHeroSet.split && hasCharForHero && stageHero) stageHero.classList.add('tt-split');

          // The old vertical poster player (preview page section) is retired: undo it the instant it switches on,
          // so the song always plays on the 16:9 themed video with their character on the left
          if (window.TT_NO_POSTER_PLAYER && stageHero) {
            if (!document.getElementById('ttNoPosterStyles')) {
              const np = document.createElement('style');
              np.id = 'ttNoPosterStyles';
              // Only our own pieces may show inside the player; anything the old poster/clip script adds is hidden
              np.textContent =
                '#ttStageHero > :not(.tt-blur-bg):not(.tt-lock-bg):not(.tt-reveal-video):not(.tt-personal-demo):not(.tt-personal-demo-badge)' +
                ':not(.tt-hero-dim):not(.tt-next-cap):not(.tt-pv-badge):not(.tt-video-unlock-hint):not(.tt-hero-char-reveal)' +
                ':not(.tt-hero-char-slot):not(.tt-hero-meta):not(.tt-tap-play):not(.tt-rv-poster):not(.tt-hero-example):not(.tt-hero-star):not(.tt-hero-split-panel):not(.tt-hero-ex-pill):not(.tt-opening):not(.tt-op-lock):not(style){display:none !important}';
              document.head.appendChild(np);
            }
            const undoPoster = () => {
              if (stageHero.classList.contains('tt-poster-mode')) stageHero.classList.remove('tt-poster-mode');
              const pv = stageHero.querySelector('.tt-hero-posters video');
              if (pv && !pv.dataset.off) {
                pv.dataset.off = '1';
                try { pv.pause(); pv.removeAttribute('src'); pv.load(); } catch (e) {} // stop its hidden clip from downloading
              }
            };
            new MutationObserver(undoPoster).observe(stageHero, { attributes: true, attributeFilter: ['class'], childList: true });
            // It may also hide or pause our themed video: keep it showing and playing during the song
            setInterval(() => {
              undoPoster();
              if (!blurBg || stageHero.classList.contains('tt-reveal-phase')) return;
              if (blurBg.style.display === 'none') blurBg.style.display = '';
              const songNow = document.getElementById('ttAudio');
              if (songNow && !songNow.paused && blurBg.paused) blurBg.play().catch(() => {});
            }, 500);
            undoPoster();
          }

          const audioPlayBtn = document.getElementById('ttAudioPlayBtn');
          const playIcon = document.getElementById('ttPlayIcon');
          const pauseIcon = document.getElementById('ttPauseIcon');
          const progressFill = document.getElementById('ttProgressFill');
          const progressBar = document.getElementById('ttProgressBar');
          const timeDisplay = document.getElementById('ttTimeDisplay');

          const heroHintText = document.getElementById('ttVideoHintText');
          const heroHintWrap = document.getElementById('ttVideoHint');
          const heroCharReveal = document.getElementById('ttHeroCharReveal');
          const personalDemo = document.getElementById('ttPersonalDemo');
          const personalDemoBadge = document.getElementById('ttPersonalDemoBadge');
          let personalDemoShownEarly = false;
          let personalDemoShownLate = false;

          function applyPersonalDemoSrc(url, alsoPlay) {
            if (!personalDemo) return;
            const src = personalDemo.querySelector('source');
            if (src) src.src = url;
            personalDemo.load();
            if (alsoPlay) personalDemo.play().catch(() => {});
          }
          window.ttApplyPersonalDemoClip = function (url) {
            applyPersonalDemoSrc(url, false);
          };

          if (window.ttDemoClipUrl) applyPersonalDemoSrc(window.ttDemoClipUrl, false);
          const nameForOverlay = titleCaseName(capturedChildName);
          const NAME_HINT = pt('unlockVideoHint')
            ? PT_ES.unlockVideoHint(nameForOverlay)
            : nameForOverlay
            ? `🔒 Purchase to Unlock ${nameForOverlay}'s Video`
            : `🔒 Purchase to Unlock Their Video`;
          if (heroHintText) heroHintText.textContent = NAME_HINT;
          let heroHintShown = false;
          let heroCharShown = false;

          if (blurBg) {
            blurBg.addEventListener('timeupdate', () => {
              const t = blurBg.currentTime || 0;
              const usePersonal = !!window.ttDemoClipUrl;
              // Themed hero videos (birthday/princess) already tell their own visual story —
              // never show the static character popup or the "unlock your video" hint over them.
              const skipThemedOverlay = !!themedHeroSet;

              // Early window (0-5s): static character image — never the demo clip, which loads too laggy this early.
              if (!skipThemedOverlay && t < 5 && !heroCharShown && charImg) {
                heroCharShown = true;
                if (heroCharReveal) heroCharReveal.classList.add('show');
              } else if (!skipThemedOverlay && t >= 5 && t < 26 && heroCharShown) {
                heroCharShown = false;
                if (heroCharReveal) heroCharReveal.classList.remove('show');
              }

              if (!usePersonal && !skipThemedOverlay) {
                if (t < 4.5 && !heroHintShown) {
                  heroHintShown = true;
                  if (heroHintWrap) heroHintWrap.classList.add('show');
                } else if (t >= 4.5 && heroHintShown) {
                  heroHintShown = false;
                  if (heroHintWrap) heroHintWrap.classList.remove('show');
                }
              }

              // Late window (26s+): demo clip if we have one, otherwise the static character image again.
              if (usePersonal) {
                if (t >= 26 && !personalDemoShownLate) {
                  personalDemoShownLate = true;
                  if (heroCharReveal) heroCharReveal.classList.remove('show');
                  if (personalDemo) {
                    personalDemo.classList.add('show');
                    const heroCharSlotEl = document.getElementById('ttHeroCharSlot');
                    if (heroCharSlotEl) heroCharSlotEl.style.display = 'none';
                    personalDemo.play().catch(() => {});
                  }
                  if (personalDemoBadge) personalDemoBadge.classList.add('show');
                } else if (t < 26 && personalDemoShownLate) {
                  personalDemoShownLate = false;
                  if (personalDemo) personalDemo.classList.remove('show');
                  if (personalDemoBadge) personalDemoBadge.classList.remove('show');
                  const heroCharSlotEl2 = document.getElementById('ttHeroCharSlot');
                  if (heroCharSlotEl2) heroCharSlotEl2.style.display = '';
                }
              } else if (!skipThemedOverlay) {
                if (t >= 33 && !heroCharShown && charImg) {
                  heroCharShown = true;
                  if (heroCharReveal) heroCharReveal.classList.add('show');
                } else if (t < 33 && heroCharShown) {
                  heroCharShown = false;
                  if (heroCharReveal) heroCharReveal.classList.remove('show');
                }
              }
            });
          }

          if (blurBg) {
            blurBg.addEventListener('error', () => {
              console.warn('[TT] hero video failed to load:', blurVideoUrl);
              blurBg.style.display = 'none';
              if (heroHintWrap) heroHintWrap.classList.add('show');
            });
          }

          // Called once the 60s song preview ends: swap the blurred clip for the
          // clear reveal clip, let it play fully, then open the purchase modal.
          // Load the right post-preview video (and voiceover) while the song plays, so there's no black gap
          window.ttPreloadReveal = () => {
            if (window.ttRevealPreloaded || !revealVideo) return;
            window.ttRevealPreloaded = true;
            const castPre = null; // always the standard post-preview video + voiceover
            const rsPre = revealVideo.querySelector('source');
            if (castPre && rsPre && rsPre.src !== castPre.url) rsPre.src = castPre.url;
                 revealVideo.preload = 'auto';
            try { revealVideo.load(); } catch (e) {}
            // Also load the purchase modal's videos now, so they're ready when it opens
            document.querySelectorAll('#ttModal video').forEach((v) => {
              v.preload = 'auto';
              try { v.load(); } catch (e) {}
            });
            const EXTRAS_AUDIO_PRE = 'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/POST_PREVIEW_-_EXTRAS_AUDIO.mp3?v=1791411709';
            if (castPre && upsellAudio.src !== EXTRAS_AUDIO_PRE) { upsellAudio.src = EXTRAS_AUDIO_PRE; upsellAudio.load(); }
                        // Preload the gift photo and their poster, so the modal shows them instantly
            const giftBases = {
              princess: 'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/Post_-_Princess.jpg?v=1791692931',
              superhero: 'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/POST_-_SUPER_HERO.jpg?v=1791692931',
              bedtime: 'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/Post_-_Bedtime.jpg?v=1791692931',
            };
            [giftBases[String(window.ttSongTheme || '').toLowerCase()] ||
              'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/Post_-_everything_else.jpg?v=1791692931',
              window.ttPoster1].forEach((u) => { if (u) { const im = new Image(); im.src = u; } });
          };

          playRevealSequence = () => {
            window.ttRevealActive = true;
                        ttTrack('pv_reveal_start');
            ttShowNextStepsBar(); // the gold button appears under the post-preview video right away
            if (blurBg) {
              blurBg.pause();
              blurBg.style.display = 'none';
            }
            if (personalDemo) {
              personalDemo.classList.remove('show');
              try {
                personalDemo.pause();
              } catch (e) {}
            }
            if (personalDemoBadge) personalDemoBadge.classList.remove('show');
                    if (stageHero) stageHero.classList.add('tt-reveal-phase');
            // Family detected → the extras version: its own video, voiceover, and names on screen
            const castReveal = null; // always the standard post-preview video + voiceover
            const EXTRAS_AUDIO = 'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/POST_PREVIEW_-_EXTRAS_AUDIO.mp3?v=1791411709';
            if (castReveal && upsellAudio.src !== EXTRAS_AUDIO) {
              upsellAudio.src = EXTRAS_AUDIO;
              upsellAudio.load();
            }
            upsellAudio.play().catch(() => {});

            const modalDemoEl = document.getElementById('ttModalDemoClip');
            if (modalDemoEl && !window.ttDemoClipUrl) {
              modalDemoEl.preload = 'auto';
              modalDemoEl.load();
            }

            if (!revealVideo) {
              openModal();
              return;
            }
              if (castReveal) {
              const rs = revealVideo.querySelector('source');
              if (rs && rs.src !== castReveal.url) {
                rs.src = castReveal.url;
                revealVideo.load();
              }
              window.TTCastVideo.attach(stageHero, revealVideo, castReveal);
            }
            revealVideo.style.transition = 'opacity .35s ease';
            revealVideo.style.opacity = revealVideo.readyState >= 3 ? '1' : '0';
            revealVideo.addEventListener('playing', () => { revealVideo.style.opacity = '1'; }, { once: true });
            revealVideo.style.display = 'block';
            revealVideo.currentTime = 0;
            ttAttachRevealPoster(stageHero, revealVideo);
            let opened = false;
            const openOnce = () => {
              if (opened) return;
              opened = true;
              clearTimeout(failSafe);
              openModal();
            };
            const failSafe = setTimeout(openOnce, castReveal ? 30000 : 25000); // new video is 20.5s; this only fires if it stalls
            revealVideo.addEventListener('ended', openOnce, { once: true });
            revealVideo.addEventListener(
              'error',
              () => {
                console.warn('[TT] reveal clip failed to load:', revealVideoUrl);
                openOnce();
              },
              { once: true }
            );
            revealVideo.play().catch(() => {
              openOnce();
            });
          };

          elAudio = document.getElementById('ttAudio');
          audioHandlersBound = false;
          playCount = 0;
          faded = false;
          bindAudioHandlersOnce();

          const src = `${WORKER_BASE}/preview-file?code=${encodeURIComponent(capturedCode)}`;
          const u = new URL(src, window.location.href);
          elAudio.src = u.toString();
          elAudio.load();

          const capturedAudio = elAudio;
          // Never autoplay a song on page load or when returning to an existing preview.
          // Playback is started only by the customer's explicit Play button.

          function updatePlayerUI() {
            if (!capturedAudio) return;
            const t = capturedAudio.currentTime || 0;
            const limit = PREVIEW_LIMIT > 0 ? PREVIEW_LIMIT : capturedAudio.duration || 60;
            const pct = limit > 0 ? Math.min(100, (t / limit) * 100) : 0;
            if (progressFill) progressFill.style.width = pct + '%';
                 if (timeDisplay) timeDisplay.textContent = `${fmtTime(t)} / ${fmtTime(limit)}`;
            const pvBadge = document.getElementById('ttPvBadge');
            const pvTop = document.getElementById('ttPvBadgeTop');
            const pvSub = document.getElementById('ttPvBadgeSub');
            if (pvBadge && pvTop && pvSub) {
              const left = Math.max(0, Math.ceil(limit - t));
              const esL = ttLang === 'es';
              if (!capturedAudio.paused && left <= 10 && left > 0) {
                pvBadge.style.display = '';
                pvBadge.classList.add('ending');
                pvTop.textContent = (esL ? '⏳ La vista previa termina en ' : '⏳ Preview ends in ') + left + 's';
              } else {
                // No pill during the song; the header already says it's a 60-second preview
                pvBadge.style.display = 'none';
                pvBadge.classList.remove('ending');
              }
            }
            if (playIcon && pauseIcon) {
              playIcon.style.display = capturedAudio.paused ? 'block' : 'none';
              pauseIcon.style.display = capturedAudio.paused ? 'none' : 'block';
            }
          }

                  capturedAudio.addEventListener('timeupdate', updatePlayerUI);
                    // Last 10 seconds of the song: their poster, big and full-screen, tappable, with the gold button
          capturedAudio.addEventListener('timeupdate', () => {
            const lim = PREVIEW_LIMIT > 0 ? PREVIEW_LIMIT : capturedAudio.duration || 60;
            const t = capturedAudio.currentTime || 0;
            const pRaw = window.ttPosterReady || window.ttPoster1 || '';
            const pUrl = pRaw && pRaw !== (window.ttPosterBefore || '') ? pRaw : '';
            const es = ttLang === 'es';
            let ep = document.getElementById('ttEndPoster');
            if (window.TT_END_POSTER && pUrl && t >= lim - 10 && t < lim && !window.ttSongDone && !window.ttEndPosterClosed) {
              if (ep) {
                const cd = ep.querySelector('.ttep-cd');
                if (cd) cd.textContent = (es ? 'La vista previa termina en ' : 'Preview ends in ') + Math.max(0, Math.ceil(lim - t)) + 's';
                return;
              }
              if (!document.getElementById('ttEndPosterStyles2')) {
                const st = document.createElement('style');
                st.id = 'ttEndPosterStyles2';
                st.textContent = [
                  '#ttEndPoster{position:fixed;inset:0;z-index:99990;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;overflow-y:auto;' +
                    'padding:calc(20px + env(safe-area-inset-top,0px)) 20px calc(20px + env(safe-area-inset-bottom,0px));text-align:center;' +
                    'background:radial-gradient(80% 60% at 50% 25%,rgba(43,49,96,.96),rgba(11,15,31,.98));opacity:0;transition:opacity .7s ease}',
                  '#ttEndPoster.on{opacity:1}',
                  '.ttep-x{position:absolute;top:calc(12px + env(safe-area-inset-top,0px));right:12px;width:40px;height:40px;border:none;border-radius:50%;background:rgba(255,255,255,.14);color:#fff;font-size:22px;line-height:1;cursor:pointer}',
                  '.ttep-poster{position:relative;flex-shrink:0;display:block;width:min(78vw,calc(min(54vh,540px) * .6667));aspect-ratio:2/3;padding:0;border:5px solid #fff;border-radius:10px;overflow:hidden;background:#0b1020;cursor:pointer;-webkit-tap-highlight-color:transparent;' +
                    'box-shadow:0 0 0 2px #f6d27a,0 30px 70px rgba(0,0,0,.6),0 0 90px rgba(246,210,122,.35);transform:scale(.88) rotate(-2deg);transition:transform 1.1s cubic-bezier(.2,1.3,.4,1)}',
                  '#ttEndPoster.on .ttep-poster{transform:none}',
                  '.ttep-poster img{display:block;width:100%;height:100%;object-fit:cover}',
                  '.ttep-shine{position:absolute;top:0;bottom:0;left:-70%;width:50%;background:linear-gradient(105deg,transparent,rgba(255,255,255,.7),transparent);transform:skewX(-18deg);pointer-events:none}',
                  '#ttEndPoster .ttep-poster.tap{animation:ttepTap .6s ease}',
                  '.ttep-poster.tap .ttep-shine{animation:ttepShine .8s ease}',
                  '@keyframes ttepTap{0%{transform:none}30%{transform:scale(1.04) rotate(-1.5deg)}60%{transform:scale(.99) rotate(1deg)}100%{transform:none}}',
                  '@keyframes ttepShine{to{left:130%}}',
                  '#ttEndPoster h3{margin:6px 0 0;font-family:Fraunces,Georgia,serif;font-style:italic;font-weight:600;font-size:clamp(24px,6vw,32px);line-height:1.15;color:#fff}',
                  '.ttep-p{margin:0;min-height:44px;max-width:340px;font-family:Nunito,sans-serif;font-size:15px;font-weight:700;line-height:1.45;color:rgba(255,255,255,.82)}',
                  '.ttep-p.in{animation:ttepIn .45s ease}',
                  '@keyframes ttepIn{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:none}}',
                  '.ttep-go{flex-shrink:0;width:min(86vw,360px);min-height:56px;margin-top:2px;border-radius:14px;font-family:Nunito,sans-serif;font-size:17px;font-weight:900;cursor:pointer}',
                  '.ttep-cd{font-family:Nunito,sans-serif;font-size:12.5px;font-weight:800;color:rgba(255,255,255,.55)}',
                  '@media (prefers-reduced-motion:reduce){#ttEndPoster,.ttep-poster{transition:opacity .3s}.ttep-poster{transform:none}#ttEndPoster .ttep-poster.tap,.ttep-poster.tap .ttep-shine{animation:none}}',
                ].join('');
                document.head.appendChild(st);
              }
              const nmE = titleCaseName(capturedChildName) || (es ? 'su estrella' : 'their star');
              const possE = /s$/i.test(nmE) ? nmE + "'" : nmE + "'s";
              const meE = window.ttSelfPick && window.ttSelfPick.label ? window.ttSelfPick.label : '';
              const lines = es
                ? [
                    'Protagonizada por ' + nmE + (meE ? ' y ' + meE : '') + '. Cada escena hecha para la canción de ' + nmE + '.',
                    '¡Sí, es ' + nmE + ' en el póster! 🎉',
                    'Viene con su película y su boleto de estreno.',
                    'Toca el botón dorado para hacer la película de ' + nmE + '.',
                  ]
                : [
                    'Starring ' + nmE + (meE ? ' & ' + meE : '') + '. Every scene made to match ' + possE + ' song.',
                    "Yes, that's " + nmE + ' on the poster! 🎉',
                    'It comes with ' + possE + ' movie and premiere ticket.',
                    'Tap the gold button to make ' + possE + ' movie.',
                  ];
              ep = document.createElement('div');
              ep.id = 'ttEndPoster';
              ep.innerHTML =
                '<button type="button" class="ttep-x" aria-label="Close">×</button>' +
                '<button type="button" class="ttep-poster"><img alt=""><i class="ttep-shine"></i></button>' +
                '<h3></h3><p class="ttep-p"></p>' +
                '<button type="button" class="ttns-go ttep-go"></button>' +
                '<small class="ttep-cd"></small>';
              ep.querySelector('.ttep-poster img').src = pUrl;
              ep.querySelector('.ttep-poster').setAttribute('aria-label', es ? 'Póster de ' + nmE : possE + ' movie poster');
              ep.querySelector('h3').textContent = es ? 'El póster de la película de ' + nmE : possE + ' movie poster';
              const pEl = ep.querySelector('.ttep-p');
              pEl.textContent = lines[0];
              ep.querySelector('.ttep-go').textContent = '🎬 ' + (es ? 'Obtener la película de ' + nmE : 'Get ' + possE + ' movie') + ' · ' + (regionPrice('video') || '$24.99');
              document.body.appendChild(ep);
              requestAnimationFrame(() => ep.classList.add('on'));
              ttTrack('pv_end_poster');
              ttTrack('pv_offer_shown');

              // Tap the poster: it bounces and shines, and the caption moves to the next line
              let li = 0;
              const posterBtn = ep.querySelector('.ttep-poster');
              posterBtn.addEventListener('click', () => {
                ttTrack('pv_end_poster_tap');
                posterBtn.classList.remove('tap');
                void posterBtn.offsetWidth;
                posterBtn.classList.add('tap');
                li = Math.min(li + 1, lines.length - 1);
                pEl.classList.remove('in');
                void pEl.offsetWidth;
                pEl.textContent = lines[li];
                pEl.classList.add('in');
              });
              const closeEP = () => {
                window.ttEndPosterClosed = true;
                ep.classList.remove('on');
                ep.id = '';
                setTimeout(() => ep.remove(), 700);
              };
              ep.querySelector('.ttep-x').addEventListener('click', () => { ttTrack('pv_end_poster_close'); closeEP(); });
              ep.querySelector('.ttep-go').addEventListener('click', () => {
                ttTrack('pv_end_poster_buy');
                ttTrack('pv_click_movie');
                closeEP();
                if (window.ttPosterReady) window.ttPoster1 = window.ttPosterReady; // so "Your order" shows their poster
                if (window.ttDrawerTest) ttShowOrderDrawer();
                else goToVideoCheckout({ fromSheet: true });
              });
            } else if (ep && t < lim - 10) {
              // Song finished (it resets to 0) → fade out into the post-preview video
              ep.classList.remove('on');
              ep.id = '';
              setTimeout(() => ep.remove(), 700);
            }
          });
                            // ── Karaoke lyrics: the current line lights up word by word ──
          (function () {
            const box = document.getElementById('ttLy');
            const cur = document.getElementById('ttLyLine');
            const nxt = document.getElementById('ttLyNext');
            if (!box || !cur) return;
            let lines = [];
               let staticMode = false;
            const LY_OFFSET = 0;    // lyrics feel early → raise to 0.2–0.4 · feel late → lower to -0.2 to -0.4
             const LY_LEAD = 0.25;   // show each line just before it's sung
            function ttStaticLyrics() {
              const src = String(realLyrics || '').split('\n').map((l) => l.trim()).filter((l) => l && !/^\[.*\]$/.test(l));
              if (!src.length) return;
              staticMode = true;
              cur.innerHTML = src.slice(0, 12).map((l) => '<div>' + escL(l) + '</div>').join('');
              cur.style.cssText = 'font-size:18px;line-height:1.6;color:#182b49;max-height:200px;overflow-y:auto;';
              if (nxt) nxt.textContent = '';
              box.style.pointerEvents = 'auto';
              box.style.display = '';
            }
            fetch(WORKER_BASE + '/preview-lyrics?code=' + encodeURIComponent(capturedCode), { cache: 'no-store' })
              .then((r) => r.json())
              .then((d) => {
                if (!d || !d.ok || !Array.isArray(d.words) || !d.words.length) { ttStaticLyrics(); return; }
                let line = [];
                const byLine = d.words.every((w) => typeof w.l === 'number');
                d.words.forEach((w) => {
                  const prev = line[line.length - 1];
                  const gap = line.length ? w.s - prev.e : 0;
                  const breakHere = byLine
                    ? line.length && (w.l !== prev.l || gap > 2 || (line.length >= 12 && gap > 0.5)) // real lyric lines
                    : line.length && (gap > 0.7 || line.length >= 7);                                // fallback: by pauses
                  if (breakHere) { lines.push(line); line = []; }
                  line.push(w);
                });
                if (line.length) lines.push(line);
              })
              .catch(() => ttStaticLyrics());
            const nameLow = String(capturedChildName || '').toLowerCase().replace(/[^a-z]/g, '');
            const escL = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;');
            let lyKey = '';
            function paint() {
                  if (!lines.length) { if (!staticMode) box.style.display = 'none'; return; }
               const t = (capturedAudio.currentTime || 0) - LY_OFFSET;
              let idx = lines.findIndex((l, k) => {
                const next = lines[k + 1];
                const until = next ? next[0].s - LY_LEAD : l[l.length - 1].e + 1;
                return t >= l[0].s - LY_LEAD && t < Math.max(until, l[l.length - 1].e + 0.2);
              });
              if (idx === -1) {
                idx = lines.findIndex((l) => l[0].s > t);
                if (idx > -1 && lines[idx][0].s - t > 2.5) idx = -1;
              }
                 if (idx === -1) idx = t < lines[0][0].s ? 0 : lines.length - 1; // before the first line / after the last
              // Only redraw when the line or the lit word changes (was redrawing every frame)
              const lit = lines[idx].filter((w) => t >= w.s).length;
              const key = idx + ':' + lit;
              if (key === lyKey) return;
              lyKey = key;
              box.style.display = '';
              const plain = (l) => escL(l.map((w) => w.w).join(' '));
              cur.innerHTML =
                (lines[idx - 1] ? '<div class="tt-ly-row past">' + plain(lines[idx - 1]) + '</div>' : '<div class="tt-ly-row past">&nbsp;</div>') +
                '<div class="tt-ly-row now">' + lines[idx].map((w) => {
                     const isName = nameLow && w.w.toLowerCase().replace(/['’]s\b/, '').replace(/[^a-z]/g, '') === nameLow;
                  return '<span class="' + (t >= w.s ? 'on' : '') + (isName ? ' nm' : '') + '">' + escL(w.w) + '</span>';
                }).join(' ') + '</div>' +
                (lines[idx + 1] ? '<div class="tt-ly-row next">' + plain(lines[idx + 1]) + '</div>' : '<div class="tt-ly-row next">&nbsp;</div>');
              if (nxt) nxt.textContent = '';
            }
            capturedAudio.addEventListener('timeupdate', paint);
            (function loop() { if (!capturedAudio.paused) paint(); requestAnimationFrame(loop); })();
          })();

          // Facebook's in-app browser grabs the sound back when our audio stalls — resume unless the user paused
          let ttUserPausedSong = false;
          const ttResumeIfStolen = (media, shouldResume) => {
            if (!media) return;
            media.addEventListener('pause', () => {
              setTimeout(() => {
                if (!media.paused || !shouldResume()) return;
                const p = media.play();
                if (p && p.catch) p.catch(() => window.ttShowResumeTap(media));
              }, 350);
            });
          };
          const ttSongShouldPlay = () => {
            const lim = PREVIEW_LIMIT > 0 ? PREVIEW_LIMIT : capturedAudio.duration || 60;
            const t = capturedAudio.currentTime || 0;
            return !ttUserPausedSong && !window.ttRevealActive && t > 0.2 && t < lim - 0.6 &&
              !document.documentElement.classList.contains('tt-building'); // the builder pauses it on purpose
          };
          ttResumeIfStolen(capturedAudio, ttSongShouldPlay);
          // Watchdog: also catches pauses that happened while the page was hidden (photo picker, app switch)
          const ttSongWatch = () => {
            if (document.hidden || !capturedAudio.paused || !ttSongShouldPlay()) return;
            ttTrack('pv_media_stolen');
            const p = capturedAudio.play();
            if (p && p.catch) p.catch(() => window.ttShowResumeTap(capturedAudio));
          };
          setInterval(ttSongWatch, 1000);
          document.addEventListener('visibilitychange', () => { if (!document.hidden) setTimeout(ttSongWatch, 300); });
          if (revealVideo) ttResumeIfStolen(revealVideo, () => !!window.ttRevealActive && !revealVideo.ended);
          ttResumeIfStolen(upsellAudio, () => !!window.ttRevealActive && !upsellAudio.ended);
          // Retry active reveal media after returning from Facebook/app switching; keep the reveal video muted.
          const ttRevealWatch = () => {
            if (document.hidden || !window.ttRevealActive) return;
            [revealVideo, upsellAudio].forEach((media) => {
              if (!media || media.ended || !media.paused) return;
              const p = media.play();
              if (p && p.catch) p.catch(() => window.ttShowResumeTap(media));
            });
          };
          setInterval(ttRevealWatch, 1200);
          document.addEventListener('visibilitychange', () => {
            if (!document.hidden) setTimeout(ttRevealWatch, 300);
          });
          capturedAudio.addEventListener('play', updatePlayerUI);
          capturedAudio.addEventListener('pause', updatePlayerUI);

                    // ── Their opening: scenes 1 → 2 → 3 with no gaps, then the last scene blurs into "the rest is locked" ──
          (function () {
            const box = document.getElementById('ttOpening');
            const lockEl = document.getElementById('ttOpLock');
            if (!box || !stageHero) return;
            const vids = Array.from(box.querySelectorAll('video'));
            // Behind the lock: the theme's no-character video, full frame
            const lockBg = document.getElementById('ttLockBg');
            const lockSrc = (themedHeroSet && themedHeroSet.noCharacter) || DEFAULT_BLUR_URL;
            let state = 'idle'; // idle → playing → locked
            let loaded = false;
            let cur = -1;
            const coverEl = () => document.querySelector('#ttSO, #ttSS, #ttOD, #ttEndPoster, #ttPremiere');
            // Load all 3 the moment they exist, so each one is ready before its turn
            const load = () => {
              const clips = window.ttOpeningClips;
              if (loaded || !clips) return;
              loaded = true;
              vids.forEach((v, i) => { v.muted = true; v.playsInline = true; v.src = clips[i]; try { v.load(); } catch (e) {} });
            };
            const show = (i) => vids.forEach((v, k) => v.classList.toggle('on', k === i));
            const lock = () => {
              if (state === 'locked') return;
              state = 'locked';
              stageHero.classList.remove('tt-op-on');
              stageHero.classList.add('tt-op-locked'); // last scene blurs while "the rest is locked" fades in
              ttTrack('pv_opening_locked');
              if (lockBg) { if (!lockBg.getAttribute('src')) lockBg.src = lockSrc; lockBg.play().catch(() => {}); }
            };
            const abort = (e) => {
              if (state !== 'playing') return;
              console.log('[TT opening] clip failed:', (e && (e.message || e.type)) || e);
              state = 'idle';
              stageHero.classList.remove('tt-op-on', 'tt-op-locked');
              vids.forEach((v) => { v.classList.remove('on'); try { v.pause(); } catch (x) {} });
            };
            const playAt = (i) => {
              const v = vids[i];
              cur = i;
              try { v.currentTime = 0; } catch (e) {}
              v.addEventListener('playing', () => show(i), { once: true }); // switch only once its picture is really there (no black)
              v.play().catch(abort);
            };
            vids.forEach((v, i) => {
              v.addEventListener('error', abort);
              v.addEventListener('timeupdate', () => {
                if (state !== 'playing' || i !== cur || !v.duration) return;
                const left = v.duration - v.currentTime;
                if (i < vids.length - 1 && left < 0.25) playAt(i + 1);       // start the next one a beat early
                else if (i === vids.length - 1 && left < 1.4) lock();        // fade into "locked" over the last moment
              });
              v.addEventListener('ended', () => { if (state === 'playing' && cur === i && i < vids.length - 1) playAt(i + 1); });
            });
            const start = () => {
              const clips = window.ttOpeningClips;
              const cov = coverEl();
              const why = state === 'playing' ? 'already playing'
                : !clips ? 'no clips on page yet'
                : cov ? 'player covered by ' + cov.id
                : capturedAudio.paused ? 'song paused' : '';
              if (why) {
                if (window.ttOpLogged !== why) { window.ttOpLogged = why; console.log('[TT opening] not starting:', why); }
                return;
              }
              console.log('[TT opening] starting');
              load();
              state = 'playing';
              stageHero.classList.remove('tt-op-locked');
              stageHero.classList.add('tt-op-on');
              ttTrack('pv_opening_shown');
              playAt(0);
              if (lockBg && !lockBg.getAttribute('src')) { lockBg.src = lockSrc; lockBg.preload = 'auto'; try { lockBg.load(); } catch (e) {} } // ready by the lock
            };
            capturedAudio.addEventListener('play', () => {
              if (state === 'playing') { if (vids[cur]) vids[cur].play().catch(() => {}); return; }
              // Song starting over (and nothing covering the player) → their opening again
              if ((capturedAudio.currentTime || 0) < 1.5 && state === 'locked' && !coverEl()) {
                state = 'idle';
                stageHero.classList.remove('tt-op-locked');
                if (lockBg) { try { lockBg.pause(); } catch (e) {} }
              }
              setTimeout(start, 50);
            });
            capturedAudio.addEventListener('pause', () => { if (state === 'playing' && vids[cur]) vids[cur].pause(); });
            // Tap the lock → the offer
            if (lockEl) lockEl.addEventListener('click', () => { ttTrack('pv_lock_tap'); ttShowSimpleOffer(); });
            // Clips arrive: load them right away; arrived mid-song → play them as soon as the player is on screen
            const arrival = setInterval(() => {
              if (state === 'locked') { clearInterval(arrival); return; }
              if (window.ttOpeningClips) { load(); if (state === 'idle') start(); }
            }, 1000);
          })();

          if (audioPlayBtn) {
            audioPlayBtn.addEventListener('click', () => {
              if (capturedAudio.paused) { ttUserPausedSong = false; capturedAudio.play().catch(() => {}); }
              else { ttUserPausedSong = true; capturedAudio.pause(); }
            });
          }

          if (progressBar) {
            progressBar.addEventListener('click', (e) => {
              const limit = PREVIEW_LIMIT > 0 ? PREVIEW_LIMIT : capturedAudio.duration || 0;
              if (!limit) return;
              const r = progressBar.getBoundingClientRect();
              const pct = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
              capturedAudio.currentTime = pct * limit;
              updatePlayerUI();
            });
          }

          if (giftReveal) {
            giftReveal.addEventListener('click', () => {
              capturedAudio.play().catch(() => {});
              // Pick the right voiceover now, then unlock it with this tap so phones let it play later
              const castPrime = null;
              const EXTRAS_PRIME = 'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/POST_PREVIEW_-_EXTRAS_AUDIO.mp3?v=1791411709';
              if (castPrime && upsellAudio.src !== EXTRAS_PRIME) upsellAudio.src = EXTRAS_PRIME;
                  // Unlock it silently: start + stop in the same tap, never waiting on the phone
              upsellAudio.muted = true;
              const primeP = upsellAudio.play();
              if (primeP && primeP.catch) primeP.catch(() => {});
              upsellAudio.pause();
              upsellAudio.currentTime = 0;
              setTimeout(() => {
                if (!window.ttRevealActive) { upsellAudio.pause(); upsellAudio.currentTime = 0; }
                upsellAudio.muted = false;
              }, 300);
                     giftReveal.style.display = 'none';
              if (videoWrap) videoWrap.style.display = 'block';
              if (blurBg) blurBg.play().catch(() => {});
              playCount++;

              const heroCharSlotEl = document.getElementById('ttHeroCharSlot');
              if (heroCharSlotEl) {
                setTimeout(() => heroCharSlotEl.classList.add('show'), 500);
              }

                    });
          }

          // Song ready → start it right away. Phones that block autoplay get one big play button.
          const nmT = titleCaseName(capturedChildName);
          const possT = nmT ? (nmT.endsWith('s') ? nmT + "'" : nmT + "'s") : 'their';
                function ttShowTapToPlay() {
            if (!stageHero || stageHero.querySelector('.tt-tap-play')) return;
            const esT = ttLang === 'es';
            const lim = typeof PREVIEW_LIMIT === 'number' ? PREVIEW_LIMIT : 60;
            const limTxt = Math.floor(lim / 60) + ':' + String(lim % 60).padStart(2, '0');
            if (!document.getElementById('ttTapPlayStyles')) {
              const st = document.createElement('style');
              st.id = 'ttTapPlayStyles';
              st.textContent =
                '.tt-tap-play{position:absolute;inset:0;z-index:9;display:flex;align-items:center;justify-content:center;gap:clamp(14px,4.5vw,32px);padding:clamp(12px,4vw,30px);border:none;cursor:pointer;text-align:left;color:#fff;font-family:Nunito,sans-serif;overflow:hidden;background:#0c1130;-webkit-tap-highlight-color:transparent;transition:opacity .25s ease,transform .25s ease}' +
                '.tt-tap-play.is-go{opacity:0;transform:scale(1.03)}' +
                '*:has(> .tt-tap-play){aspect-ratio:16/9 !important;height:auto !important;min-height:0 !important}' +
                '.ttpl-glow{position:absolute;display:block!important;width:75%;aspect-ratio:1;left:-15%;top:-45%;border-radius:50%;background:radial-gradient(circle,rgba(246,210,122,.30),transparent 65%);animation:ttplDrift 9s ease-in-out infinite alternate;pointer-events:none}' +
                '.ttpl-glow.g2{left:auto;top:auto;right:-25%;bottom:-55%;background:radial-gradient(circle,rgba(110,140,255,.26),transparent 65%);animation-duration:12s}' +
                '.ttpl-art{position:relative;z-index:1;flex:0 0 auto;display:block!important;width:clamp(112px,36%,210px);aspect-ratio:1}' +
                '.ttpl-disc{position:absolute;inset:0;display:block!important;border-radius:50%;background:radial-gradient(circle,#232842 0 17%,transparent 17.5%),repeating-radial-gradient(circle,#0f1326 0 2px,#191d33 2px 4px);box-shadow:0 20px 44px rgba(0,0,0,.55),inset 0 0 0 2px rgba(255,255,255,.06);animation:ttplSpin 9s linear infinite}' +
                '.ttpl-disc::after{content:"";position:absolute;inset:0;border-radius:50%;background:conic-gradient(from 30deg,transparent 0 18%,rgba(255,255,255,.13) 24%,transparent 32% 66%,rgba(255,255,255,.08) 73%,transparent 81%)}' +
                '.ttpl-play{position:absolute;left:50%;top:50%;width:48%;aspect-ratio:1;transform:translate(-50%,-50%);display:flex!important;align-items:center;justify-content:center;border-radius:50%;background:linear-gradient(135deg,#ffeab0,#f6d27a 45%,#e7a636);box-shadow:0 10px 28px rgba(231,166,54,.6),inset 0 2px 0 rgba(255,255,255,.7);transition:transform .15s ease}' +
                '.ttpl-play::before{content:"";position:absolute;inset:-5px;border-radius:50%;border:2px solid rgba(246,210,122,.75);animation:ttplRing 1.8s ease-out infinite}' +
                '.ttpl-play svg{width:42%;height:42%;fill:#151a33;margin-left:9%}' +
                '.tt-tap-play:active .ttpl-play{transform:translate(-50%,-50%) scale(.93)}' +
                '.ttpl-info{position:relative;z-index:1;flex:1;min-width:0;max-width:320px}' +
                '.ttpl-k{display:flex!important;align-items:center;gap:7px;font-size:10.5px;font-weight:900;letter-spacing:.16em;text-transform:uppercase;color:#f6d27a}' +
                '.ttpl-eq{display:inline-flex!important;align-items:flex-end;gap:2px;height:11px}' +
                '.ttpl-eq i{display:block!important;width:3px;height:100%;border-radius:2px;background:#f6d27a;transform-origin:bottom;animation:ttplEq 1s ease-in-out infinite}' +
                '.ttpl-eq i:nth-child(2){animation-delay:.2s}.ttpl-eq i:nth-child(3){animation-delay:.4s}' +
                '.ttpl-t{display:block;margin-top:6px;font-family:Fraunces,Georgia,serif;font-style:italic;font-weight:600;font-size:clamp(21px,5.8vw,34px);line-height:1.06;letter-spacing:-.01em;color:#fff;overflow-wrap:anywhere}' +
                '.ttpl-s{display:block;margin-top:4px;font-size:clamp(11.5px,3vw,13.5px);font-weight:700;color:rgba(255,255,255,.62)}' +
                '.ttpl-bar{position:relative;display:block!important;height:4px;margin-top:clamp(10px,3vw,18px);border-radius:4px;background:rgba(255,255,255,.16)}' +
                '.ttpl-bar i{position:absolute;left:0;top:50%;display:block!important;width:12px;height:12px;margin-top:-6px;border-radius:50%;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,.4)}' +
                '.ttpl-time{display:flex!important;justify-content:space-between;margin-top:6px;font-size:11px;font-weight:800;color:rgba(255,255,255,.5);font-variant-numeric:tabular-nums}' +
                '@keyframes ttplSpin{to{transform:rotate(360deg)}}' +
                '@keyframes ttplRing{0%{transform:scale(1);opacity:.9}100%{transform:scale(1.45);opacity:0}}' +
                '@keyframes ttplEq{0%,100%{transform:scaleY(.3)}50%{transform:scaleY(1)}}' +
                '@keyframes ttplDrift{to{transform:translate(12%,10%) scale(1.1)}}' +
                '@media (prefers-reduced-motion:reduce){.ttpl-disc,.ttpl-play::before,.ttpl-eq i,.ttpl-glow{animation:none}}';
              document.head.appendChild(st);
            }
            const title = esT ? 'La canción de ' + (nmT || 'su estrella') : (nmT ? possT : 'Their') + ' Song';
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'tt-tap-play';
            b.setAttribute('aria-label', esT ? 'Reproducir la canción' : 'Play the song');
            b.innerHTML =
              '<span class="ttpl-glow"></span><span class="ttpl-glow g2"></span>' +
              '<span class="ttpl-art"><span class="ttpl-disc"></span>' +
              '<span class="ttpl-play"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg></span></span>' +
              '<span class="ttpl-info">' +
              '<span class="ttpl-k"><span class="ttpl-eq"><i></i><i></i><i></i></span>' + (esT ? 'Lista para escuchar' : 'Ready to play') + '</span>' +
              '<span class="ttpl-t">' + title + '</span>' +
              '<span class="ttpl-s">' + (esT ? 'Un original de TinyTunes<br>Avance de ' + limTxt : 'A TinyTunes original<br>' + limTxt + ' preview') + '</span>' +
              '<span class="ttpl-bar"><i></i></span>' +
              '<span class="ttpl-time"><span>0:00</span><span>' + limTxt + '</span></span>' +
              '</span>';
            b.addEventListener('click', () => {
              b.classList.add('is-go');
              setTimeout(() => b.remove(), 250);
              setTimeout(() => { if (window.ttFrameStage) window.ttFrameStage(); }, 320); // after it switches back to the poster
              ttUserPausedSong = false;
              if (giftReveal) giftReveal.click();
              else capturedAudio.play().catch(() => {});
            });
            stageHero.appendChild(b);
          }
     capturedAudio.addEventListener('play', () => {
            const tp = stageHero && stageHero.querySelector('.tt-tap-play');
            if (tp) tp.remove();
            try { localStorage.setItem('tt_heard_' + capturedCode, '1'); } catch (e) {} // remember they've heard it
          });
     const TT_AUTOPLAY_SONG = true; // Start the song and run the poster-to-player transition (first visit only)
          window.ttStartSongNow = () => {
            let heardBefore = false;
            try { heardBefore = localStorage.getItem('tt_heard_' + capturedCode) === '1'; } catch (e) {}
            if (TT_AUTOPLAY_SONG && !heardBefore) {
              if (giftReveal && giftReveal.style.display !== 'none') giftReveal.click();
              setTimeout(() => {
                if (!capturedAudio.paused || ttUserPausedSong) return;
                capturedAudio.play().catch(() => ttShowTapToPlay());
              }, 600);
              return;
            }
            // Show the player with the first lyrics, and one big play button
            if (giftReveal) giftReveal.style.display = 'none';
            if (videoWrap) videoWrap.style.display = 'block';
            ttShowTapToPlay();
          };
        }

        function bindAudioHandlersOnce() {
          if (audioHandlersBound || !elAudio) return;
          let previewFinishedThisPlay = false;

          function getLimit() {
            return PREVIEW_LIMIT > 0 ? PREVIEW_LIMIT : elAudio.duration || 0;
          }
          function resetFade() {
            elAudio.volume = 1;
            faded = false;
          }
          function applyFadeIfNeeded() {
            const limit = getLimit();
            if (!limit) return;
            const t = elAudio.currentTime || 0;
            const remaining = limit - t;
            if (remaining <= FADE_LAST && remaining > 0) {
              elAudio.volume = Math.max(0, Math.min(1, remaining / FADE_LAST));
              faded = true;
            } else if (faded) resetFade();
          }
            function stopAtLimit() {
            if (!previewFinishedThisPlay) {
              previewFinishedThisPlay = true;
              window.ttSongDone = true;
              if (window.ttPosterReady) window.ttPoster1 = window.ttPosterReady; // now the poster can be used everywhere
              ttTrack('pv_song_end');
              // Start the voiceover BEFORE stopping the song so the audio never goes silent
              // (in the Facebook app, a silent gap lets the ad's own audio take over)
                // Straight to the offer (set window.TT_SKIP_REVEAL = false to bring the reveal video back)
              if (window.TT_SKIP_REVEAL === false && typeof playRevealSequence === 'function') playRevealSequence();
              else ttShowSalesSheet();
            }
            elAudio.pause();
            elAudio.currentTime = 0;
            resetFade();
          }

                 elAudio.addEventListener('ended', () => {
            stopAtLimit();
          });
          elAudio.addEventListener('timeupdate', () => {
            // Safety: the voiceover must never play over the song
            if (!window.ttRevealActive && !upsellAudio.paused) { upsellAudio.pause(); upsellAudio.currentTime = 0; }
            const limit = getLimit();
            if (!limit) return;
            applyFadeIfNeeded();
            if (elAudio.currentTime >= limit) {
              stopAtLimit();
            }
          });
          elAudio.addEventListener('seeking', () => {
            const limit = getLimit();
            if (!limit) return;
            if (elAudio.currentTime > limit) elAudio.currentTime = limit;
            else resetFade();
          });
          elAudio.addEventListener('loadedmetadata', () => {
            resetFade();
            setCTAName();
            if (elAudio.currentTime > PREVIEW_LIMIT) elAudio.currentTime = 0;
          });
          elAudio.addEventListener('play', () => {
  ttTrack('pv_song_play');
  ttShowNextStepsBar(); // June mode: buy buttons visible while the song plays
  if (!window.ttRevealActive && !upsellAudio.paused) { upsellAudio.pause(); upsellAudio.currentTime = 0; }
  if (window.TT_SKIP_REVEAL === false) setTimeout(() => { if (typeof window.ttPreloadReveal === 'function') window.ttPreloadReveal(); }, 8000);
  const limit = getLimit();
  if (limit && elAudio.currentTime >= limit) elAudio.currentTime = 0;
  resetFade();
  const nice = titleCaseName(childName);
  const possessive = nice ? (nice.endsWith('s') ? nice + "'" : nice + "'s") : 'their';
  if (elTitle) {
    elTitle.textContent = ttLang === 'es'
      ? (possessive === 'their' ? '🎧 Esta es su vista previa' : '🎧 La vista previa de ' + possessive.replace(/'s?$/, ''))
      : `🎧 This is ${possessive} preview`;
  }
  if (elSub) elSub.textContent = ''; // the lyrics card already says "60-second preview"
});
          audioHandlersBound = true;
        }

        const stageMeta = {
          generating_lyrics: { pct: 18, cute: 'Personalizing lyrics just for your kiddo… ✍️' },
          lyrics_generating: { pct: 22, cute: 'Picking the cutest rhymes… 🧸' },
          lyrics_ready: { pct: 30, cute: 'Sending lyrics to the music studio… 🎼' },
          composing_music: { pct: 45, cute: 'Creating the perfect track… 🎶' },
          producing_audio: { pct: 62, cute: 'Mixing voices + instruments… 🎧' },
          retrying_kie: { pct: 55, cute: 'Studio line is busy — trying again soon… ☎️' },
          trimming_preview: { pct: 80, cute: 'Snipping your preview… ✂️' },
          uploading_preview: { pct: 88, cute: 'Polishing + packing it up… 🎁' },
          ready: { pct: 100, cute: 'Your preview is ready! ✅' },
          preview_error: { pct: 92, cute: 'Almost there — one more little fix… 🛠️' },
          audio_error: { pct: 60, cute: 'Something went wrong in the studio… 😕' },
          new: { pct: 10, cute: 'Warming up the TinyTunes studio… 🔥' },
        };

        let done = false;
        let pollTimer = null;
        let displayedPercent = 5;

        function setUIProgress(pct, cuteText) {
          const clamped = Math.max(5, Math.min(100, pct));
          const bar = document.getElementById('ttBar');
          if (bar) bar.style.setProperty('width', `${clamped}%`, 'important');
          if (elPercent) elPercent.textContent = Math.floor(clamped) + '%';
          if (cuteText && elCute) elCute.textContent = cuteText;
        }

        const CAP_REASSURANCE = [
          'Still working — almost there… 🎶',
          'Putting on the finishing touches… ✨',
          'Just a little longer… 🎧',
        ];
        let capMsgIndex = 0;
        let capMsgTimer = null;

        function startSmoothAnimator() {
          const tickMs = 140;
          const totalMs = 170000;
          const totalTicks = totalMs / tickMs;
          let tick = 0;
          setInterval(() => {
            if (done) return;
            updateEmailMessaging();
            tick++;
            const timeBasedPct = Math.min(99, (tick / totalTicks) * 100);
            displayedPercent = timeBasedPct;
            const bar = document.getElementById('ttBar');
            if (bar) bar.style.setProperty('width', `${timeBasedPct}%`, 'important');
            if (elPercent) elPercent.textContent = Math.floor(timeBasedPct) + '%';
            if (timeBasedPct >= 99 && !capMsgTimer) {
              capMsgTimer = setInterval(() => {
                if (done) return;
                capMsgIndex = (capMsgIndex + 1) % CAP_REASSURANCE.length;
                if (elCute) elCute.textContent = CAP_REASSURANCE[capMsgIndex];
              }, 4000);
            }
          }, tickMs);
        }

        function setProgress(stage, fallbackPct = 12) {
          currentStage = stage;
          const meta = stageMeta[stage] || { pct: fallbackPct, cute: 'Adding finishing sparkles… ✨' };
          if (elCute) elCute.textContent = meta.cute || 'Working on it… ✨';
          if (childName) startLyricPreview();
        }

        function showError(text) {
          if (!elErr) return;
          if (elExpired) elExpired.style.display = 'none';
          elErr.style.display = 'block';
          elErr.textContent = text;
        }

        function hideError() {
          if (!elErr) return;
          elErr.style.display = 'none';
        }
        function stopPolling() {
          if (pollTimer) clearInterval(pollTimer);
          pollTimer = null;
        }

        function showAudio() {
          done = true;
          previewReady = true;
          updateFlowGuide();
          stopPolling();
          stopLyricPreview();
          if (!introFinished) {
            introFinished = true;
            introStarted = true;
            if (elIntroVideoWrap) elIntroVideoWrap.style.display = 'none';
          }
          if (elExpired) elExpired.style.display = 'none';
          const nice = titleCaseName(childName) || 'your little one';
          if (elSub) elSub.textContent = ttLang === 'es' ? 'Presiona play para escuchar los primeros 60 segundos.' : 'Press play to hear the first 60 seconds.';
          if (elHead) elHead.textContent = 'Almost there - We are adding the finishing touches...';
          if (elLoadingSub) elLoadingSub.textContent = '';
          if (elEmailReassure) elEmailReassure.style.display = 'none';
          if (elInboxTip) elInboxTip.style.display = 'none';
          displayedPercent = 100;
          setUIProgress(100, 'Almost there - We are adding the finishing touches...');
          if (elAudioBlock) elAudioBlock.style.display = 'none';
          if (elLoading) elLoading.style.display = 'none';
                 showPreviewVideo();
          if (elLyricsWrap) elLyricsWrap.style.display = 'none';
          const cbDone = document.getElementById('ttCharBuilder');
          if (cbDone && !window.ttBuildingForMovie) cbDone.style.display = 'none';
          // Song's ready → straight into the player with lyrics above it (no gift card, no full-lyrics card)
           // Song done → step 2, or step 3 once we know they already made their character
          const ttCharStep = () => (window.savedCharacterUrl || document.querySelector('.tt-poster-mode') ? 3 : 2);
          if (window.ttTrackerStep) {
            window.ttTrackerStep(ttCharStep());
            // The character can load a moment after the song: keep checking for 10 seconds
            let charTries = 0;
            const charWatch = setInterval(() => {
              if (ttCharStep() === 3) {
                clearInterval(charWatch);
                window.ttTrackerStep(3);
              } else if (++charTries > 20) {
                clearInterval(charWatch);
              }
            }, 500);
          }
          // If they're still in the dark card (approve / add yourself / family), start the song when it closes
          const ttStartSong = () => { if (typeof window.ttStartSongNow === 'function') window.ttStartSongNow(); };
          if (document.getElementById('ttPremiere')) {
            const waitCard = setInterval(() => {
              if (document.getElementById('ttPremiere')) return;
              clearInterval(waitCard);
              ttStartSong(); // the card's own close glides them back up to the player
            }, 500);
          } else {
            ttStartSong();
          }

          // Back to a preview they've already heard → buttons right away, no sitting through it again
          let heardBefore = hasEverPlayedBefore === true;
          try { if (localStorage.getItem('tt_heard_' + code) === '1') heardBefore = true; } catch (e) {}
          if (heardBefore) ttShowNextStepsBar();

          // Song's ready: bring them up to the logo + player, unless they're mid-way through making their character
          const shown = (id) => { const el = document.getElementById(id); return !!el && el.style.display === 'block'; };
          const busyBuilding =
            shown('ttCharbForm') ||
            shown('ttncReveal') ||
            !!document.getElementById('ttLikenessUpload') ||
            !!document.getElementById('ttCastNotice') ||
            !!document.getElementById('ttPremiere') ||
            (shown('ttCharbSaved') && !window.ttCharacterApproved);
          if (!busyBuilding) {
            const hdr = document.querySelector('.tt-preview-header');
            setTimeout(() => {
              try {
                window.scrollTo({ top: hdr ? Math.max(0, hdr.getBoundingClientRect().top + window.pageYOffset - 12) : 0, behavior: 'smooth' });
              } catch (e) {}
            }, 150);
          }
        }

        function showExpired() {
          window._ttExpired = true;
          done = true;
          stopPolling();
          stopLyricPreview();
          hideError();
          try {
            if (elIntroVideo) {
              elIntroVideo.pause();
              elIntroVideo.muted = true;
            }
          } catch (e) {}
          try {
            const a = document.getElementById('ttAudio');
            if (a) {
              a.pause();
              a.removeAttribute('src');
              a.load();
            }
          } catch (e) {}
          const mediaStage = document.getElementById('ttMediaStage');
          if (mediaStage) mediaStage.style.display = 'none';
          const charBuilder = document.getElementById('ttCharBuilder');
          if (charBuilder) charBuilder.style.display = 'none';
          if (elLoading) elLoading.style.display = 'none';
          if (elAudioBlock) elAudioBlock.style.display = 'none';
          if (elOfferStack) elOfferStack.style.display = 'none';
          const underCta = document.getElementById('ttUnderCta');
          if (underCta) underCta.style.display = 'none';
          const m = document.getElementById('ttModal');
          if (m) m.setAttribute('aria-hidden', 'true');
          const sc = document.getElementById('ttSongConfirm');
          if (sc) sc.classList.remove('tt-open');
          if (elTitle) elTitle.textContent = pt('expiredJsTitle') || '⏳ Your preview expired';
          if (elSub) elSub.textContent = pt('expiredJsSub') || 'Your preview expired after 48 hours.';
          if (elExpired) elExpired.style.display = 'block';
          displayedPercent = 100;
          setUIProgress(100, 'Preview expired ⏳');
        }

        async function poll() {
          if (!code) {
            showError('Missing preview code in the URL.');
            return;
          }
          try {
            const res = await fetch(`${WORKER_BASE}/status-by-code?code=${encodeURIComponent(code)}`, {
              cache: 'no-store',
            });
            const data = await res.json().catch(() => ({}));

            if (!res.ok || !data.ok) {
              showError(data.error || 'Could not load preview status.');
              return;
            }

            const f = data.fields || data.airtable_fields || data.record_fields || data.record || {};
                        const previewIsReady = data.preview_ready === true || f.preview_ready === true;
            if (f.email) window.ttRecordEmail = String(f.email).trim().toLowerCase();
            window.ttRecFields = f; // used for family names (detected in the song, or added on the form)
            const expired =
              String(data.status || '').toLowerCase() === 'expired' ||
              data.expired === true ||
              data.preview_expired === true ||
              (f && (String(f.status || '').toLowerCase() === 'expired' || f.expired === true));
            if (expired) {
              window.ttExpiredName = String(f.child_name || '').trim();
              showExpired();
              return;
            }

            hideError();
            revealContent();

                      if (!realLyrics) {
              const customerLyrics = data.lyrics || (data.fields && data.fields.lyrics) || (data.airtable_fields && data.airtable_fields.lyrics) || '';
              if (customerLyrics) realLyrics = String(customerLyrics).trim();
            }
            const maybeChild = data.child_name || f.child_name || f.child || '';
            if (f.expires_at && !window.ttExpiresAt) {
              const exp = new Date(f.expires_at).getTime();
              if (exp) window.ttExpiresAt = exp;
            }
                      const maybeOccasion = data.occasion || f.occasion || f.occasion_text || '';
            if (!occasion && maybeOccasion) occasion = String(maybeOccasion).trim().toLowerCase();
            const maybeGenre = data.genre || f.genre || f.genre_text || '';
            if (!genre && maybeGenre) genre = String(maybeGenre).trim().toLowerCase();
            const maybeCustomer = data.customer_name || f.customer_name || f.customer || '';
            const priorChild = childName;
            if (!childName && maybeChild) childName = String(maybeChild || '').trim();
            if (childName) window.ttChildName = titleCaseName(childName);
            if (!customerName && maybeCustomer) customerName = String(maybeCustomer || '').trim();

            if (!priorChild && childName) {
              setCTAName();
              startLyricPreview();
            } else {
              setCTAName();
            }

            // pick up a saved character across page reloads (in case builder isn't re-run)
            const demoClipUrlFromPoll = data.demo_clip_url || (f && f.demo_clip_url) || '';
            if (demoClipUrlFromPoll && !window.ttDemoClipUrl) {
              window.ttDemoClipUrl = demoClipUrlFromPoll;
              if (typeof window.ttApplyPersonalDemoClip === 'function')
                window.ttApplyPersonalDemoClip(demoClipUrlFromPoll);
              if (typeof window.ttWarmDemoClip === 'function') window.ttWarmDemoClip(demoClipUrlFromPoll);
            }

            if (hasEverPlayedBefore === null) {
              const playedAt = data.preview_played_at || f.preview_played_at || '';
              hasEverPlayedBefore = !!playedAt;
            }

            if (!window.ttOpeningClips) { const oc = ttParseOpening(f.opening_clips); if (oc) window.ttOpeningClips = oc; }
            const charImageUrl = f.video_character_image || f.custom_character_image_url || f.character_image_url || '';
            if (charImageUrl && !window.savedCharacterUrl) {
              window.savedCharacterUrl = charImageUrl;
              window.savedCharacterId = f.base_character || window.savedCharacterId || 'restored';
              updateVideoCta();
              applyCharacterToPlayer();
            }

            const isFamilyPass = data.unlock_purchased === true && !!data.fields && data.fields.family_pass_used === true;
            if (isFamilyPass) {
              const fpActive = document.getElementById('ttFamilyPassActive');
              const fpBanner = document.getElementById('ttFamilyPassBanner');
              const ctaGrid = document.getElementById('ttCtaGrid');
              const offerStack = document.getElementById('ttOfferStack');
              if (fpActive) fpActive.style.display = 'block';
              if (fpBanner) fpBanner.style.display = 'none';
              if (ctaGrid) ctaGrid.style.display = 'none';
              if (offerStack) offerStack.style.display = 'none';
              if (previewIsReady) {
                if (window._ttCharacterSaveBusy > 0) {
                  console.log('[TT] Delaying Family Pass redirect — character save in progress');
                  return;
                }
                setPreviewLocked(false);
                window.location.href =
                  ttRoot + 'pages/song-unlocked?code=' +
                  encodeURIComponent(code) +
                  (ttLang === 'es' ? '&lang=es' : '') +
                  (ttRegion !== 'us' ? '&region=' + ttRegion : '');
                return;
              }
              return;
            }

            if (data.unlock_purchased === true && previewIsReady) {
              if (window._ttCharacterSaveBusy > 0) {
                console.log('[TT] Delaying unlock redirect — character save in progress');
                return;
              }
              setPreviewLocked(false);
              window.location.href =
                ttRoot + 'pages/song-unlocked?code=' +
                encodeURIComponent(code) +
                (ttLang === 'es' ? '&lang=es' : '') +
                (ttRegion !== 'us' ? '&region=' + ttRegion : '');
              return;
            }

            const stage = String(
              data.progress_stage || (f && f.progress_stage) || data.status || (f && f.status) || 'new'
            ).toLowerCase();
            setProgress(stage);
            // Song's nearly done → build the timed lyrics now, so they're instant when it plays
            if (!window.ttLyWarm && ['trimming_preview', 'uploading_preview', 'ready'].indexOf(stage) !== -1) {
              window.ttLyWarm = true;
              fetch(WORKER_BASE + '/preview-lyrics?code=' + encodeURIComponent(code), { cache: 'no-store' }).catch(() => {});
            }
            if (previewIsReady) {
              previewReady = true;
              if (!introStarted) {
                introStarted = true;
                introFinished = true;
              }
                if (introFinished) showAudio();
              else cutIntroWhenReady(); // song's ready, cut to it once the intro has played 90s
              return;
            }
          } catch (e) {
            console.error(e);
            showError('Network error loading preview. Please refresh.');
          }
        }

        let _contentRevealed = false;
        function revealContent() {
                 if (_contentRevealed) return;
          _contentRevealed = true;
          // Character builder now opens from the "make their movie" step after the song, not during the wait
          const cb = document.getElementById('ttCharBuilder');
          if (cb && !window.ttBuildingForMovie) cb.style.display = 'none';
          // Keep purchase choices out of the way during creation; show them at the preview stage.
          if (elOfferStack) elOfferStack.style.display = 'none';
          const uc = document.getElementById('ttUnderCta');
          if (uc) uc.style.display = 'none';
        }
        (function gateContent() {
          // Builder stays hidden until they choose to make the movie
          const cb = document.getElementById('ttCharBuilder');
          if (cb) cb.style.display = 'none';
                   if (elOfferStack) elOfferStack.style.display = 'none';
          if (!document.getElementById('ttWaitNext')) {
            const es = ttLang === 'es';
            const nm = String(window.ttChildName || '').trim();
            const poss = nm ? (/s$/i.test(nm) ? nm + "'" : nm + "'s") : '';
            const S = es
              ? [
                  ['Creando la canción de ' + (nm || 'su estrella'), 'Normalmente en menos de un minuto', 'La canción de ' + (nm || 'su estrella') + ' está lista', 'Dale play arriba 🎧'],
                  ['¿Te encanta? Crea su personaje', 'Sube una foto o diséñalo', 'Su personaje está listo', 'Se ve increíble ✨'],
                  ['Crea su película', nm ? 'Protagonizada por ' + nm : 'Protagonizada por tu pequeño'],
                ]
              : [
                  ['Making ' + (poss || 'their') + ' song', 'Ready in 60 seconds', (poss || 'Their') + ' song is ready', 'Press play above 🎧'],
                  ['Love it? Make ' + (poss || 'their') + ' character', 'Upload a photo or design them', (poss || 'Their') + ' character is ready', 'Looking great ✨'],
                  ['Create ' + (poss || 'their') + ' movie', nm ? 'Starring ' + nm : 'Starring your little one'],
                ];
            const chk = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
            const nx = document.createElement('div');
            nx.id = 'ttWaitNext';
            nx.innerHTML = S.map((s, i) =>
              '<div class="ttk-row" data-s="' + (i + 1) + '"' + (s[2] ? ' data-dt="' + s[2] + '" data-ds="' + s[3] + '"' : '') + '>' +
              '<span class="ttk-dot"><span class="ttk-ring"></span><b>' + (i + 1) + '</b>' + chk + '</span>' +
              '<div class="ttk-t">' + s[0] + '</div><div class="ttk-s">' + s[1] + '</div>' +
              '<span class="ttk-bar"><i></i></span></div>'
            ).join('');
            const st = document.createElement('style');
            st.textContent =
              '#ttWaitNext{max-width:520px;margin:14px auto 0;padding:20px 20px 2px;border-radius:20px;background:#fff;border:1px solid rgba(21,26,51,.07);box-shadow:0 1px 2px rgba(21,26,51,.04),0 14px 34px -14px rgba(21,26,51,.18);font-family:Nunito,sans-serif}' +
              '.ttk-row{position:relative;min-height:36px;padding:0 0 22px 54px;opacity:0;transform:translateY(6px);animation:ttkIn .5s ease forwards}' +
              '.ttk-row:nth-child(2){animation-delay:.12s}.ttk-row:nth-child(3){animation-delay:.24s}' +
              '.ttk-row:not(:last-child)::before{content:"";position:absolute;left:17px;top:42px;bottom:6px;width:2px;border-radius:2px;background:#e8ebf2;transition:background .4s}' +
              '.ttk-row.is-done::before{background:#151a33}' +
              '.ttk-row.is-active:not(:last-child)::after{content:"";position:absolute;left:17px;top:42px;bottom:6px;width:2px;border-radius:2px;background:linear-gradient(180deg,transparent,#f0b429,transparent) no-repeat;background-size:100% 50%;animation:ttkFlow 1.4s linear infinite}' +
              '.ttk-dot{position:absolute;left:0;top:0;width:36px;height:36px;border-radius:50%;display:flex!important;align-items:center;justify-content:center;background:#f1f3f7;color:#a3abb9;font-size:14px;font-weight:900;transition:background .35s,color .35s}' +
              '.ttk-dot svg{display:none;width:17px;height:17px}' +
              '.ttk-ring{position:absolute;inset:-4px;border-radius:50%;border:2.5px solid rgba(240,180,41,.22);border-top-color:#f0b429;display:none;animation:ttkSpin .9s linear infinite}' +
              '.ttk-row.is-active .ttk-dot{background:#fff6dc;color:#151a33}' +
              '.ttk-row.is-active.is-loading .ttk-ring{display:block!important}' +
              '.ttk-row.is-active:not(.is-loading) .ttk-dot{background:#f6d27a;animation:ttkPulse 1.8s ease-in-out infinite}' +
              '.ttk-row.is-done .ttk-dot{background:#151a33;color:#f6d27a}' +
              '.ttk-row.is-done .ttk-dot b{display:none}.ttk-row.is-done .ttk-dot svg{display:block}' +
              '.ttk-t{padding-top:7px;font-size:16px;font-weight:900;line-height:1.25;color:#a3abb9;transition:color .3s}' +
              '.ttk-row.is-active .ttk-t,.ttk-row.is-done .ttk-t{color:#151a33}' +
              '.ttk-s{margin-top:2px;font-size:13px;font-weight:700;color:#b3bac6}' +
              '.ttk-row.is-active .ttk-s,.ttk-row.is-done .ttk-s{color:#5b6475}' +
              '.ttk-bar{position:relative;display:none;max-width:240px;height:4px;margin-top:10px;border-radius:4px;background:#f1f3f7;overflow:hidden}' +
              '.ttk-row.is-loading .ttk-bar{display:block!important}' +
              '.ttk-bar i{position:absolute;top:0;bottom:0;width:40%;display:block!important;border-radius:4px;background:linear-gradient(90deg,#f6d27a,#e7a636);animation:ttkSlide 1.3s ease-in-out infinite}' +
              '@keyframes ttkIn{to{opacity:1;transform:none}}' +
              '@keyframes ttkSpin{to{transform:rotate(360deg)}}' +
              '@keyframes ttkFlow{from{background-position:0 -100%}to{background-position:0 200%}}' +
              '@keyframes ttkSlide{from{left:-40%}to{left:100%}}' +
              '@keyframes ttkPulse{0%,100%{box-shadow:0 0 0 0 rgba(240,180,41,.45)}50%{box-shadow:0 0 0 7px rgba(240,180,41,0)}}' +
              '@media (prefers-reduced-motion:reduce){.ttk-ring,.ttk-bar i,.ttk-row::after,.ttk-dot{animation:none!important}}';
            document.head.appendChild(st);
              window.ttTrackerStep = function (n) {
              // Character made → the step tracker has done its job
              if (n >= 3 || window.savedCharacterUrl) { nx.remove(); return; }
              // Swap in the child's name once it has loaded
              const nm2 = String(window.ttChildName || '').trim();
              if (nm2 && !nx.dataset.named) {
                nx.dataset.named = '1';
                const p2 = /s$/i.test(nm2) ? nm2 + "'" : nm2 + "'s";
                const fix = (t) => es
                  ? t.replace(/su estrella/g, nm2).replace(/tu pequeño/g, nm2)
                  : t.replace(/\btheir\b/g, p2).replace(/\bTheir\b/g, p2).replace(/your little one/g, nm2);
                nx.querySelectorAll('.ttk-t,.ttk-s').forEach((el) => { el.textContent = fix(el.textContent); });
                nx.querySelectorAll('.ttk-row[data-dt]').forEach((r) => { r.dataset.dt = fix(r.dataset.dt); });
              }
              nx.querySelectorAll('.ttk-row').forEach((r) => {
                const s = +r.dataset.s;
                r.classList.toggle('is-done', s < n);
                r.classList.toggle('is-active', s === n);
                r.classList.toggle('is-loading', s === n && n === 1);
                if (s < n && r.dataset.dt) {
                  r.querySelector('.ttk-t').textContent = r.dataset.dt;
                  r.querySelector('.ttk-s').textContent = r.dataset.ds;
                }
              });
            };
            const stage = document.getElementById('ttMediaStage');
            if (stage) stage.after(nx);
            window.ttTrackerStep(1);
          }
          const uc = document.getElementById('ttUnderCta');
          if (uc) uc.style.display = 'none';
        })();

                // ── While the song is being made: what every movie comes with (coupon, ticket, poster, gift) ──
        // Shows once their character is made and approved (and the song is still being made)
        const ttPerksWait = setInterval(() => {
          if (introFinished || window._ttExpired) { clearInterval(ttPerksWait); return; }
          const charDone = !!window.savedCharacterUrl && !!window.ttCharacterApproved &&
            !document.getElementById('ttPremiere') && !window.ttMakingCast;
          if (!charDone) return;
          clearInterval(ttPerksWait);
          ttShowPerks();
        }, 1000);
        function ttShowPerks() {
          return; // June mode: no perks card
          const es = ttLang === 'es';
          const songNum = parseFloat(String(regionPrice('song') || '$9.99').replace(/[^0-9.]/g, '')) || 9.99;
          const showValue = ttRegion === 'us';
          const valueTxt = '$' + Math.round(songNum * 2); // 2 × $9.99 → $20
          const placeholder = es ? 'Su estrella' : 'Your star';
          // Decorative QR for the ticket picture
          const qrSvg = (() => {
            let a = 7;
            const rnd = () => { a = (a * 9301 + 49297) % 233280; return a / 233280; };
            const f = (x, y) => '<rect x="' + x + '" y="' + y + '" width="7" height="7" fill="#3a2400"/><rect x="' + (x + 1) + '" y="' + (y + 1) + '" width="5" height="5" fill="#fff8e1"/><rect x="' + (x + 2) + '" y="' + (y + 2) + '" width="3" height="3" fill="#3a2400"/>';
            const inF = (x, y) => (x < 8 && y < 8) || (x > 12 && y < 8) || (x < 8 && y > 12);
            let d = '';
            for (let y = 0; y < 21; y++) for (let x = 0; x < 21; x++) if (!inF(x, y) && rnd() > 0.5) d += '<rect x="' + x + '" y="' + y + '" width="1" height="1"/>';
            return '<svg viewBox="-1 -1 23 23" shape-rendering="crispEdges" aria-hidden="true"><rect x="-1" y="-1" width="23" height="23" fill="#fff8e1"/>' + f(0, 0) + f(14, 0) + f(0, 14) + '<g fill="#3a2400">' + d + '</g></svg>';
          })();

          if (!document.getElementById('ttPerksStyles')) {
            const st = document.createElement('style');
            st.id = 'ttPerksStyles';
            st.textContent = [
              '#ttPerks{max-width:520px;margin:14px auto 0;padding:20px 16px 18px;border-radius:22px;background:#fffaf0;border:1px solid rgba(240,180,41,.28);box-shadow:0 14px 34px -16px rgba(21,26,51,.18);font-family:Nunito,sans-serif;text-align:center;overflow:hidden}',
              '.ttpk-k{font-size:11px;font-weight:900;letter-spacing:.18em;text-transform:uppercase;color:#b7862a}',
              '.ttpk-h{margin:4px 0 18px;font-family:Fraunces,Georgia,serif;font-size:clamp(22px,5.8vw,26px);font-weight:600;line-height:1.15;color:#151a33}',
                  // The movie
              '.ttpk-mv{position:relative;margin:0 0 20px;padding:16px 14px 14px;border-radius:16px;background:radial-gradient(90% 70% at 50% 0%,#3a3f6b,#151a33 75%);color:#fff;text-align:center;box-shadow:0 16px 34px -14px rgba(21,26,51,.6);opacity:0;animation:ttpkIn .55s ease forwards}',
              '.ttpk-mv > small{display:block;font-size:10px;font-weight:900;letter-spacing:.22em;color:#f6d27a}',
              '.ttpk-mv > b{display:block;margin:5px 0 3px;font-family:Fraunces,Georgia,serif;font-size:clamp(29px,8vw,36px);font-weight:700;line-height:1}',
              '.ttpk-mv > p{margin:0 0 12px;font-size:13.5px;font-weight:700;color:rgba(255,255,255,.78)}',
              '.ttpk-strip{position:relative;margin:0 -4px 14px;padding:9px 0;border-radius:6px;background:#0b0f1f;overflow:hidden}',
              '.ttpk-strip::before,.ttpk-strip::after{content:"";position:absolute;left:0;right:0;height:4px;background:repeating-linear-gradient(90deg,rgba(255,255,255,.4) 0 6px,transparent 6px 12px)}',
              '.ttpk-strip::before{top:2px}.ttpk-strip::after{bottom:2px}',
              '.ttpk-track{display:flex;gap:6px;width:max-content;animation:ttpkRoll 16s linear infinite}',
              '.ttpk-fr{flex:0 0 66px;aspect-ratio:16/10;border-radius:3px;display:flex !important;align-items:center;justify-content:center;font-size:20px;background:linear-gradient(135deg,#2b3160,#56609e)}',
              '@keyframes ttpkRoll{to{transform:translateX(-50%)}}',
              '.ttpk-mv ul{list-style:none;margin:0;padding:0;display:inline-flex;flex-direction:column;gap:7px;text-align:left}',
              '.ttpk-mv li{display:flex;align-items:center;gap:9px;font-size:13.5px;font-weight:800;color:#fff}',
              '.ttpk-mv li i{flex-shrink:0;display:flex !important;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#f6d27a;color:#151a33;font-style:normal;font-size:11px;font-weight:900}',
              '@media (prefers-reduced-motion:reduce){.ttpk-track{animation:none}}',
              // Coupon
              '.ttpk-cp{position:relative;display:flex;align-items:stretch;margin:0 6px 20px;border-radius:14px;background:linear-gradient(135deg,#fff,#fff4d6);border:2px dashed #e0a93a;overflow:hidden;transform:rotate(-1.2deg);opacity:0;animation:ttpkIn .55s ease .1s forwards}',
              '.ttpk-cp::before,.ttpk-cp::after{content:"";position:absolute;top:50%;width:20px;height:20px;margin-top:-10px;border-radius:50%;background:#fffaf0;z-index:2}',
              '.ttpk-cp::before{left:-11px}.ttpk-cp::after{right:-11px}',
              '.ttpk-cp-l{flex:1;padding:14px 10px 14px 20px;text-align:left}',
              '.ttpk-cp-l small{display:block;font-size:10px;font-weight:900;letter-spacing:.2em;color:#b7862a}',
              '.ttpk-cp-l b{display:block;margin-top:3px;font-family:Fraunces,Georgia,serif;font-size:clamp(25px,7.2vw,31px);font-weight:700;line-height:1;letter-spacing:-.01em;color:#151a33}',
              '.ttpk-cp-l em{display:block;margin-top:6px;font-style:normal;font-size:12.5px;font-weight:700;color:#7a6331}',
              '.ttpk-cp-r{position:relative;flex:0 0 30%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1px;padding:10px 12px 10px 10px;background:#151a33;color:#f6d27a;border-left:2px dashed #e0a93a}',
              '.ttpk-cp-r i{font-style:normal;font-size:10.5px;font-weight:900;letter-spacing:.16em;color:rgba(246,210,122,.85)}',
              '.ttpk-cp-r b{font-family:Fraunces,Georgia,serif;font-size:clamp(24px,7vw,30px);font-weight:700;line-height:1;color:#fff}',
              '.ttpk-cp-r small{font-size:10px;font-weight:900;letter-spacing:.18em}',
              '.ttpk-sc{position:absolute;left:-9px;top:4px;font-size:15px;line-height:1;color:#c98f22;transform:rotate(90deg)}',
              '.ttpk-shine{position:absolute;top:0;bottom:0;left:-60%;width:40%;pointer-events:none;background:linear-gradient(105deg,transparent,rgba(255,255,255,.85),transparent);transform:skewX(-18deg);animation:ttpkShine 3.6s ease-in-out 1s infinite}',
              // Ticket
              '.ttpk-tk{position:relative;display:flex;align-items:center;gap:14px;margin:0 10px 6px;padding:14px 14px 14px 22px;border-radius:14px;border:4px solid #fff;text-align:left;background:linear-gradient(140deg,#fff3d0 0%,#f5dc8a 45%,#d4af37 100%);color:#3a2400;box-shadow:0 14px 30px -12px rgba(120,80,0,.5);transform:rotate(1.2deg);opacity:0;animation:ttpkIn .55s ease .3s forwards}',
              '.ttpk-tk::before,.ttpk-tk::after{content:"";position:absolute;top:50%;width:22px;height:22px;margin-top:-11px;border-radius:50%;background:#fffaf0}',
              '.ttpk-tk::before{left:-15px}.ttpk-tk::after{right:-15px}',
              '.ttpk-tk-l{flex:1;min-width:0}',
              '.ttpk-tk-l small{display:block;font-size:9.5px;font-weight:900;letter-spacing:.22em}',
              '.ttpk-tk-l b{display:block;margin:6px 0 3px;font-family:Fraunces,Georgia,serif;font-size:clamp(22px,6.4vw,28px);font-weight:700;line-height:1;text-transform:uppercase;overflow-wrap:anywhere}',
              '.ttpk-tk-l em{display:block;font-family:Fraunces,Georgia,serif;font-style:italic;font-size:13.5px;font-weight:600}',
              '.ttpk-tk-l span{display:block;margin-top:5px;font-size:11px;letter-spacing:.3em;color:#8a6200}',
              '.ttpk-qr{position:relative;flex-shrink:0;width:64px;text-align:center}',
              '.ttpk-qr::before{content:"";position:absolute;left:-9px;top:-12px;bottom:-12px;border-left:2px dashed rgba(58,36,0,.35)}',
              '.ttpk-qr svg{display:block;width:64px;height:64px;padding:3px;border-radius:6px;background:#fff8e1;box-shadow:inset 0 0 0 1px rgba(58,36,0,.2)}',
              '.ttpk-qr small{display:block;margin-top:4px;font-size:9px;font-weight:900;letter-spacing:.06em}',
              '.ttpk-cap{margin:8px 0 18px;font-size:13px;font-weight:800;color:#5b6475}',
              // Poster + gift
              '.ttpk-row{display:grid;grid-template-columns:1fr 1fr;gap:10px}',
              '.ttpk-card{display:flex;flex-direction:column;align-items:center;gap:8px;padding:14px 10px 12px;border-radius:16px;background:#fff;border:1px solid #f0e6cf;opacity:0;animation:ttpkIn .55s ease forwards}',
              '.ttpk-card:nth-child(1){animation-delay:.5s}.ttpk-card:nth-child(2){animation-delay:.65s}',
              '.ttpk-pst{display:flex !important;flex-direction:column;align-items:center;justify-content:center;gap:3px;width:64px;aspect-ratio:2/3;padding:4px;border-radius:5px;border:3px solid #fff;color:#fff;background:radial-gradient(80% 60% at 50% 25%,#3a3f6b,#151a33);box-shadow:0 0 0 1.5px #f6d27a,0 8px 18px rgba(0,0,0,.28);transform:rotate(-3deg)}',
              '.ttpk-pst i{font-style:normal;font-size:16px}',
              '.ttpk-pst b{font-family:Fraunces,Georgia,serif;font-size:10px;font-weight:700;line-height:1.05;text-transform:uppercase;overflow-wrap:anywhere}',
              '.ttpk-pst small{font-size:5.5px;font-weight:900;letter-spacing:.12em;color:#f6d27a}',
              '.ttpk-gift{display:block;height:64px;font-size:40px;line-height:64px;animation:ttpkBob 2.4s ease-in-out infinite}',
              '.ttpk-t{font-size:14px;font-weight:900;line-height:1.2;color:#151a33}',
              '.ttpk-s{font-size:12px;font-weight:700;line-height:1.35;color:#6b7280}',
              '@keyframes ttpkIn{to{opacity:1}}',
              '@keyframes ttpkShine{0%,55%{left:-60%}85%,100%{left:130%}}',
              '@keyframes ttpkBob{0%,100%{transform:translateY(0) rotate(-4deg)}50%{transform:translateY(-4px) rotate(4deg)}}',
              '@media (prefers-reduced-motion:reduce){.ttpk-cp,.ttpk-tk,.ttpk-card{animation:none;opacity:1}.ttpk-shine,.ttpk-gift{animation:none}}',
            ].join('');
            document.head.appendChild(st);
          }

          const box = document.createElement('div');
          box.id = 'ttPerks';
          box.innerHTML =
            '<div class="ttpk-k">' + (es ? 'Cada película incluye' : 'Every movie comes with') + '</div>' +
            '<div class="ttpk-h">' + (es ? 'Mucho más que una canción ✨' : 'So much more than a song ✨') + '</div>' +
            // The movie
            '<div class="ttpk-mv"><small>🎬 ' + (es ? 'LA PELÍCULA' : 'THE MOVIE') + '</small>' +
              '<b>' + (es ? '25+ escenas a medida' : '25+ custom scenes') + '</b>' +
              '<p>' + (es ? 'Protagonizada por ' : 'Starring ') + '<span class="ttpk-nm">' + placeholder + '</span>' + (es ? ', en cada escena' : ', in every scene') + '</p>' +
              '<div class="ttpk-strip"><div class="ttpk-track">' +
                ['🎈', '🌟', '🏰', '🐶', '🎂', '🌈', '🚀', '🎠'].concat(['🎈', '🌟', '🏰', '🐶', '🎂', '🌈', '🚀', '🎠'])
                  .map((e) => '<span class="ttpk-fr">' + e + '</span>').join('') +
              '</div></div>' +
              '<ul>' +
                '<li><i>✓</i>' + (es ? 'Cada escena hecha para su letra' : 'Every scene made to match their lyrics') + '</li>' +
                '<li><i>✓</i>' + (es ? 'Revisada por una persona antes de enviarla' : 'Crafted by hand after you order ') + '</li>' +
                '<li><i>✓</i>' + (es ? 'Directo a tu correo' : 'Delivered straight to your inbox') + '</li>' +
              '</ul></div>' +
            // Coupon
            '<div class="ttpk-cp"><i class="ttpk-shine"></i>' +
              '<div class="ttpk-cp-l"><small>' + (es ? 'BONO · INCLUIDO' : 'BONUS · INCLUDED') + '</small>' +
                '<b>' + (es ? '2 CANCIONES GRATIS' : '2 FREE SONGS') + '</b>' +
                '<em>' + (es ? 'Dos cupones de canción, enviados por correo' : 'Two song coupons, emailed to you') + '</em></div>' +
              '<div class="ttpk-cp-r"><span class="ttpk-sc">✂</span>' +
                (showValue
                  ? '<i>A</i><b>' + valueTxt + '</b><small>VALUE</small>'
                  : '<b>' + (es ? 'GRATIS' : 'FREE') + '</b>') +
              '</div></div>' +
            // Ticket
            '<div class="ttpk-tk"><div class="ttpk-tk-l">' +
                '<small>ADMIT ONE · ' + (es ? 'ESTRENO' : 'WORLD PREMIERE') + '</small>' +
                '<b class="ttpk-nm">' + placeholder + '</b>' +
                '<em>' + (es ? 'Protagonizada por ' : 'Starring ') + '<span class="ttpk-nm" style="display:inline;margin:0;letter-spacing:0;font-size:inherit;color:inherit">' + placeholder + '</span></em>' +
                '<span>★ ★ ★ ★ ★</span></div>' +
              '<div class="ttpk-qr">' + qrSvg + '<small>' + (es ? 'ESCANEA PARA VER' : 'SCAN TO WATCH') + '</small></div></div>' +
            '<div class="ttpk-cap">🎟️ ' + (es ? 'Boleto de estreno con código QR' : 'Their own QR-code premiere ticket') + '</div>' +
            // Poster + gift
            '<div class="ttpk-row">' +
              '<div class="ttpk-card"><span class="ttpk-pst">' + (window.savedCharacterUrl ? '<img src="' + window.savedCharacterUrl + '" alt="" style="width:100%;flex:1;min-height:0;object-fit:cover;object-position:center 15%;border-radius:2px">' : '<i>⭐</i>') + '<b class="ttpk-nm">' + placeholder + '</b><small>A TINYTUNES ORIGINAL</small></span>' +
                '<div class="ttpk-t">' + (es ? 'Su propio póster' : 'Their own movie poster') + '</div>' +
                '<div class="ttpk-s">' + (es ? 'Para imprimir y enmarcar' : 'Print it, frame it') + '</div></div>' +
              '<div class="ttpk-card"><span class="ttpk-gift">🎁</span>' +
                '<div class="ttpk-t">' + (es ? 'El regalo perfecto' : 'The perfect gift') + '</div>' +
                '<div class="ttpk-s">' + (es ? 'Compártelo con toda la familia' : 'Share it with the whole family') + '</div></div>' +
            '</div>';

          const after = document.getElementById('ttWaitNext') || document.getElementById('ttMediaStage');
          if (!after) return;
          after.after(box);
          ttTrack('pv_perks_shown');

          // Their name on the ticket and poster as soon as it loads
          const nameTimer = setInterval(() => {
            const nm = String(window.ttChildName || '').trim();
            if (!nm) return;
            clearInterval(nameTimer);
            box.querySelectorAll('.ttpk-nm').forEach((el) => { el.textContent = nm; });
          }, 500);

          // Only while the song is being made: fades away once it's ready
          const gone = setInterval(() => {
            if (!introFinished) return; // stays up until the song actually starts playing
            clearInterval(gone);
            clearInterval(nameTimer);
            box.style.transition = 'opacity .4s ease';
            box.style.opacity = '0';
            setTimeout(() => box.remove(), 420);
          }, 1000);
        }

        // ── INIT ──
        updateVideoCta();
        updateFlowGuide();
        setCTAName();
        setProgress('new');
        setUIProgress(5, 'Warming up the TinyTunes studio… 🔥');
        updateEmailMessaging();
        startSmoothAnimator();
        poll().finally(() => {
          // If the song was already ready on the very first check (returning visitor),
          // poll() already called showAudio() itself — don't replay the intro video.
          if (!introStarted) startIntroFlow({ userInitiated: false });
          document.documentElement.classList.remove('tt-pv-boot'); // first state is decided: show it
        });
        pollTimer = setInterval(poll, 4000);
      });